webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getTopLevelRoute */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parseLocation; });
/* unused harmony export sanitizeQueries */
/* unused harmony export getFlattenQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getFlattenLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return makeLink; });
/* unused harmony export defaultSortParamForQuery */
/* unused harmony export getOptionsArrayFromQueryString */
/* unused harmony export getQueryStringFromOptionsArray */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getQueryWithoutParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getQueryWithoutOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getQueryWithoutCategory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omit__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_sites__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_searchQueryWhitelist__ = __webpack_require__(124);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







/**
 * check the top level pathname
 * /category/wordpress -> category
 * /search?category=wordpress -> search
 * /tags/clean -> tags
 * @param  {String} pathname
 * @return {String} top level route name
 */
var getTopLevelRoute = function getTopLevelRoute() {
  var pathname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';

  return pathname.split('/').slice(1, 2).join('');
};

var QUERY_KEYS_TO_LOWERCASE = ['category', 'tags'];

var slugifyQueries = function slugifyQueries(queries) {
  return Object.keys(queries).reduce(function (result, key) {
    if (queries[key]) {
      var slugifiedValue = queries[key].toString();
      if (QUERY_KEYS_TO_LOWERCASE.indexOf(key) >= 0) {
        slugifiedValue = slugifiedValue.replace(/_/g, '-').toLowerCase();
      }
      var decodedValue = null;
      try {
        decodedValue = decodeURI(slugifiedValue);
      } catch (e) {
        decodedValue = slugifiedValue;
      }
      result[key] = decodedValue;
    }
    return result;
  }, {});
};

/**
 * a function to parse current location to a query object
 * it should handle all possible url
 * /search?category=wordpress
 * /search?category=wordpres,site-template
 * /search?tags=clean&category=wordpress&sales=rank-3
 * /category/wordpress
 * /category/wordpress/ecomerce
 * /tags/clean
 * /tags/clean,modern
 * /attributes/themeforest-files-included/css-files
 * /attributes/compatible-software/Wordpress 4.5.2
 * @param {Object} The location object from react-router
 * {
 *   pathname: '/',
 *   query: {
 *     term: 'cat'
 *   }
 * }
 * @return {Object} a object of all the seach queries
 */
var parseLocation = function parseLocation() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$pathname = _ref.pathname,
      pathname = _ref$pathname === undefined ? '/search' : _ref$pathname,
      _ref$query = _ref.query,
      query = _ref$query === undefined ? {} : _ref$query;

  var categoryPageRegex = /\/(category)\/+/g;
  var tagsPageRegex = /\/(tags)\/+/g;
  var attributesPageRegex = /\/(attributes)\/+/g;

  var topLevelRoute = getTopLevelRoute(pathname);

  // the last win if there are same queries in the url
  var sortedQuery = Object.keys(query).filter(function (param) {
    return query[param] !== null && query[param] !== '';
  }).reduce(function (prev, curr) {
    if (Array.isArray(query[curr])) {
      // colors=red&colors=yellow -> colors=red,yellow
      prev[curr] = query[curr].join(',');
    } else {
      prev[curr] = query[curr];
    }
    return prev;
  }, {});

  var queries = void 0;
  switch (topLevelRoute) {
    case 'category':
      var categoryName = pathname.replace(categoryPageRegex, '');
      queries = Object.assign({}, sortedQuery, {
        category: categoryName
      });
      // when the category is equal to `all` from the url
      // it's passing empty string to search sortedQuery
      if (categoryName === '' || categoryName === 'all') {
        delete queries.category;
      }
      break;
    case 'tags':
      queries = Object.assign({}, sortedQuery, {
        tags: pathname.replace(tagsPageRegex, '')
      });
      break;
    case 'attributes':
      var attributes = pathname.replace(attributesPageRegex, '');
      queries = Object.assign({}, sortedQuery, {
        attribute_key: attributes.split('/')[0],
        attribute_value: attributes.split('/')[1] || ''
      });
      break;
    default:
      queries = Object.assign({}, sortedQuery);
  }

  var slugifiedQueries = slugifyQueries(queries);

  var sortOption = slugifiedQueries.sort;

  if (sortOption) {
    // in the url we only store the sort filter as `search?sort=trending'
    // but in public-search api it matches to `sort_by` and `sort_direction`
    // so whenever we match `sort` from the url, we have to parse it to
    // `sort_by` and `sort_direction` so we could fetch the correct result
    // this is also used in rendering the selected filters
    if (sortOption.indexOf('price-') >= 0) {
      slugifiedQueries = Object.assign({}, slugifiedQueries, {
        sort_direction: sortOption.split('-')[1],
        sort_by: 'price'
      });
    } else {
      slugifiedQueries = Object.assign({}, slugifiedQueries, {
        sort_by: sortOption
      });
    }
    delete slugifiedQueries.sort;

    /**
    * We should only keep valid sort by options so the server does not
    * throw error
    */
    if (__WEBPACK_IMPORTED_MODULE_4__constants_searchQueryWhitelist__["a" /* validSortByOptions */].indexOf(slugifiedQueries.sort_by) === -1) {
      delete slugifiedQueries.sort_by;
    }
    // when there's no sort value, use default settings
  }
  if (!slugifiedQueries.sort_by) {
    slugifiedQueries.sort_by = __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default()(slugifiedQueries.term) ? 'date' : 'relevance';
  }

  return slugifiedQueries;
};

/**
 * Sanitize queries object by removing params with no value (empty string).
 * @param {Object} queries object
 * @returns {Object} new queries object
 */

var sanitizeQueries = function sanitizeQueries(queries) {
  return Object.keys(queries).reduce(function (prev, curr) {
    if (queries[curr] !== '') {
      prev[curr] = queries[curr];
    }
    return prev;
  }, {});
};

/**
 * Make a copy of the location object which pick the last option if it's an array
 * @param query
 * @returns {*}
 */
var getFlattenQuery = function getFlattenQuery(query) {
  return Object.keys(query).reduce(function (prev, curr) {
    if (Array.isArray(query[curr])) {
      var arrayLength = query[curr].length;
      prev[curr] = query[curr][arrayLength - 1];
    } else {
      prev[curr] = query[curr];
    }
    return prev;
  }, {});
};

var getFlattenLocation = function getFlattenLocation(location) {
  var flattenQuery = getFlattenQuery(location.query);
  var flattenLocation = _extends({}, location, {
    query: flattenQuery
  });
  return flattenLocation;
};

/**
 * Return the most SEO friendly URL
 * prioritise order category > tags > attributes > search queries
 * @param  {Object} queries object
 * @return {String} a SEO friendly URL
 */
var makeLink = function makeLink() {
  var queries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var url = '';
  var newQueries = sanitizeQueries(queries);

  /*
    We should not allow to show search results for pages greater than 60 because of the performance.
    So the purpose of this is to set a limit to being able to browser by the user maximum 60 pages.
   */
  if (newQueries.page && Number(newQueries.page) > __WEBPACK_IMPORTED_MODULE_3__config_sites__["a" /* default */].defaults.common.max_pages_count) {
    newQueries.page = __WEBPACK_IMPORTED_MODULE_3__config_sites__["a" /* default */].defaults.common.max_pages_count;
  }

  /**
   * re-direct colours to color
   */
  if (newQueries.colours) {
    newQueries.colors = newQueries.colours;
    delete newQueries.colours;
  }

  // revert the process of decode sort_by value
  // when there's sort_by or sort_direction
  // we convert them to sort='price-desc'
  if (newQueries.sort_by) {
    if (newQueries.sort_by === 'price' && newQueries.sort_direction) {
      newQueries = Object.assign({}, newQueries, {
        sort: 'price-' + newQueries.sort_direction
      });
      delete newQueries.sort_direction;
    } else {
      newQueries = Object.assign({}, newQueries, {
        sort: newQueries.sort_by
      });
    }
    delete newQueries.sort_by;
  }

  var defaultSortParam = defaultSortParamForQuery(newQueries);
  // we don't want default value in the url
  if (newQueries.sort && newQueries.sort === defaultSortParam) {
    delete newQueries.sort;
  }

  // if the queries has category, go to category page
  // TODO @nogates. This is not enterely true, when both a category
  // and a tag exists, the canonical url should be
  // http://site/tags/<tags>?category=<category>
  // Created a card on the seo board to address this, but
  // leaving a comment here, because it might take a while to get to it
  if (queries.category) {
    // create a new copy of the current queries object
    var categories = queries.category;
    delete newQueries.category;
    // append the other queries to the end of the url
    var queriesString = __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(newQueries, {
      encode: false
    }) ? '?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(newQueries, {
      encode: false
    }) : '';
    url = '/category/' + categories + queriesString;
    // if the queries has tags, go to tags page
  } else if (queries.tags) {
    // create a new copy of the current queries object
    var tags = queries.tags;
    delete newQueries.tags;
    // append the other queries to the end of the url
    var _queriesString = __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(newQueries, {
      encode: false
    }) ? '?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(newQueries, {
      encode: false
    }) : '';
    // append the other queries to the end of the url
    url = '/tags/' + tags + _queriesString;
    // if the queries has attributes, go to attributes
  } else if (queries.attribute_key && queries.attribute_value) {
    // create a new copy of the current queries object
    var attribute_key = queries.attribute_key; // eslint-disable-line
    var attribute_value = queries.attribute_value; // eslint-disable-line
    delete newQueries.attribute_key;
    delete newQueries.attribute_value;
    // append the other queries to the end of the url
    var _queriesString2 = __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(newQueries, {
      encode: false
    }) ? '?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(newQueries, {
      encode: false
    }) : '';
    // append the other queries to the end of the url
    url = '/attributes/' + attribute_key + '/' + attribute_value + _queriesString2; // eslint-disable-line
    // else just to go search result page
  } else {
    var _queriesString3 = __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(newQueries, {
      encode: false
    }) ? '?' + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(newQueries, {
      encode: false
    }) : '';
    url = _queriesString3 === '' ? '/category/all' : '/search' + _queriesString3;
  }
  return encodeURI(url);
};

var defaultSortParamForQuery = function defaultSortParamForQuery(query) {
  return __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default()(query.term) ? 'date' : 'relevance';
};

/**
 * get option array from query string
 * @param  {String} option string a,b,c
 * @return {Array} [a, b, c]
 */
var getOptionsArrayFromQueryString = function getOptionsArrayFromQueryString() {
  var optionsString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (typeof optionsString !== 'string') throw new Error('tags should be a string.');
  return optionsString ? optionsString.split(',') : [];
};

/**
 * get option string from query array
 * @param  {Array} option array [a, b, c]
 * @return {String} a,b,c
 */
var getQueryStringFromOptionsArray = function getQueryStringFromOptionsArray() {
  var optionsArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (!Array.isArray(optionsArray)) throw new Error('tags array should be an array.');
  return optionsArray.join(',');
};

/**
 * Returns query without specified param
 * @param {Object} query
 * @param {String|Array} paramNames
 * @returns {Object}
 */
var getQueryWithoutParam = function getQueryWithoutParam(query, paramNames) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_omit___default()(query, paramNames);
};

/**
 * Returns query without specified option within the query param.
 * Eg. getQueryWithoutOption({t1: 'ab,cd,ef'}, 't1', 'cd') -> {t1: 'ab,ef'}
 * @param {Object} query
 * @param {String} paramName
 * @param {String} optionName
 * @returns {Object}
 */
var getQueryWithoutOption = function getQueryWithoutOption(query, paramName, optionName) {
  var nextQuery = _extends({}, query);
  var options = getOptionsArrayFromQueryString(query[paramName]);
  options = options.filter(function (option) {
    return option !== optionName;
  });
  if (options.length === 0) {
    delete nextQuery[paramName];
  } else {
    nextQuery[paramName] = getQueryStringFromOptionsArray(options);
  }
  return nextQuery;
};

/**
 * Remove specific category and all its subcategories form a category query param
 * @param {Object} query
 * @param {String} paramName
 * @param {String} categoryName
 * @returns {Object}
 */
var getQueryWithoutCategory = function getQueryWithoutCategory(query, paramName, categoryName) {
  var nextQuery = _extends({}, query);
  var categories = nextQuery[paramName].split('/');
  categories = categories.slice(0, categories.indexOf(categoryName));

  if (categories.length === 0) {
    delete nextQuery[paramName];
  } else {
    nextQuery[paramName] = categories.join('/');
  }

  return nextQuery;
};

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UndefinedError */
/* unused harmony export NotAnError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ResponseDataError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SearchOfflineError; });
/* unused harmony export MetadataGenerationError */
/* unused harmony export MetadataGenerationWarning */
/* unused harmony export RedisClientWarning */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AxiosNetworkError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AxiosTimeoutError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AxiosError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return logError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_error_typed__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_error_typed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_error_typed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rollbar___ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isError__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isError___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isError__);




var UndefinedError = __WEBPACK_IMPORTED_MODULE_0_error_typed___default()({
  type: 'undefined',
  message: 'Exception or rejection value was null or undefined'
});

var NotAnError = __WEBPACK_IMPORTED_MODULE_0_error_typed___default()({
  type: 'not-an-error',
  message: 'Exception or rejection value was not an error object',
  value: null
});

var ResponseDataError = __WEBPACK_IMPORTED_MODULE_0_error_typed___default()({
  type: 'response-data-error',
  message: 'response data error'
});

var SearchOfflineError = __WEBPACK_IMPORTED_MODULE_0_error_typed___default()({
  type: 'search.offline',
  message: 'HTTP {statusCode} error, search offline',
  level: 'critical',
  statusCode: null
});

var MetadataGenerationError = __WEBPACK_IMPORTED_MODULE_0_error_typed___default()({
  type: 'metadata',
  title: 'Metadata',
  message: '{title}: {origMessage}'
});

var MetadataGenerationWarning = __WEBPACK_IMPORTED_MODULE_0_error_typed___default()({
  type: 'metadata',
  title: 'Metadata',
  message: '{title}: {origMessage}',
  level: 'warning'
});

var RedisClientWarning = __WEBPACK_IMPORTED_MODULE_0_error_typed___default()({
  type: 'redis',
  title: 'Redis client',
  message: '{title}: {origMessage}',
  level: 'warning'
});

var AxiosNetworkError = __WEBPACK_IMPORTED_MODULE_0_error_typed___default()({
  type: 'axios.network',
  level: 'warning',
  message: 'Network Error'
});

var AxiosTimeoutError = __WEBPACK_IMPORTED_MODULE_0_error_typed___default()({
  type: 'axios.timeout',
  message: 'Request [{endpoint}] timed out',
  level: 'warning',
  endpoint: '',
  url: '',
  statusCode: null,
  code: null
});

var AxiosError = __WEBPACK_IMPORTED_MODULE_0_error_typed___default()({
  type: 'axios',
  message: 'Request [{endpoint}] failed with status code {statusCode}',
  endpoint: '',
  url: '',
  httpMethod: '',
  statusCode: null,
  statusText: '',
  responseData: null
});

/**
 * Log error to rollbar
 * @param {Error} error
 */
var logError = function logError(error) {
  if (__WEBPACK_IMPORTED_MODULE_2_lodash_isError___default()(error)) {
    var level = [400, 401, 403].includes(error.statusCode) ? 'warning' : error.level;
    if (__WEBPACK_IMPORTED_MODULE_1__rollbar___["a" /* default */][level]) {
      __WEBPACK_IMPORTED_MODULE_1__rollbar___["a" /* default */][level](error.message, error);
    } else {
      __WEBPACK_IMPORTED_MODULE_1__rollbar___["a" /* default */].error(error.message, error);
    }

    return error;
  } else {
    if (error) {
      return logError(NotAnError({ value: error }));
    } else {
      return logError(UndefinedError());
    }
  }
};

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interceptors__ = __webpack_require__(145);



var axiosVerbose = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  timeout: 10000
});

axiosVerbose.interceptors.response.use(undefined, __WEBPACK_IMPORTED_MODULE_1__interceptors__["a" /* timeoutRetryRejectionInterceptor */]);
axiosVerbose.interceptors.response.use(undefined, __WEBPACK_IMPORTED_MODULE_1__interceptors__["b" /* betterErrorsRejectionInterceptor */]);

/* harmony default export */ __webpack_exports__["a"] = (axiosVerbose);

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ga = function ga() {
  if (typeof window !== 'undefined') {
    var _window;

    (_window = window).ga.apply(_window, arguments);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ga);

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  category: {
    isMultiple: true,
    delimiter: '/',
    icon: 'folder',
    order: 0
  },
  tags: {
    isMultiple: true,
    delimiter: ',',
    icon: 'tag',
    order: 1
  },
  price_min: {
    inRangeWith: { max: 'price_max' },
    icon: 'dollar',
    label: 'At least',
    format: function format(value) {
      return '$' + value;
    },
    order: 2
  },
  price_max: {
    inRangeWith: { min: 'price_min' },
    icon: 'dollar',
    label: 'At most',
    format: function format(value) {
      return '$' + value;
    },
    order: 3
  },
  length_min: {
    inRangeWith: { max: 'length_max' },
    icon: 'clock',
    label: 'At least'
  },
  length_max: {
    inRangeWith: { min: 'length_min' },
    icon: 'clock',
    label: 'At most'
  },
  sales: {
    isMultiple: false,
    icon: 'bar-chart',
    labels: {
      'rank-0': 'No sales',
      'rank-1': 'Low',
      'rank-2': 'Medium',
      'rank-3': 'High',
      'rank-4': 'Top Sellers'
    },
    order: 4
  },
  rating_min: {
    isMultiple: false,
    icon: 'star',
    labels: {
      '1': '1 star and higher',
      '2': '2 stars and higher',
      '3': '3 stars and higher',
      '4': '4 stars and higher'
    },
    order: 5
  },
  sort_by: {
    isMultiple: false,
    icon: 'sort',
    labels: {
      relevance: 'Best match',
      trending: 'Trending items',
      sales: 'Best sellers',
      rating: 'Best rated',
      date: 'Newest items',
      'price-asc': 'Price: low to high',
      'price-desc': 'Price: high to low'
    },
    order: 6
  },
  date: {
    isMultiple: false,
    icon: 'calendar',
    labels: {
      '': 'Any date',
      'this-year': 'In the last year',
      'this-month': 'In the last month',
      'this-week': 'In the last week',
      'this-day': 'In the last day'
    },
    order: 7
  },
  platform: {
    isMultiple: false,
    icon: 'code',
    delimiter: ' ',
    order: 8
  },
  compatible_with: {
    isMultiple: true,
    delimiter: ',',
    icon: 'code',
    order: 9
  },
  attribute_value: {
    isMultiple: false,
    icon: '',
    order: 10
  },
  poly_count: {
    isMultiple: false,
    icon: 'polygon',
    order: 11
  },
  file_formats: {
    isMultiple: true,
    isArrayFormat: true,
    delimiter: ',',
    icon: 'document',
    order: 12,
    labels: {
      obj: '.obj (multi format)',
      fbx: '.fbx (multi format)',
      max: '.max (3ds Max)',
      c4d: '.c4d (cinema 4d)',
      ma: '.ma (maya)',
      blend: '.blend (blender)',
      '3ds': '.3ds (multi format)',
      mb: '.mb (maya)',
      lwo: '.lwo (lightwave)',
      dxf: '.dxf (multi format)',
      dwg: '.dwg (AutoCAD)',
      lws: '.lws (lightwave)',
      '3b': '.3b (3dcoat)',
      unitypackage: '.unitypackage (Unity3D)',
      vob: '.vob (Vue)',
      vue: '.vue (Vue)',
      ztl: '.ztl (zbrush)',
      xsi: '.xsi (softimage)'
    }
  },
  orientation: {
    isMultiple: false,
    icon: 'frame-rotated',
    labels: {
      landscape: 'Landscape',
      portrait: 'Portrait',
      square: 'Square'
    },
    order: 13
  },
  colors: {
    isMultiple: true,
    delimiter: ',',
    icon: 'palette',
    order: 14
  },
  sizes: {
    isMultiple: true,
    delimiter: ',',
    icon: 'ruler',
    labels: {
      m: 'Medium',
      l: 'Large',
      xl: 'Extra large',
      xxl: 'Extra extra large'
    },
    order: 15
  },
  vocals_in_audio: {
    isMultiple: true,
    delimiter: ',',
    icon: 'vocals',
    isArrayFormat: true
  },
  tempo: {
    isMultiple: false,
    icon: 'tempo',
    labels: {
      'very-slow': 'Very slow (0 - 60 BPM)',
      slow: 'Slow (60 - 90 BPM)',
      medium: 'Medium (90 - 110 BPM)',
      upbeat: 'Upbeat (110 - 140 BPM)',
      fast: 'Fast (140 - 160 BPM)',
      'very-fast': 'Very fast (160+ BPM)'
    }
  },
  resolution_min: {
    isMultiple: false,
    icon: 'tv',
    labels: {
      '720p': '720p (HD)',
      '1080p': '1080p (Full HD)',
      '2K': '2K',
      '4K': '4K (UHD)'
    }
  },
  frame_rate: {
    isMultiple: false,
    icon: 'film',
    format: function format(value) {
      return value + ' fps';
    }
  },
  requires_plugins: {
    isMultiple: false,
    icon: 'plug',
    labels: {
      'F': 'No',
      'T': 'Yes'
    }
  },
  alpha: {
    isMultiple: false,
    isBoolean: true,
    icon: 'alpha'
  },
  looped: {
    isMultiple: false,
    isBoolean: true,
    icon: 'looped'
  }
});

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Expose a single entry point where both the client and server can use
 */
var config = {
  sso: {
    SERVER_HOST: "https://account.envato.com",
    API_KEY: process.env.SSO_API_KEY,
    RECAPTCHA_KEY: "6LcigAcTAAAAAAruaW_goIkW3FD2oZR40YqDXgcB"
  },
  jwt: {
    PUBLIC_KEY: process.env.JWT_PUBLIC_KEY
  },
  marketplaceApi: {
    URL: process.env.MARKETPLACE_API_URL,
    SECRET: process.env.X_ENVATO_SECRET
  },
  eventsApi: {
    URL: "https://events-api.shopfront.envato.com/api"
  },
  discoveryUser: {
    PUBLIC_SEARCH_API_URL: process.env.PUBLIC_SEARCH_API_URL,
    RECOMMENDATION_API_URL: process.env.RECOMMENDATION_API_URL
  },
  db: {
    REDIS_URL: process.env.REDIS_URL
  },
  analytics: {
    rollbar: {
      CLIENT_SIDE_TOKEN: "8146d878f4df4242ae6deb8d3d79b6a4",
      SERVER_SIDE_TOKEN: process.env.ROLLBAR_SERVER_SIDE_TOKEN
    },
    newrelic: {
      ENABLED: process.env.NEW_RELIC_ENABLED,
      LICENSE_KEY: process.env.NEW_RELIC_LICENSE_KEY
    },
    affiliate: {
      MARKETPLACE_URL: "https://marketplace.envato.com"
    },
    intercom: {
      APP_ID: "s9exa3j0",
      SECRET: process.env.INTERCOM_SECRET
    }
  },
  assets: {
    PUBLIC_PATH: "https://assets.shopfront.envato-static.com"
  }
};

/* harmony default export */ __webpack_exports__["a"] = (config);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(77)))

/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return commaStyleString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toTitle; });
/* unused harmony export centlessFormat */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPriceVariation; });
/**
 * A util function to convert numbers to more comma style format
 * e.g. `12342353` => `12,342,353`
 * e.g. `123` => `123`
 * e.g. `12` => `12`
 * @param  {String} string or number
 * @return {string} formatted string
 */
var commaStyleString = function commaStyleString(number, separator) {
  separator = typeof separator === 'undefined' ? ',' : '' + separator;

  // Convert to number if it's a non-numeric value
  if (typeof number !== 'number') {
    number = Number(number);
  }

  // NaN => 0
  if (isNaN(number)) {
    number = 0;
  }

  // Return Infinity immediately
  if (!isFinite(number)) {
    return '' + number;
  }

  var stringNumber = ('' + Math.abs(number)).split('').reverse();

  var result = [];
  for (var i = 0; i < stringNumber.length; i++) {
    if (i && i % 3 === 0) {
      result.push(separator);
    }
    result.push(stringNumber[i]);
  }

  // Handle negative numbers
  if (number < 0) {
    result.push('-');
  }

  return result.reverse().join('');
};

/**
 * Convert key-text to be more attractive as a title
 * eg. 'blog-magazine' => 'Blog Magazine'
 *     'blog magazine' => 'Blog Magazine'
 * @param {String} text
 * @returns {String}
 */
var toTitle = function toTitle(key) {
  return key.split('-').join(' ').replace(/\b\w/g, function (l) {
    return l.toUpperCase();
  });
};

/**
 * $10.00 should be $10
 * $10.15 should be $10.15
 */
var centlessFormat = function centlessFormat(data) {
  var absValue = Math.abs(data);
  var isInt = function isInt(n) {
    return n % 1 === 0;
  };
  return isInt(absValue) ? parseInt(absValue) : absValue.toFixed(2);
};

/**
 * get price variation
 * $12.12 - $5.00
 * should return a centless formatted value
 */
var getPriceVariation = function getPriceVariation(currentPrice, upgradePrice) {
  var intPrice = function intPrice(priceString) {
    return parseFloat(priceString.replace('$', ''));
  };
  var variation = intPrice(upgradePrice) - intPrice(currentPrice);
  if (variation === 0) return '';
  var variationType = variation > 0 ? '+' : '-';
  return variationType + '$' + centlessFormat(variation);
};

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3docean__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__audiojungle__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__codecanyon__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphicriver__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__photodune__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__themeforest__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__videohive__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__defaults__ = __webpack_require__(147);









/* harmony default export */ __webpack_exports__["a"] = ({
  '3docean': __WEBPACK_IMPORTED_MODULE_0__3docean__["a" /* default */],
  audiojungle: __WEBPACK_IMPORTED_MODULE_1__audiojungle__["a" /* default */],
  codecanyon: __WEBPACK_IMPORTED_MODULE_2__codecanyon__["a" /* default */],
  graphicriver: __WEBPACK_IMPORTED_MODULE_3__graphicriver__["a" /* default */],
  photodune: __WEBPACK_IMPORTED_MODULE_4__photodune__["a" /* default */],
  themeforest: __WEBPACK_IMPORTED_MODULE_5__themeforest__["a" /* default */],
  videohive: __WEBPACK_IMPORTED_MODULE_6__videohive__["a" /* default */],
  defaults: __WEBPACK_IMPORTED_MODULE_7__defaults__["a" /* default */]
});

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


/**
 * code from https://github.com/tj/react-click-outside
 */


var ClickOutside = function (_Component) {
  _inherits(ClickOutside, _Component);

  function ClickOutside(props) {
    _classCallCheck(this, ClickOutside);

    var _this = _possibleConstructorReturn(this, (ClickOutside.__proto__ || Object.getPrototypeOf(ClickOutside)).call(this, props));

    _this.handle = function (e) {
      var onClickOutside = _this.props.onClickOutside;

      var el = _this.container;
      if (!el.contains(e.target)) onClickOutside(e);
    };

    _this.setWrapperRef = _this.setWrapperRef.bind(_this);
    return _this;
  }

  _createClass(ClickOutside, [{
    key: 'setWrapperRef',
    value: function setWrapperRef(ref) {
      if (ref !== null) {
        this.container = ref;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { ref: this.setWrapperRef },
        children
      );
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('click', this.handle, true);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handle, true);
    }
  }]);

  return ClickOutside;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ClickOutside.propTypes = {
  onClickOutside: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ClickOutside);

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var OnKeyDown = function (_Component) {
  _inherits(OnKeyDown, _Component);

  function OnKeyDown(props) {
    _classCallCheck(this, OnKeyDown);

    var _this = _possibleConstructorReturn(this, (OnKeyDown.__proto__ || Object.getPrototypeOf(OnKeyDown)).call(this, props));

    _this.handle = function (e) {
      var onKeyDown = _this.props.onKeyDown;

      var el = _this.container;
      if (!el.contains(e.target)) onKeyDown(e);
    };

    _this.setWrapperRef = _this.setWrapperRef.bind(_this);
    return _this;
  }

  _createClass(OnKeyDown, [{
    key: 'setWrapperRef',
    value: function setWrapperRef(ref) {
      if (ref !== null) {
        this.container = ref;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['children']);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        _extends({}, props, { ref: this.setWrapperRef }),
        children
      );
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('keydown', this.handle, true);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handle, true);
    }
  }]);

  return OnKeyDown;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

OnKeyDown.propTypes = {
  onKeyDown: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (OnKeyDown);

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getRSSFeeds; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_undefsafe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_titleize__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_titleize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_titleize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_sites__ = __webpack_require__(57);





/**
 * Returns specific site config property value with fallback to default one
 * @param currentSite {String}
 * @param configPath {String}
 * @returns {*}
 */
/* harmony default export */ __webpack_exports__["a"] = (function (currentSite, configPath) {
  return __WEBPACK_IMPORTED_MODULE_0_undefsafe___default()(__WEBPACK_IMPORTED_MODULE_2__config_sites__["a" /* default */][currentSite], configPath) || __WEBPACK_IMPORTED_MODULE_0_undefsafe___default()(__WEBPACK_IMPORTED_MODULE_2__config_sites__["a" /* default */].defaults, configPath);
});

/**
 * Returns flat structure of menu items which are in feeds_categories site config.
 * @param {String} currentSite
 * @param {Array} menuConfig
 * @returns {Array}
 */
var getRSSFeeds = function getRSSFeeds(currentSite, menuConfig, feedsCategories) {
  var getTitle = function getTitle(name) {
    return __WEBPACK_IMPORTED_MODULE_1_titleize___default()(currentSite) + ' new ' + name + ' items feed';
  };

  var getFeedUrl = function getFeedUrl(categoryUrl) {
    var urlSection = categoryUrl.split('/').pop();
    return '/feeds/new-' + urlSection + '-items.atom';
  };

  return feedsCategories.map(function (feedCategory) {
    // Look for a category in menu config, return title and url if found
    for (var i = 0; i < menuConfig.length; i++) {
      if (menuConfig[i].url === feedCategory) {
        return {
          title: getTitle(menuConfig[i].name),
          url: getFeedUrl(menuConfig[i].url)
        };
      }

      // Searching second level of the menu
      if (menuConfig[i].children) {
        for (var j = 0; j < menuConfig[i].children.length; j++) {
          if (menuConfig[i].children[j].url === feedCategory) {
            return {
              title: getTitle(menuConfig[i].children[j].name),
              url: getFeedUrl(menuConfig[i].children[j].url)
            };
          }
        }
      }
    }
  }).filter(function (item) {
    return !!item;
  }) // remove feeds which were not found in menu config
  // Add general feed for whole site
  .concat([{
    title: __WEBPACK_IMPORTED_MODULE_1_titleize___default()(currentSite) + ' new items feed',
    url: '/feeds/new-' + currentSite + '-items.atom'
  }]);
};

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentSiteDomain; });
/* unused harmony export isInSitesList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__envHelper__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_siteList__ = __webpack_require__(193);



var getCurrentSiteDomain = function getCurrentSiteDomain(currentSite) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__envHelper__["a" /* isDevelopment */])()) {
    return currentSite + '.dev';
  } else {
    return currentSite + '.net';
  }
};

var isInSitesList = function isInSitesList(host) {
  return __WEBPACK_IMPORTED_MODULE_1__constants_siteList__["a" /* allDomains */].indexOf(host) !== -1;
};

/***/ }),
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return closeModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return openModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return showModalMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return dismissModalMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return toggleOffCanvas; });
var closeModal = function closeModal() {
  return {
    type: 'closeModal'
  };
};

var openModal = function openModal(data) {
  return {
    type: 'openModal',
    payload: data
  };
};

var showModalMessage = function showModalMessage(data) {
  return {
    type: 'showModalMessage',
    payload: data
  };
};

var dismissModalMessage = function dismissModalMessage() {
  return {
    type: 'dismissModalMessage'
  };
};

var toggleOffCanvas = function toggleOffCanvas(direction) {
  return {
    type: 'toggleOffCanvas',
    payload: direction
  };
};

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reportOpenSearchFilterPanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_ga__ = __webpack_require__(33);


var reportOpenSearchFilterPanel = function reportOpenSearchFilterPanel(panelName) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["a" /* default */])('send', 'event', 'Search', 'click', 'open panel ' + panelName);
};

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_assetsPath__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__envHelper__ = __webpack_require__(194);



/* harmony default export */ __webpack_exports__["a"] = (function () {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__envHelper__["b" /* isProduction */])()) {
    return __WEBPACK_IMPORTED_MODULE_0__constants_assetsPath__["a" /* default */].production;
  }
  return __WEBPACK_IMPORTED_MODULE_0__constants_assetsPath__["a" /* default */].development;
});

/***/ }),
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils_urlHelper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__multiSelectPanelFooter__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__multiSelectPanelBody__ = __webpack_require__(537);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var FiltersMultiSelectPanel = function (_React$Component) {
  _inherits(FiltersMultiSelectPanel, _React$Component);

  function FiltersMultiSelectPanel(props) {
    _classCallCheck(this, FiltersMultiSelectPanel);

    var _this = _possibleConstructorReturn(this, (FiltersMultiSelectPanel.__proto__ || Object.getPrototypeOf(FiltersMultiSelectPanel)).call(this, props));

    _this.state = {
      isExpanded: false,
      selectedOption: props.parsedLocation[props.type] || ''
    };

    _this.onToggleOption = _this.onToggleOption.bind(_this);
    _this.onUpdateOption = _this.onUpdateOption.bind(_this);
    _this.onSelectOption = _this.onSelectOption.bind(_this);
    return _this;
  }

  _createClass(FiltersMultiSelectPanel, [{
    key: 'onToggleOption',
    value: function onToggleOption(event) {
      event.preventDefault();
      this.setState({
        isExpanded: !this.state.isExpanded
      });
    }
  }, {
    key: 'onSelectOption',
    value: function onSelectOption(option) {
      var selectedOption = this.state.selectedOption;

      var selectedOptionArray = selectedOption !== '' ? selectedOption.split(',') : [];
      if (selectedOptionArray.indexOf(option) >= 0) {
        this.setState({
          selectedOption: selectedOptionArray.filter(function (opts) {
            return opts !== option;
          }).join(',')
        });
      } else {
        this.setState({
          selectedOption: [].concat(_toConsumableArray(selectedOptionArray), [option]).join(',')
        });
      }
    }
  }, {
    key: 'onUpdateOption',
    value: function onUpdateOption() {
      var selectedOption = this.state.selectedOption;
      var _props = this.props,
          parsedLocation = _props.parsedLocation,
          history = _props.history,
          type = _props.type;


      var newQuery = Object.assign({}, parsedLocation);
      newQuery[type] = selectedOption;

      // reset page param
      delete newQuery.page;

      history.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_urlHelper__["b" /* makeLink */])(newQuery));
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          isExpanded = _state.isExpanded,
          selectedOption = _state.selectedOption;
      var _props2 = this.props,
          items = _props2.items,
          showPanel = _props2.showPanel,
          togglePanel = _props2.togglePanel,
          parsedLocation = _props2.parsedLocation,
          type = _props2.type;

      var isExpandable = items.length > __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* showMoreThreshold */][type];

      var panelBodyClassNames = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('search-facet-panel__body', {
        'is-active': showPanel
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: panelBodyClassNames },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'search-facet-panel__body-inner' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'button',
            { className: 'search-facet-panel__body-close fds-c-button', onClick: togglePanel },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'i',
              { className: 'e-icon -icon-cancel' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { className: 'e-icon__alt' },
                'Close'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__multiSelectPanelBody__["a" /* default */], {
            isExpandable: isExpandable,
            isExpanded: isExpanded,
            onSelectOption: this.onSelectOption,
            parsedLocation: parsedLocation,
            selectedOption: selectedOption,
            items: items,
            type: type
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__multiSelectPanelFooter__["a" /* default */], {
            isExpandable: isExpandable,
            isExpanded: isExpanded,
            moreOptionCount: items.length - __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* showMoreThreshold */][type],
            onToggleOption: this.onToggleOption,
            togglePanel: togglePanel,
            onUpdateOption: this.onUpdateOption
          })
        )
      );
    }
  }]);

  return FiltersMultiSelectPanel;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

FiltersMultiSelectPanel.propTypes = {
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  items: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired,
  parsedLocation: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  showPanel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
  togglePanel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* withRouter */])(FiltersMultiSelectPanel));

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getItemSmallPreviewUrl */
/* unused harmony export formattedItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StarRating; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MetaCategories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return filterSortByOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return itemDecorator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_undefsafe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_sites__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils_siteConfig__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils_formatString__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils_sites__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_analytics_resultAnalytics__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_utils_errors__ = __webpack_require__(16);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }













var getItemSmallPreviewUrl = function getItemSmallPreviewUrl(item) {
  var previewPaths = __WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(__WEBPACK_IMPORTED_MODULE_3__config_sites__["a" /* default */].defaults, 'ui.item_small_preview_paths');
  return previewPaths.map(function (path) {
    return __WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(item.previews, path);
  })
  // return first non falsy value
  .reduce(function (prevPath, currPath) {
    if (prevPath) {
      return prevPath;
    }
    return currPath;
  });
};

var formattedItem = function formattedItem(item) {
  var additionalProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var nextItem = Object.assign({}, item, additionalProps);
  // price
  // TODO: price_cents is missing from photodue search result...
  nextItem.price = item.price_cents ? item.price_cents.toString().slice(0, -2) : '';
  // classification
  nextItem.formattedClassification = item.classification && typeof item.classification === 'string' ? item.classification.split('/').map(function (category) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_formatString__["a" /* toTitle */])(category);
  }).join(' / ') : '';
  return nextItem;
};

var StarRating = function StarRating(_ref) {
  var rating = _ref.rating,
      className = _ref.className,
      _ref$fullStarClass = _ref.fullStarClass,
      fullStarClass = _ref$fullStarClass === undefined ? 'star-rating__star--full' : _ref$fullStarClass,
      _ref$halfStarClass = _ref.halfStarClass,
      halfStarClass = _ref$halfStarClass === undefined ? 'star-rating__star--half' : _ref$halfStarClass,
      _ref$emptyStarClass = _ref.emptyStarClass,
      emptyStarClass = _ref$emptyStarClass === undefined ? 'star-rating__star--empty' : _ref$emptyStarClass,
      _ref$maxStars = _ref.maxStars,
      maxStars = _ref$maxStars === undefined ? 5 : _ref$maxStars;

  var stars = [];
  var roundedRating = Math.round(rating * 2) / 2.0;
  for (var i = 0; i < Math.floor(roundedRating); i++) {
    stars.push(fullStarClass);
  }

  if (roundedRating % 1) {
    stars.push(halfStarClass);
  }

  while (stars.length < maxStars) {
    stars.push(emptyStarClass);
  }

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: className },
    stars.map(function (starClass, index) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('b', { key: index, className: starClass });
    })
  );
};

StarRating.propTypes = {
  rating: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  fullStarClass: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  halfStarClass: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  emptyStarClass: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  maxStars: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
};

var MetaCategories = function MetaCategories(_ref2) {
  var className = _ref2.className,
      classification = _ref2.classification;

  var categories = classification.split('/');
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'span',
    { className: className },
    'in ',
    categories.map(function (category, index) {
      var slash = index === categories.length - 1 ? null : ' / ';
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        { key: index },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'b',
          null,
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_formatString__["a" /* toTitle */])(category)
        ),
        slash
      );
    })
  );
};

MetaCategories.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  classification: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
};

// https://github.com/envato/foundation-docs/blob/master/docs/shopfront_special_ui_rules.md
var filterSortByOptions = function filterSortByOptions(currentSite, parsedLocation, options) {
  var filteredOptions = [].concat(_toConsumableArray(options));
  if (currentSite === 'photodune') {
    filteredOptions = filteredOptions.filter(function (options) {
      return options.value !== 'rating';
    });
  }

  // no `Best Match` if there's no search term
  if (!parsedLocation.term) {
    filteredOptions = filteredOptions.filter(function (options) {
      return options.value !== 'relevance';
    });
  }
  return filteredOptions;
};

var getFooterLink = function getFooterLink(item, currentSite) {
  var footerLink = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_utils_siteConfig__["a" /* default */])(currentSite, 'item_view.footer_link');
  return footerLink && {
    label: footerLink.label,
    href: footerLink.href.replace(/\{(.*)\}/g, function (match, field) {
      return item[field];
    })
  };
};

var itemDecorator = function itemDecorator(currentSite, openModal, signedOut, favoriteCollectionID, collections, deleteBookmark, addBookmark, createFavoriteCollection, pageSize, cartItems, location) {
  return function (item, index) {
    var rank = index + ((Number(location.query.page) || 1) - 1) * pageSize + 1;
    var reportProductClickHandler = __WEBPACK_IMPORTED_MODULE_7__common_analytics_resultAnalytics__["b" /* reportProductClick */].bind(null, item, rank, currentSite);
    var reportProductAddToCartAttemptHandler = __WEBPACK_IMPORTED_MODULE_7__common_analytics_resultAnalytics__["c" /* reportProductAddToCartAttempt */].bind(null, item, rank, currentSite);
    var nonFavoriteCollections = Object.keys(collections).map(function (collectionID) {
      return collections[collectionID];
    }).filter(function (collection) {
      return collection.special_role !== 'favorite';
    });
    var isItemInFavorites = collections[favoriteCollectionID] && collections[favoriteCollectionID].bookmarks[item.id] && collections[favoriteCollectionID].bookmarks[item.id].optimisticStatus !== 'deleted';
    var enhancedItem = formattedItem(item, {
      ui: {
        isInFavourites: isItemInFavorites,
        isInBookmarks: nonFavoriteCollections.some(function (collection) {
          return collection.bookmarks[item.id];
        }),
        isInCart: cartItems.some(function (cartItemId) {
          return cartItemId.item_id === item.id;
        }),
        smallPreviewUrl: getItemSmallPreviewUrl(item),
        footerLink: getFooterLink(item, currentSite)
      }
    });
    var onAddToFavourites = function onAddToFavourites(event) {
      event.preventDefault();
      if (signedOut) {
        window.location = '//' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_utils_sites__["a" /* getCurrentSiteDomain */])(currentSite) + '/sign_in?action_name=favorite&resource_id=' + item.id + '&return_to=' + window.location.pathname + window.location.search;
      } else {
        // check whether user has favorite collection
        if (favoriteCollectionID) {
          if (isItemInFavorites) {
            var bookmark = collections[favoriteCollectionID].bookmarks[item.id];
            if (bookmark.id && bookmark.optimisticStatus !== 'pending') {
              var isFavouriteCollection = true;
              deleteBookmark(favoriteCollectionID, item.id, bookmark.id, isFavouriteCollection);
            }
          } else {
            var _isFavouriteCollection = true;
            addBookmark(favoriteCollectionID, item.id, _isFavouriteCollection);
          }
        } else {
          createFavoriteCollection().then(function (action) {
            if (action && action.type === 'createCollectionSuccess') {
              var newCollectionId = action.payload.id;
              // this is used for ga tracking so we know it's add to favourite collection
              var _isFavouriteCollection2 = true;
              return addBookmark(newCollectionId, item.id, _isFavouriteCollection2);
            }
          }).catch(__WEBPACK_IMPORTED_MODULE_8__common_utils_errors__["a" /* logError */]);
        }
      }
    };
    var onAddToCollections = function onAddToCollections(event) {
      event.preventDefault();
      if (signedOut) {
        window.location = '//' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_utils_sites__["a" /* getCurrentSiteDomain */])(currentSite) + '/sign_in?action_name=collection&resource_id=' + item.id + '&return_to=' + window.location.pathname + window.location.search;
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_analytics_resultAnalytics__["d" /* reportModalPageView */])({
          title: 'Modal: Add item to collection',
          page: window.location.pathname + '/add-item-to-collection' + window.location.search
        });
        openModal({
          type: 'addItemToCollection',
          payload: {
            item: item
          }
        });
      }
    };
    var onAddToCart = function onAddToCart(event) {
      event.preventDefault();
      reportProductAddToCartAttemptHandler();

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_analytics_resultAnalytics__["d" /* reportModalPageView */])({
        title: 'Modal: Customize item before adding to cart',
        page: window.location.pathname + '/customize-item-before-adding-to-cart' + window.location.search
      });
      openModal({
        type: 'addItemToCart',
        payload: {
          item: enhancedItem
        }
      });
    };

    return {
      item: enhancedItem,
      rank: rank,
      onItemLinkClick: reportProductClickHandler,
      onAddToCart: onAddToCart,
      onAddToFavourites: onAddToFavourites,
      onAddToCollections: onAddToCollections
    };
  };
};

/***/ }),
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);



var createMarkup = function createMarkup() {
  var markup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (typeof markup !== 'string') {
    throw new Error('must have a single html string as a child.');
  }
  return { __html: '' + markup };
};

var InnerHtml = function InnerHtml(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? null : _ref$className,
      children = _ref.children;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: className, dangerouslySetInnerHTML: createMarkup(children) });
};

InnerHtml.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (InnerHtml);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'element-corner--triangle -position-left -color-trending' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'e-icon -icon-bolt' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'e-icon__alt' },
        'Trending'
      )
    )
  );
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validSortByOptions; });
/* unused harmony export validSortDirectionOptions */
/* unused harmony export validDateOptions */
/* unused harmony export validSizesOptions */
/* unused harmony export validOrientationOptions */
/**
 * A list of all the search query that public search api accepts
 */
/* harmony default export */ __webpack_exports__["b"] = (['term', 'site', 'tags', 'category', 'platform', 'compatible_with', 'colors', 'sizes', 'sales', 'rating_min', 'price_min', 'price_max', 'poly_count', 'file_formats', 'item_type', 'suggest', 'date', 'length_min', 'length_max', 'tempo', 'alpha', 'vocals_in_audio', 'looped', 'orientation', 'requires_plugins', 'resolution_min', 'frame_rate', 'page', 'page_size', 'attribute_key', 'attribute_value', 'username', 'sort_by', 'sort_direction', 'item_id', 'metadata', 'include_pro_affiliated']);

var validSortByOptions = ['relevance', 'rating', 'sales', 'price', 'date', 'updated', 'category', 'name', 'trending'];

var validSortDirectionOptions = ['asc', 'desc'];

var validDateOptions = ['this-year', 'this-month', 'this-week', 'this-day'];

var validSizesOptions = ['m', 'l', 'xl', 'xxl'];

var validOrientationOptions = ['landscape', 'portrait', 'square'];

/***/ }),
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return showMoreThreshold; });
var showMoreThreshold = {
  category: 10,
  tags: 12,
  compatible_with: 12,
  platform: 12,
  file_formats: 12
};



/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchStats */
/* unused harmony export setCurrentSite */
/* unused harmony export setBaseUrl */
/* unused harmony export setMenuConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return showAlert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hideAlert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return resetAlerts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setErrorPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return resetErrorPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return noIndex; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_axios_axiosVerbose__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_errors__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_sites_menus__ = __webpack_require__(331);




var CACHED_STATS = null;

var fetchStats = function fetchStats(_ref) {
  var apiUrlPrefix = _ref.apiUrlPrefix;

  return function (dispatch, getState) {
    var state = getState();
    if (state.common.stats) {
      return;
    }

    if (CACHED_STATS) {
      return dispatch({
        type: 'receiveStats',
        payload: CACHED_STATS
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0__utils_axios_axiosVerbose__["a" /* default */].get(apiUrlPrefix + '/shopfront_api/stat').then(function (response) {
      CACHED_STATS = response.data;

      return dispatch({
        type: 'receiveStats',
        payload: response.data
      });
    }).catch(function (err) {
      return Promise.reject(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_errors__["a" /* logError */])(err));
    }).catch(function () {
      return dispatch({
        type: 'receiveStatsError',
        error: true
      });
    });
  };
};

var setCurrentSite = function setCurrentSite(currentSite) {
  return {
    type: 'setCurrentSite',
    payload: currentSite
  };
};

var setBaseUrl = function setBaseUrl(baseUrl) {
  return {
    type: 'setBaseUrl',
    payload: baseUrl
  };
};

var setMenuConfig = function setMenuConfig(currentSite) {
  return {
    type: 'setMenuConfig',
    payload: __WEBPACK_IMPORTED_MODULE_2__config_sites_menus__["a" /* default */][currentSite] || []
  };
};

var showAlert = function showAlert(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'warning';
  var canBeDismissed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  return {
    type: 'showAlert',
    payload: {
      message: message,
      type: type,
      canBeDismissed: canBeDismissed
    }
  };
};

var hideAlert = function hideAlert(message) {
  return {
    type: 'hideAlert',
    payload: {
      message: message
    }
  };
};

var resetAlerts = function resetAlerts() {
  return {
    type: 'resetAlerts'
  };
};

var setErrorPage = function setErrorPage(id) {
  return {
    type: 'setErrorPage',
    payload: {
      id: id
    }
  };
};

var resetErrorPage = function resetErrorPage() {
  return {
    type: 'resetErrorPage'
  };
};

var noIndex = function noIndex() {
  return {
    type: 'noIndex'
  };
};

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return reportItemAddedToFavourite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reportItemRemovedFromFavourite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return reportItemAddedToCollection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reportItemRemovedFromCollection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reportCollectionCreated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setGAUserID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return reportModalPageView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_ga__ = __webpack_require__(33);


var reportItemAddedToFavourite = function reportItemAddedToFavourite(itemID) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["a" /* default */])('send', 'event', 'Item', 'click', 'favourite: added', itemID);
};

var reportItemRemovedFromFavourite = function reportItemRemovedFromFavourite(itemID) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["a" /* default */])('send', 'event', 'Item', 'click', 'favourite: removed', itemID);
};

var reportItemAddedToCollection = function reportItemAddedToCollection(itemID) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["a" /* default */])('send', 'event', 'Item', 'click', 'collection: added', itemID);
};

var reportItemRemovedFromCollection = function reportItemRemovedFromCollection(itemID) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["a" /* default */])('send', 'event', 'Item', 'click', 'collection: removed', itemID);
};

var reportCollectionCreated = function reportCollectionCreated() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["a" /* default */])('send', 'event', 'Item', 'click', 'collection: created');
};

var setGAUserID = function setGAUserID(id) {
  if (!id) return;

  var idString = id;
  if (typeof id === 'number') {
    idString = id.toString();
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["a" /* default */])('set', 'userId', id);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["a" /* default */])('set', 'dimension1', idString);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["a" /* default */])('send', 'event', 'User Authentication', 'signed-in', 'shopfront');
};

var reportModalPageView = function reportModalPageView(_ref) {
  var title = _ref.title,
      page = _ref.page;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["a" /* default */])('send', {
    hitType: 'pageview',
    page: page,
    title: title
  });
};

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return timeoutRetryRejectionInterceptor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return betterErrorsRejectionInterceptor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_undefsafe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__errors__ = __webpack_require__(16);





var timeoutRetryRejectionInterceptor = function timeoutRetryRejectionInterceptor(err) {
  if (err && err.code === 'ECONNABORTED' && err.config && !err.config.__isRetryRequest) {
    err.config.__isRetryRequest = true;
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()(err.config);
  }
  throw err;
};

var betterErrorsRejectionInterceptor = function betterErrorsRejectionInterceptor(err) {
  if (!err) {
    return null;
  }

  var url = __WEBPACK_IMPORTED_MODULE_1_undefsafe___default()(err, 'config.url');
  var statusCode = __WEBPACK_IMPORTED_MODULE_1_undefsafe___default()(err, 'response.status');
  var endpoint = url && url.split('?')[0];

  if (err.message === 'Network Error') {
    throw __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__errors__["b" /* AxiosNetworkError */])({
      url: url,
      message: err.message
    });
  }

  if (err.code === 'ECONNABORTED' || [408, 504].includes(statusCode)) {
    throw __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__errors__["c" /* AxiosTimeoutError */])({
      endpoint: endpoint,
      url: url,
      statusCode: statusCode,
      code: err.code
    });
  }

  throw __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__errors__["d" /* AxiosError */])({
    endpoint: endpoint,
    url: url,
    statusCode: statusCode,
    statusText: __WEBPACK_IMPORTED_MODULE_1_undefsafe___default()(err, 'response.statusText'),
    httpMethod: __WEBPACK_IMPORTED_MODULE_1_undefsafe___default()(err, 'config.method'),
    responseData: __WEBPACK_IMPORTED_MODULE_1_undefsafe___default()(err, 'response.data')
  });
};

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getUserProfileRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getGuestCartRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return addItemToUserCartRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return editUserCartEntryRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return createUserCartRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return createGuestCartRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return addItemToGuestCartRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return editGuestCartEntryRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deleteBookmarkRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createBookmarkRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createCollectionRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return formatUserResponse; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__ = __webpack_require__(32);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var getUserProfileRequest = function getUserProfileRequest(token) {
  return __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__["a" /* default */].get('/shopfront_api/user', {
    headers: {
      'Authorization': 'Bearer ' + token // eslint-disable-line
    }
  }).then(function (res) {
    return res.data;
  });
};

var getGuestCartRequest = function getGuestCartRequest() {
  return __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__["a" /* default */].get('/shopfront_api/cart');
};

var addItemToUserCartRequest = function addItemToUserCartRequest(token, data) {
  return __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__["a" /* default */].post('/shopfront_api/user/cart/entry', data, {
    headers: {
      'Authorization': 'Bearer ' + token // eslint-disable-line
    }
  }).then(function (res) {
    return res.data;
  });
};

var editUserCartEntryRequest = function editUserCartEntryRequest(token, entryID, data) {
  return __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__["a" /* default */].put('/shopfront_api/user/cart/entry/' + entryID, data, {
    headers: {
      'Authorization': 'Bearer ' + token // eslint-disable-line
    }
  }).then(function (res) {
    return res.data;
  });
};

var createUserCartRequest = function createUserCartRequest(token) {
  return __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__["a" /* default */].post('/shopfront_api/user/cart/', {}, {
    headers: {
      'Authorization': 'Bearer ' + token // eslint-disable-line
    }
  }).then(function (res) {
    return res.data;
  });
};

var createGuestCartRequest = function createGuestCartRequest() {
  return __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__["a" /* default */].post('/shopfront_api/cart/', {}).then(function (res) {
    return res.data;
  });
};

var addItemToGuestCartRequest = function addItemToGuestCartRequest(data) {
  return __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__["a" /* default */].post('/shopfront_api/cart/entry', data).then(function (res) {
    return res.data;
  });
};

var editGuestCartEntryRequest = function editGuestCartEntryRequest(entryID, data) {
  return __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__["a" /* default */].put('/shopfront_api/cart/entry/' + entryID, data).then(function (res) {
    return res.data;
  });
};

var deleteBookmarkRequest = function deleteBookmarkRequest(token, id) {
  return __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__["a" /* default */].delete('/shopfront_api/user/bookmark/' + id, {
    headers: {
      'Authorization': 'Bearer ' + token // eslint-disable-line
    }
  }).then(function (res) {
    return res.data;
  });
};

var createBookmarkRequest = function createBookmarkRequest(token, collectionId, itemId) {
  return __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__["a" /* default */].post('/shopfront_api/user/collection/' + collectionId + '/bookmark', {
    item_id: itemId
  }, {
    headers: {
      'Authorization': 'Bearer ' + token // eslint-disable-line
    }
  }).then(function (res) {
    return res.data;
  });
};

var createCollectionRequest = function createCollectionRequest(token, _ref) {
  var name = _ref.name,
      isPublic = _ref.isPublic,
      description = _ref.description,
      specialRole = _ref.specialRole;

  return __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__["a" /* default */].post('/shopfront_api/user/collection', {
    name: name,
    public: isPublic,
    description: description,
    specialRole: specialRole
  }, {
    headers: {
      'Authorization': 'Bearer ' + token // eslint-disable-line
    }
  }).then(function (res) {
    return res.data;
  });
};

/**
 * Converts a User Api Response to a user object,
 * a list of their collections with bookmarks nested,
 * @param  {Object} the api user response
 * @return {Object} a object with the users info, collections/bookmarks and favorites collection ID
 */
var formatUserResponse = function formatUserResponse(userResponse) {
  try {
    var user = _extends({}, userResponse);

    delete user.collections;
    delete user.bookmarks;
    delete user.cart;
    delete user.misc;

    var collections = userResponse.collections,
        bookmarks = userResponse.bookmarks;


    var newCollections = void 0;

    if (collections && bookmarks) {
      newCollections = collections.reduce(function (prev, collection) {
        prev[collection.id] = collection;
        prev[collection.id].bookmarks = {};
        return prev;
      }, {});
      bookmarks.forEach(function (bookmark) {
        newCollections[bookmark.collection_id].bookmarks[bookmark.item_id] = { id: bookmark.id };
      });
    }

    return {
      profile: user,
      collections: newCollections,
      cart: userResponse.cart,
      misc: userResponse.misc
    };
  } catch (e) {
    console.log('format user response error', e);
  }
};

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  analytics: {
    google_conversion_id: '943617023',
    google_analytics_sandbox_id: 'UA-11834194-31'
  },
  ui: {
    default_user_image_path: '/images/default-user.jpg',
    item_list_views: [{
      value: 'list',
      label: 'List'
    }, {
      value: 'grid',
      label: 'Grid'
    }],
    item_small_preview_paths: ['icon_with_landscape_preview.icon_url', 'icon_with_square_preview.icon_url', 'icon_with_video_preview.icon_url', 'icon_with_audio_preview.icon_url', 'thumbnail_preview.small_url']
  },
  common: {
    search_page_size: 30,
    max_pages_count: 60
  },
  assets_domains: {
    main: 'd2mdw063ttlqtq.cloudfront.net',
    main_alias: '0.s3.envato.com',
    user_profile: 'user-profile.s3.envato.com'
  },
  search_query: {
    defalut_sort_by_options: [{
      label: 'Best match',
      value: 'relevance'
    }, {
      label: 'Trending items',
      value: 'trending'
    }, {
      label: 'Best sellers',
      value: 'sales'
    }, {
      label: 'Best rated',
      value: 'rating'
    }, {
      label: 'Newest items',
      value: 'date'
    }, {
      label: 'Price: low to high',
      value: 'price-asc'
    }, {
      label: 'Price: high to low',
      value: 'price-desc'
    }]
  },
  recommendations_limit: 8
});

/***/ }),
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Dropdown = function (_React$Component) {
  _inherits(Dropdown, _React$Component);

  function Dropdown() {
    _classCallCheck(this, Dropdown);

    return _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).apply(this, arguments));
  }

  _createClass(Dropdown, [{
    key: 'renderOptionTags',
    value: function renderOptionTags() {
      var options = this.props.options;


      return options.map(function (option) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'option',
          { key: option.value, value: option.value },
          option.label
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var props = _extends({}, this.props);
      delete props.options;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'select',
        props,
        this.renderOptionTags()
      );
    }
  }]);

  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

Dropdown.propTypes = {
  options: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array
};
Dropdown.defaultProps = {
  options: []
};


/* harmony default export */ __webpack_exports__["a"] = (Dropdown);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_favorite__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_cart__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_icons_folderOpen__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__itemActions_module_css__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__itemActions_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__itemActions_module_css__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var ItemActions = function ItemActions(_ref) {
  var item = _ref.item,
      onAddToFavourites = _ref.onAddToFavourites,
      onAddToCollections = _ref.onAddToCollections,
      onAddToCart = _ref.onAddToCart,
      _ref$defaultTheme = _ref.defaultTheme,
      defaultTheme = _ref$defaultTheme === undefined ? true : _ref$defaultTheme;

  var favoriteClassNames = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_5__itemActions_module_css___default.a.action, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_5__itemActions_module_css___default.a.active, item.ui.isInFavourites));

  var bookmarkClassNames = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_5__itemActions_module_css___default.a.action, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_5__itemActions_module_css___default.a.active, item.ui.isInBookmarks));

  var cartClassNames = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_5__itemActions_module_css___default.a.action, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_5__itemActions_module_css___default.a.active, item.ui.isInCart));

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: defaultTheme ? __WEBPACK_IMPORTED_MODULE_5__itemActions_module_css___default.a.defaultTheme : null },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_5__itemActions_module_css___default.a.actionsContainer },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        {
          href: '/favorites?item_id=' + item.id,
          onClick: onAddToFavourites,
          title: 'Add to Favorites',
          rel: 'nofollow',
          className: favoriteClassNames
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_favorite__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_5__itemActions_module_css___default.a.icon, style: { verticalAlign: '' }, title: 'Add to Favorites' })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        {
          href: '/bookmarks/widget?item_id=' + item.id,
          onClick: function onClick(event) {
            return onAddToCollections(event);
          },
          title: 'Add to Collection',
          rel: 'nofollow',
          className: bookmarkClassNames
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_icons_folderOpen__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_5__itemActions_module_css___default.a.icon, style: { verticalAlign: '' }, title: 'Add to Collection' })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        {
          className: cartClassNames,
          onClick: onAddToCart,
          href: '/cart/configure_before_adding/' + item.id,
          rel: 'nofollow',
          title: 'Add to Cart'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_icons_cart__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_5__itemActions_module_css___default.a.icon, style: { verticalAlign: '' }, title: 'Add to Cart' })
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ItemActions);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__listDefault__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gridDefault__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__listAudio__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__gridAudio__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gridVideo__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_analytics_videoHiveAnalytics__ = __webpack_require__(653);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };












var ItemCard = function ItemCard(_ref) {
  var viewType = _ref.viewType,
      videoMuted = _ref.videoMuted,
      itemProps = _ref.itemProps,
      currentSite = _ref.currentSite;

  if (viewType === 'grid') {
    if (currentSite === 'audiojungle') {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__gridAudio__["a" /* default */], itemProps);
    } else if (currentSite === 'videohive') {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__gridVideo__["a" /* default */], _extends({
        reportVideoProgress: __WEBPACK_IMPORTED_MODULE_6__common_analytics_videoHiveAnalytics__["a" /* reportVideoProgress */],
        muted: videoMuted
      }, itemProps));
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__gridDefault__["a" /* default */], itemProps);
  }

  if (currentSite === 'audiojungle') {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__listAudio__["a" /* default */], itemProps);
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__listDefault__["a" /* default */], itemProps);
};

/* harmony default export */ __webpack_exports__["a"] = (ItemCard);

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omit__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils_urlHelper__ = __webpack_require__(5);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var SearchBarFormPure = function SearchBarFormPure(props) {
  var location = props.location,
      history = props.history,
      children = props.children;

  var passProps = __WEBPACK_IMPORTED_MODULE_1_lodash_omit___default()(props, ['location', 'router', 'onSubmit', 'role', 'method', 'action', 'match', 'history', 'staticContext']);

  var onSubmit = function onSubmit(event) {
    event.preventDefault();

    // get query from form
    var form = event.target;
    var query = {};
    Array.prototype.slice.call(form.elements).filter(function (el) {
      return el.getAttribute('name') && el.value;
    }).forEach(function (el) {
      query[el.getAttribute('name')] = el.value;
    });

    // only update query inside the from and keep the existing one
    var nextQuery = Object.assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_utils_urlHelper__["a" /* parseLocation */])(location), query);

    // remove page param when do search
    delete nextQuery.page;

    history.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_utils_urlHelper__["b" /* makeLink */])(nextQuery));
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'form',
    _extends({ role: 'search', method: 'get', action: '/search', onSubmit: onSubmit }, passProps),
    children
  );
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* withRouter */])(SearchBarFormPure));

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setActiveAudio; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_undefsafe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_common__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_errors__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_getProxyApiUrl__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_axios_axiosVerbose__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_search_fetchRecommendedSearchesByTermResults__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_search_fetchRecommendedSearchesByCategoryResults__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_urlHelper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__search_setStudioRecommendations__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_sites_studio_recommendations__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_searchQueryHelper__ = __webpack_require__(675);














var fetchSearchResults = function fetchSearchResults(parsedUrl, opts) {
  return function (dispatch, getState) {
    var parsedLocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_urlHelper__["a" /* parseLocation */])({
      pathname: parsedUrl.pathname,
      query: __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.parse(parsedUrl.search)
    });

    var currentSite = __WEBPACK_IMPORTED_MODULE_0_undefsafe___default()(getState(), 'common.currentSite') || 'themeforest';
    var apiUrlPrefix = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_getProxyApiUrl__["a" /* default */])(opts);
    var searchStringQuery = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_searchQueryHelper__["a" /* buildSearchQueryString */])(parsedLocation, currentSite);
    var hasItemId = parsedLocation.item_id;
    var hasSearchTerm = parsedLocation.term;

    var searchUrl = hasItemId ? apiUrlPrefix + '/shopfront_api/search/similar?' + searchStringQuery : apiUrlPrefix + '/shopfront_api/search?' + searchStringQuery;

    dispatch(fetchSearchResultsRequest());

    if (hasSearchTerm && !hasItemId) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__actions_search_fetchRecommendedSearchesByTermResults__["a" /* default */])(parsedLocation.term, {
        apiUrlPrefix: apiUrlPrefix
      }));
    }

    return __WEBPACK_IMPORTED_MODULE_5__utils_axios_axiosVerbose__["a" /* default */].get(searchUrl).then(function (res) {
      if (res.data && res.data.matches && !res.data.error) {
        var results = Object.assign({}, res.data, {
          term: parsedLocation.term
        });

        dispatch(fetchSearchResultsSuccess(results));
        dispatch(fetchIngestedContentSuccess(res.data.searchIngestedContent));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__search_setStudioRecommendations__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_10__config_sites_studio_recommendations__["a" /* default */][currentSite] || {}));

        // process other types of recommendations if term is not present
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_searchQueryHelper__["b" /* isCategoryOnlySearch */])(parsedLocation)) {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__actions_search_fetchRecommendedSearchesByCategoryResults__["a" /* default */])(parsedLocation, results, currentSite));
        }

        return dispatch(setSeoData(res.data.metadata));
      } else {
        throw __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_errors__["e" /* ResponseDataError */])({ response: res });
      }
    }).catch(function (err) {
      var isSearchOffline = [422, 500, 502, 503].includes(err.statusCode);
      if (isSearchOffline) {
        throw __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_errors__["f" /* SearchOfflineError */])({
          statusCode: err.statusCode
        });
      }

      throw err;
    }).catch(function (err) {
      return Promise.reject(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_errors__["a" /* logError */])(err));
    }).catch(function (err) {
      return Promise.reject(dispatch(fetchSearchResultsFailure(err)));
    });
  };
};

/**
 * Search result actions
 */
var fetchSearchResultsRequest = function fetchSearchResultsRequest() {
  return { type: 'fetchSearchResultsRequest' };
};
var fetchSearchResultsSuccess = function fetchSearchResultsSuccess(results) {
  return {
    type: 'fetchSearchResultsSuccess',
    payload: {
      results: results
    }
  };
};
var fetchSearchResultsFailure = function fetchSearchResultsFailure(error) {
  return function (dispatch) {
    var timeout = false;

    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions_common__["a" /* noIndex */])());

    if (error.type === 'search.offline') {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions_common__["b" /* setErrorPage */])('SearchOffline'));
    } else {
      if (error.type === 'axios.timeout') {
        timeout = true;
      }
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__actions_common__["c" /* showAlert */])(error.message, 'failure', false));
    }

    return dispatch({
      type: 'fetchSearchResultsFailure',
      error: true,
      httpStatus: 500,
      timeout: timeout
    });
  };
};

/**
 * IngestedContentSuccess
 */
var fetchIngestedContentSuccess = function fetchIngestedContentSuccess(content) {
  return {
    type: 'fetchIngestedContentSuccess',
    payload: {
      content: content
    }
  };
};

/**
 * SEO data
 */
var setSeoData = function setSeoData(seoMeta) {
  return {
    type: 'setSeoData',
    payload: {
      seoMeta: seoMeta
    }
  };
};

var setActiveAudio = function setActiveAudio(activeAudio) {
  return {
    type: 'setActiveAudio',
    payload: {
      activeAudio: activeAudio
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (fetchSearchResults);

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_auth__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_errors__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__session__ = __webpack_require__(192);




/**
 * Handle auth error middleware
 */
/* harmony default export */ __webpack_exports__["a"] = (function (next) {
  return function (dispatch) {
    // token expired, let's try get session again.
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__session__["a" /* getSessionRequestAction */])());
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_auth__["a" /* getSession */])().then(function (res) {
      return res.data.token;
    }).then(function (jwtToken) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__session__["b" /* getSessionSuccessAction */])(jwtToken));
      dispatch(next);
    }).catch(__WEBPACK_IMPORTED_MODULE_1__utils_errors__["a" /* logError */]);
  };
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return initUserSearchResultsViewType; });
/* unused harmony export initServerUserSearchResultsViewType */
/* unused harmony export getUserSearchResultsViewType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setUserSearchResultsViewType; });
/* unused harmony export setServerUserSearchResultsViewType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getUserVideoPlayerStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setUserVideoPlayerStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);


var initUserSearchResultsViewType = function initUserSearchResultsViewType(location) {
  return function (dispatch, getState) {
    // if there is view parameter for initial rendering, set view type to cookie
    if (location && location.query.view) {
      dispatch(setUserSearchResultsViewType(location.query.view));
    } else {
      dispatch(getUserSearchResultsViewType(getState().user.preferences.searchResultsViewType));
    }
  };
};

var initServerUserSearchResultsViewType = function initServerUserSearchResultsViewType(location) {
  return function (dispatch, getState) {
    // if there is view parameter for initial rendering, set view type to cookie
    if (location && location.query.view) {
      dispatch(setServerUserSearchResultsViewType(location.query.view));
    }
  };
};

var getUserSearchResultsViewType = function getUserSearchResultsViewType(defaultView) {
  var view = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('search-view-mode-preference') || defaultView;
  return { type: 'getUserSearchResultsViewType', payload: { view: view } };
};

var setUserSearchResultsViewType = function setUserSearchResultsViewType(nextView) {
  __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('search-view-mode-preference', nextView);
  return { type: 'setUserSearchResultsViewType', payload: { view: nextView } };
};

var setServerUserSearchResultsViewType = function setServerUserSearchResultsViewType(nextView) {
  return { type: 'setUserSearchResultsViewType', payload: { view: nextView } };
};

var getUserVideoPlayerStatus = function getUserVideoPlayerStatus() {
  var key = 'search_videos_muted';
  if (window.localStorage && window.localStorage.getItem(key)) {
    return {
      type: 'getUserVideoPlayerStatus',
      payload: {
        type: window.localStorage.getItem(key) === 'true'
      }
    };
  } else {
    return {
      type: 'nullAction'
    };
  }
};

var setUserVideoPlayerStatus = function setUserVideoPlayerStatus(type) {
  if (window.localStorage) {
    var key = 'search_videos_muted';
    window.localStorage.setItem(key, type);
    return { type: 'setUserVideoPlayerStatus', payload: { type: type } };
  } else {
    return {
      type: 'nullAction'
    };
  }
};

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSessionRequestAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSessionSuccessAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSessionFailureAction; });
/**
 * Get user session actions
 */
var getSessionRequestAction = function getSessionRequestAction() {
  return { type: 'getSessionRequest' };
};
var getSessionSuccessAction = function getSessionSuccessAction(jwtToken) {
  return {
    type: 'getSessionSuccess',
    payload: { token: jwtToken }
  };
};
var getSessionFailureAction = function getSessionFailureAction() {
  return { type: 'getSessionFailure' };
};

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return allDomains; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return siteNames; });
var allDomains = ['activeden.net', 'audiojungle.net', 'themeforest.net', 'videohive.net', 'graphicriver.net', '3docean.net', 'codecanyon.net', 'photodune.net', 'market.envato.com', 'market.styleguide.envato.com', 'elements.envato.com', 'build.envatohostedservices.com', 'author.envato.com'];

// The order of exported sites determines the order of logotypes
// in the header.
var siteNames = ['themeforest', 'codecanyon', 'videohive', 'audiojungle', 'graphicriver', 'photodune', '3docean'];

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isServer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isProduction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isDevelopment; });
/**
 * A helper function to decide the current env, ie browser/server.
 * @return {Boolean} true/false
 */
var isServer = function isServer() {
  return false === true; // eslint-disable-line
};

/**
 * A helpful funciton to decide the current env, ie production/development
 * @return {Boolean} true/false
 */
var isProduction = function isProduction() {
  return "production" === 'production';
};

var isDevelopment = function isDevelopment() {
  return "production" === 'development';
};

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__errors__ = __webpack_require__(16);



var legacyAffiliates = function legacyAffiliates(location) {
  __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__["a" /* default */].get('/shopfront_api/affiliate/legacy?location=' + escape(location.href)).then(function (res) {
    if (res.data && res.data.redirect) {
      window.location = res.data.redirect_url;
    }
  }).catch(__WEBPACK_IMPORTED_MODULE_1__errors__["a" /* logError */]);
};

/* harmony default export */ __webpack_exports__["a"] = (legacyAffiliates);

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Generates fingerprint based on error object
 * @param {Error} error
 * @return {String}
 */
/* harmony default export */ __webpack_exports__["a"] = (function (error) {
  var name = error.name || '';
  var message = error.message || '';
  var level = error.level || '';
  var hashBase = level + name + message;

  if (!name && !message) {
    return null;
  }

  return hashBase;
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rollbarIsomorphic = void 0;

if (false) {
  rollbarIsomorphic = require('./rollbar.test.js').default;
} else if (false) {
  rollbarIsomorphic = require('./rollbar.development.js').default;
} else {
  if (false) {
    // eslint-disable-line
    rollbarIsomorphic = require('./rollbar.server.js').default;
  } else {
    rollbarIsomorphic = __webpack_require__(198).default;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (rollbarIsomorphic);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rollbar_browser__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rollbar_browser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rollbar_browser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fingerprint__ = __webpack_require__(196);





var rollbarClientSideToken = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].analytics.rollbar.CLIENT_SIDE_TOKEN;
var ignoredDomains = ['js.intercomcdn.com'];

var payload = {
  environment: 'shopfront-' + "production"
};

// this `GIT_COMMIT_SHA` is generated from `webpack.client.config.js`
// and defined from DefinePlugin
if (true) {
  // eslint-disable-line
  payload.client = {
    javascript: {
      source_map_enabled: true,
      code_version: "d1dc7533d7c1d0ffb50340b3caadfeb0fe1f66bb", // eslint-disable-line
      guess_uncaught_frames: true
    }
  };
}

var escapeRegExp = function escapeRegExp(text) {
  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
};

var rollbarClient = __WEBPACK_IMPORTED_MODULE_0_rollbar_browser___default.a.init({
  accessToken: rollbarClientSideToken,
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: payload,
  ignoredMessages: [
  // File "(unknown)" line (unknown) in [anonymous] -- not helpful (CORS uncaught error, 3rd party libraries)
  'Script error',
  // Seems to be chrome bug, happening only on iphone or ipad - https://bugs.chromium.org/p/chromium/issues/detail?id=590375
  '__gCrWeb.autofill.extractForms',
  // Firefox error, not helpful 'Exception... "<no message>" nsresult: "0x805e0006 (<unknown>)" location: "JS frame'
  // seems to be related to web sockets, happens only for some users, not able to reproduce: https://bugzilla.mozilla.org/show_bug.cgi?id=977020
  'NS_ERROR_UNEXPECTED',
  // https://github.com/getsentry/raven-js/issues/756
  escapeRegExp('null is not an object (evaluating \'elt.parentNode\')')],
  checkIgnore: function checkIgnore(isUncaught, args, payload) {
    // args holds arguments passed to rollbar methods with error level. For example for call: rollbar.error('some message', err)
    // args[0] = 'error'; args[1] = 'some message'; args[2] = err
    var error = args && args[2] || {};
    var stack = error.stack || '';

    return ignoredDomains.some(function (ignoredDomain) {
      return stack.indexOf(ignoredDomain) !== -1;
    });
  }
});

// rollbar global config
rollbarClient.global({
  // Max number of items to report per minute.
  itemsPerMinute: 15,
  // Max number of items to report per page load.
  maxItems: 20
});

var rollbarClientProxy = {
  info: function info(msg, data) {
    rollbarClient.info(msg, data);
  },
  debug: function debug(msg, data) {
    rollbarClient.debug(msg, data);
  },
  warning: function warning(msg, exception, data) {
    rollbarClient.scope({ fingerprint: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__fingerprint__["a" /* default */])(exception) }).warning(msg, exception, {
      details: exception,
      data: data
    });
  },
  error: function error(msg, exception, data) {
    rollbarClient.scope({ fingerprint: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__fingerprint__["a" /* default */])(exception) }).error(msg, exception, {
      details: exception,
      data: data
    });
  },
  critical: function critical(msg, exception, data) {
    rollbarClient.scope({ fingerprint: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__fingerprint__["a" /* default */])(exception) }).critical(msg, exception, {
      details: exception,
      data: data
    });
  }
};

/* harmony default export */ __webpack_exports__["default"] = (rollbarClientProxy);

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: '3DOcean',
  abbreviation: '3D',
  domain: '3docean.net',
  google_analytics_id: 'UA-11834194-2',
  google_remarketing_label: '24jqCK2CugMQp-WC_AM',
  default_category_view: 'list',
  filters: {
    aggregations: {
      poly_count: {
        min: 4000,
        max: 10000,
        avg: 5000
      }
    }
  },
  assets_domains: {
    item_thumbnail: 'thumb-3do.s3.envato.com',
    item_image: 'image-3do.s3.envato.com'
  },
  feeds_categories: ['/category/3d-models', '/category/cg-textures', '/category/materials-and-shaders', '/category/scripts-and-plugins', '/category/2d-concepts', '/category/animation-data', '/category/render-setups']
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AudioJungle',
  abbreviation: 'AJ',
  domain: 'audiojungle.net',
  google_analytics_id: 'UA-11834194-4',
  google_remarketing_label: 'SQ7NCLWBugMQp-WC_AM',
  default_category_view: 'list',
  assets_domains: {
    item_thumbnail: 'thumb-aj.s3.envato.com',
    item_image: 'image-aj.s3.envato.com'
  },
  feeds_categories: ['/category/music', '/category/music-packs', '/category/music-kits', '/category/sound', '/category/source-files', '/category/logos-idents']
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CodeCanyon',
  abbreviation: 'CC',
  domain: 'codecanyon.net',
  google_analytics_id: 'UA-11834194-12',
  google_remarketing_label: 'bdtlCM3-uQMQp-WC_AM',
  default_category_view: 'list',
  assets_domains: {
    item_thumbnail: 'thumb-cc.s3.envato.com',
    item_image: 'image-cc.s3.envato.com'
  },
  feeds_categories: ['/category/javascript', '/category/php-scripts', '/category/net', '/category/wordpress', '/category/plugins', '/category/css', '/category/html5', '/category/mobile', '/category/apps', '/category/skins', '/category/edge-animate-templates']
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GraphicRiver',
  abbreviation: 'GR',
  domain: 'graphicriver.net',
  google_analytics_id: 'UA-11834194-6',
  google_remarketing_label: 'hJ8ZCL2AugMQp-WC_AM',
  default_category_view: 'grid',
  assets_domains: {
    item_thumbnail: 'thumb-gr.s3.envato.com',
    item_image: 'image-gr.s3.envato.com'
  },
  feeds_categories: ['/category/graphics', '/category/print-templates', '/category/epublishing', '/category/textures', '/category/vectors', '/category/infographics', '/category/add-ons', '/category/isolated-objects', '/category/icons', '/category/presentation-templates', '/category/fonts', '/category/web-elements', '/category/logo-templates', '/category/t-shirts', '/category/game-assets']
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PhotoDune',
  abbreviation: 'PD',
  domain: 'photodune.net',
  google_analytics_id: 'UA-11834194-35',
  google_remarketing_label: 'rsMOCJ2EugMQp-WC_AM',
  default_category_view: 'grid',
  ui: {
    item_list_views: [{
      value: 'grid',
      label: 'Grid'
    }]
  },
  assets_domains: {
    item_thumbnail: 'thumb-pd.s3.envato.com',
    item_image: 'image-pd.s3.envato.com'
  },
  item_view: {
    footer_link: {
      label: 'Similar images',
      href: '/search?item_id={id}'
    }
  }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ThemeForest',
  abbreviation: 'TF',
  domain: 'themeforest.net',
  google_analytics_id: 'UA-11834194-7',
  google_remarketing_label: 'u-J6CI3SqQMQp-WC_AM',
  default_category_view: 'list',
  assets_domains: {
    item_thumbnail: 'thumb-tf.s3.envato.com',
    item_image: 'image-tf.s3.envato.com'
  },
  feeds_categories: ['/category/wordpress', '/category/site-templates', '/category/marketing', '/category/cms-themes', '/category/ecommerce', '/category/muse-templates', '/category/sketch-templates', '/category/psd-templates', '/category/blogging', '/category/courses', '/category/forums', '/category/typeengine-themes']
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VideoHive',
  abbreviation: 'VH',
  domain: 'videohive.net',
  google_analytics_id: 'UA-11834194-8',
  google_remarketing_label: 'NrSdCMX_uQMQp-WC_AM',
  default_category_view: 'list',
  assets_domains: {
    item_thumbnail: 'thumb-vh.s3.envato.com',
    item_image: 'image-vh.s3.envato.com'
  },
  feeds_categories: ['/category/after-effects-project-files', '/category/apple-motion-templates', '/category/motion-graphics', '/category/stock-footage', '/category/cinema-4d-templates', '/category/add-ons']
});

/***/ }),
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FiltersBooleanBody */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isUndefined__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils_formatString__ = __webpack_require__(56);







var FiltersBooleanBody = function FiltersBooleanBody(_ref) {
  var name = _ref.name,
      label = _ref.label,
      onChange = _ref.onChange,
      isChecked = _ref.isChecked,
      isAtBottom = _ref.isAtBottom,
      count = _ref.count,
      icon = _ref.icon;

  icon = icon || name;
  var id = name + '-filter';
  var boxClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
    'search-facet-box': !isAtBottom,
    'search-facet-box--end': isAtBottom
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'search-facet--no-margin', id: id },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: boxClass },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'search-facet-box__inner' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          { className: 'search-facet-box__heading' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'e-icon -icon-' + icon + ' -margin-right' }),
          label
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'label',
          { className: 'search-facet-boolean' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'checkbox', name: name, value: '1', checked: isChecked, onChange: onChange }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'search-facet-boolean__label' },
            'Yes'
          ),
          !__WEBPACK_IMPORTED_MODULE_3_lodash_isUndefined___default()(count) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'search-facet-result-count' },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_utils_formatString__["b" /* commaStyleString */])(count)
          )
        )
      )
    )
  );
};

FiltersBooleanBody.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  isChecked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isAtBottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  count: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

/* harmony default export */ __webpack_exports__["a"] = (FiltersBooleanBody);

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__panelFooter__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__panelBody__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__panelHeader__ = __webpack_require__(541);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var FiltersSingleSelectPanel = function (_React$Component) {
  _inherits(FiltersSingleSelectPanel, _React$Component);

  function FiltersSingleSelectPanel(props) {
    _classCallCheck(this, FiltersSingleSelectPanel);

    var _this = _possibleConstructorReturn(this, (FiltersSingleSelectPanel.__proto__ || Object.getPrototypeOf(FiltersSingleSelectPanel)).call(this, props));

    _this.state = {
      isExpanded: false
    };

    _this.toggleOption = _this.toggleOption.bind(_this);
    return _this;
  }

  _createClass(FiltersSingleSelectPanel, [{
    key: 'toggleOption',
    value: function toggleOption(event) {
      event.preventDefault();
      this.setState({
        isExpanded: !this.state.isExpanded
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var isExpanded = this.state.isExpanded;
      var _props = this.props,
          items = _props.items,
          showPanel = _props.showPanel,
          togglePanel = _props.togglePanel,
          rootCount = _props.rootCount,
          parsedLocation = _props.parsedLocation,
          type = _props.type,
          breadcrumbsLabel = _props.breadcrumbsLabel;

      var isExpandable = items.length > __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* showMoreThreshold */][type];

      var panelBodyClassNames = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('search-facet-panel__body', {
        'is-active': showPanel
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: panelBodyClassNames },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'search-facet-panel__body-inner' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'button',
            { className: 'search-facet-panel__body-close fds-c-button', onClick: togglePanel },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'i',
              { className: 'e-icon -icon-cancel' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { className: 'e-icon__alt' },
                'Close'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__panelHeader__["a" /* default */], {
            togglePanel: togglePanel,
            parsedLocation: parsedLocation,
            rootCount: rootCount,
            type: type,
            breadcrumbsLabel: breadcrumbsLabel
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__panelBody__["a" /* default */], {
            isExpandable: isExpandable,
            isExpanded: isExpanded,
            togglePanel: togglePanel,
            parsedLocation: parsedLocation,
            items: items,
            type: type
          }),
          isExpandable && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__panelFooter__["a" /* default */], {
            isExpandable: isExpandable,
            isExpanded: isExpanded,
            moreOptionCount: items.length - __WEBPACK_IMPORTED_MODULE_3__utils__["a" /* showMoreThreshold */][type],
            toggleOption: this.toggleOption,
            togglePanel: togglePanel
          })
        )
      );
    }
  }]);

  return FiltersSingleSelectPanel;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

FiltersSingleSelectPanel.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired,
  parsedLocation: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  showPanel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
  togglePanel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  rootCount: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  breadcrumbsLabel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (FiltersSingleSelectPanel);

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 512 512' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Pause' },
      props.title || 'Pause'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M224 435.8v-359.7c0-6.7-5.4-12.1-12.2-12.1h-71.6c-6.8 0-12.2 5.4-12.2 12.1v359.7c0 6.7 5.4 12.2 12.2 12.2h71.6c6.8 0 12.2-5.4 12.2-12.2zM371.8 64h-71.6c-6.7 0-12.2 5.4-12.2 12.1v359.7c0 6.7 5.4 12.2 12.2 12.2h71.6c6.7 0 12.2-5.4 12.2-12.2v-359.7c0-6.7-5.4-12.1-12.2-12.1z' })
    )
  );
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 512 512' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Play' },
      props.title || 'Play'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M255.5 5C116.6 5 4 117.6 4 256.5 4 395.41 116.6 508 255.5 508S507 395.4 507 256.5 394.4 5 255.5 5m119.3 264.99l-172.98 98.6c-13.03 7.44-23.69 1.36-23.69-13.48V157.9c0-14.84 10.66-20.91 23.69-13.49L374.8 243c13 7.43 13 19.57 0 26.99' })
    )
  );
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 512 512' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Spinner' },
      props.title || 'Spinner'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M169.9 408c0 12.7-4.5 23.4-13.5 32.3s-19.7 13.3-32.1 13.3c-12.7 0-23.4-4.4-32.3-13.3S78.7 420.6 78.7 408s4.4-23.4 13.3-32.3c8.9-8.9 19.6-13.3 32.3-13.3 12.5 0 23.2 4.4 32.1 13.3 9 8.8 13.5 19.6 13.5 32.3zm136.7 60.7c0 11.2-4 20.7-11.9 28.6-7.9 7.9-17.5 11.9-28.6 11.9-11.2 0-20.7-4-28.6-11.9-7.9-7.9-11.9-17.5-11.9-28.6 0-11.2 4-20.7 11.9-28.6 7.9-7.9 17.5-11.9 28.6-11.9 11.2 0 20.7 4 28.6 11.9 8 7.9 11.9 17.5 11.9 28.6zM114.2 266.1c0 13.9-5 25.9-14.9 35.8s-21.8 14.9-35.8 14.9c-13.9 0-25.9-5-35.8-14.9s-14.9-21.8-14.9-35.8 5-25.9 14.9-35.8c9.9-9.9 21.8-14.9 35.8-14.9 13.9 0 25.9 5 35.8 14.9s14.9 21.9 14.9 35.8zM443.4 408c0 9.7-3.5 18-10.4 25-7 7-15.3 10.5-25 10.4-9.7 0-18.1-3.5-25-10.4s-10.4-15.3-10.4-25 3.5-18.1 10.4-25c7-6.9 15.3-10.4 25-10.4s18.1 3.5 25 10.4c6.9 6.9 10.4 15.3 10.4 25zM180 124.3c0 15.4-5.4 28.5-16.3 39.4-10.9 10.9-24 16.3-39.4 16.3-15.4 0-28.5-5.4-39.4-16.3-10.9-10.9-16.3-24-16.3-39.4S74 95.8 84.9 84.9s24-16.3 39.4-16.3 28.5 5.4 39.4 16.3c10.9 10.9 16.3 24 16.3 39.4zm146.9-60.8c0 16.9-5.9 31.2-17.7 43.1s-26.2 17.7-43.1 17.7-31.2-5.9-43.1-17.7c-11.8-11.8-17.7-26.2-17.7-43.1 0-16.9 5.9-31.2 17.7-43.1 11.8-11.8 26.2-17.7 43.1-17.7s31.2 5.9 43.1 17.7 17.7 26.2 17.7 43.1zm172.2 202.6c0 8.4-3 15.6-8.9 21.5s-13.1 8.9-21.5 8.9-15.6-3-21.5-8.9-8.9-13.1-8.9-21.5 3-15.6 8.9-21.5 13.1-8.9 21.5-8.9 15.6 3 21.5 8.9c6 5.9 8.9 13.1 8.9 21.5zm-65.8-141.8c0 7-2.5 12.9-7.4 17.9-5 5-10.9 7.4-17.9 7.4-7 0-12.9-2.5-17.9-7.4-5-5-7.4-10.9-7.4-17.9s2.5-12.9 7.4-17.9c5-5 10.9-7.4 17.9-7.4 7 0 12.9 2.5 17.9 7.4 4.9 5 7.4 10.9 7.4 17.9z' })
    )
  );
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_undefsafe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__videoLoader__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__magnifier__ = __webpack_require__(571);






var MagnifierConfigurator = function MagnifierConfigurator(_ref) {
  var item = _ref.item;

  var previews = item.previews;

  var getMagnifier = function getMagnifier() {
    if (__WEBPACK_IMPORTED_MODULE_1_undefsafe___default()(previews, 'icon_with_square_preview.square_url')) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__magnifier__["a" /* default */],
        { item: item, width: 300, height: 300 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: previews.icon_with_square_preview.square_url })
      );
    }

    if (__WEBPACK_IMPORTED_MODULE_1_undefsafe___default()(previews, 'icon_with_thumbnail_preview.thumbnail_url')) {
      var width = previews.icon_with_thumbnail_preview.thumbnail_width || 300;
      var height = previews.icon_with_thumbnail_preview.thumbnail_height || 300;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__magnifier__["a" /* default */],
        { item: item, width: width, height: height },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: previews.icon_with_thumbnail_preview.thumbnail_url })
      );
    }

    if (__WEBPACK_IMPORTED_MODULE_1_undefsafe___default()(previews, 'icon_with_video_preview.video_url')) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__magnifier__["a" /* default */],
        { item: item, width: 477, height: 264 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__videoLoader__["a" /* default */], {
          autoPlay: true,
          loop: true,
          src: previews.icon_with_video_preview.video_url,
          poster: previews.icon_with_video_preview.landscape_url })
      );
    }

    if (__WEBPACK_IMPORTED_MODULE_1_undefsafe___default()(previews, 'icon_with_landscape_preview.landscape_url')) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__magnifier__["a" /* default */],
        { item: item, width: 477, height: 240 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: previews.icon_with_landscape_preview.landscape_url })
      );
    }

    return null;
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'fds-u-hide-small-and-below' },
    getMagnifier()
  );
};

/* harmony default export */ __webpack_exports__["a"] = (MagnifierConfigurator);

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_undefsafe__);




var renderMatrix = function renderMatrix(_ref) {
  var itemMatrix = _ref.itemMatrix,
      selectedMatrixLicense = _ref.selectedMatrixLicense,
      selectedMatrixSupport = _ref.selectedMatrixSupport,
      showChangeDetailsLink = _ref.showChangeDetailsLink,
      goToEditScreen = _ref.goToEditScreen,
      cartEntry = _ref.cartEntry;

  var hasItemSupport = itemMatrix && Object.keys(itemMatrix).some(function (license) {
    var support = itemMatrix[license].support;

    return Object.keys(support).some(function (supportName) {
      return support[supportName] && supportName !== 'none';
    });
  });
  var supportOptions = __WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(itemMatrix[selectedMatrixLicense], 'support');

  var onGoToEditScreen = function onGoToEditScreen(e) {
    e.preventDefault();
    goToEditScreen();
  };

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: 'cart-modal__variant-info' },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'p',
      { className: 'fds-c-text-heading -size-l' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'b',
        { className: 'fds-c-text-currency' },
        __WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(supportOptions[selectedMatrixSupport], 'price')
      )
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'p',
      { className: 'fds-c-text-body -weight-bold -size-s fds-u-mb0' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        null,
        'License: '
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'a',
        {
          href: __WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(itemMatrix[selectedMatrixLicense], 'terms_url'),
          className: 'fds-c-text-link -size-m -weight-normal -decoration-none'
        },
        __WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(itemMatrix[selectedMatrixLicense], 'license_label')
      )
    ),
    hasItemSupport && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'p',
      { className: 'fds-c-text-body -weight-bold -size-s fds-u-mb0' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        null,
        'Support: '
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        { className: 'fds-c-text-body -weight-normal -size-s' },
        __WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(supportOptions[selectedMatrixSupport], 'label')
      )
    ),
    showChangeDetailsLink && cartEntry && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'p',
      { className: 'fds-c-text-body -weight-bold -size-s fds-u-mb0' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'a',
        {
          href: '/cart/edit/' + cartEntry.id,
          onClick: onGoToEditScreen,
          className: 'fds-c-text-link -size-m -weight-normal'
        },
        'Change details'
      )
    )
  );
};

var ItemSummary = function ItemSummary(_ref2) {
  var item = _ref2.item,
      itemMatrix = _ref2.itemMatrix,
      selectedMatrixLicense = _ref2.selectedMatrixLicense,
      selectedMatrixSupport = _ref2.selectedMatrixSupport,
      showChangeDetailsLink = _ref2.showChangeDetailsLink,
      goToEditScreen = _ref2.goToEditScreen,
      cartEntry = _ref2.cartEntry;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: 'fds-c-modal__section -background-mid -height-scroll fds-u-p2 ' },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'cart-modal__thumbnail' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', {
        alt: item.name,
        src: item.ui.smallPreviewUrl
      })
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'cart-modal__core-info' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'h5',
        { className: 'fds-c-text-heading -size-xxs' },
        item.name
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'p',
        { className: 'fds-c-text-body -size-s' },
        'by ',
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'fds-c-text-body -size-s -style-italic' },
          item.author_username
        )
      )
    ),
    itemMatrix && selectedMatrixLicense && renderMatrix({
      itemMatrix: itemMatrix,
      selectedMatrixLicense: selectedMatrixLicense,
      selectedMatrixSupport: selectedMatrixSupport,
      showChangeDetailsLink: showChangeDetailsLink,
      goToEditScreen: goToEditScreen,
      cartEntry: cartEntry
    })
  );
};

ItemSummary.propTypes = {
  item: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  itemMatrix: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  selectedMatrixLicense: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  selectedMatrixSupport: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  showChangeDetailsLink: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  goToEditScreen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  cartEntry: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (ItemSummary);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_undefsafe__);



/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var error = _ref.error;

  var errorMsg = __WEBPACK_IMPORTED_MODULE_1_undefsafe___default()(error, 'response.status') === 404 ? 'Sorry this item is no longer for sale.' : 'Hmm, looks like we can\'t load the matrix of this item.';

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'fds-c-modal__section fds-u-text-align-center fds-u-p3' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      { className: 'fds-c-text-body fds-u-mb0' },
      errorMsg
    )
  );
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var modalMessages = _ref.modalMessages;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'fds-c-modal__section fds-u-text-align-center fds-u-p3' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      { className: 'fds-c-text-body fds-u-mb0' },
      modalMessages.message || 'There was an error adding item to your cart. Please try again.'
    )
  );
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var getOverlaySidePosition = function getOverlaySidePosition(container, target) {
  var top = void 0,
      left = void 0;

  var documentWidth = document.body.offsetWidth || document.documentElement.offsetWidth;
  var containerViewportPosition = container.getBoundingClientRect();

  top = target.offsetHeight - container.offsetHeight;
  left = target.offsetWidth;

  // Adjust top if exceeds viewport at the top
  if (Math.abs(top) > containerViewportPosition.top) {
    top = -containerViewportPosition.top;
  }

  // Display container on the left side of the target if it exceeds viewport on the right side
  if (target.offsetWidth + containerViewportPosition.right > documentWidth) {
    left = -container.offsetWidth;
  }

  return {
    top: top,
    left: left
  };
};

var POSITION_STRATEGIES = {
  'side': getOverlaySidePosition
};

var Overlay = function (_React$Component) {
  _inherits(Overlay, _React$Component);

  function Overlay(props) {
    _classCallCheck(this, Overlay);

    var _this = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this, props));

    _this.state = {
      showContent: false
    };

    _this.timeoutId = null;
    return _this;
  }

  _createClass(Overlay, [{
    key: 'getOverlayPosition',
    value: function getOverlayPosition(container, target) {
      if (typeof this.props.position === 'function') {
        return this.props.position(container, target);
      }
      return POSITION_STRATEGIES[this.props.position](container, target);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.state.showContent && this.$target && this.$content) {
        var position = this.getOverlayPosition(this.$content, this.$target);
        this.$content.style.left = position.left + 'px';
        this.$content.style.top = position.top + 'px';
      }
    }
  }, {
    key: 'onMouseEnter',
    value: function onMouseEnter() {
      var _this2 = this;

      this.timeoutId = setTimeout(function () {
        _this2.setState({ showContent: true });
      }, 500);
    }
  }, {
    key: 'onMouseLeave',
    value: function onMouseLeave() {
      clearTimeout(this.timeoutId);
      this.setState({ showContent: false });
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { ref: function ref($content) {
            _this3.$content = $content;
          }, style: { display: 'inline-block', position: 'absolute' } },
        this.props.content
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { style: { position: 'relative' } },
        this.state.showContent && this.renderContent(),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { ref: function ref($target) {
              _this4.$target = $target;
            },
            style: { display: 'inline-block' },
            onMouseEnter: this.onMouseEnter.bind(this),
            onMouseLeave: this.onMouseLeave.bind(this) },
          this.props.children
        )
      );
    }
  }]);

  return Overlay;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

Overlay.propTypes = {
  content: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  position: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func])
};
Overlay.defaultProps = {
  position: 'side'
};


/* harmony default export */ __webpack_exports__["a"] = (Overlay);

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_range__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_helmet__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils_urlHelper__ = __webpack_require__(5);








/**
 * Return array of pages by given params with gap elements if needed. For pagination purpose. Examples:
 *  getPagesRange(1, 20, 10) -> [1, 2, 3, 4, 5, 6, 7, 8, 9, '...', 20]
 *  getPagesRange(11, 20, 10) -> [1, '...', 7, 8, 9, 10, 11, 12, 13, 14, '...', 20]
 * @param {Number} currentPage
 * @param {Number} pagesCount
 * @param {Number} maxDisplayedPages
 * @returns {Array}
 */
var getPagesRange = function getPagesRange(currentPage, pagesCount, maxDisplayedPages) {
  if (pagesCount <= maxDisplayedPages) {
    return __WEBPACK_IMPORTED_MODULE_2_lodash_range___default()(1, pagesCount + 1);
  }

  var pagesRange = [currentPage];
  var minPage = currentPage - 1;
  var maxPage = currentPage + 1;
  var direction = 1;

  while (pagesRange.length < maxDisplayedPages) {
    if (direction < 0 && minPage > 0) {
      pagesRange.unshift(minPage);
      minPage--;
    }

    if (direction > 0 && maxPage <= pagesCount) {
      pagesRange.push(maxPage);
      maxPage++;
    }

    direction *= -1;
  }

  if (pagesRange[0] !== 1) {
    pagesRange.splice(0, 1, 1, '...');
  }

  if (pagesRange[pagesRange.length - 1] !== pagesCount) {
    pagesRange.pop();
    pagesRange.push('...', pagesCount);
  }

  return pagesRange;
};

var scrollToTop = function scrollToTop() {
  window.scrollTo(0, 0);
};

var PaginationItem = function PaginationItem(_ref) {
  var value = _ref.value,
      link = _ref.link,
      isCurrentPage = _ref.isCurrentPage;

  var content = void 0;

  if (value === '...') {
    content = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'span',
      { className: 'pagination__gap' },
      value
    );
  } else if (isCurrentPage) {
    content = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'span',
      { className: 'pagination__page--current' },
      value
    );
  } else {
    content = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],
      { to: link, className: 'pagination__page', onClick: scrollToTop },
      value
    );
  }
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'li',
    null,
    content
  );
};

var Pagination = function Pagination(_ref2) {
  var _ref2$currentPage = _ref2.currentPage,
      currentPage = _ref2$currentPage === undefined ? 1 : _ref2$currentPage,
      totalItemsCount = _ref2.totalItemsCount,
      pageSize = _ref2.pageSize,
      location = _ref2.location,
      _ref2$maxDisplayedPag = _ref2.maxDisplayedPages,
      maxDisplayedPages = _ref2$maxDisplayedPag === undefined ? 10 : _ref2$maxDisplayedPag,
      baseUrl = _ref2.baseUrl,
      maxPagesCount = _ref2.maxPagesCount;

  var calculatedPagesCount = Math.ceil(totalItemsCount / pageSize);
  var pagesCount = maxPagesCount && calculatedPagesCount > maxPagesCount ? maxPagesCount : calculatedPagesCount;
  var parsedLocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_urlHelper__["a" /* parseLocation */])(location);
  var previousPageLink = currentPage > 1 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_urlHelper__["b" /* makeLink */])(Object.assign({}, parsedLocation, { page: currentPage - 1 })) : null;
  var nextPageLink = currentPage < pagesCount ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_urlHelper__["b" /* makeLink */])(Object.assign({}, parsedLocation, { page: currentPage + 1 })) : null;
  var shouldShowPagination = pagesCount > 1;

  var link = [];
  if (previousPageLink) {
    link.push({
      rel: 'prev', href: baseUrl + previousPageLink
    });
  }
  if (nextPageLink) {
    link.push({
      rel: 'next', href: baseUrl + nextPageLink
    });
  }

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    null,
    shouldShowPagination && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'nav',
      { className: 'pagination' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_helmet___default.a, {
        link: link
      }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'ul',
        { className: 'pagination__list' },
        previousPageLink ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'li',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */], { to: previousPageLink, className: 'pagination__previous', onClick: scrollToTop })
        ) : null,
        getPagesRange(currentPage, pagesCount, maxDisplayedPages).map(function (pageNumber, index) {
          var pageLink = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_urlHelper__["b" /* makeLink */])(Object.assign({}, parsedLocation, { page: pageNumber }));
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PaginationItem, { key: index, value: pageNumber, link: pageLink, isCurrentPage: currentPage === pageNumber });
        }),
        nextPageLink ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'li',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */], { to: nextPageLink, className: 'pagination__next', onClick: scrollToTop })
        ) : null
      )
    )
  );
};

Pagination.propTypes = {
  currentPage: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  totalItemsCount: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  pageSize: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  maxDisplayedPages: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  maxPagesCount: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
};

/* harmony default export */ __webpack_exports__["a"] = (Pagination);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_omit__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_omit__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var SearchBarInput = function (_React$Component) {
  _inherits(SearchBarInput, _React$Component);

  function SearchBarInput(props) {
    _classCallCheck(this, SearchBarInput);

    var _this = _possibleConstructorReturn(this, (SearchBarInput.__proto__ || Object.getPrototypeOf(SearchBarInput)).call(this, props));

    _this.state = {
      value: _this.props.value
    };
    return _this;
  }

  _createClass(SearchBarInput, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var value = nextProps.value;
      if (value !== this.state.value) {
        this.setState({ value: value });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(event) {
      var _this2 = this;

      this.setState({ value: event.target.value }, function () {
        if (_this2.props.onChange) {
          _this2.props.onChange(event);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var passProps = __WEBPACK_IMPORTED_MODULE_2_lodash_omit___default()(this.props, ['type', 'value', 'onChange', 'aria-label']);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', _extends({
        type: 'search',
        value: this.state.value,
        onChange: this.onChange.bind(this),
        'aria-label': 'search' }, passProps));
    }
  }]);

  return SearchBarInput;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

SearchBarInput.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
};
SearchBarInput.defaultProps = {
  value: ''
};


/* harmony default export */ __webpack_exports__["a"] = (SearchBarInput);

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__notFoundPage__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(30);



var mapStateToProps = function mapStateToProps(state) {
  var currentSite = state.common.currentSite;


  return {
    currentSite: currentSite
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {};
};

var NotFoundContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_0__notFoundPage__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (NotFoundContainer);

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils_urlHelper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_constants_filterParamsConfig__ = __webpack_require__(38);







var SearchNoResults = function SearchNoResults(_ref) {
  var location = _ref.location;

  var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_utils_urlHelper__["a" /* parseLocation */])(location);
  var filterParamsKeys = Object.keys(__WEBPACK_IMPORTED_MODULE_4__common_constants_filterParamsConfig__["a" /* default */]);
  var paramsList = Object.keys(query);
  var activeFiltersParams = filterParamsKeys.filter(function (param) {
    return paramsList.indexOf(param) > -1;
  });

  var renderClearFiltersLink = function renderClearFiltersLink() {
    var queryWithoutFilters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_utils_urlHelper__["d" /* getQueryWithoutParam */])(query, filterParamsKeys);
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'span',
      null,
      'Try ',
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],
        { to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_utils_urlHelper__["b" /* makeLink */])(queryWithoutFilters), className: 'fds-c-text-link -decoration-reversed' },
        'clearing your filters'
      ),
      '.'
    );
  };

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: 'fds-c-box -background-light fds-u-mb2 fds-u-p2' },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'search-no-results' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'e-icon -icon-cactus -size-enormous' })
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h2',
          { className: 'fds-c-text-heading -size-xs' },
          'You\'ve ventured too far out into the desert! ',
          activeFiltersParams.length ? renderClearFiltersLink() : 'Time to head back'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          { className: 'fds-c-text-body' },
          activeFiltersParams.length ? 'We couldn\'t find any results for your search within the filters you\'ve set.' : 'We couldn\'t find any results for your search. Use more generic words or double check your spelling.'
        )
      )
    )
  );
};

SearchNoResults.propTypes = {
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (SearchNoResults);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__searchResultBody__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_actions_layout__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_selectors_user__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_actions_user_collection__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_actions_user_bookmark__ = __webpack_require__(318);








var mapStateToProps = function mapStateToProps(state) {
  var currentSite = state.common.currentSite,
      _state$user = state.user,
      token = _state$user.token,
      preferences = _state$user.preferences;


  return {
    currentSite: currentSite,
    collections: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_selectors_user__["a" /* getUserCollections */])(state),
    cartItems: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_selectors_user__["b" /* getUserCartItems */])(state),
    favoriteCollectionID: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_selectors_user__["c" /* getUserFavoriteCollectionID */])(state),
    token: token,
    preferences: preferences
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    deleteBookmark: function deleteBookmark(collectionID, itemID, id, isFavouriteCollection) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_actions_user_bookmark__["a" /* deleteBookmark */])(collectionID, itemID, id, isFavouriteCollection));
    },
    addBookmark: function addBookmark(collectionId, itemId, isFavouriteCollection) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_actions_user_bookmark__["b" /* addBookmark */])(collectionId, itemId, isFavouriteCollection));
    },
    openModal: function openModal(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_actions_layout__["a" /* openModal */])(data));
    },
    createFavoriteCollection: function createFavoriteCollection() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_actions_user_collection__["a" /* createFavoriteCollection */])());
    }
  };
};

var SearchResultBodyContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__searchResultBody__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SearchResultBodyContainer);

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return searchesCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return countSearchFor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_utils_localStorageHelpers__ = __webpack_require__(327);


var searchesCount = function searchesCount(site) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_utils_localStorageHelpers__["b" /* getLocalStorageItem */])(site + '-search-page-views', 0);
};

var countSearchFor = function countSearchFor(site) {
  var searchesCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_utils_localStorageHelpers__["b" /* getLocalStorageItem */])(site + '-search-page-views', 0);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_utils_localStorageHelpers__["a" /* setLocalStorageItem */])(site + '-search-page-views', searchesCount + 1);
};

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deleteBookmark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addBookmark; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__authMiddleware__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_user__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_errors__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__analytics_userAnalytics__ = __webpack_require__(144);
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }







var deleteBookmarkRequestAction = function deleteBookmarkRequestAction(collectionID, itemID) {
  return {
    type: 'deleteBookmarkRequest',
    payload: { collectionID: collectionID, itemID: itemID }
  };
};
var deleteBookmarkSuccessAction = function deleteBookmarkSuccessAction(collectionID, itemID, isFavouriteCollection) {
  if (isFavouriteCollection) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__analytics_userAnalytics__["b" /* reportItemRemovedFromFavourite */])(itemID);
  } else {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__analytics_userAnalytics__["c" /* reportItemRemovedFromCollection */])(itemID);
  }

  return {
    type: 'deleteBookmarkSuccess',
    payload: { collectionID: collectionID, itemID: itemID }
  };
};
var deleteBookmarkFailureAction = function deleteBookmarkFailureAction(collectionID, itemID) {
  return {
    type: 'deleteBookmarkFailure',
    payload: { collectionID: collectionID, itemID: itemID }
  };
};

var deleteBookmark = function deleteBookmark(collectionID, itemID, bookmarkID, isFavouriteCollection) {
  return function () {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _getState, token, message;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _getState = getState(), token = _getState.user.token;

              if (token) {
                _context.next = 3;
                break;
              }

              return _context.abrupt('return', dispatch(deleteBookmarkFailureAction(collectionID, itemID)));

            case 3:

              dispatch(deleteBookmarkRequestAction(collectionID, itemID));

              _context.prev = 4;
              _context.next = 7;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_user__["b" /* deleteBookmarkRequest */])(token, bookmarkID);

            case 7:
              return _context.abrupt('return', dispatch(deleteBookmarkSuccessAction(collectionID, itemID, isFavouriteCollection)));

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](4);

              if (!(_context.t0.statusCode === 401)) {
                _context.next = 16;
                break;
              }

              return _context.abrupt('return', dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__authMiddleware__["a" /* default */])(deleteBookmark(collectionID, itemID, bookmarkID))));

            case 16:
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_errors__["a" /* logError */])(_context.t0);
              message = 'Unfortunately we couldn\'t delete the bookmark. Please try again.';

              dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common__["c" /* showAlert */])(message, 'failure', false));
              return _context.abrupt('return', dispatch(deleteBookmarkFailureAction(collectionID, itemID)));

            case 20:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[4, 10]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

var addBookmarkRequestAction = function addBookmarkRequestAction(collectionID, itemID) {
  return {
    type: 'addBookmarkRequest',
    payload: { collectionID: collectionID, itemID: itemID }
  };
};
var addBookmarkSuccessAction = function addBookmarkSuccessAction(bookmarkID, collectionID, itemID, isFavouriteCollection) {
  if (isFavouriteCollection) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__analytics_userAnalytics__["d" /* reportItemAddedToFavourite */])(itemID);
  } else {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__analytics_userAnalytics__["e" /* reportItemAddedToCollection */])(itemID);
  }

  return {
    type: 'addBookmarkSuccess',
    payload: { bookmarkID: bookmarkID, collectionID: collectionID, itemID: itemID }
  };
};
var addBookmarkFailureAction = function addBookmarkFailureAction(collectionID, itemID) {
  return {
    type: 'addBookmarkFailure',
    payload: { collectionID: collectionID, itemID: itemID }
  };
};

var addBookmark = function addBookmark(collectionID, itemID, isFavouriteCollection) {
  return function () {
    var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var _getState2, token, _ref3, bookmark_id, message;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _getState2 = getState(), token = _getState2.user.token;

              if (token) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt('return', dispatch(addBookmarkFailureAction(collectionID, itemID)));

            case 3:

              dispatch(addBookmarkRequestAction(collectionID, itemID));

              _context2.prev = 4;
              _context2.next = 7;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_user__["c" /* createBookmarkRequest */])(token, collectionID, itemID);

            case 7:
              _ref3 = _context2.sent;
              bookmark_id = _ref3.bookmark_id;
              return _context2.abrupt('return', dispatch(addBookmarkSuccessAction(bookmark_id, collectionID, itemID, isFavouriteCollection)));

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2['catch'](4);

              if (!(_context2.t0.statusCode === 401)) {
                _context2.next = 18;
                break;
              }

              return _context2.abrupt('return', dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__authMiddleware__["a" /* default */])(addBookmark(collectionID, itemID))));

            case 18:
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_errors__["a" /* logError */])(_context2.t0);
              message = 'Unfortunately your bookmark hasn\'t been added. Please try again.';

              dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common__["c" /* showAlert */])(message, 'failure', false));
              return _context2.abrupt('return', dispatch(addBookmarkFailureAction(collectionID, itemID)));

            case 22:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this, [[4, 12]]);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getGuestUserCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addItemToCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return editCartEntry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__authMiddleware__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_user__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__analytics_userAnalytics__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_errors__ = __webpack_require__(16);
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }







var addItemToCartRequestAction = function addItemToCartRequestAction() {
  return { type: 'addItemToCartRequest' };
};
var addItemToCartSuccessAction = function addItemToCartSuccessAction(response) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__analytics_userAnalytics__["g" /* reportModalPageView */])({
    title: 'Modal: Item added to cart',
    page: window.location.pathname + '/item-added-to-cart' + window.location.search
  });
  return {
    type: 'addItemToCartSuccess',
    payload: response
  };
};

var getGuestUserCartRequestAction = function getGuestUserCartRequestAction() {
  return { type: 'getGuestUserCartRequest' };
};
var getGuestUserCartFailureAction = function getGuestUserCartFailureAction() {
  return { type: 'getGuestUserCartFailure' };
};

var getGuestUserCart = function getGuestUserCart() {
  return function () {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch) {
      var response;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              dispatch(getGuestUserCartRequestAction());
              _context.next = 4;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_user__["f" /* getGuestCartRequest */])();

            case 4:
              response = _context.sent;
              return _context.abrupt('return', dispatch(getGuestUserCartSuccessAction(response.data)));

            case 8:
              _context.prev = 8;
              _context.t0 = _context['catch'](0);

              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_errors__["a" /* logError */])(_context.t0);
              dispatch(getGuestUserCartFailureAction());

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

var getGuestUserCartSuccessAction = function getGuestUserCartSuccessAction(cart) {
  return {
    type: 'getGuestUserCartSuccess',
    payload: cart
  };
};

var createUserCartRequestAction = function createUserCartRequestAction() {
  return {
    type: 'createUserCartRequest'
  };
};
var createUserCartSuccessAction = function createUserCartSuccessAction(cart) {
  return {
    type: 'createUserCartSuccess',
    payload: cart
  };
};
var createUserCartFailureAction = function createUserCartFailureAction() {
  return {
    type: 'createUserCartFailure'
  };
};

var addItemToCart = function addItemToCart(data) {
  return function () {
    var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var _getState, _getState$user, token, cart, newCart, response, _newCart, _response;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _getState = getState(), _getState$user = _getState.user, token = _getState$user.token, cart = _getState$user.cart;
              // add to signed in user cart

              if (!token) {
                _context2.next = 38;
                break;
              }

              if (cart) {
                _context2.next = 20;
                break;
              }

              _context2.prev = 3;

              dispatch(createUserCartRequestAction());
              _context2.next = 7;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_user__["g" /* createUserCartRequest */])(token);

            case 7:
              newCart = _context2.sent;

              dispatch(createUserCartSuccessAction(newCart));
              _context2.next = 20;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2['catch'](3);

              if (!(_context2.t0.statusCode === 401)) {
                _context2.next = 17;
                break;
              }

              return _context2.abrupt('return', dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__authMiddleware__["a" /* default */])(addItemToCart(data))));

            case 17:
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_errors__["a" /* logError */])(_context2.t0);
              dispatch(createUserCartFailureAction());
              return _context2.abrupt('return', dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__layout__["b" /* showModalMessage */])({ message: 'Creating user cart failed' })));

            case 20:

              dispatch(addItemToCartRequestAction());
              _context2.prev = 21;
              _context2.next = 24;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_user__["h" /* addItemToUserCartRequest */])(token, data);

            case 24:
              response = _context2.sent;
              return _context2.abrupt('return', dispatch(addItemToCartSuccessAction(response)));

            case 28:
              _context2.prev = 28;
              _context2.t1 = _context2['catch'](21);

              if (!(_context2.t1.statusCode === 401)) {
                _context2.next = 34;
                break;
              }

              return _context2.abrupt('return', dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__authMiddleware__["a" /* default */])(addItemToCart(data))));

            case 34:
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_errors__["a" /* logError */])(_context2.t1);
              return _context2.abrupt('return', dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__layout__["b" /* showModalMessage */])({ message: 'Adding item to cart failed' })));

            case 36:
              _context2.next = 56;
              break;

            case 38:
              dispatch(addItemToCartRequestAction());

              if (cart) {
                _context2.next = 45;
                break;
              }

              _context2.next = 42;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_user__["i" /* createGuestCartRequest */])();

            case 42:
              _newCart = _context2.sent;
              _context2.next = 45;
              return dispatch(getGuestUserCartSuccessAction(_newCart));

            case 45:
              _context2.prev = 45;
              _context2.next = 48;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_user__["j" /* addItemToGuestCartRequest */])(data);

            case 48:
              _response = _context2.sent;
              return _context2.abrupt('return', dispatch(addItemToCartSuccessAction(_response)));

            case 52:
              _context2.prev = 52;
              _context2.t2 = _context2['catch'](45);

              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_errors__["a" /* logError */])(_context2.t2);
              return _context2.abrupt('return', dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__layout__["b" /* showModalMessage */])({ message: 'Adding item to cart failed' })));

            case 56:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this, [[3, 11], [21, 28], [45, 52]]);
    }));

    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var editCartEntryRequestAction = function editCartEntryRequestAction() {
  return { type: 'editCartEntryRequest' };
};
var editCartEntrySuccessAction = function editCartEntrySuccessAction(response) {
  return {
    type: 'editCartEntrySuccess',
    payload: response
  };
};

var editCartEntry = function editCartEntry(entryID, data) {
  return function () {
    var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dispatch, getState) {
      var _getState2, token, response, _response2;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _getState2 = getState(), token = _getState2.user.token;
              // edit to signed in user cart

              if (!token) {
                _context3.next = 20;
                break;
              }

              dispatch(editCartEntryRequestAction());
              _context3.prev = 3;
              _context3.next = 6;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_user__["k" /* editUserCartEntryRequest */])(token, entryID, data);

            case 6:
              response = _context3.sent;
              return _context3.abrupt('return', dispatch(editCartEntrySuccessAction(response)));

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3['catch'](3);

              if (!(_context3.t0.statusCode === 401)) {
                _context3.next = 16;
                break;
              }

              return _context3.abrupt('return', dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__authMiddleware__["a" /* default */])(editCartEntry(entryID, data))));

            case 16:
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_errors__["a" /* logError */])(_context3.t0);
              return _context3.abrupt('return', dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__layout__["b" /* showModalMessage */])({ message: 'Cart update failed. Please try again.' })));

            case 18:
              _context3.next = 32;
              break;

            case 20:
              dispatch(editCartEntryRequestAction());
              _context3.prev = 21;
              _context3.next = 24;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_user__["l" /* editGuestCartEntryRequest */])(entryID, data);

            case 24:
              _response2 = _context3.sent;
              return _context3.abrupt('return', dispatch(editCartEntrySuccessAction(_response2)));

            case 28:
              _context3.prev = 28;
              _context3.t1 = _context3['catch'](21);

              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_errors__["a" /* logError */])(_context3.t1);
              return _context3.abrupt('return', dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__layout__["b" /* showModalMessage */])({ message: 'Cart update failed. Please try again.' })));

            case 32:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this, [[3, 10], [21, 28]]);
    }));

    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
};

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createCollection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createFavoriteCollection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__authMiddleware__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_user__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_errors__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__analytics_userAnalytics__ = __webpack_require__(144);
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }







var createCollectionRequestAction = { type: 'createCollectionRequest' };
var createCollectionSuccessAction = function createCollectionSuccessAction(response) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__analytics_userAnalytics__["a" /* reportCollectionCreated */])();
  return {
    type: 'createCollectionSuccess',
    payload: response
  };
};
var createCollectionFailureAction = function createCollectionFailureAction(name, isPublic) {
  return {
    type: 'createCollectionFailure',
    payload: { name: name, isPublic: isPublic }
  };
};

var createCollection = function createCollection(_ref) {
  var name = _ref.name,
      _ref$isPublic = _ref.isPublic,
      isPublic = _ref$isPublic === undefined ? false : _ref$isPublic,
      description = _ref.description,
      specialRole = _ref.specialRole;

  return function () {
    var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _getState, token, response;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _getState = getState(), token = _getState.user.token;

              if (token) {
                _context.next = 3;
                break;
              }

              return _context.abrupt('return', dispatch(createCollectionFailureAction(name, isPublic)));

            case 3:

              dispatch(createCollectionRequestAction);

              _context.prev = 4;
              _context.next = 7;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_user__["a" /* createCollectionRequest */])(token, {
                name: name,
                isPublic: isPublic,
                description: description,
                specialRole: specialRole
              });

            case 7:
              response = _context.sent;
              return _context.abrupt('return', dispatch(createCollectionSuccessAction(response)));

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](4);

              if (!(_context.t0.statusCode === 401)) {
                _context.next = 17;
                break;
              }

              return _context.abrupt('return', dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__authMiddleware__["a" /* default */])(createCollection({
                name: name,
                isPublic: isPublic,
                description: description,
                specialRole: specialRole
              }))));

            case 17:
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_errors__["a" /* logError */])(_context.t0);
              return _context.abrupt('return', dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__layout__["b" /* showModalMessage */])({ message: 'Create collection failed' })));

            case 19:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[4, 11]]);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var createFavoriteCollection = function createFavoriteCollection() {
  return createCollection({
    name: 'My Favorites',
    isPublic: 'false',
    description: 'Items you marked as your favorites.',
    specialRole: 'favorite'
  });
};

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getUserProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_undefsafe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_user__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_auth__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cart__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_bootIntercom__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_errors__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__analytics_userAnalytics__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__session__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__profile__ = __webpack_require__(648);











/**
 * When SSO request failed
 */
var handleUnAuthenticatedAction = function handleUnAuthenticatedAction() {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__profile__["a" /* getGuestUserAction */])());
    __WEBPACK_IMPORTED_MODULE_4__utils_bootIntercom__["a" /* default */].boot();
    // get guest user cart
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__cart__["a" /* getGuestUserCart */])());
  };
};

var getUserProfile = function getUserProfile(jwtToken) {
  return function (dispatch) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__profile__["b" /* getUserRequestAction */])());
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_user__["d" /* getUserProfileRequest */])(jwtToken).then(__WEBPACK_IMPORTED_MODULE_1__utils_user__["e" /* formatUserResponse */]).then(function (user) {
      __WEBPACK_IMPORTED_MODULE_4__utils_bootIntercom__["a" /* default */].boot(user);
      var envatoId = __WEBPACK_IMPORTED_MODULE_0_undefsafe___default()(user, 'profile.envato_id');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__analytics_userAnalytics__["f" /* setGAUserID */])(envatoId);
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__profile__["c" /* getUserSuccessAction */])(user));
    }).catch(function (err) {
      return Promise.reject(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_errors__["a" /* logError */])(err));
    }).catch(function () {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__profile__["d" /* getUserFailureAction */])());
    });
  };
};

var getUser = function getUser() {
  return function (dispatch, getState) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__session__["a" /* getSessionRequestAction */])());

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_auth__["a" /* getSession */])().then(function (res) {
      return res.data.token;
    }).then(function (jwtToken) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__session__["b" /* getSessionSuccessAction */])(jwtToken));
      dispatch(getUserProfile(jwtToken));
    }).catch(function (err) {
      if (err.statusCode === 401) {
        return dispatch(handleUnAuthenticatedAction());
      } else {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__session__["c" /* getSessionFailureAction */])());
      }
    });
  };
};

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reportProductClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reportProductAddToCartAttempt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reportProductsImpressions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return reportModalPageView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_sites__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_ga__ = __webpack_require__(33);



var LIST_NAME = 'Search Results: Search';

var reportProductClick = function reportProductClick(item, index, currentSite) {
  var currentSiteDomain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_sites__["a" /* getCurrentSiteDomain */])(currentSite);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_ga__["a" /* default */])('ec:addProduct', {
    id: item.id,
    name: item.name,
    category: currentSiteDomain + '/' + item.classification,
    brand: item.author_username,
    list: LIST_NAME,
    position: index
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_ga__["a" /* default */])('ec:setAction', 'click', {
    list: LIST_NAME
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_ga__["a" /* default */])('send', 'event', 'Ecommerce', 'click', 'Product click: product list');
};

var reportProductAddToCartAttempt = function reportProductAddToCartAttempt(item, index, currentSite) {
  var currentSiteDomain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_sites__["a" /* getCurrentSiteDomain */])(currentSite);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_ga__["a" /* default */])('ec:addProduct', {
    id: item.id,
    name: item.name,
    category: currentSiteDomain + '/' + item.classification,
    brand: item.author_username,
    list: LIST_NAME,
    position: index
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_ga__["a" /* default */])('ec:setAction', 'add');
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_ga__["a" /* default */])('send', 'event', 'Ecommerce', 'click', 'Add to cart: product list');
};

var reportProductsImpressions = function reportProductsImpressions(items, currentSite) {
  var currentSiteDomain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_sites__["a" /* getCurrentSiteDomain */])(currentSite);
  items.forEach(function (item, index) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_ga__["a" /* default */])('ec:addImpression', {
      id: item.id,
      name: item.name,
      category: currentSiteDomain + '/' + item.classification,
      brand: item.author_username,
      list: LIST_NAME,
      position: index + 1
    });
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_ga__["a" /* default */])('send', 'event', 'Ecommerce', 'view', 'Product impression', {
    nonInteraction: true
  });
};

var reportModalPageView = function reportModalPageView(_ref) {
  var title = _ref.title,
      page = _ref.page;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_ga__["a" /* default */])('send', {
    hitType: 'pageview',
    page: page,
    title: title
  });
};

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__client_pages_appContainer__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__client_pages_search_searchPageContainer__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__client_pages_landing_landingPageContainer__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__client_pages_notFoundContainer__ = __webpack_require__(314);





/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__client_pages_appContainer__["a" /* default */],
  routes: [{
    path: '/',
    exact: true,
    component: __WEBPACK_IMPORTED_MODULE_1__client_pages_search_searchPageContainer__["a" /* default */]
  }, {
    path: '/category/*',
    component: __WEBPACK_IMPORTED_MODULE_1__client_pages_search_searchPageContainer__["a" /* default */]
  }, {
    path: '/tags/:tags',
    component: __WEBPACK_IMPORTED_MODULE_1__client_pages_search_searchPageContainer__["a" /* default */]
  }, {
    path: '/attributes/:key/:value',
    component: __WEBPACK_IMPORTED_MODULE_1__client_pages_search_searchPageContainer__["a" /* default */]
  }, {
    path: '/search',
    component: __WEBPACK_IMPORTED_MODULE_1__client_pages_search_searchPageContainer__["a" /* default */]
  }, {
    path: '/free/:page',
    component: __WEBPACK_IMPORTED_MODULE_2__client_pages_landing_landingPageContainer__["a" /* default */]
  }, {
    path: '/*',
    component: __WEBPACK_IMPORTED_MODULE_3__client_pages_notFoundContainer__["a" /* default */]
  }]
}]);

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getUserCollections; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getUserCartItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getUserFavoriteCollectionID; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_undefsafe__);



var getUserCollections = function getUserCollections(state) {
  return state.user.collections;
};

var getUserCartItems = function getUserCartItems(state) {
  return __WEBPACK_IMPORTED_MODULE_1_undefsafe___default()(state, 'user.cart.entries') || [];
};

var getUserFavoriteCollectionID = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getUserCollections], function (collections) {
  return Object.keys(collections).filter(function (collectionID) {
    return collections[collectionID].special_role === 'favorite';
  })[0];
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSession; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__ = __webpack_require__(32);


/**
 * Get shopfront jwt token with given sso token
 * @return {String} jwt token
 */
var getSession = function getSession() {
  return __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__["a" /* default */].get('/jwt_session');
};



/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var isServer = _ref.isServer,
      isBoxenUser = _ref.isBoxenUser,
      internalServerUrl = _ref.internalServerUrl,
      baseUrl = _ref.baseUrl;

  var apiUrlPrefix = '';
  // on client side there's no need for prefix, browser will append it for us
  if (isServer) {
    if (isBoxenUser) {
      apiUrlPrefix = baseUrl;
    } else {
      apiUrlPrefix = internalServerUrl;
    }
  }
  return apiUrlPrefix;
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setLocalStorageItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLocalStorageItem; });
var setLocalStorageItem = function setLocalStorageItem(itemKey, itemValue) {
  if (typeof window !== 'undefined' && window.localStorage) {
    window.localStorage.setItem(itemKey, JSON.stringify(itemValue));
  }
};

var getLocalStorageItem = function getLocalStorageItem(itemKey, defaultValue) {
  if (typeof window !== 'undefined' && window.localStorage) {
    return JSON.parse(window.localStorage.getItem(itemKey)) || defaultValue;
  } else {
    return defaultValue;
  }
};

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMinutesSecondsTime; });
/* unused harmony export toSeconds */
/**
 * Convert time to proper MM:SS format:
 *  12 -> '00:12'
 *  74 -> '1:14'
 *  ':12' -> '0:12'
 *  '1:12' -> '1:12'
 *  '1:74' -> '2:14'
 *  'ab:' -> ''
 * @param {Number|String} input
 * @returns {*}
 */
var getMinutesSecondsTime = function getMinutesSecondsTime(input) {
  var matchedSeconds = void 0;
  var matchedMinutes = void 0;

  if (Number(input)) {
    matchedMinutes = 0;
    matchedSeconds = Number(input);
  } else {
    var inputString = String(input);
    var format = /^(\d*):?(\d+)$/;
    var match = inputString.match(format);

    if (!match) {
      return '';
    }

    matchedMinutes = match[1] ? Number(match[1]) : 0;
    matchedSeconds = match[2] ? Number(match[2]) : 0;
  }

  var additionalMinutes = Math.floor(matchedSeconds / 60);
  var seconds = matchedSeconds - additionalMinutes * 60;
  var minutes = matchedMinutes + additionalMinutes;
  var secondsFormatted = seconds < 10 ? '0' + seconds.toFixed(0) : String(seconds.toFixed(0));
  var minutesFormatted = String(minutes);
  return minutesFormatted + ':' + secondsFormatted;
};

/**
 * Convert user input MM:SS to seconds
 * 12 -> 12
 * '0:12' -> 12
 * '1:12' -> 72
 * 'ab' -> ''
 * @param  {String|Number} input
 * @return {Number} time in seconds
 */
var toSeconds = function toSeconds(input) {
  var timeReg = /^([0-9]?[0-9]):([0-5][0-9])(:[0-5][0-9])?$/;
  if (Number(input)) {
    if (parseInt(input) < 0) {
      return 0;
    } else {
      return parseInt(input);
    }
  } else if (timeReg.test(input)) {
    var parts = input.split(':');
    var sec = 0;
    var min = 1;

    while (parts.length > 0) {
      sec += min * parseInt(parts.pop(), 10);
      min *= 60;
    }

    return sec;
  } else {
    return null;
  }
};

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return canUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_undefsafe__);


var authorizators = {
  userIsAuthor: function userIsAuthor(user, _site) {
    return __WEBPACK_IMPORTED_MODULE_0_undefsafe___default()(user, 'profile.is_author');
  },
  userIsNotAuthor: function userIsNotAuthor(user, _site) {
    var isAuthor = __WEBPACK_IMPORTED_MODULE_0_undefsafe___default()(user, 'profile.is_author');
    return isAuthor === undefined || isAuthor === false;
  },
  canViewAdmin: function canViewAdmin(user, _site) {
    return __WEBPACK_IMPORTED_MODULE_0_undefsafe___default()(user, 'profile.permissions.global.can_view_admin_menu');
  },
  hasAuthorPermissionsInCurrentSite: function hasAuthorPermissionsInCurrentSite(user, site) {
    return __WEBPACK_IMPORTED_MODULE_0_undefsafe___default()(user, 'profile.permissions.' + site + '.author_permissions');
  },
  canUploadInCurrentSite: function canUploadInCurrentSite(user, site) {
    return __WEBPACK_IMPORTED_MODULE_0_undefsafe___default()(user, 'profile.permissions.' + site + '.can_upload');
  },
  canViewPortfolio: function canViewPortfolio(user, site) {
    return __WEBPACK_IMPORTED_MODULE_0_undefsafe___default()(user, 'profile.permissions.' + site + '.can_view_portfolio');
  }
};

var canUser = function canUser(user, permission) {
  var site = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (user) {
    var authorizator = authorizators[permission];
    if (authorizator) {
      return authorizator(user, site) === true;
    } else {
      throw new Error('Couldn\'t find permission with name ' + permission);
    }
  } else {
    return false;
  }
};

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3docean_json__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3docean_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3docean_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__audiojungle_json__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__audiojungle_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__audiojungle_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__codecanyon_json__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__codecanyon_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__codecanyon_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphicriver_json__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphicriver_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__graphicriver_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__photodune_json__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__photodune_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__photodune_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__themeforest_json__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__themeforest_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__themeforest_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__videohive_json__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__videohive_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__videohive_json__);








/* harmony default export */ __webpack_exports__["a"] = ({
  '3docean': __WEBPACK_IMPORTED_MODULE_0__3docean_json___default.a,
  audiojungle: __WEBPACK_IMPORTED_MODULE_1__audiojungle_json___default.a,
  codecanyon: __WEBPACK_IMPORTED_MODULE_2__codecanyon_json___default.a,
  graphicriver: __WEBPACK_IMPORTED_MODULE_3__graphicriver_json___default.a,
  photodune: __WEBPACK_IMPORTED_MODULE_4__photodune_json___default.a,
  themeforest: __WEBPACK_IMPORTED_MODULE_5__themeforest_json___default.a,
  videohive: __WEBPACK_IMPORTED_MODULE_6__videohive_json___default.a
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3docean_json__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3docean_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3docean_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__audiojungle_json__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__audiojungle_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__audiojungle_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__codecanyon_json__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__codecanyon_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__codecanyon_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphicriver_json__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphicriver_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__graphicriver_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__photodune_json__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__photodune_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__photodune_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__themeforest_json__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__themeforest_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__themeforest_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__videohive_json__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__videohive_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__videohive_json__);








/* harmony default export */ __webpack_exports__["a"] = ({
  '3docean': __WEBPACK_IMPORTED_MODULE_0__3docean_json___default.a,
  audiojungle: __WEBPACK_IMPORTED_MODULE_1__audiojungle_json___default.a,
  codecanyon: __WEBPACK_IMPORTED_MODULE_2__codecanyon_json___default.a,
  graphicriver: __WEBPACK_IMPORTED_MODULE_3__graphicriver_json___default.a,
  photodune: __WEBPACK_IMPORTED_MODULE_4__photodune_json___default.a,
  themeforest: __WEBPACK_IMPORTED_MODULE_5__themeforest_json___default.a,
  videohive: __WEBPACK_IMPORTED_MODULE_6__videohive_json___default.a
});

/***/ }),
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_hot_loader__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils_legacyAffiliates__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_store_configureStore__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_stylesheets_core_css__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_stylesheets_core_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_stylesheets_core_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_stylesheets_search_css__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_stylesheets_search_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_stylesheets_search_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_stylesheets_style_css__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_stylesheets_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_stylesheets_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_stylesheets_compontents_css__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_stylesheets_compontents_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_stylesheets_compontents_css__);













// this only runs on initial rendering
var initialState = window.INITIAL_STATE;
delete window.INITIAL_STATE;

var store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_store_configureStore__["a" /* default */])(initialState);

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_utils_legacyAffiliates__["a" /* default */])(window.location);

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_2_react_hot_loader__["AppContainer"],
  null,
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__app__["a" /* default */], { store: store })
), document.querySelector('#react-view'));

if (false) {
  module.hot.accept('./app', function (props) {
    render(React.createElement(
      AppContainer,
      null,
      React.createElement(App, { store: store })
    ), document.querySelector('#react-view'));
  });
}

/***/ }),
/* 463 */,
/* 464 */
/***/ (function(module, exports) {

module.exports = [
	{
		"match": "cg-textures",
		"title": "More Textures",
		"content": "The CG textures you'll find here are made specifically for 3d. If you just need flat, tiled textures, be sure to check out the <a href=\"https://graphicriver.net/category/textures\">textures category</a> on GraphicRiver. ",
		"button_label": "Browse Textures",
		"icon_source": "photo_v4.png",
		"link": "https://3docean.net/category/cg-textures"
	}
];

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports = [
	{
		"match": "sound",
		"title": "Making a Mobile App?",
		"content": "Find some great SFX for your new game or app?  Be sure to check out our <a href=\"https://codecanyon.net/category/mobile\">Android and iOS mobile templates</a> over on CodeCanyon as well. ",
		"button_label": "Browse Mobile Templates",
		"icon_source": "robot_v1.png",
		"link": "https://codecanyon.net/category/mobile"
	},
	{
		"match": [
			"logos-idents",
			"music",
			"music-packs"
		],
		"title": "Media Players",
		"content": "Embed music and videos directly into your website with these cutting-edge <a href=\"https://codecanyon.net/category/html5/media\">HTML5 media players</a> on CodeCanyon. ",
		"button_label": "Browse Media Players",
		"icon_source": "games_v1.png",
		"link": "https://codecanyon.net/category/html5/media"
	}
];

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports = [
	{
		"match": "javascript",
		"title": "Web Graphics",
		"content": "Like the scripts you see here, but don't love the look? Check out all the <a href=\"https://graphicriver.net/category/web-elements\">web graphics</a> on GraphicRiver.",
		"button_label": "Browse Graphics",
		"icon_source": null,
		"link": "https://graphicriver.net/category/web-elements"
	},
	{
		"match": "mobile",
		"title": "Mobile Themes",
		"content": "Be sure to check out all our <a href=\"https://themeforest.net/category/site-templates/mobile\">premium mobile themes</a> on ThemeForest.",
		"button_label": "Browse Mobile Themes",
		"icon_source": "wordpress.png",
		"link": "https://themeforest.net/category/site-templates/mobile"
	},
	{
		"match": "plugins/magento-extensions",
		"title": "Magento Themes",
		"content": "Be sure to check out all our <a href=\"https://themeforest.net/category/ecommerce/magento\">premium Magento themes</a> on ThemeForest.",
		"button_label": "Browse Magento Themes",
		"icon_source": "magneto-4d6853a18507111dc928627d1a4c1032.png",
		"link": "https://themeforest.net/category/ecommerce/magento"
	},
	{
		"match": "plugins/opencart",
		"title": "OpenCart Themes",
		"content": "Showcase your products in style with beautifully designed <a href=\"https://themeforest.net/category/ecommerce/opencart\">OpenCart themes</a> from ThemeForest. ",
		"button_label": "Browse Themes",
		"link": "https://themeforest.net/category/ecommerce/opencart"
	},
	{
		"match": "plugins/prestashop",
		"title": "PrestaShop Themes",
		"content": "Browse professionally designed <a href=\"https://themeforest.net/category/ecommerce/prestashop\">PrestaShop themes</a>, designed for functionality and conversion. ",
		"button_label": "Browse Themes",
		"link": "https://themeforest.net/category/ecommerce/prestashop"
	},
	{
		"match": "wordpress/ecommerce",
		"title": "eCommerce WordPress Themes",
		"content": "Turn your site into an online store with <a href=\"https://themeforest.net/category/wordpress/ecommerce\">eCommerce compatible WordPress themes</a> from ThemeForest. ",
		"button_label": "Browse Themes",
		"link": "https://themeforest.net/category/wordpress/ecommerce"
	},
	{
		"match": "wordpress/ecommerce/woocommerce",
		"title": "WooCommerce WordPress Themes",
		"content": "Create multi-functional WooCommerce websites using <a href=\"https://themeforest.net/category/wordpress/ecommerce/woocommerce\">WooCommerce compatible themes</a> from ThemeForest. ",
		"button_label": "Browse Themes",
		"link": "https://themeforest.net/category/wordpress/ecommerce/woocommerce"
	}
];

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports = [
	{
		"match": "graphics",
		"title": "Customize your graphics",
		"content": "Have an Envato Studio expert customize your graphics, starting from&nbsp;$20.",
		"button_label": "Customize Now",
		"icon_source": "envato-studio.png",
		"link": "https://studio.envato.com/explore/customize-graphics?utm_source=EnvatoMarket&utm_medium=graphicriver&utm_campaign=sidebar&utm_content=CustomizeGraphics"
	},
	{
		"match": "print-templates/newsletters",
		"title": "Get your copy right",
		"content": "Hire a professional Copywriter on Envato Studio to create engaging content to share with your&nbsp;customers.",
		"button_label": "Find Copywriters",
		"icon_source": "envato-studio.png",
		"link": "https://studio.envato.com/explore/copywriting?utm_source=EnvatoMarket&utm_medium=graphicriver&utm_campaign=sidebar&utm_content=GetYourCopyRight"
	},
	{
		"match": "print-templates/stationery/resumes",
		"title": "Improve your resume",
		"content": "Hire an expert Copywriter on Envato Studio to craft the perfect resume for&nbsp;you.",
		"button_label": "Find Copywriters",
		"icon_source": "envato-studio.png",
		"link": "https://studio.envato.com/explore/resumes-cover-letters?utm_source=EnvatoMarket&utm_medium=graphicriver&utm_campaign=sidebar&utm_content=ImproveYourResume"
	},
	{
		"match": "logo-templates",
		"title": "Animate your logo",
		"content": "Have an Envato Studio expert animate your logo and bring your brand to&nbsp;life.",
		"button_label": "Get Animated",
		"icon_source": "envato-studio.png",
		"link": "https://studio.envato.com/explore/logo-animation?utm_source=EnvatoMarket&utm_medium=graphicriver&utm_campaign=sidebar&utm_content=AnimateYourLogo"
	},
	{
		"match": "graphics/3d-renders",
		"title": "Need 3D Models?",
		"content": "If you need more than the layered 3D renders we sell right here, check out the thousands of <a href=\"https://3docean.net/category/3d-models\">stock 3D models</a> on our sister site, <a href=\"https://3docean.net/\">3dOcean</a>. ",
		"button_label": "Browse 3D Models",
		"icon_source": "3d.png",
		"link": "https://3docean.net/category/3d-models"
	},
	{
		"match": "presentation-templates",
		"title": "Hello World",
		"content": "If you want your <a href=\"https://graphicriver.net/category/presentation-templates/keynote-templates\">Keynote</a> or <a href=\"https://graphicriver.net/category/presentation-templates/powerpoint-templates\">Powerpoint presentation templates</a> to really stand out, you need the <a href=\"https://audiojungle.net/category/music\">right music</a>, which you can find on <a href=\"https://audiojungle.net\">AudioJungle</a>.",
		"button_label": "Browse Stock Music",
		"icon_source": "audio_v2.png",
		"link": "https://audiojungle.net/category/logos-idents"
	},
	{
		"match": "web-elements",
		"title": "Full CSS",
		"content": "If rather than just buying the web element graphics, you'd prefer it to be fully functional, be sure to check out the CSS category on CodeCanyon.",
		"button_label": "Browse CSS",
		"icon_source": "code_2.png",
		"link": "https://codecanyon.net/category/css"
	}
];

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports = [];

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports = [
	{
		"match": "ecommerce",
		"title": "eCommerce Plugins",
		"content": "Add more features to your WordPress store with premium <a href=\"https://codecanyon.net/category/wordpress/ecommerce\">eCommerce plugins for WordPress</a>. ",
		"button_label": "Browse Plugins",
		"link": "https://codecanyon.net/category/wordpress/ecommerce"
	},
	{
		"match": "ecommerce/prestashop",
		"title": "PrestaShop Modules",
		"content": "Add more features to your PrestaShop store with premium <a href=\"https://codecanyon.net/category/plugins/prestashop\">PrestaShop modules</a> and Addons. ",
		"button_label": "Browse Modules",
		"link": "https://codecanyon.net/category/plugins/prestashop"
	},
	{
		"match": "ecommerce/opencart",
		"title": "OpenCart Extensions",
		"content": "Add more features to your OpenCart store with premium <a href=\"https://codecanyon.net/category/plugins/opencart\">OpenCart extensions</a>. ",
		"button_label": "Browse Extensions",
		"link": "https://codecanyon.net/category/plugins/opencart"
	},
	{
		"match": "ecommerce/magento",
		"title": "Magento Plugins",
		"content": "Once you've found the perfect Magento theme for your store, be sure to enhance it with <a href=\"https://codecanyon.net/category/plugins/magento-extensions\">premium Magento plugins on CodeCanyon</a>. ",
		"button_label": "Browse Magento Plugins",
		"icon_source": "magneto.png",
		"link": "https://codecanyon.net/category/plugins/magento-extensions"
	},
	{
		"match": "marketing",
		"title": "Web Elements",
		"content": "Need some marketing-related graphics to go along with your marketing template? If so, check out the <a href=\"https://graphicriver.net/category/web-elements\">web elements</a> on GraphicRiver.",
		"button_label": "Browse Web Elements",
		"icon_source": "learn_v1.png",
		"link": "https://graphicriver.net/category/web-elements"
	},
	{
		"match": "psd-templates",
		"title": "Full HTML Templates",
		"content": "If you'are looking for a fully functional web template, rather than just a PSD, check out the <a href=\"https://themeforest.net/category/site-templates\">Site Templates</a> category on ThemeForest. ",
		"button_label": "Browse Site Templates",
		"icon_source": "learn_v1.png",
		"link": "https://themeforest.net/category/site-templates"
	},
	{
		"match": "wordpress",
		"title": "Learn how to use WordPress",
		"content": "Check out our <a href=\"https://webdesign.tutsplus.com/courses/a-beginners-guide-to-using-wordpress?utm_source=EnvatoMarket&utm_medium=TF_Sidebar&utm_campaign=Envato_TF_Sidebar_FreeWPCourse\">beginner's guide to WordPress</a> on Tuts+. You will learn how to to install WordPress, customise your theme and much more.",
		"button_label": "Start Free Course",
		"icon_source": "envato-tuts-black.png",
		"link": "https://webdesign.tutsplus.com/courses/a-beginners-guide-to-using-wordpress?utm_source=EnvatoMarket&utm_medium=TF_Sidebar&utm_campaign=Envato_TF_Sidebar_FreeWPCourse"
	},
	{
		"match": "wordpress",
		"title": "Get your theme installed",
		"content": "Hire an expert to install your WordPress theme for you, starting from $50 on Envato Studio.",
		"button_label": "Install Theme Now",
		"icon_source": "envato-studio.png",
		"link": "https://studio.envato.com/themeforest-installation?utm_source=EnvatoMarket&utm_medium=TF_Sidebar&utm_campaign=Envato_TF_Sidebar_WPInstall"
	},
	{
		"match": "wordpress/ecommerce",
		"title": "WordPress Plugins",
		"content": "Add powerful features to your online shop with thousands of unique <a href=\"https://codecanyon.net/category/wordpress\">WordPress plugins</a> on CodeCanyon. ",
		"button_label": "Browse Plugins",
		"link": "https://codecanyon.net/category/wordpress"
	},
	{
		"match": "wordpress/ecommerce/woocommerce",
		"title": "WooCommerce Plugins",
		"content": "Add more features to your WooCommerce store with premium <a href=\"https://codecanyon.net/category/wordpress/ecommerce/woocommerce\">WooCommerce plugins</a>. ",
		"button_label": "Browse Plugins",
		"link": "https://codecanyon.net/category/wordpress/ecommerce/woocommerce"
	}
];

/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports = [
	{
		"match": "after-effects-project-files",
		"title": "Need Music?",
		"content": "What good is an AE Project if it doesn't have the perfect music to go along with it? Find <a href=\"https://audiojungle.net/category/music\">beautiful stock music</a> on AudioJungle.",
		"button_label": "Browse Stock Music",
		"icon_source": "audio_v2.png",
		"link": "https://audiojungle.net/category/music"
	},
	{
		"match": "motion-graphics",
		"title": "Need Sound Effects?",
		"content": "What good is a video if it doesn't have the perfect sound effects to go along with it? Find <a href=\"https://audiojungle.net/category/sound\">amazing stock sound effects</a> on AudioJungle.",
		"button_label": "Browse Sound Effects",
		"icon_source": "audio_v2.png",
		"link": "https://audiojungle.net/category/music"
	},
	{
		"match": "cinema-4d-templates",
		"title": "Need C4D Models?",
		"content": "Need 3D models to go along with your Cinema 4D templates? If so, check out all the <a href=\"https://3docean.net/attributes/created-in/cinema%204d%20r10\">amazing C4D models</a> on 3dOcean. ",
		"button_label": "Browse C4D Models",
		"icon_source": "3d.png",
		"link": "https://3docean.net/attributes/created-in/cinema%204d%20r10"
	},
	{
		"match": "stock-footage",
		"title": "Need Music?",
		"content": "What good is a video if it doesn't have the perfect music to go along with it? Find <a href=\"https://audiojungle.net/category/music\">beautiful stock music</a> on AudioJungle.",
		"button_label": "Browse Stock Music",
		"icon_source": "audio_v1.png",
		"link": "https://audiojungle.net/category/music"
	},
	{
		"match": "after-effects-project-files/logo-stings",
		"title": "Audio Logo/Idents",
		"content": "Find the perfect audio Logo/Ident for your Logo Sting in our dedicated <nobr>Logos & Idents</nobr> category on AudioJungle.",
		"button_label": "Browse Audio Idents",
		"icon_source": "games_v1.png",
		"link": "https://audiojungle.net/category/logos-idents"
	}
];

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports = [
	{
		"path": "3d-models",
		"name": "3D Models"
	},
	{
		"path": "cg-textures",
		"name": "CG Textures"
	},
	{
		"path": "materials-and-shaders",
		"name": "Materials & Shaders"
	},
	{
		"path": "scripts-and-plugins",
		"name": "Scripts & Plugins"
	},
	{
		"path": "2d-concepts",
		"name": "2D Concepts"
	},
	{
		"path": "animation-data",
		"name": "Animation Data"
	},
	{
		"path": "render-setups",
		"name": "Render Setups"
	}
];

/***/ }),
/* 472 */
/***/ (function(module, exports) {

module.exports = [
	{
		"path": "music",
		"name": "Music"
	},
	{
		"path": "music-packs",
		"name": "Music Packs"
	},
	{
		"path": "music-kits",
		"name": "Music Kits"
	},
	{
		"path": "logos-idents",
		"name": "Logos & Idents"
	},
	{
		"path": "sound",
		"name": "Sound Effects"
	},
	{
		"path": "source-files",
		"name": "Source Files"
	}
];

/***/ }),
/* 473 */
/***/ (function(module, exports) {

module.exports = [
	{
		"path": "php-scripts",
		"name": "PHP Scripts"
	},
	{
		"path": "wordpress",
		"name": "WordPress"
	},
	{
		"path": "javascript",
		"name": "JavaScript"
	},
	{
		"path": "css",
		"name": "CSS"
	},
	{
		"path": "mobile",
		"name": "Mobile"
	},
	{
		"path": "html5",
		"name": "HTML5"
	},
	{
		"path": "skins",
		"name": "Skins"
	},
	{
		"path": "plugins",
		"name": "Plugins"
	},
	{
		"path": "net",
		"name": ".NET"
	},
	{
		"path": "apps",
		"name": "Apps"
	},
	{
		"path": "edge-animate-templates",
		"name": "Edge Animate Templates"
	}
];

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports = [
	{
		"path": "graphics",
		"name": "Graphics"
	},
	{
		"path": "print-templates",
		"name": "Print"
	},
	{
		"path": "epublishing",
		"name": "ePublishing"
	},
	{
		"path": "web-elements",
		"name": "Web Elements"
	},
	{
		"path": "add-ons",
		"name": "Add-ons"
	},
	{
		"path": "vectors",
		"name": "Vectors"
	},
	{
		"path": "presentation-templates",
		"name": "Presentations"
	},
	{
		"path": "infographics",
		"name": "Infographics"
	},
	{
		"path": "icons",
		"name": "Icons"
	},
	{
		"path": "fonts",
		"name": "Fonts"
	},
	{
		"path": "logo-templates",
		"name": "Logos"
	},
	{
		"path": "game-assets",
		"name": "Game Assets"
	},
	{
		"path": "isolated-objects",
		"name": "Isolated Objects"
	},
	{
		"path": "t-shirts",
		"name": "T-Shirts"
	},
	{
		"path": "textures",
		"name": "Textures"
	}
];

/***/ }),
/* 475 */
/***/ (function(module, exports) {

module.exports = [];

/***/ }),
/* 476 */
/***/ (function(module, exports) {

module.exports = [
	{
		"path": "wordpress",
		"name": "WordPress"
	},
	{
		"path": "site-templates",
		"name": "HTML"
	},
	{
		"path": "marketing",
		"name": "Marketing"
	},
	{
		"path": "cms-themes",
		"name": "CMS"
	},
	{
		"path": "ecommerce",
		"name": "eCommerce"
	},
	{
		"path": "muse-templates",
		"name": "Muse"
	},
	{
		"path": "sketch-templates",
		"name": "UI Design"
	},
	{
		"path": "psd-templates",
		"name": "PSD Templates"
	},
	{
		"path": "blogging",
		"name": "Blogging"
	},
	{
		"path": "courses",
		"name": "Courses"
	},
	{
		"path": "forums",
		"name": "Forums"
	},
	{
		"path": "typeengine-themes",
		"name": "TypeEngine Themes"
	}
];

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports = [
	{
		"path": "after-effects-project-files",
		"name": "After Effects Project Files"
	},
	{
		"path": "apple-motion-templates",
		"name": "Apple Motion"
	},
	{
		"path": "motion-graphics",
		"name": "Motion Graphics"
	},
	{
		"path": "stock-footage",
		"name": "Stock Footage"
	},
	{
		"path": "cinema-4d-templates",
		"name": "Cinema 4D Templates"
	},
	{
		"path": "add-ons",
		"name": "Add Ons"
	}
];

/***/ }),
/* 478 */
/***/ (function(module, exports) {

module.exports = [
	{
		"name": "All Items",
		"url": "/category/all",
		"children": [
			{
				"name": "Popular Files",
				"url": "/page/top_sellers"
			},
			{
				"name": "Featured Files",
				"url": "/feature"
			},
			{
				"name": "Top New Files",
				"url": "/search?date=this-month&length_max=&length_min=&price_max=&price_min=&rating_min=&sales=&sort=sales&term=&utf8=%E2%9C%93&view=list"
			},
			{
				"name": "Follow Feed",
				"url": "/follow_feed"
			},
			{
				"name": "Top Authors",
				"url": "/authors/top"
			},
			{
				"name": "Top New Authors",
				"url": "/page/top_new_sellers"
			},
			{
				"name": "Public Collections",
				"url": "/collections"
			},
			{
				"name": "View All Categories",
				"url": "/category"
			}
		]
	},
	{
		"name": "3D Models",
		"url": "/category/3d-models",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=3d-models",
				"isTop": true
			},
			{
				"name": "Anatomy",
				"url": "/category/3d-models/anatomy"
			},
			{
				"name": "Animals",
				"url": "/category/3d-models/animals"
			},
			{
				"name": "Base Meshes",
				"url": "/category/3d-models/base-meshes"
			},
			{
				"name": "Buildings and Architecture",
				"url": "/category/3d-models/buildings-and-architecture"
			},
			{
				"name": "Clothes & Accessories",
				"url": "/category/3d-models/clothes-accessories"
			},
			{
				"name": "Deco Objects",
				"url": "/category/3d-models/deco-objects"
			},
			{
				"name": "Design Elements",
				"url": "/category/3d-models/design-elements"
			},
			{
				"name": "Electronics",
				"url": "/category/3d-models/electronics"
			},
			{
				"name": "Engines and Parts",
				"url": "/category/3d-models/engines-and-parts"
			},
			{
				"name": "Fantasy and Fiction",
				"url": "/category/3d-models/fantasy-and-fiction"
			},
			{
				"name": "Food and Drinks",
				"url": "/category/3d-models/food-and-drinks"
			},
			{
				"name": "Furnishings",
				"url": "/category/3d-models/furnishings"
			},
			{
				"name": "Humans",
				"url": "/category/3d-models/humans"
			},
			{
				"name": "Music",
				"url": "/category/3d-models/music"
			},
			{
				"name": "Nature",
				"url": "/category/3d-models/nature"
			},
			{
				"name": "Products",
				"url": "/category/3d-models/products"
			},
			{
				"name": "Science",
				"url": "/category/3d-models/science"
			},
			{
				"name": "Sports",
				"url": "/category/3d-models/sports"
			},
			{
				"name": "Theme Packages",
				"url": "/category/3d-models/theme-packages"
			},
			{
				"name": "Tools",
				"url": "/category/3d-models/tools"
			},
			{
				"name": "Toys and Games",
				"url": "/category/3d-models/toys-and-games"
			},
			{
				"name": "Vehicles",
				"url": "/category/3d-models/vehicles"
			},
			{
				"name": "Weapons and Armor",
				"url": "/category/3d-models/weapons-and-armor"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/3d-models/miscellaneous"
			}
		]
	},
	{
		"name": "Cars",
		"url": "/category/3d-models/vehicles/land/cars",
		"children": []
	},
	{
		"name": "HDRI Images",
		"url": "/category/cg-textures/hdri-images",
		"children": [
			{
				"name": "Exterior",
				"url": "/category/cg-textures/hdri-images/exterior"
			},
			{
				"name": "Interior",
				"url": "/category/cg-textures/hdri-images/interior"
			},
			{
				"name": "Sky",
				"url": "/category/cg-textures/hdri-images/exterior/sky"
			}
		]
	},
	{
		"name": "CG Textures",
		"url": "/category/cg-textures",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=cg-textures",
				"isTop": true
			},
			{
				"name": "Bones",
				"url": "/category/cg-textures/bones"
			},
			{
				"name": "Buildings",
				"url": "/category/cg-textures/buildings"
			},
			{
				"name": "Concrete",
				"url": "/category/cg-textures/concrete"
			},
			{
				"name": "Doors",
				"url": "/category/cg-textures/doors"
			},
			{
				"name": "Fabric",
				"url": "/category/cg-textures/fabric"
			},
			{
				"name": "Fauna",
				"url": "/category/cg-textures/fauna"
			},
			{
				"name": "Flora",
				"url": "/category/cg-textures/flora"
			},
			{
				"name": "Ground",
				"url": "/category/cg-textures/ground"
			},
			{
				"name": "HDRI Images",
				"url": "/category/cg-textures/hdri-images"
			},
			{
				"name": "Humans",
				"url": "/category/cg-textures/humans"
			},
			{
				"name": "Ice",
				"url": "/category/cg-textures/ice"
			},
			{
				"name": "Metal",
				"url": "/category/cg-textures/metal"
			},
			{
				"name": "Ornaments",
				"url": "/category/cg-textures/ornaments"
			},
			{
				"name": "Paper",
				"url": "/category/cg-textures/paper"
			},
			{
				"name": "Plaster",
				"url": "/category/cg-textures/plaster"
			},
			{
				"name": "Plastic",
				"url": "/category/cg-textures/plastic"
			},
			{
				"name": "Roads",
				"url": "/category/cg-textures/roads"
			},
			{
				"name": "Roofing",
				"url": "/category/cg-textures/roofing"
			},
			{
				"name": "Skies",
				"url": "/category/cg-textures/skies"
			},
			{
				"name": "Splatter",
				"url": "/category/cg-textures/splatter"
			},
			{
				"name": "Stone",
				"url": "/category/cg-textures/stone"
			},
			{
				"name": "Tiles",
				"url": "/category/cg-textures/tiles"
			},
			{
				"name": "Walls",
				"url": "/category/cg-textures/walls"
			},
			{
				"name": "Water",
				"url": "/category/cg-textures/water"
			},
			{
				"name": "Windows",
				"url": "/category/cg-textures/windows"
			},
			{
				"name": "Wood",
				"url": "/category/cg-textures/wood"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/cg-textures/miscellaneous"
			}
		]
	},
	{
		"name": "Materials & Shaders",
		"url": "/category/materials-and-shaders",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=materials-and-shaders",
				"isTop": true
			},
			{
				"name": "Ceramic",
				"url": "/category/materials-and-shaders/ceramic"
			},
			{
				"name": "Fabric",
				"url": "/category/materials-and-shaders/fabric"
			},
			{
				"name": "Glass",
				"url": "/category/materials-and-shaders/glass"
			},
			{
				"name": "Glow",
				"url": "/category/materials-and-shaders/glow"
			},
			{
				"name": "Marble",
				"url": "/category/materials-and-shaders/marble"
			},
			{
				"name": "Metal",
				"url": "/category/materials-and-shaders/metal"
			},
			{
				"name": "Organic",
				"url": "/category/materials-and-shaders/organic"
			},
			{
				"name": "Plastic",
				"url": "/category/materials-and-shaders/plastic"
			},
			{
				"name": "Sci-fi",
				"url": "/category/materials-and-shaders/sci-fi"
			},
			{
				"name": "Stone",
				"url": "/category/materials-and-shaders/stone"
			},
			{
				"name": "Water",
				"url": "/category/materials-and-shaders/water"
			},
			{
				"name": "Wood",
				"url": "/category/materials-and-shaders/wood"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/materials-and-shaders/miscellaneous"
			}
		]
	},
	{
		"name": "Base Meshes",
		"url": "/category/3d-models/base-meshes",
		"children": []
	},
	{
		"name": "Scripts & Plugins",
		"url": "/category/scripts-and-plugins",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=scripts-and-plugins",
				"isTop": true
			},
			{
				"name": "Plugins",
				"url": "/category/scripts-and-plugins/plugins"
			},
			{
				"name": "Scripts",
				"url": "/category/scripts-and-plugins/scripts"
			}
		]
	},
	{
		"name": "More",
		"url": "/category",
		"children": [
			{
				"name": "2D Concepts",
				"url": "/category/2d-concepts"
			},
			{
				"name": "Animation Data",
				"url": "/category/animation-data"
			},
			{
				"name": "Render Setups",
				"url": "/category/render-setups"
			}
		]
	}
];

/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports = [
	{
		"name": "All Items",
		"url": "/category/all",
		"children": [
			{
				"name": "Popular Files",
				"url": "/page/top_sellers"
			},
			{
				"name": "Featured Files",
				"url": "/feature"
			},
			{
				"name": "Top New Files",
				"url": "/search?date=this-month&length_max=&length_min=&price_max=&price_min=&rating_min=&sales=&sort=sales&term=&utf8=%E2%9C%93&view=list"
			},
			{
				"name": "Follow Feed",
				"url": "/follow_feed"
			},
			{
				"name": "Top Authors",
				"url": "/authors/top"
			},
			{
				"name": "Top New Authors",
				"url": "/page/top_new_sellers"
			},
			{
				"name": "Public Collections",
				"url": "/collections"
			},
			{
				"name": "View All Categories",
				"url": "/category"
			}
		]
	},
	{
		"name": "Music",
		"url": "/category/music",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=music",
				"isTop": true
			},
			{
				"name": "Ambient",
				"url": "/category/music/ambient"
			},
			{
				"name": "Children's",
				"url": "/category/music/children-s"
			},
			{
				"name": "Cinematic",
				"url": "/category/music/cinematic"
			},
			{
				"name": "Classical",
				"url": "/category/music/classical"
			},
			{
				"name": "Corporate",
				"url": "/category/music/corporate"
			},
			{
				"name": "Country, Western",
				"url": "/category/music/country-western"
			},
			{
				"name": "Drum & Bass, Breakbeat",
				"url": "/category/music/drum-bass-breakbeat"
			},
			{
				"name": "Electronica",
				"url": "/category/music/electronica"
			},
			{
				"name": "Experimental, Abstract",
				"url": "/category/music/experimental-abstract"
			},
			{
				"name": "Folk, Acoustic",
				"url": "/category/music/folk-acoustic"
			},
			{
				"name": "Funk, Groove",
				"url": "/category/music/funk-groove"
			},
			{
				"name": "Hip-Hop",
				"url": "/category/music/hip-hop"
			},
			{
				"name": "Holiday & Seasonal",
				"url": "/category/music/holiday-seasonal"
			},
			{
				"name": "House",
				"url": "/category/music/house"
			},
			{
				"name": "Jazz",
				"url": "/category/music/jazz"
			},
			{
				"name": "Percussion",
				"url": "/category/music/percussion"
			},
			{
				"name": "Pop",
				"url": "/category/music/pop"
			},
			{
				"name": "Rock",
				"url": "/category/music/rock"
			},
			{
				"name": "Soul, R&B",
				"url": "/category/music/soul-r-b"
			},
			{
				"name": "Vocals, Voice",
				"url": "/category/music/vocals-voice"
			},
			{
				"name": "World Beat",
				"url": "/category/music/world-beat"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/music/miscellaneous"
			}
		]
	},
	{
		"name": "Music Packs",
		"url": "/category/music-packs",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=music-packs",
				"isTop": true
			},
			{
				"name": "Ambient",
				"url": "/category/music-packs/ambient"
			},
			{
				"name": "Children's",
				"url": "/category/music-packs/children-s"
			},
			{
				"name": "Cinematic",
				"url": "/category/music-packs/cinematic"
			},
			{
				"name": "Classical",
				"url": "/category/music-packs/classical"
			},
			{
				"name": "Corporate",
				"url": "/category/music-packs/corporate"
			},
			{
				"name": "Country, Western",
				"url": "/category/music-packs/country-western"
			},
			{
				"name": "Drum & Bass, Breakbeat",
				"url": "/category/music-packs/drum-bass-breakbeat"
			},
			{
				"name": "Electronica",
				"url": "/category/music-packs/electronica"
			},
			{
				"name": "Experimental, Abstract",
				"url": "/category/music-packs/experimental-abstract"
			},
			{
				"name": "Folk, Acoustic",
				"url": "/category/music-packs/folk-acoustic"
			},
			{
				"name": "Funk, Groove",
				"url": "/category/music-packs/funk-groove"
			},
			{
				"name": "Hip-Hop",
				"url": "/category/music-packs/hip-hop"
			},
			{
				"name": "Holiday & Seasonal",
				"url": "/category/music-packs/holiday-seasonal"
			},
			{
				"name": "House",
				"url": "/category/music-packs/house"
			},
			{
				"name": "Jazz",
				"url": "/category/music-packs/jazz"
			},
			{
				"name": "Percussion",
				"url": "/category/music-packs/percussion"
			},
			{
				"name": "Pop",
				"url": "/category/music-packs/pop"
			},
			{
				"name": "Rock",
				"url": "/category/music-packs/rock"
			},
			{
				"name": "Soul, R&B",
				"url": "/category/music-packs/soul-r-b"
			},
			{
				"name": "Vocals, Voice",
				"url": "/category/music-packs/vocals-voice"
			},
			{
				"name": "World Beat",
				"url": "/category/music-packs/world-beat"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/music-packs/miscellaneous"
			}
		]
	},
	{
		"name": "Music Kits",
		"url": "/category/music-kits",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=music-kits",
				"isTop": true
			},
			{
				"name": "Ambient",
				"url": "/category/music-kits/ambient"
			},
			{
				"name": "Children's",
				"url": "/category/music-kits/children-s"
			},
			{
				"name": "Cinematic",
				"url": "/category/music-kits/cinematic"
			},
			{
				"name": "Classical",
				"url": "/category/music-kits/classical"
			},
			{
				"name": "Corporate",
				"url": "/category/music-kits/corporate"
			},
			{
				"name": "Country, Western",
				"url": "/category/music-kits/country-western"
			},
			{
				"name": "Drum & Bass, Breakbeat",
				"url": "/category/music-kits/drum-bass-breakbeat"
			},
			{
				"name": "Electronica",
				"url": "/category/music-kits/electronica"
			},
			{
				"name": "Experimental, Abstract",
				"url": "/category/music-kits/experimental-abstract"
			},
			{
				"name": "Folk, Acoustic",
				"url": "/category/music-kits/folk-acoustic"
			},
			{
				"name": "Funk, Groove",
				"url": "/category/music-kits/funk-groove"
			},
			{
				"name": "Hip-Hop",
				"url": "/category/music-kits/hip-hop"
			},
			{
				"name": "Holiday & Seasonal",
				"url": "/category/music-kits/holiday-seasonal"
			},
			{
				"name": "House",
				"url": "/category/music-kits/house"
			},
			{
				"name": "Jazz",
				"url": "/category/music-kits/jazz"
			},
			{
				"name": "Percussion",
				"url": "/category/music-kits/percussion"
			},
			{
				"name": "Pop",
				"url": "/category/music-kits/pop"
			},
			{
				"name": "Rock",
				"url": "/category/music-kits/rock"
			},
			{
				"name": "Soul, R&B",
				"url": "/category/music-kits/soul-r-b"
			},
			{
				"name": "Vocals, Voice",
				"url": "/category/music-kits/vocals-voice"
			},
			{
				"name": "World Beat",
				"url": "/category/music-kits/world-beat"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/music-kits/miscellaneous"
			}
		],
		"isNew": true
	},
	{
		"name": "Logos & Idents",
		"url": "/category/logos-idents",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=logos-idents",
				"isTop": true
			},
			{
				"name": "Individual",
				"url": "/category/logos-idents/individual"
			},
			{
				"name": "Packs",
				"url": "/category/logos-idents/packs"
			}
		]
	},
	{
		"name": "Sound Effects",
		"url": "/category/sound",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=sound",
				"isTop": true
			},
			{
				"name": "Buttons & Menus",
				"url": "/category/sound/buttons-menus"
			},
			{
				"name": "Cartoon Sounds",
				"url": "/category/sound/cartoon-sounds"
			},
			{
				"name": "Domestic Sounds",
				"url": "/category/sound/domestic-sounds"
			},
			{
				"name": "Futuristic Sounds",
				"url": "/category/sound/futuristic-sounds"
			},
			{
				"name": "Game Sounds",
				"url": "/category/sound/game-sounds"
			},
			{
				"name": "Human Sounds",
				"url": "/category/sound/human-sounds"
			},
			{
				"name": "Industrial Sounds",
				"url": "/category/sound/industrial-sounds"
			},
			{
				"name": "Interface Sounds",
				"url": "/category/sound/interface-sounds"
			},
			{
				"name": "Nature Sounds",
				"url": "/category/sound/nature-sounds"
			},
			{
				"name": "Sound",
				"url": "/category/sound/sound"
			},
			{
				"name": "Sound Packs",
				"url": "/category/sound/sound-packs"
			},
			{
				"name": "Transitions & Movement",
				"url": "/category/sound/transitions-movement"
			},
			{
				"name": "Urban Sounds",
				"url": "/category/sound/urban-sounds"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/sound/miscellaneous"
			}
		]
	},
	{
		"name": "Source Files",
		"url": "/category/source-files",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=source-files",
				"isTop": true
			},
			{
				"name": "Cubase",
				"url": "/category/source-files/cubase"
			},
			{
				"name": "FL Studio",
				"url": "/category/source-files/fl-studio"
			},
			{
				"name": "Logic Pro",
				"url": "/category/source-files/logic-pro"
			},
			{
				"name": "Reason",
				"url": "/category/source-files/reason"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/source-files/miscellaneous"
			}
		]
	}
];

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports = [
	{
		"name": "All Items",
		"url": "/category/all",
		"children": [
			{
				"name": "Popular Files",
				"url": "/page/top_sellers"
			},
			{
				"name": "Featured Files",
				"url": "/feature"
			},
			{
				"name": "Top New Files",
				"url": "/search?date=this-month&length_max=&length_min=&price_max=&price_min=&rating_min=&sales=&sort=sales&term=&utf8=%E2%9C%93&view=list"
			},
			{
				"name": "Follow Feed",
				"url": "/follow_feed"
			},
			{
				"name": "Top Authors",
				"url": "/authors/top"
			},
			{
				"name": "Top New Authors",
				"url": "/page/top_new_sellers"
			},
			{
				"name": "Public Collections",
				"url": "/collections"
			},
			{
				"name": "View All Categories",
				"url": "/category"
			}
		]
	},
	{
		"name": "PHP Scripts",
		"url": "/category/php-scripts",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=php-scripts",
				"isTop": true
			},
			{
				"name": "Add-ons",
				"url": "/category/php-scripts/add-ons"
			},
			{
				"name": "Calendars",
				"url": "/category/php-scripts/calendars"
			},
			{
				"name": "Countdowns",
				"url": "/category/php-scripts/countdowns"
			},
			{
				"name": "Database Abstractions",
				"url": "/category/php-scripts/database-abstractions"
			},
			{
				"name": "Forms",
				"url": "/category/php-scripts/forms"
			},
			{
				"name": "Help and Support Tools",
				"url": "/category/php-scripts/help-and-support-tools"
			},
			{
				"name": "Images and Media",
				"url": "/category/php-scripts/images-and-media"
			},
			{
				"name": "Loaders and Uploaders",
				"url": "/category/php-scripts/loaders-and-uploaders"
			},
			{
				"name": "Navigation",
				"url": "/category/php-scripts/navigation"
			},
			{
				"name": "News Tickers",
				"url": "/category/php-scripts/news-tickers"
			},
			{
				"name": "Polls",
				"url": "/category/php-scripts/polls"
			},
			{
				"name": "Project Management Tools",
				"url": "/category/php-scripts/project-management-tools"
			},
			{
				"name": "Ratings and Charts",
				"url": "/category/php-scripts/ratings-and-charts"
			},
			{
				"name": "Search",
				"url": "/category/php-scripts/search"
			},
			{
				"name": "Shopping Carts",
				"url": "/category/php-scripts/shopping-carts"
			},
			{
				"name": "Social Networking",
				"url": "/category/php-scripts/social-networking"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/php-scripts/miscellaneous"
			}
		]
	},
	{
		"name": "WordPress",
		"url": "/category/wordpress",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=wordpress",
				"isTop": true
			},
			{
				"name": "Add-ons",
				"url": "/category/wordpress/add-ons"
			},
			{
				"name": "Advertising",
				"url": "/category/wordpress/advertising"
			},
			{
				"name": "Auctions",
				"url": "/category/wordpress/auctions"
			},
			{
				"name": "Calendars",
				"url": "/category/wordpress/calendars"
			},
			{
				"name": "eCommerce",
				"url": "/category/wordpress/ecommerce"
			},
			{
				"name": "Forms",
				"url": "/category/wordpress/forms"
			},
			{
				"name": "Forums",
				"url": "/category/wordpress/forums"
			},
			{
				"name": "Galleries",
				"url": "/category/wordpress/galleries"
			},
			{
				"name": "Interface Elements",
				"url": "/category/wordpress/interface-elements"
			},
			{
				"name": "Layers WP",
				"url": "/attributes/compatible-with/layers%20wp"
			},
			{
				"name": "Media",
				"url": "/category/wordpress/media"
			},
			{
				"name": "Membership",
				"url": "/category/wordpress/membership"
			},
			{
				"name": "Newsletters",
				"url": "/category/wordpress/newsletters"
			},
			{
				"name": "SEO",
				"url": "/category/wordpress/seo"
			},
			{
				"name": "Social Networking",
				"url": "/category/wordpress/social-networking"
			},
			{
				"name": "Utilities",
				"url": "/category/wordpress/utilities"
			},
			{
				"name": "Widgets",
				"url": "/category/wordpress/widgets"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/wordpress/miscellaneous"
			},
			{
				"name": "WordPress Themes on ThemeForest",
				"url": "http://themeforest.net/category/wordpress",
				"isBottom": true
			}
		]
	},
	{
		"name": "eCommerce",
		"url": "/tags/ecommerce",
		"children": [
			{
				"name": "Easy Digital Downloads",
				"url": "/search?compatible_with=Easy+Digital+Downloads"
			},
			{
				"name": "Jigoshop",
				"url": "/category/wordpress/ecommerce/jigoshop"
			},
			{
				"name": "Magento Extensions",
				"url": "/category/plugins/magento-extensions"
			},
			{
				"name": "OpenCart",
				"url": "/category/plugins/opencart"
			},
			{
				"name": "osCommerce",
				"url": "/category/plugins/oscommerce"
			},
			{
				"name": "Prestashop",
				"url": "/category/plugins/prestashop"
			},
			{
				"name": "UberCart",
				"url": "/category/plugins/ubercart"
			},
			{
				"name": "VirtueMart",
				"url": "/category/plugins/virtuemart"
			},
			{
				"name": "WooCommerce",
				"url": "/category/wordpress/ecommerce/woocommerce"
			},
			{
				"name": "WP e-Commerce",
				"url": "/category/wordpress/ecommerce/wp-e-commerce"
			},
			{
				"name": "WP Standalone",
				"url": "/category/wordpress/ecommerce/standalone"
			},
			{
				"name": "Zen Cart",
				"url": "/category/plugins/zen-cart"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/wordpress/ecommerce/miscellaneous"
			}
		]
	},
	{
		"name": "JavaScript",
		"url": "/category/javascript",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=javascript",
				"isTop": true
			},
			{
				"name": "Animated SVGs",
				"url": "/category/javascript/animated-svgs"
			},
			{
				"name": "Calendars",
				"url": "/category/javascript/calendars"
			},
			{
				"name": "Countdowns",
				"url": "/category/javascript/countdowns"
			},
			{
				"name": "Database Abstractions",
				"url": "/category/javascript/database-abstractions"
			},
			{
				"name": "Forms",
				"url": "/category/javascript/forms"
			},
			{
				"name": "Images and Media",
				"url": "/category/javascript/images-and-media"
			},
			{
				"name": "Loaders and Uploaders",
				"url": "/category/javascript/loaders-and-uploaders"
			},
			{
				"name": "Media",
				"url": "/category/javascript/media"
			},
			{
				"name": "Navigation",
				"url": "/category/javascript/navigation"
			},
			{
				"name": "News Tickers",
				"url": "/category/javascript/news-tickers"
			},
			{
				"name": "Project Management Tools",
				"url": "/category/javascript/project-management-tools"
			},
			{
				"name": "Ratings and Charts",
				"url": "/category/javascript/ratings-and-charts"
			},
			{
				"name": "Shopping Carts",
				"url": "/category/javascript/shopping-carts"
			},
			{
				"name": "Sliders",
				"url": "/category/javascript/sliders"
			},
			{
				"name": "Social Networks",
				"url": "/category/javascript/social-networks"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/javascript/miscellaneous"
			}
		]
	},
	{
		"name": "CSS",
		"url": "/category/css",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=css",
				"isTop": true
			},
			{
				"name": "Animations and Effects",
				"url": "/category/css/animations-and-effects"
			},
			{
				"name": "Buttons",
				"url": "/category/css/buttons"
			},
			{
				"name": "Charts and Graphs",
				"url": "/category/css/charts-and-graphs"
			},
			{
				"name": "Forms",
				"url": "/category/css/forms"
			},
			{
				"name": "Layouts",
				"url": "/category/css/layouts"
			},
			{
				"name": "Navigation and Menus",
				"url": "/category/css/navigation-and-menus"
			},
			{
				"name": "Pricing Tables",
				"url": "/category/css/pricing-tables"
			},
			{
				"name": "Tabs and Sliders",
				"url": "/category/css/tabs-and-sliders"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/css/miscellaneous"
			}
		]
	},
	{
		"name": "Mobile",
		"url": "/category/mobile",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=mobile",
				"isTop": true
			},
			{
				"name": "Android",
				"url": "/category/mobile/android"
			},
			{
				"name": "iOS",
				"url": "/category/mobile/ios"
			},
			{
				"name": "Native Web",
				"url": "/category/mobile/native-web"
			},
			{
				"name": "Titanium",
				"url": "/category/mobile/titanium"
			}
		]
	},
	{
		"name": "HTML5",
		"url": "/category/html5",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=html5",
				"isTop": true
			},
			{
				"name": "3D",
				"url": "/category/html5/3d"
			},
			{
				"name": "Ad Templates",
				"url": "/category/html5/ad-templates"
			},
			{
				"name": "Canvas",
				"url": "/category/html5/canvas"
			},
			{
				"name": "Charts and Graphs",
				"url": "/category/html5/charts-and-graphs"
			},
			{
				"name": "Forms",
				"url": "/category/html5/forms"
			},
			{
				"name": "Games",
				"url": "/category/html5/games"
			},
			{
				"name": "Libraries",
				"url": "/category/html5/libraries"
			},
			{
				"name": "Media",
				"url": "/category/html5/media"
			},
			{
				"name": "Presentations",
				"url": "/category/html5/presentations"
			},
			{
				"name": "Sliders",
				"url": "/category/html5/sliders"
			},
			{
				"name": "Storage",
				"url": "/category/html5/storage"
			},
			{
				"name": "Templates",
				"url": "/category/html5/templates"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/html5/miscellaneous"
			}
		]
	},
	{
		"name": "Skins",
		"url": "/category/skins",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=skins",
				"isTop": true
			},
			{
				"name": "Bootstrap",
				"url": "/category/skins/bootstrap"
			},
			{
				"name": "Layers WP Style Kits",
				"url": "/category/skins/layers-wp-style-kits"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/skins/miscellaneous"
			}
		]
	},
	{
		"name": "WP Themes",
		"url": "http://themeforest.net/category/wordpress",
		"children": []
	},
	{
		"name": "Plugins",
		"url": "/category/plugins",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=plugins",
				"isTop": true
			},
			{
				"name": "Concrete5",
				"url": "/category/plugins/concrete5"
			},
			{
				"name": "Drupal",
				"url": "/category/plugins/drupal"
			},
			{
				"name": "ExpressionEngine",
				"url": "/category/plugins/expressionengine"
			},
			{
				"name": "Joomla",
				"url": "/category/plugins/joomla"
			},
			{
				"name": "Magento Extensions",
				"url": "/category/plugins/magento-extensions"
			},
			{
				"name": "Muse Widgets",
				"url": "/category/plugins/muse-widgets"
			},
			{
				"name": "OpenCart",
				"url": "/category/plugins/opencart"
			},
			{
				"name": "osCommerce",
				"url": "/category/plugins/oscommerce"
			},
			{
				"name": "Prestashop",
				"url": "/category/plugins/prestashop"
			},
			{
				"name": "Ubercart",
				"url": "/category/plugins/ubercart"
			},
			{
				"name": "VirtueMart",
				"url": "/category/plugins/virtuemart"
			},
			{
				"name": "Zen Cart",
				"url": "/category/plugins/zen-cart"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/plugins/miscellaneous"
			}
		]
	},
	{
		"name": "More",
		"url": "/category",
		"children": [
			{
				"name": ".NET",
				"url": "/category/net"
			},
			{
				"name": "Apps",
				"url": "/category/apps"
			},
			{
				"name": "Edge Animate Templates",
				"url": "/category/edge-animate-templates"
			},
			{
				"name": "Facebook",
				"url": "/search?term=facebook&type=files"
			}
		]
	}
];

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports = [
	{
		"name": "All Items",
		"url": "/category/all",
		"children": [
			{
				"name": "Popular Files",
				"url": "/page/top_sellers"
			},
			{
				"name": "Featured Files",
				"url": "/feature"
			},
			{
				"name": "Top New Files",
				"url": "/search?date=this-month&length_max=&length_min=&price_max=&price_min=&rating_min=&sales=&sort=sales&term=&utf8=%E2%9C%93&view=list"
			},
			{
				"name": "Follow Feed",
				"url": "/follow_feed"
			},
			{
				"name": "Top Authors",
				"url": "/authors/top"
			},
			{
				"name": "Top New Authors",
				"url": "/page/top_new_sellers"
			},
			{
				"name": "Public Collections",
				"url": "/collections"
			},
			{
				"name": "View All Categories",
				"url": "/category"
			}
		]
	},
	{
		"name": "Graphics",
		"url": "/category/graphics",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=graphics",
				"isTop": true
			},
			{
				"name": "3D Renders",
				"url": "/category/graphics/3d-renders"
			},
			{
				"name": "Backgrounds",
				"url": "/category/graphics/backgrounds"
			},
			{
				"name": "Decorative",
				"url": "/category/graphics/decorative"
			},
			{
				"name": "Hero Images",
				"url": "/category/graphics/hero-images"
			},
			{
				"name": "Illustrations",
				"url": "/category/graphics/illustrations"
			},
			{
				"name": "Photo Templates",
				"url": "/category/graphics/photo-templates"
			},
			{
				"name": "Product Mock-Ups",
				"url": "/category/graphics/product-mock-ups"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/graphics/miscellaneous"
			}
		]
	},
	{
		"name": "Print",
		"url": "/category/print-templates",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=print-templates",
				"isTop": true
			},
			{
				"name": "Brochures",
				"url": "/category/print-templates/brochures"
			},
			{
				"name": "Business Cards",
				"url": "/category/print-templates/business-cards"
			},
			{
				"name": "Cards & Invites",
				"url": "/category/print-templates/cards-invites"
			},
			{
				"name": "CD & DVD Artwork",
				"url": "/category/print-templates/cd-dvd-artwork"
			},
			{
				"name": "ePublishing",
				"url": "/category/epublishing"
			},
			{
				"name": "Flyers",
				"url": "/category/print-templates/flyers"
			},
			{
				"name": "Food Menus",
				"url": "/category/print-templates/food-menus"
			},
			{
				"name": "Magazines",
				"url": "/category/print-templates/magazines"
			},
			{
				"name": "Newsletters",
				"url": "/category/print-templates/newsletters"
			},
			{
				"name": "Packaging",
				"url": "/category/print-templates/packaging"
			},
			{
				"name": "Photo Albums",
				"url": "/category/print-templates/photo-albums"
			},
			{
				"name": "Signage",
				"url": "/category/print-templates/signage"
			},
			{
				"name": "Stationery",
				"url": "/category/print-templates/stationery"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/print-templates/miscellaneous"
			}
		]
	},
	{
		"name": "Web Elements",
		"url": "/category/web-elements",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=web-elements",
				"isTop": true
			},
			{
				"name": "404 Pages",
				"url": "/category/web-elements/4-4-pages"
			},
			{
				"name": "Badges & Stickers",
				"url": "/category/web-elements/badges-stickers"
			},
			{
				"name": "Banners & Ads",
				"url": "/category/web-elements/banners-ads"
			},
			{
				"name": "Buttons",
				"url": "/category/web-elements/buttons"
			},
			{
				"name": "E-newsletters",
				"url": "/category/web-elements/e-newsletters"
			},
			{
				"name": "Forms",
				"url": "/category/web-elements/forms"
			},
			{
				"name": "Navigation Bars",
				"url": "/category/web-elements/navigation-bars"
			},
			{
				"name": "Sliders & Features",
				"url": "/category/web-elements/sliders-features"
			},
			{
				"name": "Social Media",
				"url": "/category/web-elements/social-media"
			},
			{
				"name": "Tables",
				"url": "/category/web-elements/tables"
			},
			{
				"name": "User Interfaces",
				"url": "/category/web-elements/user-interfaces"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/web-elements/miscellaneous"
			}
		]
	},
	{
		"name": "Add-ons",
		"url": "/category/add-ons",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=add-ons",
				"isTop": true
			},
			{
				"name": "Aperture Presets",
				"url": "/category/add-ons/aperture-presets"
			},
			{
				"name": "Illustrator",
				"url": "/category/add-ons/illustrator"
			},
			{
				"name": "Lightroom Presets",
				"url": "/category/add-ons/lightroom-presets"
			},
			{
				"name": "Photoshop",
				"url": "/category/add-ons/photoshop"
			},
			{
				"name": "Sketch Plugins",
				"url": "/category/add-ons/sketch-plugins"
			}
		]
	},
	{
		"name": "Vectors",
		"url": "/category/vectors",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=vectors",
				"isTop": true
			},
			{
				"name": "Characters",
				"url": "/category/vectors/characters"
			},
			{
				"name": "Conceptual",
				"url": "/category/vectors/conceptual"
			},
			{
				"name": "Decorative",
				"url": "/category/vectors/decorative"
			},
			{
				"name": "Objects",
				"url": "/category/vectors/objects"
			},
			{
				"name": "Tattoos",
				"url": "/category/vectors/tattoos"
			},
			{
				"name": "Web Elements",
				"url": "/category/vectors/web-elements"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/vectors/miscellaneous"
			}
		]
	},
	{
		"name": "Presentations",
		"url": "/category/presentation-templates",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=presentation-templates",
				"isTop": true
			},
			{
				"name": "Google Slides",
				"url": "/category/presentation-templates/google-slides"
			},
			{
				"name": "Keynote Templates",
				"url": "/category/presentation-templates/keynote-templates"
			},
			{
				"name": "PowerPoint Templates",
				"url": "/category/presentation-templates/powerpoint-templates"
			}
		]
	},
	{
		"name": "Infographics",
		"url": "/category/infographics",
		"children": []
	},
	{
		"name": "Icons",
		"url": "/category/icons",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=icons",
				"isTop": true
			},
			{
				"name": "Abstract",
				"url": "/category/icons/abstract"
			},
			{
				"name": "Business",
				"url": "/category/icons/business"
			},
			{
				"name": "Characters",
				"url": "/category/icons/characters"
			},
			{
				"name": "Media",
				"url": "/category/icons/media"
			},
			{
				"name": "Objects",
				"url": "/category/icons/objects"
			},
			{
				"name": "Seasonal",
				"url": "/category/icons/seasonal"
			},
			{
				"name": "Software",
				"url": "/category/icons/software"
			},
			{
				"name": "Technology",
				"url": "/category/icons/technology"
			},
			{
				"name": "Web",
				"url": "/category/icons/web"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/icons/miscellaneous"
			}
		]
	},
	{
		"name": "Fonts",
		"url": "/category/fonts",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=fonts",
				"isTop": true
			},
			{
				"name": "Cool",
				"url": "/category/fonts/cool"
			},
			{
				"name": "Decorative",
				"url": "/category/fonts/decorative"
			},
			{
				"name": "Ding-bats",
				"url": "/category/fonts/ding-bats"
			},
			{
				"name": "Fancy",
				"url": "/category/fonts/fancy"
			},
			{
				"name": "Graffiti",
				"url": "/category/fonts/graffiti"
			},
			{
				"name": "Handwriting",
				"url": "/category/fonts/handwriting"
			},
			{
				"name": "Sans-Serif",
				"url": "/category/fonts/sans-serif"
			},
			{
				"name": "Script",
				"url": "/category/fonts/script"
			},
			{
				"name": "Serif",
				"url": "/category/fonts/serif"
			}
		]
	},
	{
		"name": "Logos",
		"url": "/category/logo-templates",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=logo-templates",
				"isTop": true
			},
			{
				"name": "Abstract",
				"url": "/category/logo-templates/abstract"
			},
			{
				"name": "Animals",
				"url": "/category/logo-templates/animals"
			},
			{
				"name": "Buildings",
				"url": "/category/logo-templates/buildings"
			},
			{
				"name": "College",
				"url": "/category/logo-templates/college"
			},
			{
				"name": "Company",
				"url": "/category/logo-templates/company"
			},
			{
				"name": "Crests",
				"url": "/category/logo-templates/crests"
			},
			{
				"name": "Food",
				"url": "/category/logo-templates/food"
			},
			{
				"name": "Humans",
				"url": "/category/logo-templates/humans"
			},
			{
				"name": "Letters",
				"url": "/category/logo-templates/letters"
			},
			{
				"name": "Nature",
				"url": "/category/logo-templates/nature"
			},
			{
				"name": "Numbers",
				"url": "/category/logo-templates/numbers"
			},
			{
				"name": "Objects",
				"url": "/category/logo-templates/objects"
			},
			{
				"name": "Restaurant",
				"url": "/category/logo-templates/restaurant"
			},
			{
				"name": "Sports",
				"url": "/category/logo-templates/sports"
			},
			{
				"name": "Symbols",
				"url": "/category/logo-templates/symbols"
			}
		]
	},
	{
		"name": "More",
		"url": "/category",
		"children": [
			{
				"name": "Game Assets",
				"url": "/category/game-assets"
			},
			{
				"name": "Isolated Objects",
				"url": "/category/isolated-objects"
			},
			{
				"name": "T-Shirts",
				"url": "/category/t-shirts"
			},
			{
				"name": "Textures",
				"url": "/category/textures"
			}
		]
	}
];

/***/ }),
/* 482 */
/***/ (function(module, exports) {

module.exports = [
	{
		"name": "All Items",
		"url": "/category/all",
		"children": [
			{
				"name": "Popular Files",
				"url": "/page/top_sellers"
			},
			{
				"name": "Featured Files",
				"url": "/feature"
			},
			{
				"name": "Top New Files",
				"url": "/search?date=this-month&length_max=&length_min=&price_max=&price_min=&rating_min=&sales=&sort=sales&term=&utf8=%E2%9C%93&view=list"
			},
			{
				"name": "Follow Feed",
				"url": "/follow_feed"
			},
			{
				"name": "Top Authors",
				"url": "/authors/top"
			},
			{
				"name": "Top New Authors",
				"url": "/page/top_new_sellers"
			},
			{
				"name": "Public Collections",
				"url": "/collections"
			}
		]
	},
	{
		"name": "Animals",
		"url": "/tags/animals",
		"children": []
	},
	{
		"name": "Architecture",
		"url": "/tags/architecture",
		"children": []
	},
	{
		"name": "Business",
		"url": "/tags/business",
		"children": []
	},
	{
		"name": "Food",
		"url": "/tags/food",
		"children": []
	},
	{
		"name": "Health",
		"url": "/tags/health",
		"children": []
	},
	{
		"name": "Sports",
		"url": "/tags/sports",
		"children": []
	},
	{
		"name": "People",
		"url": "/tags/people",
		"children": []
	},
	{
		"name": "Technology",
		"url": "/tags/technology",
		"children": []
	},
	{
		"name": "Travel",
		"url": "/tags/travel",
		"children": []
	},
	{
		"name": "Video Footage",
		"url": "http://videohive.net/category/stock-footage",
		"children": []
	}
];

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports = [
	{
		"name": "All Items",
		"url": "/category/all",
		"children": [
			{
				"name": "Popular Files",
				"url": "/page/top_sellers"
			},
			{
				"name": "Featured Files",
				"url": "/feature"
			},
			{
				"name": "Top New Files",
				"url": "/search?date=this-month&length_max=&length_min=&price_max=&price_min=&rating_min=&sales=&sort=sales&term=&utf8=%E2%9C%93&view=list"
			},
			{
				"name": "Follow Feed",
				"url": "/follow_feed"
			},
			{
				"name": "Top Authors",
				"url": "/authors/top"
			},
			{
				"name": "Top New Authors",
				"url": "/page/top_new_sellers"
			},
			{
				"name": "Public Collections",
				"url": "/collections"
			},
			{
				"name": "View All Categories",
				"url": "/category"
			}
		]
	},
	{
		"name": "WordPress",
		"url": "/category/wordpress",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=wordpress",
				"isTop": true
			},
			{
				"name": "Blog / Magazine",
				"url": "/category/wordpress/blog-magazine"
			},
			{
				"name": "BuddyPress",
				"url": "/category/wordpress/buddypress"
			},
			{
				"name": "Corporate",
				"url": "/category/wordpress/corporate"
			},
			{
				"name": "Creative",
				"url": "/category/wordpress/creative"
			},
			{
				"name": "Directory & Listings",
				"url": "/category/wordpress/corporate/directory-listings"
			},
			{
				"name": "eCommerce",
				"url": "/category/wordpress/ecommerce"
			},
			{
				"name": "Education",
				"url": "/category/wordpress/education"
			},
			{
				"name": "Entertainment",
				"url": "/category/wordpress/entertainment"
			},
			{
				"name": "Layers WP",
				"url": "/attributes/compatible-with/layers%20wp"
			},
			{
				"name": "Mobile",
				"url": "/category/wordpress/mobile"
			},
			{
				"name": "Nonprofit",
				"url": "/category/wordpress/nonprofit"
			},
			{
				"name": "Real Estate",
				"url": "/category/wordpress/real-estate"
			},
			{
				"name": "Retail",
				"url": "/category/wordpress/retail"
			},
			{
				"name": "Technology",
				"url": "/category/wordpress/technology"
			},
			{
				"name": "Wedding",
				"url": "/category/wordpress/wedding"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/wordpress/miscellaneous"
			},
			{
				"name": "WordPress Plugins on CodeCanyon",
				"url": "https://codecanyon.net/category/wordpress",
				"isBottom": true
			}
		]
	},
	{
		"name": "Hosted WordPress",
		"url": "/wordpress/hosted",
		"children": [],
		"isNew": true
	},
	{
		"name": "HTML",
		"url": "/category/site-templates",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=site-templates",
				"isTop": true
			},
			{
				"name": "Admin Templates",
				"url": "/category/site-templates/admin-templates"
			},
			{
				"name": "Corporate",
				"url": "/category/site-templates/corporate"
			},
			{
				"name": "Creative",
				"url": "/category/site-templates/creative"
			},
			{
				"name": "Entertainment",
				"url": "/category/site-templates/entertainment"
			},
			{
				"name": "Mobile",
				"url": "/category/site-templates/mobile"
			},
			{
				"name": "Nonprofit",
				"url": "/category/site-templates/nonprofit"
			},
			{
				"name": "Personal",
				"url": "/category/site-templates/personal"
			},
			{
				"name": "Retail",
				"url": "/category/site-templates/retail"
			},
			{
				"name": "Specialty Pages",
				"url": "/category/site-templates/specialty-pages"
			},
			{
				"name": "Technology",
				"url": "/category/site-templates/technology"
			},
			{
				"name": "Wedding",
				"url": "/category/site-templates/wedding"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/site-templates/miscellaneous"
			}
		]
	},
	{
		"name": "Marketing",
		"url": "/category/marketing",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=marketing",
				"isTop": true
			},
			{
				"name": "Email Templates",
				"url": "/category/marketing/email-templates"
			},
			{
				"name": "Instapage",
				"url": "/category/marketing/instapage"
			},
			{
				"name": "Landing Pages",
				"url": "/category/marketing/landing-pages"
			},
			{
				"name": "Pagewiz",
				"url": "/category/marketing/pagewiz"
			},
			{
				"name": "Unbounce Landing Pages",
				"url": "/category/marketing/unbounce-landing-pages"
			},
			{
				"name": "Google Web Designer Ads on CodeCanyon",
				"url": "http://codecanyon.net/category/html5/ad-templates?platform=Google%2BWeb%2BDesigner",
				"isBottom": true
			}
		]
	},
	{
		"name": "CMS",
		"url": "/category/cms-themes",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=cms-themes",
				"isTop": true
			},
			{
				"name": "Concrete5",
				"url": "/category/cms-themes/concrete5"
			},
			{
				"name": "Drupal",
				"url": "/category/cms-themes/drupal"
			},
			{
				"name": "Joomla",
				"url": "/category/cms-themes/joomla"
			},
			{
				"name": "MODX Themes",
				"url": "/category/cms-themes/modx-themes"
			},
			{
				"name": "Moodle",
				"url": "/category/cms-themes/moodle"
			},
			{
				"name": "Mura",
				"url": "/category/cms-themes/mura"
			},
			{
				"name": "Webflow",
				"url": "/category/cms-themes/webflow"
			},
			{
				"name": "Weebly",
				"url": "/category/cms-themes/weebly"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/cms-themes/miscellaneous"
			}
		]
	},
	{
		"name": "eCommerce",
		"url": "/category/ecommerce",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=ecommerce",
				"isTop": true
			},
			{
				"name": "WooCommerce",
				"url": "/category/wordpress/ecommerce/woocommerce"
			},
			{
				"name": "3dcart",
				"url": "/category/ecommerce/3dcart"
			},
			{
				"name": "BigCommerce",
				"url": "/category/ecommerce/bigcommerce"
			},
			{
				"name": "Cart66",
				"url": "/category/wordpress/ecommerce/cart66"
			},
			{
				"name": "CS-Cart",
				"url": "/category/ecommerce/cs-cart"
			},
			{
				"name": "Drupal Commerce",
				"url": "/attributes/compatible-with/Drupal Commerce?sort=date"
			},
			{
				"name": "Easy Digital Downloads",
				"url": "/search?compatible_with=Easy+Digital+Downloads"
			},
			{
				"name": "Ecwid",
				"url": "/attributes/themeforest-files-included/ecwid%20css%20files"
			},
			{
				"name": "Jigoshop",
				"url": "/category/wordpress/ecommerce/jigoshop"
			},
			{
				"name": "Magento",
				"url": "/category/ecommerce/magento"
			},
			{
				"name": "OpenCart",
				"url": "/category/ecommerce/opencart"
			},
			{
				"name": "osCommerce",
				"url": "/category/ecommerce/oscommerce"
			},
			{
				"name": "PrestaShop",
				"url": "/category/ecommerce/prestashop"
			},
			{
				"name": "Shopify",
				"url": "/category/ecommerce/shopify"
			},
			{
				"name": "Ubercart",
				"url": "/attributes/compatible-with/Ubercart?sort=date"
			},
			{
				"name": "VirtueMart",
				"url": "/category/cms-themes/joomla/virtuemart"
			},
			{
				"name": "WP e-Commerce",
				"url": "/category/wordpress/ecommerce/wp-e-commerce"
			},
			{
				"name": "Zen Cart",
				"url": "/category/ecommerce/zen-cart"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/ecommerce/miscellaneous"
			}
		]
	},
	{
		"name": "Muse",
		"url": "/category/muse-templates",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=muse-templates",
				"isTop": true
			},
			{
				"name": "Corporate",
				"url": "/category/muse-templates/corporate"
			},
			{
				"name": "Creative",
				"url": "/category/muse-templates/creative"
			},
			{
				"name": "eCommerce",
				"url": "/category/muse-templates/ecommerce"
			},
			{
				"name": "Landing",
				"url": "/category/muse-templates/landing"
			},
			{
				"name": "Personal",
				"url": "/category/muse-templates/personal"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/muse-templates/miscellaneous"
			},
			{
				"name": "Muse Widgets on CodeCanyon",
				"url": "http://codecanyon.net/category/plugins/muse-widgets",
				"isBottom": true
			}
		]
	},
	{
		"name": "UI Design",
		"url": "/category/sketch-templates",
		"children": [
			{
				"name": "PSD Templates",
				"url": "/category/psd-templates"
			},
			{
				"name": "Popular PSD Templates",
				"url": "/popular_item/by_category?category=psd-templates\n        "
			},
			{
				"name": "Sketch Templates",
				"url": "/category/sketch-templates"
			},
			{
				"name": "Popular Sketch Templates",
				"url": "/popular_item/by_category?category=sketch-templates"
			}
		]
	},
	{
		"name": "Plugins",
		"url": "https://codecanyon.net/category/wordpress",
		"children": []
	},
	{
		"name": "More",
		"url": "/category",
		"children": [
			{
				"name": "Blogging",
				"url": "/category/blogging"
			},
			{
				"name": "Courses",
				"url": "/category/courses"
			},
			{
				"name": "Facebook Templates",
				"url": "/attributes/compatible-with/facebook"
			},
			{
				"name": "Forums",
				"url": "/category/forums"
			},
			{
				"name": "Ghost Themes",
				"url": "/category/blogging/ghost-themes"
			},
			{
				"name": "Hosting",
				"url": "/get_hosting"
			},
			{
				"name": "Jekyll",
				"url": "/category/static-site-generators/jekyll"
			},
			{
				"name": "Tumblr",
				"url": "/category/blogging/tumblr"
			},
			{
				"name": "TypeEngine Themes",
				"url": "/category/typeengine-themes"
			}
		]
	}
];

/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports = [
	{
		"name": "All Items",
		"url": "/category/all",
		"children": [
			{
				"name": "Popular Files",
				"url": "/page/top_sellers"
			},
			{
				"name": "Featured Files",
				"url": "/feature"
			},
			{
				"name": "Top New Files",
				"url": "/search?date=this-month&length_max=&length_min=&price_max=&price_min=&rating_min=&sales=&sort=sales&term=&utf8=%E2%9C%93&view=list"
			},
			{
				"name": "Follow Feed",
				"url": "/follow_feed"
			},
			{
				"name": "Top Authors",
				"url": "/authors/top"
			},
			{
				"name": "Top New Authors",
				"url": "/page/top_new_sellers"
			},
			{
				"name": "Public Collections",
				"url": "/collections"
			},
			{
				"name": "View All Categories",
				"url": "/category"
			}
		]
	},
	{
		"name": "After Effects Project Files",
		"url": "/category/after-effects-project-files",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=after-effects-project-files",
				"isTop": true
			},
			{
				"name": "Broadcast Packages",
				"url": "/category/after-effects-project-files/broadcast-packages"
			},
			{
				"name": "Element 3D",
				"url": "/attributes/video-project-requires/Element 3D?sort=date"
			},
			{
				"name": "Elements",
				"url": "/category/after-effects-project-files/elements"
			},
			{
				"name": "Infographics",
				"url": "/category/after-effects-project-files/infographics"
			},
			{
				"name": "Logo Stings",
				"url": "/category/after-effects-project-files/logo-stings"
			},
			{
				"name": "Openers",
				"url": "/category/after-effects-project-files/openers"
			},
			{
				"name": "Product Promo",
				"url": "/category/after-effects-project-files/product-promo"
			},
			{
				"name": "Titles",
				"url": "/category/after-effects-project-files/titles"
			},
			{
				"name": "Video Displays",
				"url": "/category/after-effects-project-files/video-displays"
			}
		]
	},
	{
		"name": "Apple Motion",
		"url": "/category/apple-motion-templates",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=apple-motion-templates",
				"isTop": true
			},
			{
				"name": "Elements",
				"url": "/category/apple-motion-templates/elements"
			},
			{
				"name": "Logo Stings",
				"url": "/category/apple-motion-templates/logo-stings"
			},
			{
				"name": "Openers",
				"url": "/category/apple-motion-templates/openers"
			},
			{
				"name": "Titles",
				"url": "/category/apple-motion-templates/titles"
			},
			{
				"name": "Video Displays",
				"url": "/category/apple-motion-templates/video-displays"
			}
		]
	},
	{
		"name": "Motion Graphics",
		"url": "/category/motion-graphics",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=motion-graphics",
				"isTop": true
			},
			{
				"name": "Backgrounds",
				"url": "/category/motion-graphics/backgrounds"
			},
			{
				"name": "Bugs",
				"url": "/category/motion-graphics/bugs"
			},
			{
				"name": "Elements",
				"url": "/category/motion-graphics/elements"
			},
			{
				"name": "Infographics",
				"url": "/category/motion-graphics/infographics"
			},
			{
				"name": "Interface Effects",
				"url": "/category/motion-graphics/interface-effects"
			},
			{
				"name": "Lower Thirds",
				"url": "/category/motion-graphics/lower-thirds"
			},
			{
				"name": "Overlays",
				"url": "/category/motion-graphics/overlays"
			},
			{
				"name": "Revealer",
				"url": "/category/motion-graphics/revealer"
			},
			{
				"name": "Transitions",
				"url": "/category/motion-graphics/transitions"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/motion-graphics/miscellaneous"
			}
		]
	},
	{
		"name": "Stock Footage",
		"url": "/category/stock-footage",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=stock-footage",
				"isTop": true
			},
			{
				"name": "Buildings",
				"url": "/category/stock-footage/buildings"
			},
			{
				"name": "Business, Corporate",
				"url": "/category/stock-footage/business-corporate"
			},
			{
				"name": "Cartoons",
				"url": "/category/stock-footage/cartoons"
			},
			{
				"name": "City",
				"url": "/category/stock-footage/city"
			},
			{
				"name": "Construction",
				"url": "/category/stock-footage/construction"
			},
			{
				"name": "Education",
				"url": "/category/stock-footage/education"
			},
			{
				"name": "Food",
				"url": "/category/stock-footage/food"
			},
			{
				"name": "Holidays",
				"url": "/category/stock-footage/holidays"
			},
			{
				"name": "Industrial",
				"url": "/category/stock-footage/industrial"
			},
			{
				"name": "Kids",
				"url": "/category/stock-footage/kids"
			},
			{
				"name": "Lifestyle",
				"url": "/category/stock-footage/lifestyle"
			},
			{
				"name": "Medical",
				"url": "/category/stock-footage/medical"
			},
			{
				"name": "Military",
				"url": "/category/stock-footage/military"
			},
			{
				"name": "Nature",
				"url": "/category/stock-footage/nature"
			},
			{
				"name": "Overhead",
				"url": "/category/stock-footage/overhead"
			},
			{
				"name": "People",
				"url": "/category/stock-footage/people"
			},
			{
				"name": "Religious",
				"url": "/category/stock-footage/religious"
			},
			{
				"name": "Science",
				"url": "/category/stock-footage/science"
			},
			{
				"name": "Slow Motion",
				"url": "/category/stock-footage/slow-motion"
			},
			{
				"name": "Special Events",
				"url": "/category/stock-footage/special-events"
			},
			{
				"name": "Sports",
				"url": "/category/stock-footage/sports"
			},
			{
				"name": "Stop Motion",
				"url": "/category/stock-footage/stop-motion"
			},
			{
				"name": "Technology",
				"url": "/category/stock-footage/technology"
			},
			{
				"name": "Time Lapse",
				"url": "/category/stock-footage/time-lapse"
			},
			{
				"name": "Vehicles",
				"url": "/category/stock-footage/vehicles"
			},
			{
				"name": "Weather",
				"url": "/category/stock-footage/weather"
			}
		]
	},
	{
		"name": "Cinema 4D Templates",
		"url": "/category/cinema-4d-templates",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=cinema-4d-templates",
				"isTop": true
			},
			{
				"name": "Elements",
				"url": "/category/cinema-4d-templates/elements"
			},
			{
				"name": "Logo Stings",
				"url": "/category/cinema-4d-templates/logo-stings"
			},
			{
				"name": "Openers",
				"url": "/category/cinema-4d-templates/openers"
			},
			{
				"name": "Titles",
				"url": "/category/cinema-4d-templates/titles"
			},
			{
				"name": "Video Displays",
				"url": "/category/cinema-4d-templates/video-displays"
			}
		]
	},
	{
		"name": "Add Ons",
		"url": "/category/add-ons",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=add-ons",
				"isTop": true
			},
			{
				"name": "After Effects Presets",
				"url": "/category/add-ons/after-effects-presets"
			},
			{
				"name": "After Effects Scripts",
				"url": "/category/add-ons/after-effects-scripts"
			}
		]
	},
	{
		"name": "More",
		"url": "/category",
		"children": [
			{
				"name": "Logo Files",
				"url": "/search?term=logo"
			},
			{
				"name": "News Files",
				"url": "/search?term=news"
			},
			{
				"name": "Wedding Files",
				"url": "/search?term=wedding"
			}
		]
	}
];

/***/ }),
/* 485 */
/***/ (function(module, exports) {

module.exports = {
	"generation": 12,
	"links_in_ad": 3,
	"items": [
		{
			"id": 17340,
			"name": "Game Development and Design",
			"url": "https://studio.envato.com/explore/mobile-design-development/17340-game-development-design-reskin",
			"price_from": 150
		},
		{
			"id": 9740,
			"name": "Mobile-Friendly Redesign for a WordPress Site",
			"url": "https://studio.envato.com/explore/mobile-design-development/9740-make-wordpress-existing-site-mobile-responsive",
			"price_from": 150
		},
		{
			"id": 9320,
			"name": "Android UI/UX App Design",
			"url": "https://studio.envato.com/explore/app-design/9320-android-ui-ux-app-design-or-android-xml-layout",
			"price_from": 200
		},
		{
			"id": 14553,
			"name": "Slider (Carousel) Banners",
			"url": "https://studio.envato.com/explore/web-banner-design/14553-slider-carousel-banners",
			"price_from": 55
		},
		{
			"id": 8155,
			"name": "3D Rendering Service",
			"url": "https://studio.envato.com/explore/3d-design-modeling/8155-3d-rendering",
			"price_from": 120
		},
		{
			"id": 8374,
			"name": "Professional High-Quality Infographics Design",
			"url": "https://studio.envato.com/explore/infographic-design/8374-professional-high-quality-infographics-design",
			"price_from": 250
		},
		{
			"id": 1453,
			"name": "Effective Web Banner Design",
			"url": "https://studio.envato.com/explore/web-banner-design/1453-effective-web-banner-design",
			"price_from": 55
		},
		{
			"id": 2017,
			"name": "3D Logo Design",
			"url": "https://studio.envato.com/explore/3d-design-modeling/2017-3d-logo-design",
			"price_from": 200
		}
	]
};

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports = {
	"generation": 12,
	"links_in_ad": 3,
	"items": [
		{
			"id": 44820,
			"name": "Audio Mastering",
			"url": "https://studio.envato.com/explore/mixing-mastering/44820-audio-mastering",
			"price_from": 90
		},
		{
			"id": 9314,
			"name": "1 Minute Explainer Animation plus Voice Over and Music",
			"url": "https://studio.envato.com/explore/explainer-videos/9314-explainer-animation-1-minute-voice-over-and-music",
			"price_from": 1500
		},
		{
			"id": 44881,
			"name": "Professional Female Voice Over Talent",
			"url": "https://studio.envato.com/explore/voice-overs/44881-professional-female-voice-over-talent",
			"price_from": 100
		},
		{
			"id": 44937,
			"name": "Profesional Guitar and Bass Tracking",
			"url": "https://studio.envato.com/explore/session-musicians/44937-profesional-guitar-and-bass-tracking",
			"price_from": 125
		},
		{
			"id": 38271,
			"name": "Up to 30 Second Voice Over",
			"url": "https://studio.envato.com/explore/voice-overs/38271-up-to-30-second-voice-over-male-american-english",
			"price_from": 50
		},
		{
			"id": 44912,
			"name": "Audio Editing For Any Type Of Project",
			"url": "https://studio.envato.com/explore/audio-editing/44912-audio-editing-for-any-type-of-project",
			"price_from": 40
		},
		{
			"id": 45370,
			"name": "In-Vision Explainer HD Videos shot in a Virtual Newsroom Studio",
			"url": "https://studio.envato.com/explore/explainer-videos/45370-in-vision-explainer-hd-videos-shot-in-a-virtual-newsroom-studio",
			"price_from": 275
		},
		{
			"id": 3335,
			"name": "Speed up WordPress PageSpeed",
			"url": "https://studio.envato.com/explore/wordpress-speed-optimization/3335-speed-up-wordpress-pagespeed",
			"price_from": 100
		},
		{
			"id": 44805,
			"name": "Soundtrack Production for Movies, Games and more",
			"url": "https://studio.envato.com/explore/music-production/44805-soundtrack-production-movies-games-more",
			"price_from": 320
		}
	]
};

/***/ }),
/* 487 */
/***/ (function(module, exports) {

module.exports = {
	"generation": 12,
	"links_in_ad": 4,
	"items": [
		{
			"id": 45370,
			"name": "In-Vision Explainer HD Videos shot in a Virtual Newsroom Studio",
			"url": "https://studio.envato.com/explore/explainer-videos/45370-in-vision-explainer-hd-videos-shot-in-a-virtual-newsroom-studio",
			"price_from": 275
		},
		{
			"id": 12830,
			"name": "Parallels Plesk Panel Instalation & Configuration",
			"url": "https://studio.envato.com/explore/server-admin/12830-parallels-plesk-panel-instalation-configuration",
			"price_from": 100
		},
		{
			"id": 38913,
			"name": "1 Hour Remote Support Session",
			"url": "https://studio.envato.com/explore/wordpress-support/38913-remote-support-session-1-hour-max",
			"price_from": 50
		},
		{
			"id": 7150,
			"name": "Wordpress Website SEO Optimization",
			"url": "https://studio.envato.com/explore/wordpress-seo/7150-wordpress-website-seo-optimization",
			"price_from": 150
		},
		{
			"id": 939,
			"name": "Professional Logo Design",
			"url": "https://studio.envato.com/explore/logo-design/939-professional-logo-design",
			"price_from": 100
		},
		{
			"id": 5108,
			"name": "Adaptive Logo Design",
			"url": "https://studio.envato.com/explore/logo-design/5108-adaptive-logo-design",
			"price_from": 60
		},
		{
			"id": 3891,
			"name": "UX/UI Design for Mobile and Web Apps",
			"url": "https://studio.envato.com/explore/app-design/3891-ux-ui-design-for-mobile-and-web-apps",
			"price_from": 300
		},
		{
			"id": 16089,
			"name": "PSD to Responsive Email template for MailChimp",
			"url": "https://studio.envato.com/explore/email-design-development/16089-psd-to-responsive-email-template-for-mailchimp-or-any-email-marketing-platform",
			"price_from": 100
		},
		{
			"id": 9333,
			"name": "Shopify Store Setup/Creation",
			"url": "https://studio.envato.com/explore/shopify-development/9333-shopify-store-setup-creation",
			"price_from": 1200
		},
		{
			"id": 39161,
			"name": "Website to IOS / IPad App",
			"url": "https://studio.envato.com/explore/app-development/39161-website-to-ios-ipad-app",
			"price_from": 100
		}
	]
};

/***/ }),
/* 488 */
/***/ (function(module, exports) {

module.exports = {
	"generation": 12,
	"links_in_ad": 4,
	"items": [
		{
			"id": 399,
			"name": "Professional Express Logo Design",
			"url": "https://studio.envato.com/explore/logo-design/399-professional-express-logo-design",
			"price_from": 50
		},
		{
			"id": 3099,
			"name": "Corporate Business Card Design",
			"url": "https://studio.envato.com/explore/business-card-design/3099-corporate-business-card",
			"price_from": 40
		},
		{
			"id": 6136,
			"name": "Professional WordPress OnSite SEO",
			"url": "https://studio.envato.com/explore/wordpress-seo/6136-professional-wordpress-onsite-seo",
			"price_from": 100
		},
		{
			"id": 3746,
			"name": "Logo Vectorization, Customization & Improvements",
			"url": "https://studio.envato.com/explore/logo-customization/3746-logo-vectorization-customization-improvements",
			"price_from": 20
		},
		{
			"id": 1250,
			"name": "Professional Icon Set Design",
			"url": "https://studio.envato.com/explore/icon-set-design/1250-professional-icon-set-design",
			"price_from": 100
		},
		{
			"id": 38271,
			"name": "Up to 30 Second Voice Over Male American English",
			"url": "https://studio.envato.com/explore/voice-overs/38271-up-to-30-second-voice-over-male-american-english",
			"price_from": 50
		},
		{
			"id": 11264,
			"name": "Express Design & Template Customization",
			"url": "https://studio.envato.com/explore/customize-graphics/11264-express-design-customization-templates-graphic-files",
			"price_from": 20
		},
		{
			"id": 478,
			"name": "Hand-Drawn Lettering & Type Service",
			"url": "https://studio.envato.com/explore/lettering-calligraphy/478-hand-drawn-lettering-type",
			"price_from": 50
		},
		{
			"id": 9320,
			"name": "Android UI/UX App Design",
			"url": "https://studio.envato.com/explore/app-design/9320-android-ui-ux-app-design-or-android-xml-layout",
			"price_from": 200
		},
		{
			"id": 3292,
			"name": "Professional Company Brochure Design",
			"url": "https://studio.envato.com/explore/brochure-design/3292-professional-company-brochure-design",
			"price_from": 150
		}
	]
};

/***/ }),
/* 489 */
/***/ (function(module, exports) {

module.exports = {
	"generation": 12,
	"links_in_ad": 3,
	"items": [
		{
			"id": 399,
			"name": "Professional Express Logo Design",
			"url": "https://studio.envato.com/explore/logo-design/399-professional-express-logo-design",
			"price_from": 50
		},
		{
			"id": 939,
			"name": "Professional Logo Design",
			"url": "https://studio.envato.com/explore/logo-design/939-professional-logo-design",
			"price_from": 100
		},
		{
			"id": 6513,
			"name": "Logo Vectorization",
			"url": "https://studio.envato.com/explore/photo-editing/6513-vector-redraw-your-logo",
			"price_from": 20
		},
		{
			"id": 17340,
			"name": "Game Development and Design",
			"url": "https://studio.envato.com/explore/mobile-design-development/17340-game-development-design-reskin",
			"price_from": 150
		},
		{
			"id": 9740,
			"name": "Mobile-Friendly Redesign for Existing WordPress Site",
			"url": "https://studio.envato.com/explore/mobile-design-development/9740-make-wordpress-existing-site-mobile-responsive",
			"price_from": 150
		},
		{
			"id": 2759,
			"name": "Product Background Removal",
			"url": "https://studio.envato.com/explore/photo-editing/2759-product-background-removal-for-10-photos",
			"price_from": 20
		},
		{
			"id": 5108,
			"name": "Adaptive Logo Design",
			"url": "https://studio.envato.com/explore/logo-design/5108-adaptive-logo-design",
			"price_from": 60
		}
	]
};

/***/ }),
/* 490 */
/***/ (function(module, exports) {

module.exports = {
	"generation": 12,
	"links_in_ad": 4,
	"items": [
		{
			"id": 6296,
			"name": "Fix Small WordPress Issues",
			"url": "https://studio.envato.com/explore/wordpress-customization/6296-fix-small-wordpress-issues",
			"price_from": 50
		},
		{
			"id": 5108,
			"name": "Adaptive Logo Design",
			"url": "https://studio.envato.com/explore/logo-design/5108-adaptive-logo-design",
			"price_from": 60
		},
		{
			"id": 39424,
			"name": "Professional Flat Style Homepage Design",
			"url": "https://studio.envato.com/explore/new-website/39424-premium-professional-flat-style-homepage-design-psd",
			"price_from": 190
		},
		{
			"id": 2349,
			"name": "Premium Flyer Design",
			"url": "https://studio.envato.com/explore/poster-flyer-design/2349-premium-flyer-design",
			"price_from": 50
		},
		{
			"id": 7825,
			"name": "Professional WordPress Theme Customization",
			"url": "https://studio.envato.com/explore/wordpress-customization/7825-professional-wordpress-theme-customization",
			"price_from": 100
		},
		{
			"id": 6500,
			"name": "Customisation of Keynote or Powerpoint Presentations",
			"url": "https://studio.envato.com/explore/presentation-design/6500-customisation-of-keynote-or-powerpoint-presentations",
			"price_from": 225
		},
		{
			"id": 14872,
			"name": "WordPress Theme Setup & Design Customization",
			"url": "https://studio.envato.com/explore/wordpress-installation/14872-wordpress-theme-setup-design-customization",
			"price_from": 250
		},
		{
			"id": 1453,
			"name": "Effective Web Banner Design",
			"url": "https://studio.envato.com/explore/web-banner-design/1453-effective-web-banner-design",
			"price_from": 55
		},
		{
			"id": 23385,
			"name": "High Quality Website Content",
			"url": "https://studio.envato.com/explore/website-content/23385-high-quality-website-content-one-page",
			"price_from": 90
		},
		{
			"id": 9390,
			"name": "Professional Custom HD Logo Reveal",
			"url": "https://studio.envato.com/explore/logo-animation/9390-professional-custom-hd-logo-reveal",
			"price_from": 140
		},
		{
			"id": 7368,
			"name": "WordPress Theme Customization",
			"url": "https://studio.envato.com/explore/wordpress-customization/7368-wordpress-theme-customization-with-a-smile",
			"price_from": 175
		},
		{
			"id": 24158,
			"name": "Blog/Article Writing",
			"url": "https://studio.envato.com/explore/blog-article-writing/24158-blog-article-writing-up-to-1000-words",
			"price_from": 80
		},
		{
			"id": 7205,
			"name": "Mobile Application UI Designing",
			"url": "https://studio.envato.com/explore/app-design/7205-mobile-application-ui-designing",
			"price_from": 280
		},
		{
			"id": 6084,
			"name": "Convert HTML to WordPress",
			"url": "https://studio.envato.com/explore/website-to-wordpress/6084-convert-html-to-wordpress",
			"price_from": 250
		}
	]
};

/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports = {
	"generation": 12,
	"links_in_ad": 3,
	"items": [
		{
			"id": 12317,
			"name": "Express Basic After Effects Customization",
			"url": "https://studio.envato.com/explore/after-effects-customization/12317-express-basic-after-effects-customization",
			"price_from": 150
		},
		{
			"id": 11537,
			"name": "Professional Corporate Stationery Design",
			"url": "https://studio.envato.com/explore/stationery-design/11537-corporate-professional-stationery-design",
			"price_from": 70
		},
		{
			"id": 2616,
			"name": "Professional and Fun Infographics",
			"url": "https://studio.envato.com/explore/infographic-design/2616-professional-and-fun-infographics",
			"price_from": 300
		},
		{
			"id": 44936,
			"name": "Logo Sound Design",
			"url": "https://studio.envato.com/explore/jingles-drops/44936-logo-sound-design-10-seconds",
			"price_from": 50
		},
		{
			"id": 13313,
			"name": "Explainer, Sales, Startup, Promotional Videos",
			"url": "https://studio.envato.com/explore/explainer-videos/13313-explainer-video-sales-video-startup-video-promotional-videos",
			"price_from": 950
		},
		{
			"id": 17340,
			"name": "Redesign Mobile or Browser Game",
			"url": "https://studio.envato.com/explore/mobile-design-development/17340-game-development-design-reskin",
			"price_from": 150
		},
		{
			"id": 9314,
			"name": "1 Minute Explainer Animation plus Voice Over and Music",
			"url": "https://studio.envato.com/explore/explainer-videos/9314-explainer-animation-1-minute-voice-over-and-music",
			"price_from": 1500
		},
		{
			"id": 3336,
			"name": "Fun Professional Avatar",
			"url": "https://studio.envato.com/explore/social-media-design/3336-fun-professional-avatar",
			"price_from": 50
		},
		{
			"id": 44863,
			"name": "Original Music Composition",
			"url": "https://studio.envato.com/explore/music-production/44863-original-music-composition",
			"price_from": 300
		},
		{
			"id": 10073,
			"name": "Professional Web Banner Design",
			"url": "https://studio.envato.com/explore/web-banner-design/10073-professional-web-banner-design",
			"price_from": 50
		},
		{
			"id": 17634,
			"name": "Professional Unique Logo Intro Opener",
			"url": "https://studio.envato.com/explore/logo-animation/17634-professional-unique-logo-intro-opener",
			"price_from": 100
		}
	]
};

/***/ }),
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_config__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_router_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_routes__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pendingNavDataLoader__ = __webpack_require__(592);








/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var store = _ref.store;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_redux__["a" /* Provider */],
    { store: store },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* BrowserRouter */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__components_pendingNavDataLoader__["a" /* default */],
        { store: store, routes: __WEBPACK_IMPORTED_MODULE_4__common_routes__["a" /* default */] },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_router_config__["renderRoutes"])(__WEBPACK_IMPORTED_MODULE_4__common_routes__["a" /* default */])
      )
    )
  );
});

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);




var AlertBox = function AlertBox(_ref) {
  var children = _ref.children,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? 'warning' : _ref$type,
      onDismiss = _ref.onDismiss,
      _ref$showIcon = _ref.showIcon,
      showIcon = _ref$showIcon === undefined ? true : _ref$showIcon;

  var mainClasses = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('fds-c-alert-box', 'fds-u-mt2', {
    '-type-success': type === 'success',
    '-type-alert': type === 'failure'
  });
  var iconClasses = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('e-icon', {
    '-icon-flag': type === 'warning',
    '-icon-ok': type === 'success',
    '-icon-alert': type === 'failure'
  });

  var onDismissWrapper = function onDismissWrapper(event) {
    event.preventDefault();
    onDismiss(event);
  };

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: mainClasses },
    showIcon ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'fds-c-alert-box__icon' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: iconClasses })
    ) : null,
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'fds-c-alert-box__message' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'p',
        { className: 'fds-c-text-body -size-s fds-u-m0' },
        children
      )
    ),
    onDismiss ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AlertBox.DismissButton, { onClick: onDismissWrapper }) : null
  );
};

AlertBox.propTypes = {
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['warning', 'success', 'failure']),
  onDismiss: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
};

AlertBox.DismissButton = function (_ref2) {
  var onClick = _ref2.onClick;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: 'fds-c-alert-box__dismiss' },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'a',
      { onClick: onClick, className: 'fds-c-alert-box__dismiss-icon' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'e-icon -icon-cancel' })
    )
  );
};

AlertBox.DismissButton.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (AlertBox);

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransitionGroup__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransitionGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransitionGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__alertBox__ = __webpack_require__(512);





var AlertsStream = function AlertsStream(_ref) {
  var _ref$alerts = _ref.alerts,
      alerts = _ref$alerts === undefined ? [] : _ref$alerts,
      hideAlert = _ref.hideAlert;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'grid-container' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransitionGroup___default.a,
      {
        transitionName: {
          enter: '-animate--enter',
          enterActive: '-animate--enter-active',
          leave: '-animate--leave',
          leaveActive: '-animate--leave-active'
        },
        transitionEnterTimeout: 500,
        transitionLeaveTimeout: 300 },
      alerts.map(function (_ref2, index) {
        var message = _ref2.message,
            type = _ref2.type,
            canBeDismissed = _ref2.canBeDismissed;

        if (canBeDismissed) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__alertBox__["a" /* default */],
            { key: index, type: type, onDismiss: hideAlert.bind(null, message) },
            message
          );
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__alertBox__["a" /* default */],
            { key: index, type: type },
            message
          );
        }
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (AlertsStream);

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_actions_common__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__alertsStream__ = __webpack_require__(513);





var mapStateToProps = function mapStateToProps(state) {
  var alerts = state.common.alerts;

  return {
    alerts: alerts
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    hideAlert: function hideAlert(message) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_actions_common__["d" /* hideAlert */])(message));
    }
  };
};

var AlertsStreamContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__alertsStream__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AlertsStreamContainer);

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/*
 React removes custom attributes from DOM and current design depend on am-grid-col and amd-grid-row attributes.
 The only way to add those is to do it directly on DOM after component mounted. That's why we need this component.
 It allows to set AmGrid custom attributes.
 */

var AmGrid = function (_React$Component) {
  _inherits(AmGrid, _React$Component);

  function AmGrid() {
    _classCallCheck(this, AmGrid);

    return _possibleConstructorReturn(this, (AmGrid.__proto__ || Object.getPrototypeOf(AmGrid)).apply(this, arguments));
  }

  _createClass(AmGrid, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var dom = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(this);

      Object.keys(AmGrid.propTypes).forEach(function (attributeName) {
        if (typeof _this2.props[attributeName] !== 'undefined') {
          dom.setAttribute(attributeName, _this2.props[attributeName]);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: this.props.className },
        this.props.children
      );
    }
  }]);

  return AmGrid;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

AmGrid.propTypes = {
  'am-grid': __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
  'am-grid-col': __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  'am-grid-row': __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (AmGrid);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_undefsafe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raf__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_visibility_sensor__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_visibility_sensor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_visibility_sensor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils_axios_axiosVerbose__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils_errors__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils_time__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__waveform__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__icons_play__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__icons_pause__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__icons_spinner__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__audioPlayerLarge_module_css__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__audioPlayerLarge_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__audioPlayerLarge_module_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var AudioPlayerLarge = function (_React$Component) {
  _inherits(AudioPlayerLarge, _React$Component);

  function AudioPlayerLarge(props) {
    _classCallCheck(this, AudioPlayerLarge);

    var _this = _possibleConstructorReturn(this, (AudioPlayerLarge.__proto__ || Object.getPrototypeOf(AudioPlayerLarge)).call(this, props));

    _this.state = {
      playing: false,
      bufferProgress: 0,
      playBarProgress: 0,
      expectedPlayBarProgress: null,
      dragging: false,
      loading: false,
      seen: false,
      waveformData: null,
      playPromise: null
    };

    _this.togglePlay = _this.togglePlay.bind(_this);
    _this.onAudioBuffer = _this.onAudioBuffer.bind(_this);
    _this.onAudioProgress = _this.onAudioProgress.bind(_this);
    _this.onMouseDown = _this.onMouseDown.bind(_this);
    _this.onMouseUp = _this.onMouseUp.bind(_this);
    _this.onMouseMove = _this.onMouseMove.bind(_this);
    _this.onSeeked = _this.onSeeked.bind(_this);
    _this.onDurationChange = _this.onDurationChange.bind(_this);
    _this.onPlay = _this.onPlay.bind(_this);
    _this.onPause = _this.onPause.bind(_this);
    _this.onMouseLeave = _this.onMouseLeave.bind(_this);
    _this.onElementVisible = _this.onElementVisible.bind(_this);
    _this.setAudioElementRef = _this.setAudioElementRef.bind(_this);
    _this.setWaveformContainerElementRef = _this.setWaveformContainerElementRef.bind(_this);
    return _this;
  }

  _createClass(AudioPlayerLarge, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.audioElement) {
        if (prevProps.isActive && !this.props.isActive) {
          this.tryPause();
        }
      }
    }
  }, {
    key: 'onElementVisible',
    value: function onElementVisible(isVisible) {
      var _this2 = this;

      var item = this.props.item;
      var seen = this.state.seen;

      if (!seen && isVisible) {
        this.setState({ seen: true });
        // We get a url that looks like the following: https://0.s3.envato.com/files/88545/preview.mp3?foo=bar
        // This regex will extract the 88545/preview.mp3 part from it and send that to tsunami
        var mp3UrlRegex = /^.*files\/(.*\.mp3)/g;
        var mp3Url = __WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(item, 'previews.icon_with_audio_preview.mp3_url');
        var mp3PathGroup = mp3UrlRegex.exec(mp3Url);
        var mp3Path = void 0;
        if (mp3PathGroup && mp3PathGroup.length >= 1) {
          mp3Path = mp3PathGroup[1];
        }

        __WEBPACK_IMPORTED_MODULE_5__common_utils_axios_axiosVerbose__["a" /* default */].get('https://waveform-discovery.envato.com/tsunami/' + mp3Path).then(function (response) {
          _this2.setState({ waveformData: response.data });
        }).catch(__WEBPACK_IMPORTED_MODULE_6__common_utils_errors__["a" /* logError */]);
      }
    }
  }, {
    key: 'onPause',
    value: function onPause() {
      this.setState({ playing: false });
    }
  }, {
    key: 'onPlay',
    value: function onPlay() {
      this.props.onPlay();
      this.setState({ playing: true });
      __WEBPACK_IMPORTED_MODULE_3_raf___default()(this.onAudioProgress);
    }
  }, {
    key: 'tryPause',
    value: function tryPause() {
      var _this3 = this;

      if (this.state.playPromise && this.audioElement) {
        this.state.playPromise.then(function () {
          _this3.audioElement.pause();
        });
      }
    }
  }, {
    key: 'tryPlay',
    value: function tryPlay() {
      if (this.audioElement) {
        /*
          For some old browsers (Safari 9) play() does not return promise but undefined.
          Let's handle that case by returning resolved promise instead.
         */
        return this.audioElement.play() || Promise.resolve();
      }
    }
  }, {
    key: 'onDurationChange',
    value: function onDurationChange() {
      if (this.state.expectedPlayBarProgress) {
        this.audioElement.currentTime = this.state.expectedPlayBarProgress * this.audioElement.duration;
      }
    }
  }, {
    key: 'onSeeked',
    value: function onSeeked() {
      this.showLoading();
    }
  }, {
    key: 'onMouseDown',
    value: function onMouseDown(event) {
      var progress = event.nativeEvent.offsetX / this.waveformContainerElement.clientWidth;
      this.setState({ dragging: true, playBarProgress: progress });
    }
  }, {
    key: 'onMouseUp',
    value: function onMouseUp(event) {
      var _this4 = this;

      var playBarProgress = this.state.playBarProgress;


      this.setState({ dragging: false });

      if (this.audioElement.duration) {
        this.audioElement.currentTime = playBarProgress * this.audioElement.duration;
        this.setState({
          playPromise: this.tryPlay()
        });

        this.showLoading();
      } else {
        this.setState({
          expectedPlayBarProgress: playBarProgress
        }, function () {
          _this4.setState({
            playPromise: _this4.tryPlay()
          });
          _this4.showLoading();
        });
      }
    }
  }, {
    key: 'onMouseMove',
    value: function onMouseMove(event) {
      var dragging = this.state.dragging;

      if (dragging) {
        this.setState({ playBarProgress: event.nativeEvent.offsetX / this.waveformContainerElement.clientWidth });
      }
    }
  }, {
    key: 'onMouseLeave',
    value: function onMouseLeave(event) {
      this.setState({
        dragging: false
      });
    }
  }, {
    key: 'onAudioBuffer',
    value: function onAudioBuffer() {
      if (this.audioElement.buffered.length > 0 && this.audioElement.duration) {
        var percentLoaded = this.audioElement.buffered.end(this.audioElement.buffered.length - 1) / this.audioElement.duration;
        if (percentLoaded > 1) {
          percentLoaded = 1;
        }
        this.setState({ bufferProgress: percentLoaded });
      }
    }
  }, {
    key: 'onAudioProgress',
    value: function onAudioProgress() {
      if (this.state.playing) {
        if (!this.state.dragging && this.audioElement) {
          this.setState({ playBarProgress: this.audioElement.currentTime / this.audioElement.duration });
        }
        __WEBPACK_IMPORTED_MODULE_3_raf___default()(this.onAudioProgress);
      }
    }
  }, {
    key: 'showLoading',
    value: function showLoading() {
      if (this.audioElement.seeking || this.audioElement.readyState < 3) {
        this.setState({ loading: true });
      } else {
        this.setState({ loading: false });
      }
    }
  }, {
    key: 'togglePlay',
    value: function togglePlay() {
      var playing = this.state.playing;

      if (this.audioElement) {
        var isTrulyPlaying = this.audioElement.currentTime > 0 && !this.audioElement.paused && !this.audioElement.ended && this.audioElement.readyState > 2;
        if (playing && isTrulyPlaying) {
          this.tryPause();
        } else if (!isTrulyPlaying) {
          this.setState({
            playPromise: this.tryPlay()
          });
          this.showLoading();
        }
      }
    }
  }, {
    key: 'setAudioElementRef',
    value: function setAudioElementRef(audioElement) {
      this.audioElement = audioElement;
    }
  }, {
    key: 'setWaveformContainerElementRef',
    value: function setWaveformContainerElementRef(waveformElement) {
      this.waveformContainerElement = waveformElement;
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          playing = _state.playing,
          loading = _state.loading,
          seen = _state.seen,
          waveformData = _state.waveformData,
          bufferProgress = _state.bufferProgress,
          playBarProgress = _state.playBarProgress;
      var item = this.props.item;

      var playBarProgressStyles = {
        width: playBarProgress * 100 + '%',
        height: '100%',
        position: 'absolute',
        boxShadow: '2px 0px 0px #000',
        display: playBarProgress > 0 ? null : 'none'
      };
      var buttonIcon = null;
      if (loading) {
        buttonIcon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__icons_spinner__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_12__audioPlayerLarge_module_css___default.a.spinningIcon });
      } else {
        if (playing) {
          buttonIcon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__icons_pause__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_12__audioPlayerLarge_module_css___default.a.icon });
        } else {
          buttonIcon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__icons_play__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_12__audioPlayerLarge_module_css___default.a.icon });
        }
      }

      var mp3Url = __WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(item, 'previews.icon_with_audio_preview.mp3_url');

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_12__audioPlayerLarge_module_css___default.a.spaceBetween },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_visibility_sensor___default.a, { onChange: this.onElementVisible, active: !seen }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'audio',
          {
            ref: this.setAudioElementRef,
            preload: 'none',
            onPlay: this.onPlay,
            onPause: this.onPause,
            onDurationChange: this.onDurationChange,
            onProgress: this.onAudioBuffer,
            onSeeked: this.onSeeked,
            onCanPlay: this.onSeeked
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source', { src: mp3Url, type: 'audio/mpeg' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { onClick: this.togglePlay, className: 'fds-c-button -color-transparent' },
          buttonIcon
        ),
        waveformData && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { ref: this.setWaveformContainerElementRef, className: __WEBPACK_IMPORTED_MODULE_12__audioPlayerLarge_module_css___default.a.waveformContainer, onMouseDown: this.onMouseDown, onMouseUp: this.onMouseUp, onMouseMove: this.onMouseMove, onMouseLeave: this.onMouseLeave },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__waveform__["a" /* default */], { data: waveformData, colour: '#aaa', progress: 1 }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__waveform__["a" /* default */], { data: waveformData, colour: '#7e7e7e', progress: bufferProgress }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__waveform__["a" /* default */], { data: waveformData, colour: '#7aa93c', progress: playBarProgress }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: playBarProgressStyles },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __WEBPACK_IMPORTED_MODULE_12__audioPlayerLarge_module_css___default.a.timeContainer },
              this.audioElement ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils_time__["a" /* getMinutesSecondsTime */])(this.audioElement.currentTime) : ''
            )
          )
        )
      );
    }
  }]);

  return AudioPlayerLarge;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

AudioPlayerLarge.propTypes = {
  item: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onPlay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
AudioPlayerLarge.defaultProps = {
  onPlay: function onPlay() {}
};
/* harmony default export */ __webpack_exports__["a"] = (AudioPlayerLarge);

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_undefsafe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_actions_searchPage__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__audioPlayerLarge__ = __webpack_require__(516);






var mapStateToProps = function mapStateToProps(state, ownProps) {
  var itemAudioSrc = __WEBPACK_IMPORTED_MODULE_1_undefsafe___default()(ownProps, 'item.previews.icon_with_audio_preview.mp3_url');
  var activeAudio = state.searchPage.activeAudio;


  return {
    isActive: itemAudioSrc && itemAudioSrc === activeAudio
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var itemAudioSrc = __WEBPACK_IMPORTED_MODULE_1_undefsafe___default()(ownProps, 'item.previews.icon_with_audio_preview.mp3_url');
  return {
    onPlay: function onPlay() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_actions_searchPage__["b" /* setActiveAudio */])(itemAudioSrc));
    }
  };
};

var AudioPlayerLargeContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__audioPlayerLarge__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AudioPlayerLargeContainer);

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raf__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icons_play__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icons_pause__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__icons_spinner__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__audioPlayerSmall_module_css__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__audioPlayerSmall_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__audioPlayerSmall_module_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var AudioPlayerSmall = function (_React$Component) {
  _inherits(AudioPlayerSmall, _React$Component);

  function AudioPlayerSmall(props) {
    _classCallCheck(this, AudioPlayerSmall);

    var _this = _possibleConstructorReturn(this, (AudioPlayerSmall.__proto__ || Object.getPrototypeOf(AudioPlayerSmall)).call(this, props));

    _this.state = {
      playing: false,
      loading: false,
      playBarProgress: 0,
      playPromise: null
    };

    _this.togglePlay = _this.togglePlay.bind(_this);
    _this.onPlay = _this.onPlay.bind(_this);
    _this.onPause = _this.onPause.bind(_this);
    _this.audioCanPlay = _this.audioCanPlay.bind(_this);
    _this.onAudioProgress = _this.onAudioProgress.bind(_this);
    _this.setAudioElementRef = _this.setAudioElementRef.bind(_this);
    return _this;
  }

  _createClass(AudioPlayerSmall, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.audioElement) {
        if (prevProps.isActive && !this.props.isActive) {
          this.tryPause();
        }
      }
    }
  }, {
    key: 'onPause',
    value: function onPause() {
      this.setState({ playing: false });
    }
  }, {
    key: 'onPlay',
    value: function onPlay() {
      this.props.onPlay();
      this.setState({ playing: true });
      __WEBPACK_IMPORTED_MODULE_1_raf___default()(this.onAudioProgress);
    }
  }, {
    key: 'tryPause',
    value: function tryPause() {
      var _this2 = this;

      if (this.state.playPromise && this.audioElement) {
        this.state.playPromise.then(function () {
          _this2.audioElement.pause();
        });
      }
    }
  }, {
    key: 'tryPlay',
    value: function tryPlay() {
      if (this.audioElement) {
        /*
         For some old browsers (Safari 9) play() does not return promise but undefined.
         Let's handle that case by returning resolved promise instead.
         */
        return this.audioElement.play() || Promise.resolve();
      }
    }
  }, {
    key: 'togglePlay',
    value: function togglePlay() {
      var playing = this.state.playing;

      if (this.audioElement) {
        var isTrulyPlaying = this.audioElement.currentTime > 0 && !this.audioElement.paused && !this.audioElement.ended && this.audioElement.readyState > 2;
        if (playing && isTrulyPlaying) {
          this.tryPause();
        } else if (!isTrulyPlaying) {
          this.setState({
            playPromise: this.tryPlay()
          });
          this.showLoading();
        }
      }
    }
  }, {
    key: 'onAudioProgress',
    value: function onAudioProgress() {
      if (this.state.playing) {
        if (this.audioElement) {
          this.setState({ playBarProgress: this.audioElement.currentTime / this.audioElement.duration });
        }
        __WEBPACK_IMPORTED_MODULE_1_raf___default()(this.onAudioProgress);
      }
    }
  }, {
    key: 'showLoading',
    value: function showLoading() {
      if (this.audioElement.seeking || this.audioElement.readyState < 3) {
        this.setState({ loading: true });
      } else {
        this.setState({ loading: false });
      }
    }
  }, {
    key: 'audioCanPlay',
    value: function audioCanPlay() {
      this.showLoading();
    }
  }, {
    key: 'setAudioElementRef',
    value: function setAudioElementRef(audioElement) {
      this.audioElement = audioElement;
    }
  }, {
    key: 'render',
    value: function render() {
      var src = this.props.src;
      var _state = this.state,
          playing = _state.playing,
          loading = _state.loading,
          playBarProgress = _state.playBarProgress;


      var buttonIcon = null;
      if (loading) {
        buttonIcon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__icons_spinner__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_6__audioPlayerSmall_module_css___default.a.spinningIcon });
      } else {
        if (playing) {
          buttonIcon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__icons_pause__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_6__audioPlayerSmall_module_css___default.a.whiteIcon });
        } else {
          buttonIcon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__icons_play__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_6__audioPlayerSmall_module_css___default.a.icon });
        }
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_6__audioPlayerSmall_module_css___default.a.container },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'audio',
          {
            ref: this.setAudioElementRef,
            preload: 'none',
            onPlay: this.onPlay,
            onPause: this.onPause,
            onCanPlay: this.audioCanPlay
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source', { src: src, type: 'audio/mpeg' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { onClick: this.togglePlay, className: __WEBPACK_IMPORTED_MODULE_6__audioPlayerSmall_module_css___default.a.playButton },
          buttonIcon
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_6__audioPlayerSmall_module_css___default.a.progressBarContainer },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_6__audioPlayerSmall_module_css___default.a.progressBar, style: {
              width: playBarProgress * 100 + '%'
            } })
        )
      );
    }
  }]);

  return AudioPlayerSmall;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

AudioPlayerSmall.propTypes = {
  src: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  onPlay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  isActive: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};
AudioPlayerSmall.defaultProps = {
  onPlay: function onPlay() {}
};
/* harmony default export */ __webpack_exports__["a"] = (AudioPlayerSmall);

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_actions_searchPage__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__audioPlayerSmall__ = __webpack_require__(518);





var mapStateToProps = function mapStateToProps(state, ownProps) {
  var activeAudio = state.searchPage.activeAudio;


  return {
    isActive: ownProps.src && ownProps.src === activeAudio
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onPlay: function onPlay() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_actions_searchPage__["b" /* setActiveAudio */])(ownProps.src));
    }
  };
};

var AudioPlayerSmallContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__audioPlayerSmall__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AudioPlayerSmallContainer);

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Waveform = function (_React$Component) {
  _inherits(Waveform, _React$Component);

  function Waveform(props) {
    _classCallCheck(this, Waveform);

    var _this = _possibleConstructorReturn(this, (Waveform.__proto__ || Object.getPrototypeOf(Waveform)).call(this, props));

    _this.state = {
      waveformData: _this.sampleData(props.data)
    };

    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
    _this.setCanvasContainerRef = _this.setCanvasContainerRef.bind(_this);
    _this.setCanvasRef = _this.setCanvasRef.bind(_this);
    return _this;
  }

  _createClass(Waveform, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateWaveform();
      window.addEventListener('resize', this.handleWindowResize, true);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleWindowResize, true);
    }
  }, {
    key: 'handleWindowResize',
    value: function handleWindowResize() {
      if (this.canvasElement) {
        this.canvasElement.style.width = this.canvasContainerElement.parentNode.clientWidth + 'px';
      }
    }
  }, {
    key: 'sampleData',
    value: function sampleData(response) {
      var form = { max: 1, samples: [] };
      for (var i = 0; i < response.length; i++) {
        var sample = response.data[i * 2 + 1] - response.data[i * 2];
        form.samples.push(sample);
        if (sample > form.max) {
          form.max = sample;
        }
      }
      return form;
    }
  }, {
    key: 'updateWaveform',
    value: function updateWaveform() {
      var colour = this.props.colour;
      var waveformData = this.state.waveformData;

      var canvasContainer = this.canvasContainerElement;
      var canvas = this.canvasElement;

      var context = canvas.getContext('2d');
      canvas.style.width = canvasContainer.parentNode.clientWidth + 'px';
      canvas.width = this.state.waveformData.samples.length;

      // Clear the canvas
      context.clearRect(0, 0, canvas.width, canvas.height);

      // Pre-calculate some values
      var yBaseline = canvas.height / 2;
      var yMultiplier = yBaseline / waveformData.max;

      // Draw the dividing middle line
      context.lineWidth = 0.1;
      context.beginPath();
      context.moveTo(0, yBaseline);
      context.lineTo(canvas.width, yBaseline);
      context.stroke();

      // Draw the top part of the waveform
      context.fillStyle = colour;
      context.beginPath();
      context.moveTo(0, yBaseline);
      for (var i = 0; i < waveformData.samples.length; i++) {
        context.lineTo(i, yBaseline - waveformData.samples[i] * yMultiplier);
      }
      context.lineTo(canvas.width, yBaseline);
      context.closePath();
      context.fill();

      // Draw the bottom part
      context.beginPath();
      context.moveTo(0, yBaseline);
      for (var _i = 0; _i < waveformData.samples.length; _i++) {
        context.lineTo(_i, yBaseline + waveformData.samples[_i] * yMultiplier);
      }
      context.lineTo(canvas.width, yBaseline);
      context.closePath();
      context.fill();
    }
  }, {
    key: 'setCanvasContainerRef',
    value: function setCanvasContainerRef(canvasContainerElement) {
      this.canvasContainerElement = canvasContainerElement;
    }
  }, {
    key: 'setCanvasRef',
    value: function setCanvasRef(canvasElement) {
      this.canvasElement = canvasElement;
    }
  }, {
    key: 'render',
    value: function render() {
      var progress = this.props.progress;

      var canvasContainerStyles = {
        width: progress * 100 + '%',
        height: '100%',
        position: 'absolute',
        overflow: 'hidden'
      };
      var canvasStyles = {
        height: '100%',
        position: 'absolute'
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          ref: this.setCanvasContainerRef,
          style: canvasContainerStyles
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas', {
          ref: this.setCanvasRef,
          style: canvasStyles
        })
      );
    }
  }]);

  return Waveform;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Waveform);

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (suggestionText, term) {
  return suggestionText.split(term).map(function (match) {
    return "<span class='autosuggest__highlighted-text'>" + match + "</span>";
  }).join("<span>" + term + "</span>");
});

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_keycode__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__highlightSearchTerm__ = __webpack_require__(521);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var AutoSuggest = function (_React$Component) {
  _inherits(AutoSuggest, _React$Component);

  function AutoSuggest(props) {
    _classCallCheck(this, AutoSuggest);

    var _this = _possibleConstructorReturn(this, (AutoSuggest.__proto__ || Object.getPrototypeOf(AutoSuggest)).call(this, props));

    _this.state = {
      inputValue: props.inputValue,
      isOpen: false,
      focusedIndex: -1
    };

    _this.handleInputFocus = _this.handleInputFocus.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleKeyUp = _this.handleKeyUp.bind(_this);
    _this.setWrapperRef = _this.setWrapperRef.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.handleMenuMouseEnter = _this.handleMenuMouseEnter.bind(_this);
    _this.handleMenuMouseLeave = _this.handleMenuMouseLeave.bind(_this);
    return _this;
  }

  _createClass(AutoSuggest, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('click', this.handleDocumentClick, true);
      document.addEventListener('touchend', this.handleDocumentClick, true);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleDocumentClick, true);
      document.removeEventListener('touchend', this.handleDocumentClick, true);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.inputValue !== this.props.inputValue) {
        this.setState({
          inputValue: nextProps.inputValue
        });
      }
    }
  }, {
    key: 'setWrapperRef',
    value: function setWrapperRef(ref) {
      if (ref !== null) {
        this.wrapper = ref;
      }
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(event) {
      if (!this.wrapper.contains(event.target)) {
        this.setState({ isOpen: false });
      }
    }
  }, {
    key: 'handleInputChange',
    value: function handleInputChange(event) {
      if (this.props.onInputChange) {
        this.props.onInputChange(event.target.value);
      }

      // if auto suggest menu is not open, we should open it on input change
      if (!this.state.isOpen) {
        this.setState({
          isOpen: true
        });
      }
    }
  }, {
    key: 'handleInputFocus',
    value: function handleInputFocus(event) {
      this.setState({
        isOpen: true
      });
    }
  }, {
    key: 'onMenuClick',
    value: function onMenuClick(option, event) {
      event.preventDefault();

      if (this.props.onSelectOption) {
        this.props.onSelectOption(option, event);
      }

      this.setState({
        isOpen: false
      });
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      var keyCode = event.which;

      switch (keyCode) {
        // Block up/down arrow from moving the cursor in the search input
        case __WEBPACK_IMPORTED_MODULE_3_keycode___default()('up'):
        case __WEBPACK_IMPORTED_MODULE_3_keycode___default()('down'):
          event.preventDefault();
          break;

        // 1. Because Enter triggers form submission before we get the chance to run
        //    `_updateAnalyticsParamInput`, we disable the submission on keydown and
        //    manually trigger it on keyup. Ideally we'd have the form and the input
        //    as custom React components and then this wouldn't be necessary.
        // 2. Block Esc from emptying the search input
        case __WEBPACK_IMPORTED_MODULE_3_keycode___default()('enter'):
        case __WEBPACK_IMPORTED_MODULE_3_keycode___default()('esc'):
          event.preventDefault();
          break;
      }
    }
  }, {
    key: 'handleKeyUp',
    value: function handleKeyUp(event) {
      var _state = this.state,
          focusedIndex = _state.focusedIndex,
          inputValue = _state.inputValue;
      var suggestions = this.props.suggestions;


      var keyCode = event.which;

      switch (keyCode) {
        case __WEBPACK_IMPORTED_MODULE_3_keycode___default()('enter'):
          if (this.props.onSelectOption) {
            // when the user hit `enter` without selecting any option, we simply pass the inputValue to onSelection option
            this.props.onSelectOption(focusedIndex === -1 ? inputValue : suggestions[focusedIndex], event);
          }

          this.setState({
            isOpen: false
          });
          break;

        // Esc hides autosuggest and deselects the current suggestion
        case __WEBPACK_IMPORTED_MODULE_3_keycode___default()('esc'):
          this.setState({
            isOpen: false,
            focusedIndex: -1
          });
          break;

        case __WEBPACK_IMPORTED_MODULE_3_keycode___default()('up'):
          this.setFocusedIndex('prev');
          break;

        case __WEBPACK_IMPORTED_MODULE_3_keycode___default()('down'):
          this.setFocusedIndex('next');
          break;

        default:
          this.setState({
            focusedIndex: -1
          });
          event.preventDefault();
      }
    }
  }, {
    key: 'setFocusedIndex',
    value: function setFocusedIndex(dir) {
      var _state2 = this.state,
          focusedIndex = _state2.focusedIndex,
          inputValue = _state2.inputValue;
      var suggestions = this.props.suggestions;

      var optionLength = suggestions.length;

      var isNoneSelected = focusedIndex === -1;
      var isFirstSelected = focusedIndex === 0;
      var isLastSelected = focusedIndex === optionLength - 1;

      if (dir === 'prev') {
        if (isFirstSelected || isNoneSelected) {
          this.setState({
            focusedIndex: optionLength - 1,
            inputValue: suggestions[optionLength - 1] ? suggestions[optionLength - 1].text : inputValue
          });
        } else {
          this.setState({
            focusedIndex: focusedIndex - 1,
            inputValue: suggestions[focusedIndex - 1] ? suggestions[focusedIndex - 1].text : inputValue
          });
        }
      } else if (dir === 'next') {
        if (isLastSelected || isNoneSelected) {
          this.setState({
            focusedIndex: 0,
            inputValue: suggestions[0] ? suggestions[0].text : inputValue
          });
        } else {
          this.setState({
            focusedIndex: focusedIndex + 1,
            inputValue: suggestions[focusedIndex + 1] ? suggestions[focusedIndex + 1].text : inputValue
          });
        }
      }
    }
  }, {
    key: 'handleMenuMouseEnter',
    value: function handleMenuMouseEnter(index) {
      this.setState({
        focusedIndex: index
      });
    }
  }, {
    key: 'handleMenuMouseLeave',
    value: function handleMenuMouseLeave(index) {
      this.setState({
        focusedIndex: -1
      });
    }
  }, {
    key: 'renderWrapper',
    value: function renderWrapper() {
      var _this2 = this;

      var suggestions = this.props.suggestions;
      var _state3 = this.state,
          focusedIndex = _state3.focusedIndex,
          inputValue = _state3.inputValue;

      /**
       * Hack inline style :magic:
       */

      var wrapperStyle = {
        position: 'absolute',
        top: this.textInput.clientHeight,
        width: this.wrapper.clientWidth
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'autosuggest__wrapper -border-radius-bottom', style: wrapperStyle },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'section',
          { ref: function ref(_ref) {
              _this2.menu = _ref;
            }, className: 'autosuggest__suggestions' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'ul',
            { className: 'autosuggest__list fds-c-text-list -style-none' },
            suggestions.map(function (suggestion, index) {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'li',
                {
                  className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('autosuggest__list-item', {
                    focused: focusedIndex === index
                  }),
                  onMouseDown: function onMouseDown(event) {
                    return _this2.onMenuClick(suggestion, event);
                  },
                  onMouseEnter: function onMouseEnter(event) {
                    return _this2.handleMenuMouseEnter(index);
                  },
                  onMouseLeave: function onMouseLeave(event) {
                    return _this2.handleMenuMouseLeave(index);
                  },
                  key: index
                },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'a',
                  {
                    className: 'fds-c-text-link -color-dark -decoration-none',
                    href: suggestion.link
                  },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'autosuggest__suggestion-text h-text-truncate' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', {
                      dangerouslySetInnerHTML: { __html: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__highlightSearchTerm__["a" /* default */])(suggestion.text, inputValue.trim()) } })
                  )
                )
              );
            })
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state4 = this.state,
          isOpen = _state4.isOpen,
          inputValue = _state4.inputValue;
      var _props = this.props,
          suggestions = _props.suggestions,
          inputName = _props.inputName,
          placeholder = _props.placeholder,
          type = _props.type,
          ariaLabel = _props.ariaLabel;


      var inputStyle = {
        borderRadius: isOpen && suggestions.length ? '7px 0 0 0' : '7px 0 0 7px'
      };

      var buttonStyle = {
        borderRadius: isOpen && suggestions.length ? '0 7px 0 0' : '0 7px 7px 0'
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { ref: this.setWrapperRef },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
          ref: function ref(input) {
            _this3.textInput = input;
          },
          style: inputStyle,
          placeholder: placeholder || '',
          autoComplete: 'off',
          type: type || 'search',
          'aria-label': ariaLabel || 'search',
          name: inputName || '',

          value: inputValue,
          onChange: this.handleInputChange,
          onFocus: this.handleInputFocus,
          onKeyDown: this.handleKeyDown,
          onKeyUp: this.handleKeyUp
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'button',
          { className: 'fds-c-button huge-search--btn -theme-themeforest', style: buttonStyle, defaultValue: 'Submit' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'e-icon__alt' },
            'Search'
          )
        ),
        isOpen && suggestions && suggestions.length > 0 && this.renderWrapper()
      );
    }
  }]);

  return AutoSuggest;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

AutoSuggest.propTypes = {
  suggestions: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired,
  onInputChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  placeholder: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  onSelectOption: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  inputName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  inputValue: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (AutoSuggest);

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_sites_ads__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils_assetsPath__ = __webpack_require__(81);





var CrossPromoBanner = function CrossPromoBanner(_ref) {
  var currentSite = _ref.currentSite,
      currentCategory = _ref.currentCategory;

  var currentSiteConfig = __WEBPACK_IMPORTED_MODULE_1__config_sites_ads__["a" /* default */][currentSite];

  var matchedAdsFromConfig = function matchedAdsFromConfig(config) {
    return config.reduce(function (incr, ad) {
      if (Array.isArray(ad.match)) {
        ad.match.forEach(function (match) {
          if (match === currentCategory) {
            incr.push(ad);
          }
        });
      } else {
        if (ad.match === currentCategory) {
          incr.push(ad);
        }
      }
      return incr;
    }, []);
  };

  var matchedAds = matchedAdsFromConfig(currentSiteConfig);

  if (matchedAds.length === 0) return null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'search-facet-divider' }),
    matchedAds.map(function (ad) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { key: ad.title, className: 'cross-promos__box' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'cross-promos' },
          ad.icon_source && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
            className: 'fds-u-mb2',
            title: ad.title,
            src: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_utils_assetsPath__["a" /* default */])() + '/images/cross-promos/' + ad.icon_source,
            alt: ad.title
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'cross-promos__header fds-u-m0' },
            ad.title
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', {
            dangerouslySetInnerHTML: {
              __html: ad.content
            },
            className: 'fds-c-text-body -size-s'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            {
              title: ad.button_label,
              className: 'fds-c-button--outline -color-primary -width-full',
              href: ad.link
            },
            ad.button_label
          )
        )
      );
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (CrossPromoBanner);

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var siteShortNameMap = {
  themeforest: 'tf',
  codecanyon: 'cc',
  videohive: 'vh',
  audiojungle: 'aj',
  graphicriver: 'gr',
  photodune: 'pd',
  '3docean': '3d'
};

var redirectUrl = function redirectUrl(site) {
  return 'https://elements.envato.com/all-items/?utm_campaign=elements_mkt-search_26JUNE2017&amp;utm_content=' + siteShortNameMap[site] + '_search-results&amp;utm_medium=promos&amp;utm_source=' + site + '.net';
};

var ElementsBanner = function ElementsBanner(_ref) {
  var currentSite = _ref.currentSite;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'elements-promo fds-u-mb4' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'elements-promo__copy-wrapper' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'elements-promo__content' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { className: 'elements-promo__logo-white', href: redirectUrl(currentSite) },
          'Envato Elements'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          { className: 'elements-heading fds-c-text-heading -size-l fds-u-mb0' },
          'Deliver better projects faster'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'elements-heading fds-c-text-body fds-u-mb0' },
          'Unlimited photos, web templates, graphic assets & courses.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'elements-promo__button-wrapper' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'elements-promo__button', href: redirectUrl(currentSite) },
            'View all'
          )
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ElementsBanner);

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_random__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_random___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_random__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_analytics_bannerAnalytics__ = __webpack_require__(649);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var HeadBanner = function (_React$Component) {
  _inherits(HeadBanner, _React$Component);

  function HeadBanner(props) {
    _classCallCheck(this, HeadBanner);

    // we should not rendering any thing from server side for two reasons:
    // 1. content will be cached through CDN, and we don't want it to be cached
    // 2. we will get react invalid checksum warning because server and client
    // render differnt content
    var _this = _possibleConstructorReturn(this, (HeadBanner.__proto__ || Object.getPrototypeOf(HeadBanner)).call(this, props));

    _this.state = {
      bannerConfig: null,
      hideBanner: false,
      hasBindedDismissEvent: false,
      hasBindedClickEvent: false
    };
    return _this;
  }

  _createClass(HeadBanner, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var banners = this.props.banners;

      var bannerId = banners && banners[0] ? banners[0].id : null;

      if (bannerId) {
        var bannerCacheKey = 'banner_' + bannerId + '_cache';
        var localStorageSupported = !!window.localStorage;
        // should not show the banner if it's already dismissed
        var hasDimissed = localStorageSupported ? window.localStorage.getItem(bannerCacheKey) === 'hidden' : false;
        if (localStorageSupported && !hasDimissed) {
          // if it's not dismissed
          // we load random banner config after page is loaded
          var bannerIndex = __WEBPACK_IMPORTED_MODULE_3_lodash_random___default()(banners.length - 1);
          var bannerConfig = banners[bannerIndex];

          this.setState({
            bannerConfig: bannerConfig
          });
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _state = this.state,
          bannerConfig = _state.bannerConfig,
          hasBindedDismissEvent = _state.hasBindedDismissEvent,
          hasBindedClickEvent = _state.hasBindedClickEvent;

      var dismissButton = document.querySelector('.js-banner__dismiss');
      var bannerLinkButton = document.querySelector('.js-banner__link');
      // only bind the dismiss event when the banner is loaded
      if (dismissButton && !hasBindedDismissEvent) {
        this.bindDismissEvent(bannerConfig);
      }
      if (bannerLinkButton && !hasBindedClickEvent) {
        this.bindBannerClickEvent(bannerConfig);
      }
    }
  }, {
    key: 'bindDismissEvent',
    value: function bindDismissEvent(bannerConfig) {
      var _this2 = this;

      var dismissButton = document.querySelector('.js-banner__dismiss');
      // this should always align with the key set by marketplace
      var bannerCacheKey = 'banner_' + bannerConfig.id + '_cache';

      if (dismissButton) {
        this.setState({
          hasBindedDismissEvent: true
        });
        dismissButton.addEventListener('click', function (event) {
          event.preventDefault();
          var localStorageSupported = !!window.localStorage;
          if (localStorageSupported) {
            window.localStorage.setItem(bannerCacheKey, 'hidden');
          }
          _this2.setState({
            hideBanner: true
          });
        });
      }
    }
  }, {
    key: 'bindBannerClickEvent',
    value: function bindBannerClickEvent(bannerConfig) {
      var bannerLinkButton = document.querySelector('.js-banner__link');
      var bannerId = bannerConfig.id;

      if (bannerLinkButton) {
        this.setState({
          hasBindedClickEvent: true
        });
        bannerLinkButton.addEventListener('click', function (event) {
          var payload = {
            name: bannerId,
            actionData: null,
            productsArray: [{
              id: bannerId,
              name: bannerId
            }],
            timestamp: new Date().getTime()
          };
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_analytics_bannerAnalytics__["a" /* reportHeaderBannerClick */])(payload);
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state2 = this.state,
          bannerConfig = _state2.bannerConfig,
          hideBanner = _state2.hideBanner;


      if (!bannerConfig) {
        return null;
      }

      var bannerContainerClassName = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('banner-root', {
        'banner-slide-up': hideBanner
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: bannerContainerClassName },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'style',
          null,
          bannerConfig.css
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'banner-container', dangerouslySetInnerHTML: { __html: bannerConfig.html } })
      );
    }
  }]);

  return HeadBanner;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HeadBanner.propTypes = {
  banners: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (HeadBanner);

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_analytics_surveyBannerAnalytics__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils_localStorageHelpers__ = __webpack_require__(327);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var PhotoduneSearchSurveyBanner = function (_React$Component) {
  _inherits(PhotoduneSearchSurveyBanner, _React$Component);

  function PhotoduneSearchSurveyBanner(props) {
    _classCallCheck(this, PhotoduneSearchSurveyBanner);

    var _this = _possibleConstructorReturn(this, (PhotoduneSearchSurveyBanner.__proto__ || Object.getPrototypeOf(PhotoduneSearchSurveyBanner)).call(this, props));

    _this.onDismiss = function (event) {
      event.preventDefault();
      _this.dismiss();
    };

    _this.onStartSurvey = function (event) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_analytics_surveyBannerAnalytics__["a" /* reportStartSurveyClick */])('PD Search Survey');
      _this.dismiss();
    };

    _this.state = { dismissed: _this.isDismissed() };
    return _this;
  }

  _createClass(PhotoduneSearchSurveyBanner, [{
    key: 'dismiss',
    value: function dismiss() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_utils_localStorageHelpers__["a" /* setLocalStorageItem */])('pd-search-survey-banner-visibility', 'hidden');
      this.setState({ dismissed: true });
    }
  }, {
    key: 'isDismissed',
    value: function isDismissed() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_utils_localStorageHelpers__["b" /* getLocalStorageItem */])('pd-search-survey-banner-visibility', 'visible') === 'hidden';
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.state.dismissed) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_analytics_surveyBannerAnalytics__["b" /* reportViewSurveyBanner */])('PD Search Survey');
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.dismissed) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'fds-c-alert-box fds-u-mt2 -type-success' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'fds-c-alert-box__icon' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'e-icon -icon-ok' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'fds-c-alert-box__message' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'fds-c-text-body -size-s fds-u-m0' },
            'How\'s searching for photos on PhotoDune? Rewarding? Frustrating? We\'d love to know.\xA0'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PhotoduneSearchSurveyBanner.SurveyButton, { onClick: this.onStartSurvey }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PhotoduneSearchSurveyBanner.DismissButton, { onClick: this.onDismiss })
      );
    }
  }]);

  return PhotoduneSearchSurveyBanner;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PhotoduneSearchSurveyBanner.SurveyButton = function (_ref) {
  var onClick = _ref.onClick;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    { onClick: onClick, href: 'https://envato.formstack.com/forms/photodune_survey', target: '_blank', className: 'fds-c-button--3d  -color-primary' },
    'Share your experience'
  );
};

PhotoduneSearchSurveyBanner.DismissButton = function (_ref2) {
  var onClick = _ref2.onClick;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'fds-c-alert-box__dismiss' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      { onClick: onClick, className: 'fds-c-alert-box__dismiss-icon' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'e-icon -icon-cancel' })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (PhotoduneSearchSurveyBanner);

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);



var StudioRecommendationsBanner = function StudioRecommendationsBanner(_ref) {
  var config = _ref.config,
      currentSite = _ref.currentSite,
      category = _ref.category,
      term = _ref.term;

  var items = config.items;
  var generation = config.generation;

  var getLinkParams = function getLinkParams(itemId) {
    var params = {
      utm_campaign: 'shervinator',
      utm_source: 'marketplace',
      utm_medium: currentSite,
      utm_term: category || term,
      utm_content: generation + '_' + items.map(function (item) {
        return item.id;
      }).join('_') + '_' + itemId
    };

    var queries = __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.stringify(params);
    return queries;
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'studio-recommendations fds-u-mb4 fds-u-p1' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'studio-recommendations__logo fds-u-m1 fds-u-mb2', href: 'https://studio.envato.com/' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'studio-recommendations__list' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        { className: 'fds-c-text-list -style-none' },
        items.map(function (item) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            { className: 'fds-c-text-body fds-u-m1', key: item.id },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: item.url + '?' + getLinkParams(item.id),
                className: 'fds-c-text-link -decoration-reversed' },
              item.name
            ),
            ' from $',
            item.price_from
          );
        })
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (StudioRecommendationsBanner);

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




// FIXME: @shervin: not sure how happy i am with duplicating the routes here..
// Cant really think of a better way though, maybe some way of hooking into
// react router or the history stuff would be able to handle this.
var VALID_PATHS = ['/category/', '/tags/', '/attributes/', '/search'];

// This component given a path will either return a link that will do a
// full page refresh, or a SPA history pushState update
var CategoryLink = function CategoryLink(props) {
  var to = props.to;

  var validPath = VALID_PATHS.some(function (path) {
    return to.indexOf(path) === 0;
  });

  if (validPath) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */], props);
  } else {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      _extends({}, props, { href: to, target: '_self' }),
      props.children
    );
  }
};

/* harmony default export */ __webpack_exports__["a"] = (CategoryLink);

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_layout_crossSellLinks__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils_assetsPath__ = __webpack_require__(81);





var imageSrc = function imageSrc(path) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_utils_assetsPath__["a" /* default */])() + path;
};

var imageSrcSet = function imageSrcSet(paths) {
  return paths.map(function (path) {
    return imageSrc(path);
  }).join(', ');
};

var urlFor = function urlFor(urlData, currentSite) {
  return ['base', 'path', 'params'].reduce(function (url, part) {
    var selectedData = urlData[part][currentSite] || urlData[part]['default'];

    if (part === 'params') {
      var serializedParams = Object.keys(selectedData).reduce(function (params, key) {
        return params.concat(key + '=' + selectedData[key]);
      }, []).join('&');
      url = url + '?' + serializedParams;
    } else {
      url = '' + url + selectedData;
    }

    return url;
  }, '');
};

/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var currentSite = _ref.currentSite;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'cross-sell' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'grid-container' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        { className: 'cross-sell__list' },
        __WEBPACK_IMPORTED_MODULE_1__config_layout_crossSellLinks__["a" /* default */].map(function (crossSellLink) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            { key: crossSellLink.key, className: 'cross-sell__list-item' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: urlFor(crossSellLink.url, currentSite),
                className: 'cross-sell__link' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'figure',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'picture',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source', { media: '(max-width: 480px)', srcSet: '' }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: imageSrc(crossSellLink.imageSrc),
                    className: 'cross-sell__image',
                    alt: crossSellLink.label,
                    srcSet: imageSrcSet(crossSellLink.imageSrcSet) })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'figcaption',
                  { className: 'cross-sell__text-container' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'fds-c-text-body -color-inherit -size-l -weight-bold h-mb1',
                    dangerouslySetInnerHTML: { __html: crossSellLink.heading } }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    { className: 'fds-c-text-body -color-inherit -size-l h-m0' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'small',
                      { className: 'cross-sell__text' },
                      crossSellLink.subHeading
                    )
                  )
                )
              )
            )
          );
        })
      )
    )
  );
});

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FiltersBooleanComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils_urlHelper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filtersBooleanBody__ = __webpack_require__(302);







var FiltersBoolean = function FiltersBoolean(_ref) {
  var name = _ref.name,
      label = _ref.label,
      location = _ref.location,
      history = _ref.history,
      isAtBottom = _ref.isAtBottom,
      count = _ref.count,
      icon = _ref.icon;

  var parsedLocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_utils_urlHelper__["a" /* parseLocation */])(location);
  var isChecked = !!parsedLocation[name];

  var onChange = function onChange(event) {
    var checkedValue = event.target.checked;
    var newQuery = Object.assign({}, parsedLocation);
    delete newQuery.page;

    if (checkedValue) {
      newQuery[name] = 1;
    } else {
      delete newQuery[name];
    }

    history.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_utils_urlHelper__["b" /* makeLink */])(newQuery));
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__filtersBooleanBody__["a" /* default */], {
    name: name,
    label: label,
    onChange: onChange,
    isChecked: isChecked,
    isAtBottom: isAtBottom,
    count: count,
    icon: icon });
};

FiltersBoolean.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isAtBottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  count: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var FiltersBooleanComponent = FiltersBoolean;
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* withRouter */])(FiltersBoolean));

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FiltersCategoryComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_titleize__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_titleize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_titleize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_humanize_string__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_humanize_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_humanize_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_keycode__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__clickOutside__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__onKeyDown__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_utils_urlHelper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__filtersPanel_singleSelect__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_analytics_filtersAnalytics__ = __webpack_require__(80);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var FiltersCategory = function (_React$Component) {
  _inherits(FiltersCategory, _React$Component);

  function FiltersCategory(props) {
    _classCallCheck(this, FiltersCategory);

    var _this = _possibleConstructorReturn(this, (FiltersCategory.__proto__ || Object.getPrototypeOf(FiltersCategory)).call(this, props));

    _this.state = {
      showPanel: false
    };

    _this.togglePanel = _this.togglePanel.bind(_this);
    _this.onKeyDownHandler = _this.onKeyDownHandler.bind(_this);
    return _this;
  }

  _createClass(FiltersCategory, [{
    key: 'onKeyDownHandler',
    value: function onKeyDownHandler(event) {
      if (event.keyCode === __WEBPACK_IMPORTED_MODULE_5_keycode___default()('esc')) {
        this.togglePanel();
      }
    }
  }, {
    key: 'togglePanel',
    value: function togglePanel() {
      if (!this.state.showPanel) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__common_analytics_filtersAnalytics__["a" /* reportOpenSearchFilterPanel */])('Category');
      }
      this.setState({
        showPanel: !this.state.showPanel
      });
    }

    /**
     * because the result returned from api does include the top and sub category
     * we have to filter them and only keep the one that needs to be displayed in the UI
     */

  }, {
    key: 'filterOption',
    value: function filterOption(items, chosenCategory) {
      return items.filter(function (item, idx) {
        return item.key.indexOf(chosenCategory) > -1 && item.key !== chosenCategory;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var showPanel = this.state.showPanel;
      var _props = this.props,
          items = _props.items,
          location = _props.location,
          categoryRootCount = _props.categoryRootCount;

      var parsedLocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__common_utils_urlHelper__["a" /* parseLocation */])(location);

      var chosenCategory = parsedLocation.category || '';
      var chosenCategoryArray = chosenCategory.split('/');
      var chosenCategoryLength = chosenCategoryArray.length;
      var filteredCategoryItems = this.filterOption(items, chosenCategory);

      var renderChosenCategory = function renderChosenCategory() {
        var categoriesInBox = void 0;
        // show the top level categories if there's no selected category
        if (chosenCategory === '') {
          categoriesInBox = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'ul',
            { className: 'search-facet-listing' },
            items.map(function (item, index) {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'li',
                { key: index },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: 'search-facet-listing__link' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'search-facet-listing__label' },
                    __WEBPACK_IMPORTED_MODULE_3_titleize___default()(__WEBPACK_IMPORTED_MODULE_4_humanize_string___default()(item.key))
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'search-facet-result-count' },
                    item.count
                  )
                )
              );
            })
          );
          // if there's chose category, show the bread crumb menu
        } else {
          var getChosenCategoryDisplayName = function getChosenCategoryDisplayName(chosenCategory) {
            return chosenCategoryArray.map(function (categoryName, index) {
              var isLast = index === chosenCategoryLength - 1;
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { key: index, className: 'search-facet-panel__status-title' },
                __WEBPACK_IMPORTED_MODULE_3_titleize___default()(__WEBPACK_IMPORTED_MODULE_4_humanize_string___default()(categoryName)),
                !isLast && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'e-icon -icon-arrow-fill-right' })
              );
            });
          };
          categoriesInBox = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'search-facet-panel__status fds-u-is-hidden--no-js' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'search-facet-panel__status-row' },
              getChosenCategoryDisplayName(chosenCategory)
            )
          );
        }
        return categoriesInBox;
      };

      var panelHeaderClassNames = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('search-facet-panel__header--start', {
        'is-active': showPanel
      });

      // TODO: fix animation for showing and hiding the panel
      // and possiblily merge `OnKeyDown` and `ClickOutside` component
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'search-facet--no-margin', id: 'category-filter' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: panelHeaderClassNames, onClick: this.togglePanel },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h2',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'e-icon -icon-folder -margin-right' }),
            'Category'
          ),
          renderChosenCategory()
        ),
        showPanel && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__onKeyDown__["a" /* default */],
          { onKeyDown: this.onKeyDownHandler },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__clickOutside__["a" /* default */],
            { onClickOutside: this.togglePanel },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__filtersPanel_singleSelect__["a" /* default */], {
              rootCount: categoryRootCount,
              showPanel: showPanel,
              items: filteredCategoryItems,
              parsedLocation: parsedLocation,
              togglePanel: this.togglePanel,
              breadcrumbsLabel: 'categories',
              type: 'category'
            })
          )
        )
      );
    }
  }]);

  return FiltersCategory;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

FiltersCategory.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  categoryRootCount: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
};

var FiltersCategoryComponent = FiltersCategory;
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["c" /* withRouter */])(FiltersCategory));

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_keycode__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__clickOutside__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__onKeyDown__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils_urlHelper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filtersPanel_multiSelect__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_analytics_filtersAnalytics__ = __webpack_require__(80);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var FiltersColors = function (_React$Component) {
  _inherits(FiltersColors, _React$Component);

  function FiltersColors(props) {
    _classCallCheck(this, FiltersColors);

    var _this = _possibleConstructorReturn(this, (FiltersColors.__proto__ || Object.getPrototypeOf(FiltersColors)).call(this, props));

    _this.state = {
      showPanel: false
    };

    _this.togglePanel = _this.togglePanel.bind(_this);
    _this.onKeyDownHandler = _this.onKeyDownHandler.bind(_this);
    return _this;
  }

  _createClass(FiltersColors, [{
    key: 'onKeyDownHandler',
    value: function onKeyDownHandler(event) {
      if (event.keyCode === __WEBPACK_IMPORTED_MODULE_3_keycode___default()('esc')) {
        this.togglePanel();
      }
    }
  }, {
    key: 'togglePanel',
    value: function togglePanel() {
      if (!this.state.showPanel) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__common_analytics_filtersAnalytics__["a" /* reportOpenSearchFilterPanel */])('colors');
      }
      this.setState({
        showPanel: !this.state.showPanel
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var showPanel = this.state.showPanel;
      var _props = this.props,
          items = _props.items,
          location = _props.location,
          isAtTop = _props.isAtTop,
          isAtBottom = _props.isAtBottom;

      var parsedLocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_utils_urlHelper__["a" /* parseLocation */])(location);

      var chosenColors = parsedLocation.colors || '';

      var renderChosenColors = function renderChosenColors() {
        if (chosenColors === '') {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'ul',
            { className: 'search-facet-listing' },
            items.map(function (item, index) {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'li',
                { key: index },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: 'search-facet-listing__link' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'search-facet-listing__label' },
                    item.key
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'search-facet-result-count' },
                    item.count
                  )
                )
              );
            })
          );
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'search-facet-panel__status fds-u-is-hidden--no-js' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'search-facet-panel__status-row' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'search-facet-panel__status-title' },
                chosenColors.split(',').join(', ')
              )
            )
          );
        }
      };

      var panelHeaderClassNames = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
        'search-facet-panel__header--start': isAtTop,
        'search-facet-panel__header': !isAtTop,
        'search-facet-panel__header--end': isAtBottom,
        'is-active': showPanel
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'search-facet--no-margin', id: 'colors-filter' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: panelHeaderClassNames, onClick: this.togglePanel },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h2',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'e-icon -icon-palette -margin-right' }),
            'Colors'
          ),
          renderChosenColors()
        ),
        showPanel && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__onKeyDown__["a" /* default */],
          { onKeyDown: this.onKeyDownHandler },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__clickOutside__["a" /* default */],
            { onClickOutside: this.togglePanel },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__filtersPanel_multiSelect__["a" /* default */], {
              type: 'colors',
              showPanel: showPanel,
              items: items,
              parsedLocation: parsedLocation,
              togglePanel: this.togglePanel
            })
          )
        )
      );
    }
  }]);

  return FiltersColors;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

FiltersColors.propTypes = {
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  items: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array
};

/* harmony default export */ __webpack_exports__["a"] = (FiltersColors);

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_keycode__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__clickOutside__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__onKeyDown__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils_urlHelper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filtersPanel_multiSelect__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_analytics_filtersAnalytics__ = __webpack_require__(80);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var FiltersCompatibleWith = function (_React$Component) {
  _inherits(FiltersCompatibleWith, _React$Component);

  function FiltersCompatibleWith(props) {
    _classCallCheck(this, FiltersCompatibleWith);

    var _this = _possibleConstructorReturn(this, (FiltersCompatibleWith.__proto__ || Object.getPrototypeOf(FiltersCompatibleWith)).call(this, props));

    _this.state = {
      showPanel: false
    };

    _this.togglePanel = _this.togglePanel.bind(_this);
    _this.onKeyDownHandler = _this.onKeyDownHandler.bind(_this);
    return _this;
  }

  _createClass(FiltersCompatibleWith, [{
    key: 'onKeyDownHandler',
    value: function onKeyDownHandler(event) {
      if (event.keyCode === __WEBPACK_IMPORTED_MODULE_3_keycode___default()('esc')) {
        this.togglePanel();
      }
    }
  }, {
    key: 'togglePanel',
    value: function togglePanel() {
      if (!this.state.showPanel) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__common_analytics_filtersAnalytics__["a" /* reportOpenSearchFilterPanel */])('Compatible with');
      }
      this.setState({
        showPanel: !this.state.showPanel
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var showPanel = this.state.showPanel;
      var _props = this.props,
          items = _props.items,
          location = _props.location;

      var parsedLocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_utils_urlHelper__["a" /* parseLocation */])(location);

      var chosenCompatibleWith = parsedLocation.compatible_with || '';

      var renderChosenOptions = function renderChosenOptions() {
        if (chosenCompatibleWith === '') {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'ul',
            { className: 'search-facet-listing' },
            items.map(function (item, index) {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'li',
                { key: index },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: 'search-facet-listing__link' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'search-facet-listing__label' },
                    item.key
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'search-facet-result-count' },
                    item.count
                  )
                )
              );
            })
          );
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'search-facet-panel__status fds-u-is-hidden--no-js' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'search-facet-panel__status-row' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'search-facet-panel__status-title' },
                chosenCompatibleWith.split(',').join(', ')
              )
            )
          );
        }
      };

      var isAtTop = this.props.isAtTop;

      var panelHeaderClassNames = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
        'search-facet-panel__header--one-facet': isAtTop,
        'search-facet-panel__header--end': !isAtTop,
        'is-active': showPanel
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'search-facet--no-margin', id: 'compatible-with-filter' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: panelHeaderClassNames, onClick: this.togglePanel },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h2',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'e-icon -icon-code -margin-right' }),
            'Compatible with'
          ),
          renderChosenOptions()
        ),
        showPanel && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__onKeyDown__["a" /* default */],
          { onKeyDown: this.onKeyDownHandler },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__clickOutside__["a" /* default */],
            { onClickOutside: this.togglePanel },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__filtersPanel_multiSelect__["a" /* default */], {
              type: 'compatible_with',
              showPanel: showPanel,
              items: items,
              parsedLocation: parsedLocation,
              togglePanel: this.togglePanel
            })
          )
        )
      );
    }
  }]);

  return FiltersCompatibleWith;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

FiltersCompatibleWith.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (FiltersCompatibleWith);

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FiltersDropdownComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dropdown__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils_urlHelper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils_formatString__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_constants_filterParamsConfig__ = __webpack_require__(38);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }











var FiltersDropdown = function FiltersDropdown(_ref) {
  var name = _ref.name,
      label = _ref.label,
      location = _ref.location,
      history = _ref.history,
      _ref$items = _ref.items,
      items = _ref$items === undefined ? [] : _ref$items,
      _ref$ignoreOptions = _ref.ignoreOptions,
      ignoreOptions = _ref$ignoreOptions === undefined ? [] : _ref$ignoreOptions,
      isAtBottom = _ref.isAtBottom,
      isAtTop = _ref.isAtTop;

  var config = __WEBPACK_IMPORTED_MODULE_7__common_constants_filterParamsConfig__["a" /* default */][name];
  var id = name + '-filter';
  var parsedLocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_urlHelper__["a" /* parseLocation */])(location);
  var chosenOption = parsedLocation[name] || '';
  var prependLabel = label + ': ';

  var prependActiveLabel = function prependActiveLabel(option) {
    return {
      value: option.value,
      label: chosenOption === option.value ? '' + prependLabel + option.label : option.label
    };
  };

  var filterIgnoredOptions = function filterIgnoredOptions(option) {
    return !ignoreOptions.includes(option.key);
  };

  var sortOptions = function sortOptions(opt1, opt2) {
    if (config.labels) {
      var keys = Object.keys(config.labels);
      return keys.indexOf(opt1.key) - keys.indexOf(opt2.key);
    }

    return opt1.key > opt2.key;
  };

  var applyLabels = function applyLabels(option) {
    var label = void 0;

    if (option.key) {
      label = config.labels && config.labels[option.key] || config.format && config.format(option.key) || option.key;
      label = option.count !== '' && option.count !== 0 ? label + ' - ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_utils_formatString__["b" /* commaStyleString */])(option.count) : label;
    } else {
      label = 'Show All';
    }

    return {
      value: option.key,
      label: label
    };
  };

  // build the show all option
  var options = [{
    count: '',
    description: null,
    key: ''
  }].concat(_toConsumableArray(items)).filter(filterIgnoredOptions).sort(sortOptions).map(applyLabels).map(prependActiveLabel);

  var onSelectionChange = function onSelectionChange(event) {
    var value = event.target.value;

    var newQuery = Object.assign({}, parsedLocation, _defineProperty({}, name, value));
    delete newQuery.page;

    if (newQuery[name] === '') {
      delete newQuery[name];
    }

    history.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_urlHelper__["b" /* makeLink */])(newQuery));
  };

  var panelHeaderClassNames = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('group-select', {
    '-border-top-none': !isAtTop,
    '-border-radius-none': !isAtBottom && !isAtTop,
    '-border-radius-bottom': isAtBottom,
    '-border-radius-top': isAtTop
  });

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { id: id },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: panelHeaderClassNames },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'search-facet-header' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h2',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'e-icon -icon-' + config.icon + ' -margin-right' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            null,
            label
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'label',
        { className: 'fds-u-is-visually-hidden', htmlFor: name },
        label
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__dropdown__["a" /* default */], {
        name: name,
        options: options,
        onChange: onSelectionChange,
        value: chosenOption })
    )
  );
};

FiltersDropdown.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  label: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  items: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,
  ignoreOptions: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array,
  isAtBottom: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  isAtTop: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};

var FiltersDropdownComponent = FiltersDropdown;
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* withRouter */])(FiltersDropdown));

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_keycode__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_undefsafe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__clickOutside__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__onKeyDown__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils_urlHelper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_constants_filterParamsConfig__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__filtersPanel_multiSelect__ = __webpack_require__(102);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var FiltersFileType = function (_React$Component) {
  _inherits(FiltersFileType, _React$Component);

  function FiltersFileType(props) {
    _classCallCheck(this, FiltersFileType);

    var _this = _possibleConstructorReturn(this, (FiltersFileType.__proto__ || Object.getPrototypeOf(FiltersFileType)).call(this, props));

    _this.state = {
      showPanel: false
    };

    _this.togglePanel = _this.togglePanel.bind(_this);
    _this.onKeyDownHandler = _this.onKeyDownHandler.bind(_this);
    return _this;
  }

  _createClass(FiltersFileType, [{
    key: 'onKeyDownHandler',
    value: function onKeyDownHandler(event) {
      if (event.keyCode === __WEBPACK_IMPORTED_MODULE_3_keycode___default()('esc')) {
        this.togglePanel();
      }
    }
  }, {
    key: 'togglePanel',
    value: function togglePanel() {
      this.setState({
        showPanel: !this.state.showPanel
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var showPanel = this.state.showPanel;
      var _props = this.props,
          items = _props.items,
          location = _props.location;

      var parsedLocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils_urlHelper__["a" /* parseLocation */])(location);
      var formattedItems = items.map(function (item) {
        return Object.assign({}, item, {
          label: __WEBPACK_IMPORTED_MODULE_4_undefsafe___default()(__WEBPACK_IMPORTED_MODULE_8__common_constants_filterParamsConfig__["a" /* default */], 'file_formats.labels.' + item.key)
        });
      });

      var chosenFileType = parsedLocation.file_formats || '';

      var renderChosenOptions = function renderChosenOptions() {
        if (chosenFileType === '') {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'ul',
            { className: 'search-facet-listing' },
            formattedItems.map(function (item, index) {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'li',
                { key: index },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: 'search-facet-listing__link' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'search-facet-listing__label' },
                    item.label
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'search-facet-result-count' },
                    item.count
                  )
                )
              );
            })
          );
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'search-facet-panel__status fds-u-is-hidden--no-js' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'search-facet-panel__status-row' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'search-facet-panel__status-title' },
                chosenFileType.split(',').join(', ')
              )
            )
          );
        }
      };

      var isAtTop = this.props.isAtTop;

      var panelHeaderClassNames = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
        'search-facet-panel__header--one-facet': isAtTop,
        'search-facet-panel__header--end': !isAtTop,
        'is-active': showPanel
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'search-facet--no-margin', id: 'file-type-filter' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: panelHeaderClassNames, onClick: this.togglePanel },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h2',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'e-icon -icon-document -margin-right' }),
            'File type'
          ),
          renderChosenOptions()
        ),
        showPanel && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__onKeyDown__["a" /* default */],
          { onKeyDown: this.onKeyDownHandler },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__clickOutside__["a" /* default */],
            { onClickOutside: this.togglePanel },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__filtersPanel_multiSelect__["a" /* default */], {
              type: 'file_formats',
              showPanel: showPanel,
              items: formattedItems,
              parsedLocation: parsedLocation,
              togglePanel: this.togglePanel
            })
          )
        )
      );
    }
  }]);

  return FiltersFileType;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

FiltersFileType.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (FiltersFileType);

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FiltersLengthComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils_urlHelper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils_time__ = __webpack_require__(328);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var FiltersLength = function (_React$Component) {
  _inherits(FiltersLength, _React$Component);

  function FiltersLength(props) {
    _classCallCheck(this, FiltersLength);

    var _this = _possibleConstructorReturn(this, (FiltersLength.__proto__ || Object.getPrototypeOf(FiltersLength)).call(this, props));

    var query = props.location.query;

    _this.state = {
      lengthMin: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_time__["a" /* getMinutesSecondsTime */])(query.length_min),
      lengthMax: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_time__["a" /* getMinutesSecondsTime */])(query.length_max)
    };
    return _this;
  }

  _createClass(FiltersLength, [{
    key: 'onLengthMinChange',
    value: function onLengthMinChange(event) {
      this.setState({ lengthMin: event.target.value });
    }
  }, {
    key: 'onLengthMaxChange',
    value: function onLengthMaxChange(event) {
      this.setState({ lengthMax: event.target.value });
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit() {
      var parsedLocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_utils_urlHelper__["a" /* parseLocation */])(this.props.location);

      var nextQuery = Object.assign({}, parsedLocation, {
        length_min: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_time__["a" /* getMinutesSecondsTime */])(this.state.lengthMin),
        length_max: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_time__["a" /* getMinutesSecondsTime */])(this.state.lengthMax)
      });

      delete nextQuery.page;

      if (!this.state.lengthMin) {
        delete nextQuery.length_min;
      }

      if (!this.state.lengthMax) {
        delete nextQuery.length_max;
      }

      this.props.history.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_utils_urlHelper__["b" /* makeLink */])(nextQuery));
    }
  }, {
    key: 'onEnter',
    value: function onEnter(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.onSubmit();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var nextQuery = nextProps.location.query;

      if (nextQuery.length_min !== this.state.lengthMin) {
        this.setState({ lengthMin: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_time__["a" /* getMinutesSecondsTime */])(nextQuery.length_min) });
      }

      if (nextQuery.length_max !== this.state.lengthMax) {
        this.setState({ lengthMax: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_time__["a" /* getMinutesSecondsTime */])(nextQuery.length_max) });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var isAtTop = this.props.isAtTop;

      var searchFacetBoxClassNames = __WEBPACK_IMPORTED_MODULE_3_classnames___default()({
        'search-facet-box': !isAtTop,
        'search-facet-box--start': isAtTop
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'search-facet--no-margin', id: 'length-filter' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: searchFacetBoxClassNames },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'search-facet-box__inner' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'h2',
              { className: 'search-facet-box__heading' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'e-icon -icon-clock -margin-right' }),
              'Length'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'search-facet-range__inputs' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'search-facet-range__input' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'label',
                  null,
                  'Length'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
                  type: 'text',
                  className: 'e-input',
                  placeholder: this.props.length ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_time__["a" /* getMinutesSecondsTime */])(this.props.length.min) : '',
                  value: this.state.lengthMin,
                  onChange: this.onLengthMinChange.bind(this),
                  onKeyPress: this.onEnter.bind(this) })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'search-facet-range__input' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'label',
                  null,
                  'To'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
                  type: 'text',
                  className: 'e-input',
                  placeholder: this.props.length ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_time__["a" /* getMinutesSecondsTime */])(this.props.length.max) : '',
                  value: this.state.lengthMax,
                  onChange: this.onLengthMaxChange.bind(this),
                  onKeyPress: this.onEnter.bind(this) })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'search-facet-range__input--submit' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'button',
                  { type: 'button', className: 'fds-c-button fds-u-p0 no-label', onClick: this.onSubmit.bind(this) },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'i',
                    { className: 'e-icon -icon-search' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'span',
                      { className: 'e-icon__alt' },
                      'Apply'
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return FiltersLength;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

FiltersLength.propTypes = {
  length: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};


var FiltersLengthComponent = FiltersLength;
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* withRouter */])(FiltersLength));

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_titleize__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_titleize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_titleize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils_formatString__ = __webpack_require__(56);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var MultiSelectPanelBody = function MultiSelectPanelBody(props) {
  var selectedOption = props.selectedOption,
      type = props.type,
      items = props.items,
      isExpandable = props.isExpandable,
      isExpanded = props.isExpanded,
      onSelectOption = props.onSelectOption;


  var listClassNames = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('search-facet-multi-select-in-panel', {
    'is-expanded': isExpanded && isExpandable
  });

  var highestCount = items.map(function (item) {
    return item.count;
  }).reduce(function (pre, cur) {
    return pre > cur ? pre : cur;
  }, 0);

  // calculate the width of the category based on the count
  var calcWidthPercentage = function calcWidthPercentage(count) {
    var percentage = count / highestCount * 100;
    return percentage.toFixed(2);
  };

  var renderList = function renderList(item, idx) {
    // grep the last part of the chose category
    var displayName = item.label || __WEBPACK_IMPORTED_MODULE_3_titleize___default()(item.key);
    var listClassName = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('search-facet-multi-select-panel__option', {
      'is-active': selectedOption.split(',').indexOf(item.key) >= 0,
      // only apply fds-u-is-hidden class when the list is expanded and has more than 10 items
      'fds-u-is-hidden': !isExpanded && idx >= __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* showMoreThreshold */][type]
    });

    var linkStyle = {
      minWidth: '50%',
      width: 'calc(' + calcWidthPercentage(item.count) + '% - 30px)'
    };

    var labelClassName = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(_defineProperty({
      'search-panel-facet-colours__link': type === 'colors'
    }, '-color-' + item.key, type === 'colors'));

    var onClickHandler = function onClickHandler(e) {
      e.preventDefault();
      onSelectOption(item.key);
    };

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'li',
      { key: idx, className: listClassName },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'label',
        { className: labelClassName, onClick: onClickHandler },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'search-facet-multi-select-panel__title', style: linkStyle },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'search-facet-multi-select-panel__title-inner' },
            displayName
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'search-facet-multi-select-panel__count' },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_formatString__["b" /* commaStyleString */])(item.count)
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'search-facet-multi-select-panel__status' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'i',
              { className: 'e-icon -icon-ok' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { className: 'e-icon__alt' },
                'selection active'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'i',
              { className: 'e-icon -icon-cancel' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { className: 'e-icon__alt' },
                'remove selection'
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { name: type + '[]', type: 'checkbox', value: item.key })
      )
    );
  };

  // show category list if there are more than 0 item in the list
  if (items && items.length > 0) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'ul',
      { className: listClassNames },
      items.map(function (item, idx) {
        return renderList(item, idx);
      })
    );
    // if there's no more category to show, show the ran out of categoreis section
  } else {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'search-facet-panel__more-results' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'p',
        { className: 'fds-c-text-body fds-u-mt4' },
        'Sorry, we ran out of option :)'
      )
    );
  }
};

MultiSelectPanelBody.propTypes = {
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  items: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired,
  parsedLocation: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  selectedOption: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  isExpanded: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
  isExpandable: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
  onSelectOption: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (MultiSelectPanelBody);

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);




var MultiSelectPanelFooter = function MultiSelectPanelFooter(props) {
  var onToggleOption = props.onToggleOption,
      onUpdateOption = props.onUpdateOption,
      togglePanel = props.togglePanel,
      isExpanded = props.isExpanded,
      isExpandable = props.isExpandable,
      moreOptionCount = props.moreOptionCount;


  var expandableContainerClassNames = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('search-facet-panel-toggle', {
    'is-expanded': isExpanded && isExpandable
  });

  var expandableToggleClassNames = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('search-facet-panel-toggle__link', {
    'is-expanded': isExpanded && isExpandable
  });

  // only show border top when the panel is expandable
  var expandableContainerStyle = isExpandable ? {} : {
    borderTop: 0
  };

  var onSubmit = function onSubmit() {
    togglePanel();
    onUpdateOption();
  };

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { style: expandableContainerStyle, className: expandableContainerClassNames },
    isExpandable && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'a',
      { className: expandableToggleClassNames, href: '', onClick: onToggleOption },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'e-icon -icon-preview' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'search-facet-panel-toggle__remaining' },
          'Show remaining ',
          moreOptionCount,
          ' options'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        null,
        'Hide options'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'search-facet-panel__action' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'button',
        { onClick: onSubmit, className: 'fds-c-button--3d -color-primary -width-full' },
        'Done'
      )
    )
  );
};

MultiSelectPanelFooter.propTypes = {
  onToggleOption: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  onUpdateOption: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  togglePanel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isExpanded: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
  isExpandable: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
  moreOptionCount: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (MultiSelectPanelFooter);

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_titleize__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_titleize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_titleize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_undefsafe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils_formatString__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_utils_urlHelper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_constants_filterParamsConfig__ = __webpack_require__(38);












var PanelBody = function PanelBody(props) {
  var items = props.items,
      isExpandable = props.isExpandable,
      isExpanded = props.isExpanded,
      parsedLocation = props.parsedLocation,
      togglePanel = props.togglePanel,
      type = props.type;


  var optionListClassNames = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('search-facet-single-select-in-panel', {
    'is-expanded': isExpanded && isExpandable
  });

  var highestCount = items.map(function (item) {
    return item.count;
  }).reduce(function (pre, cur) {
    return pre > cur ? pre : cur;
  }, 0);

  // calculate the width of the category based on the count
  var calcWidthPercentage = function calcWidthPercentage(count) {
    var percentage = count / highestCount * 100;
    return percentage.toFixed(2);
  };

  var renderOption = function renderOption(item, idx) {
    var newQuery = Object.assign({}, parsedLocation);
    newQuery[type] = item.key;
    // reset page
    delete newQuery.page;

    // grep the last part of the chose category
    var displayName = __WEBPACK_IMPORTED_MODULE_4_titleize___default()(item.key);

    if (type === 'category') {
      displayName = __WEBPACK_IMPORTED_MODULE_4_titleize___default()(displayName.split('/')[displayName.split('/').length - 1]
      // convert '-' to ' '
      .split('-').join(' '));
    }

    var listClassName = __WEBPACK_IMPORTED_MODULE_3_classnames___default()({
      // only apply fds-u-is-hidden class when the list is expanded and has more than 10 items
      'fds-u-is-hidden': !isExpanded && idx >= __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* showMoreThreshold */][type]
    });

    var linkStyle = {
      minWidth: '50%',
      width: 'calc(' + calcWidthPercentage(item.count) + '% - 30px)'
    };

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'li',
      { key: idx, className: listClassName },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],
        { style: linkStyle, onClick: togglePanel, to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__common_utils_urlHelper__["b" /* makeLink */])(newQuery), rel: 'nofollow' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'search-facet-single-select-panel__title' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'search-facet-single-select-panel__title-inner' },
            displayName
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'search-facet-single-select-panel__count' },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils_formatString__["b" /* commaStyleString */])(item.count)
      )
    );
  };

  // show category list if there are more than 0 item in the list
  if (items && items.length > 0) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'ul',
      { className: optionListClassNames },
      items.map(function (item, idx) {
        return renderOption(item, idx);
      })
    );
    // if there's no more category to show, show the ran out of categoreis section
  } else {
    var parentQuery = Object.assign({}, parsedLocation);
    var delimiter = __WEBPACK_IMPORTED_MODULE_5_undefsafe___default()(__WEBPACK_IMPORTED_MODULE_9__common_constants_filterParamsConfig__["a" /* default */], type + '.delimiter');
    var optionArray = parsedLocation[type].split(delimiter);
    parentQuery[type] = optionArray.slice(0, optionArray.length - 1).join(delimiter);
    var parentQueryLink = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__common_utils_urlHelper__["b" /* makeLink */])(parentQuery);
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'search-facet-panel__more-results' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'p',
        { className: 'fds-c-text-body fds-u-mt4' },
        'Sorry, we ran out of options :)'
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'p',
        { className: 'fds-c-text-body' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],
          { className: 'fds-c-text-link -decoration-reversed', to: parentQueryLink, rel: 'nofollow' },
          'Take me back to the previous option'
        )
      )
    );
  }
};

PanelBody.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired,
  parsedLocation: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  isExpanded: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
  isExpandable: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
  togglePanel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (PanelBody);

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);




var PanelFooter = function PanelFooter(props) {
  var toggleOption = props.toggleOption,
      isExpanded = props.isExpanded,
      isExpandable = props.isExpandable,
      moreOptionCount = props.moreOptionCount,
      togglePanel = props.togglePanel;


  var expandableContainerClassNames = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('search-facet-panel-toggle', {
    'is-expanded': isExpanded && isExpandable
  });

  var expandableToggleClassNames = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('search-facet-panel-toggle__link', {
    'is-expanded': isExpanded && isExpandable
  });

  var onSubmit = function onSubmit() {
    togglePanel();
  };

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: expandableContainerClassNames },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'a',
      { className: expandableToggleClassNames, href: '', onClick: toggleOption },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'e-icon -icon-preview' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'search-facet-panel-toggle__remaining' },
          'Show remaining ',
          moreOptionCount,
          ' options'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        null,
        'Hide options'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'search-facet-panel__action' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'button',
        {
          onClick: onSubmit,
          className: 'fds-c-button--3d -color-primary -width-full'
        },
        'Done'
      )
    )
  );
};

PanelFooter.propTypes = {
  toggleOption: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  togglePanel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isExpanded: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
  isExpandable: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
  moreOptionCount: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (PanelFooter);

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_titleize__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_titleize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_titleize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_undefsafe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_humanize_string__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_humanize_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_humanize_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils_urlHelper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_constants_filterParamsConfig__ = __webpack_require__(38);










var PanelHeader = function PanelHeader(props) {
  var togglePanel = props.togglePanel,
      parsedLocation = props.parsedLocation,
      rootCount = props.rootCount,
      type = props.type,
      breadcrumbsLabel = props.breadcrumbsLabel;


  var chosenOption = parsedLocation[type] || '';
  var delimiter = __WEBPACK_IMPORTED_MODULE_4_undefsafe___default()(__WEBPACK_IMPORTED_MODULE_7__common_constants_filterParamsConfig__["a" /* default */], type + '.delimiter');
  var chosenOptionArray = chosenOption.split(delimiter);
  var chosenOptionLength = chosenOptionArray.length;
  var chosenOptionDisplayName = __WEBPACK_IMPORTED_MODULE_3_titleize___default()(__WEBPACK_IMPORTED_MODULE_5_humanize_string___default()(chosenOptionArray[chosenOptionLength - 1]));

  var BreadLinks = [];
  for (var i = 0; i < chosenOptionLength; i++) {
    // return empty link for last item
    if (i === chosenOptionLength - 1) {
      BreadLinks.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'a',
        { href: '', key: i, className: 'is-last' },
        chosenOptionDisplayName
      ));
    } else {
      var newQuery = Object.assign({}, parsedLocation);
      newQuery[type] = chosenOption.substring(0, chosenOption.indexOf(chosenOptionArray[i]) + chosenOptionArray[i].length);
      delete newQuery.page;
      var link = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_utils_urlHelper__["b" /* makeLink */])(newQuery);
      BreadLinks.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],
        { onClick: togglePanel, key: i, rel: 'nofollow', to: link },
        __WEBPACK_IMPORTED_MODULE_3_titleize___default()(__WEBPACK_IMPORTED_MODULE_5_humanize_string___default()(chosenOptionArray[i]))
      ));
    }
  }

  // top level option link
  var rootQuery = Object.assign({}, parsedLocation);
  delete rootQuery[type];
  var rootLink = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_utils_urlHelper__["b" /* makeLink */])(rootQuery);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: 'search-facet-panel__breadcrumbs-wrapper' },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'search-facet-panel__breadcrumbs-intro' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        { className: 'fds-c-text-body -size-s' },
        'Show:'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'search-facet-panel__breadcrumbs' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'nav',
        { className: 'breadcrumbs -line-wrap -color-grey -icon-fill fds-u-text-truncate' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],
          { onClick: togglePanel, rel: 'nofollow', to: rootLink },
          'All ',
          breadcrumbsLabel,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'breadcrumbs__count' },
            rootCount
          )
        ),
        BreadLinks
      )
    )
  );
};

PanelHeader.propTypes = {
  togglePanel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  parsedLocation: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  rootCount: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  type: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  breadcrumbsLabel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (PanelHeader);

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FiltersPolygonsComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils_urlHelper__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var FiltersPolygons = function (_React$Component) {
  _inherits(FiltersPolygons, _React$Component);

  function FiltersPolygons(props) {
    _classCallCheck(this, FiltersPolygons);

    var _this = _possibleConstructorReturn(this, (FiltersPolygons.__proto__ || Object.getPrototypeOf(FiltersPolygons)).call(this, props));

    var query = props.location.query;

    _this.state = {
      value: query && query.poly_count ? query.poly_count : ''
    };
    return _this;
  }

  _createClass(FiltersPolygons, [{
    key: 'onChange',
    value: function onChange(event) {
      this.setState({ value: event.target.value });
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit() {
      var parsedLocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_utils_urlHelper__["a" /* parseLocation */])(this.props.location);

      var nextQuery = Object.assign({}, parsedLocation, {
        poly_count: this.state.value
      });

      delete nextQuery.page;

      this.props.history.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_utils_urlHelper__["b" /* makeLink */])(nextQuery));
    }
  }, {
    key: 'onEnter',
    value: function onEnter(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.onSubmit();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var nextQuery = nextProps.location.query;

      if (nextQuery && nextQuery.poly_count !== this.state.value) {
        this.setState({ value: nextQuery.poly_count || '' });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var items = this.props.items;

      var placeholder = items.avg + ', ' + items.min + '-' + items.max;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'search-facet--no-margin', id: 'polygons-filter' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'search-facet-box--start' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'search-facet-box__inner' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'h2',
              { className: 'search-facet-box__heading' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'e-icon -icon-polygon -margin-right' }),
              'Polygons'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'search-facet-range__inputs' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'search-facet-range__input--single' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'label',
                  {
                    className: 'fds-u-is-visually-hidden',
                    htmlFor: 'poly_count' },
                  'Polygons'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
                  type: 'text',
                  id: 'poly_count',
                  className: 'e-input',
                  placeholder: placeholder,
                  pattern: '(\\d+\\s*\\-\\s*\\d+|\\d+)',
                  value: this.state.value,
                  onChange: this.onChange.bind(this),
                  onKeyPress: this.onEnter.bind(this) })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'search-facet-range__input--submit' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'button',
                  { type: 'button', className: 'fds-c-button fds-u-p0', onClick: this.onSubmit.bind(this) },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'i',
                    { className: 'e-icon -icon-search' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'span',
                      { className: 'e-icon__alt' },
                      'Apply'
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return FiltersPolygons;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

FiltersPolygons.propTypes = {
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  items: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};


var FiltersPolygonsComponent = FiltersPolygons;
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* withRouter */])(FiltersPolygons));

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FiltersPriceComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils_urlHelper__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var FiltersPrice = function (_React$Component) {
  _inherits(FiltersPrice, _React$Component);

  function FiltersPrice(props) {
    _classCallCheck(this, FiltersPrice);

    var _this = _possibleConstructorReturn(this, (FiltersPrice.__proto__ || Object.getPrototypeOf(FiltersPrice)).call(this, props));

    var query = props.location.query;


    _this.state = {
      priceMin: query ? query.price_min : '',
      priceMax: query ? query.price_max : ''
    };
    return _this;
  }

  _createClass(FiltersPrice, [{
    key: 'onPriceMinChange',
    value: function onPriceMinChange(event) {
      this.setState({ priceMin: event.target.value });
    }
  }, {
    key: 'onPriceMaxChange',
    value: function onPriceMaxChange(event) {
      this.setState({ priceMax: event.target.value });
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit() {
      var parsedLocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_utils_urlHelper__["a" /* parseLocation */])(this.props.location);

      var nextQuery = Object.assign({}, parsedLocation, {
        price_min: this.state.priceMin,
        price_max: this.state.priceMax
      });
      delete nextQuery.page;

      if (!this.state.priceMin) {
        delete nextQuery.price_min;
      }

      if (!this.state.priceMax) {
        delete nextQuery.price_max;
      }

      this.props.history.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_utils_urlHelper__["b" /* makeLink */])(nextQuery));
    }
  }, {
    key: 'onEnter',
    value: function onEnter(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.onSubmit();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var nextQuery = nextProps.location.query;

      if (nextQuery.price_min !== this.state.priceMin) {
        this.setState({ priceMin: nextQuery.price_min || '' });
      }

      if (nextQuery.price_max !== this.state.priceMax) {
        this.setState({ priceMax: nextQuery.price_max || '' });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var isAtTop = this.props.isAtTop;

      var panelHeaderClassNames = __WEBPACK_IMPORTED_MODULE_3_classnames___default()({
        'search-facet-panel__header--start': isAtTop,
        'search-facet-box__inner': !isAtTop
      });
      var searchFacetBoxClassNames = __WEBPACK_IMPORTED_MODULE_3_classnames___default()({
        'search-facet-box': !isAtTop
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'search-facet--no-margin', id: 'price-filter' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: searchFacetBoxClassNames },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: panelHeaderClassNames },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'h2',
              { className: 'search-facet-box__heading' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'e-icon -icon-dollar -margin-right' }),
              'Price'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'search-facet-range__inputs' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'search-facet-range__input--with-prefix' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'label',
                  null,
                  'From'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'span',
                  null,
                  '$'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
                  type: 'number',
                  className: 'e-input',
                  placeholder: this.props.cost ? this.props.cost.min / 100 : '',
                  value: this.state.priceMin,
                  onChange: this.onPriceMinChange.bind(this),
                  onKeyPress: this.onEnter.bind(this) })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'search-facet-range__input--with-prefix' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'label',
                  null,
                  'To'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'span',
                  null,
                  '$'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
                  type: 'number',
                  className: 'e-input',
                  placeholder: this.props.cost ? this.props.cost.max / 100 : '',
                  value: this.state.priceMax,
                  onChange: this.onPriceMaxChange.bind(this),
                  onKeyPress: this.onEnter.bind(this) })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'search-facet-range__input--submit' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'button',
                  { type: 'button', className: 'fds-c-button fds-u-p0 no-label', onClick: this.onSubmit.bind(this) },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'i',
                    { className: 'e-icon -icon-search' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'span',
                      { className: 'e-icon__alt' },
                      'Apply'
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return FiltersPrice;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

FiltersPrice.propTypes = {
  cost: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};


var FiltersPriceComponent = FiltersPrice;
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* withRouter */])(FiltersPrice));

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FiltersProMusicComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils_urlHelper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filtersBooleanBody__ = __webpack_require__(302);







var FiltersProMusic = function FiltersProMusic(_ref) {
  var location = _ref.location,
      history = _ref.history,
      isAtBottom = _ref.isAtBottom,
      count = _ref.count;

  var parsedLocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_utils_urlHelper__["a" /* parseLocation */])(location);
  var isChecked = parsedLocation.include_pro_affiliated !== 'false';

  var onChange = function onChange(event) {
    var checkedValue = event.target.checked;
    var newQuery = Object.assign({}, parsedLocation);
    delete newQuery.page;

    newQuery.include_pro_affiliated = !!checkedValue;

    history.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_utils_urlHelper__["b" /* makeLink */])(newQuery));
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__filtersBooleanBody__["a" /* default */], {
    name: 'include_pro_affiliated',
    label: 'Include P.R.O. Music',
    onChange: onChange,
    isChecked: isChecked,
    isAtBottom: isAtBottom,
    count: count,
    icon: 'performing-rights-organizations' });
};

FiltersProMusic.propTypes = {
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  isAtBottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  count: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var FiltersProMusicComponent = FiltersProMusic;
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* withRouter */])(FiltersProMusic));

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_keycode__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__clickOutside__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__onKeyDown__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils_urlHelper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filtersPanel_multiSelect__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_analytics_filtersAnalytics__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_constants_filterParamsConfig__ = __webpack_require__(38);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var sizeFilterLabels = __WEBPACK_IMPORTED_MODULE_9__common_constants_filterParamsConfig__["a" /* default */].sizes.labels;

var FiltersSize = function (_React$Component) {
  _inherits(FiltersSize, _React$Component);

  function FiltersSize(props) {
    _classCallCheck(this, FiltersSize);

    var _this = _possibleConstructorReturn(this, (FiltersSize.__proto__ || Object.getPrototypeOf(FiltersSize)).call(this, props));

    _this.state = {
      showPanel: false
    };

    _this.togglePanel = _this.togglePanel.bind(_this);
    _this.onKeyDownHandler = _this.onKeyDownHandler.bind(_this);
    return _this;
  }

  _createClass(FiltersSize, [{
    key: 'onKeyDownHandler',
    value: function onKeyDownHandler(event) {
      if (event.keyCode === __WEBPACK_IMPORTED_MODULE_3_keycode___default()('esc')) {
        this.togglePanel();
      }
    }
  }, {
    key: 'togglePanel',
    value: function togglePanel() {
      if (!this.state.showPanel) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__common_analytics_filtersAnalytics__["a" /* reportOpenSearchFilterPanel */])('Size');
      }
      this.setState({
        showPanel: !this.state.showPanel
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var showPanel = this.state.showPanel;
      var _props = this.props,
          items = _props.items,
          location = _props.location,
          isAtTop = _props.isAtTop;

      var parsedLocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_utils_urlHelper__["a" /* parseLocation */])(location);
      var chosenSizes = parsedLocation.sizes || '';

      var renderChosenSizes = function renderChosenSizes() {
        if (chosenSizes === '') {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'ul',
            { className: 'search-facet-listing' },
            items.map(function (item, index) {
              var label = sizeFilterLabels[item.key] || item.key;
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'li',
                { key: index },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: 'search-facet-listing__link' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'search-facet-listing__label' },
                    label
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'search-facet-result-count' },
                    item.count
                  )
                )
              );
            })
          );
        } else {
          var chosenSizesLabels = chosenSizes.split(',').map(function (key) {
            return sizeFilterLabels[key] || key;
          }).join(', ');
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'search-facet-panel__status fds-u-is-hidden--no-js' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'search-facet-panel__status-row' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'search-facet-panel__status-title' },
                chosenSizesLabels
              )
            )
          );
        }
      };

      var panelHeaderClassNames = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
        'search-facet-panel__header--start': isAtTop,
        'search-facet-panel__header': !isAtTop,
        'is-active': showPanel
      });

      // append the label to the items object
      var formatItems = function formatItems(items) {
        return items.map(function (item) {
          return _extends({
            label: sizeFilterLabels[item.key] || item.key
          }, item);
        });
      };

      var formattedItems = formatItems(items);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'search-facet--no-margin' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: panelHeaderClassNames, onClick: this.togglePanel },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h2',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'e-icon -icon-ruler -margin-right' }),
            'Sizes'
          ),
          renderChosenSizes()
        ),
        showPanel && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__onKeyDown__["a" /* default */],
          { onKeyDown: this.onKeyDownHandler },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__clickOutside__["a" /* default */],
            { onClickOutside: this.togglePanel },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__filtersPanel_multiSelect__["a" /* default */], {
              type: 'sizes',
              showPanel: showPanel,
              items: formattedItems,
              parsedLocation: parsedLocation,
              togglePanel: this.togglePanel
            })
          )
        )
      );
    }
  }]);

  return FiltersSize;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

FiltersSize.propTypes = {
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  items: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array
};

/* harmony default export */ __webpack_exports__["a"] = (FiltersSize);

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_titleize__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_titleize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_titleize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_keycode__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__clickOutside__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__onKeyDown__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils_urlHelper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filtersPanel_singleSelect__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_analytics_filtersAnalytics__ = __webpack_require__(80);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var FiltersSoftwareVersion = function (_React$Component) {
  _inherits(FiltersSoftwareVersion, _React$Component);

  function FiltersSoftwareVersion(props) {
    _classCallCheck(this, FiltersSoftwareVersion);

    var _this = _possibleConstructorReturn(this, (FiltersSoftwareVersion.__proto__ || Object.getPrototypeOf(FiltersSoftwareVersion)).call(this, props));

    _this.state = {
      showPanel: false
    };

    _this.togglePanel = _this.togglePanel.bind(_this);
    _this.onKeyDownHandler = _this.onKeyDownHandler.bind(_this);
    return _this;
  }

  _createClass(FiltersSoftwareVersion, [{
    key: 'onKeyDownHandler',
    value: function onKeyDownHandler(event) {
      if (event.keyCode === __WEBPACK_IMPORTED_MODULE_4_keycode___default()('esc')) {
        this.togglePanel();
      }
    }
  }, {
    key: 'togglePanel',
    value: function togglePanel() {
      if (!this.state.showPanel) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__common_analytics_filtersAnalytics__["a" /* reportOpenSearchFilterPanel */])('Software version');
      }
      this.setState({
        showPanel: !this.state.showPanel
      });
    }
  }, {
    key: 'filterOption',
    value: function filterOption(items, chosenPlatform) {
      return items.filter(function (item, idx) {
        return item.key.indexOf(chosenPlatform) > -1 && item.key !== chosenPlatform;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var showPanel = this.state.showPanel;
      var _props = this.props,
          items = _props.items,
          location = _props.location,
          platformRootCount = _props.platformRootCount;

      var parsedLocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils_urlHelper__["a" /* parseLocation */])(location);

      var chosenPlatform = parsedLocation.platform || '';
      var chosenPlatformArray = chosenPlatform.split(' ');
      var chosenPlatformLength = chosenPlatformArray.length;
      var filteredPlatformItems = this.filterOption(items, chosenPlatform);

      var renderChosenPlatform = function renderChosenPlatform() {
        if (chosenPlatform === '') {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'ul',
            { className: 'search-facet-listing' },
            items.map(function (item, index) {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'li',
                { key: index },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: 'search-facet-listing__link' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'search-facet-listing__label' },
                    __WEBPACK_IMPORTED_MODULE_3_titleize___default()(item.key)
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'search-facet-result-count' },
                    item.count
                  )
                )
              );
            })
          );
        } else {
          var getChosenPlatformDisplayName = function getChosenPlatformDisplayName(chosenPlatform) {
            return chosenPlatformArray.map(function (platformName, index) {
              var isLast = index === chosenPlatformLength - 1;
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { key: index, className: 'search-facet-panel__status-title' },
                __WEBPACK_IMPORTED_MODULE_3_titleize___default()(platformName),
                !isLast && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'e-icon -icon-arrow-fill-right' })
              );
            });
          };
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'search-facet-panel__status fds-u-is-hidden--no-js' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'search-facet-panel__status-row' },
              getChosenPlatformDisplayName(chosenPlatform)
            )
          );
        }
      };

      var isAtBottom = this.props.isAtBottom;

      var panelHeaderClassNames = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('search-facet-panel__header--start', {
        'search-facet-panel__header--one-facet': isAtBottom,
        'search-facet-panel__header--end': isAtBottom,
        'is-active': showPanel
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'search-facet--no-margin', id: 'software-version-filter' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: panelHeaderClassNames, onClick: this.togglePanel },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h2',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'e-icon -icon-code -margin-right' }),
            'Software version'
          ),
          renderChosenPlatform()
        ),
        showPanel && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__onKeyDown__["a" /* default */],
          { onKeyDown: this.onKeyDownHandler },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__clickOutside__["a" /* default */],
            { onClickOutside: this.togglePanel },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__filtersPanel_singleSelect__["a" /* default */], {
              rootCount: platformRootCount,
              showPanel: showPanel,
              items: filteredPlatformItems,
              parsedLocation: parsedLocation,
              togglePanel: this.togglePanel,
              breadcrumbsLabel: 'software versions',
              type: 'platform'
            })
          )
        )
      );
    }
  }]);

  return FiltersSoftwareVersion;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

FiltersSoftwareVersion.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  platformRootCount: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (FiltersSoftwareVersion);

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FiltersTagsComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_keycode__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__clickOutside__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__onKeyDown__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils_urlHelper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filtersPanel_multiSelect__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_analytics_filtersAnalytics__ = __webpack_require__(80);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var FiltersTags = function (_React$Component) {
  _inherits(FiltersTags, _React$Component);

  function FiltersTags(props) {
    _classCallCheck(this, FiltersTags);

    var _this = _possibleConstructorReturn(this, (FiltersTags.__proto__ || Object.getPrototypeOf(FiltersTags)).call(this, props));

    _this.state = {
      showPanel: false
    };

    _this.togglePanel = _this.togglePanel.bind(_this);
    _this.onKeyDownHandler = _this.onKeyDownHandler.bind(_this);
    return _this;
  }

  _createClass(FiltersTags, [{
    key: 'onKeyDownHandler',
    value: function onKeyDownHandler(event) {
      if (event.keyCode === __WEBPACK_IMPORTED_MODULE_3_keycode___default()('esc')) {
        this.togglePanel();
      }
    }
  }, {
    key: 'togglePanel',
    value: function togglePanel() {
      if (!this.state.showPanel) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__common_analytics_filtersAnalytics__["a" /* reportOpenSearchFilterPanel */])('Tags');
      }
      this.setState({
        showPanel: !this.state.showPanel
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var showPanel = this.state.showPanel;
      var _props = this.props,
          items = _props.items,
          location = _props.location,
          isAtTop = _props.isAtTop;

      var parsedLocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils_urlHelper__["a" /* parseLocation */])(location);
      var chosenTags = parsedLocation.tags || '';

      var renderChosenTags = function renderChosenTags() {
        if (chosenTags === '') {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'ul',
            { className: 'search-facet-listing' },
            items.map(function (item, index) {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'li',
                { key: index },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: 'search-facet-listing__link' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'search-facet-listing__label' },
                    item.key
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'search-facet-result-count' },
                    item.count
                  )
                )
              );
            })
          );
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'search-facet-panel__status fds-u-is-hidden--no-js' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'search-facet-panel__status-row' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'search-facet-panel__status-title' },
                chosenTags.split(',').join(', ')
              )
            )
          );
        }
      };

      var panelHeaderClassNames = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
        'search-facet-panel__header--start': isAtTop,
        'search-facet-panel__header': !isAtTop,
        'is-active': showPanel
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'search-facet--no-margin', id: 'tags-filter' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: panelHeaderClassNames, onClick: this.togglePanel },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h2',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'e-icon -icon-tag -margin-right' }),
            'Tags'
          ),
          renderChosenTags()
        ),
        showPanel && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__onKeyDown__["a" /* default */],
          { onKeyDown: this.onKeyDownHandler },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__clickOutside__["a" /* default */],
            { onClickOutside: this.togglePanel },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__filtersPanel_multiSelect__["a" /* default */], {
              type: 'tags',
              showPanel: showPanel,
              items: items,
              parsedLocation: parsedLocation,
              togglePanel: this.togglePanel
            })
          )
        )
      );
    }
  }]);

  return FiltersTags;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

FiltersTags.propTypes = {
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  items: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array
};

var FiltersTagsComponent = FiltersTags;
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* withRouter */])(FiltersTags));

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FiltersVocalsComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_keycode__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_titleize__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_titleize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_titleize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__clickOutside__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__onKeyDown__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_utils_urlHelper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__filtersPanel_multiSelect__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_analytics_filtersAnalytics__ = __webpack_require__(80);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var FiltersVocals = function (_React$Component) {
  _inherits(FiltersVocals, _React$Component);

  function FiltersVocals(props) {
    _classCallCheck(this, FiltersVocals);

    var _this = _possibleConstructorReturn(this, (FiltersVocals.__proto__ || Object.getPrototypeOf(FiltersVocals)).call(this, props));

    _this.state = {
      showPanel: false
    };

    _this.togglePanel = _this.togglePanel.bind(_this);
    _this.onKeyDownHandler = _this.onKeyDownHandler.bind(_this);
    return _this;
  }

  _createClass(FiltersVocals, [{
    key: 'onKeyDownHandler',
    value: function onKeyDownHandler(event) {
      if (event.keyCode === __WEBPACK_IMPORTED_MODULE_3_keycode___default()('esc')) {
        this.togglePanel();
      }
    }
  }, {
    key: 'togglePanel',
    value: function togglePanel() {
      if (!this.state.showPanel) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__common_analytics_filtersAnalytics__["a" /* reportOpenSearchFilterPanel */])('Vocals');
      }
      this.setState({
        showPanel: !this.state.showPanel
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var showPanel = this.state.showPanel;
      var _props = this.props,
          items = _props.items,
          location = _props.location,
          isAtTop = _props.isAtTop;

      var parsedLocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__common_utils_urlHelper__["a" /* parseLocation */])(location);
      var chosenVocals = parsedLocation.vocals_in_audio || '';

      var renderChosenVocals = function renderChosenVocals() {
        if (chosenVocals === '') {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'ul',
            { className: 'search-facet-listing' },
            items.map(function (item, index) {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'li',
                { key: index },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: 'search-facet-listing__link' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'search-facet-listing__label' },
                    __WEBPACK_IMPORTED_MODULE_5_titleize___default()(item.key)
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'search-facet-result-count' },
                    item.count
                  )
                )
              );
            })
          );
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'search-facet-panel__status fds-u-is-hidden--no-js' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'search-facet-panel__status-row' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'search-facet-panel__status-title' },
                chosenVocals.split(',').join(', ')
              )
            )
          );
        }
      };

      var panelHeaderClassNames = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({
        'search-facet-panel__header--start': isAtTop,
        'search-facet-panel__header': !isAtTop,
        'is-active': showPanel
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'search-facet--no-margin', id: 'vocals-filter' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: panelHeaderClassNames, onClick: this.togglePanel },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h2',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'e-icon -icon-vocals -margin-right' }),
            'Vocals'
          ),
          renderChosenVocals()
        ),
        showPanel && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__onKeyDown__["a" /* default */],
          { onKeyDown: this.onKeyDownHandler },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__clickOutside__["a" /* default */],
            { onClickOutside: this.togglePanel },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__filtersPanel_multiSelect__["a" /* default */], {
              type: 'vocals_in_audio',
              showPanel: showPanel,
              items: items,
              parsedLocation: parsedLocation,
              togglePanel: this.togglePanel
            })
          )
        )
      );
    }
  }]);

  return FiltersVocals;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

FiltersVocals.propTypes = {
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  items: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array
};

var FiltersVocalsComponent = FiltersVocals;
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* withRouter */])(FiltersVocals));

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_undefsafe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filtersCategory__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filtersTags__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__filtersPrice__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filtersCompatibleWith__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filtersSoftwareVersion__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filtersPolygons__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__filtersFileType__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__selectedFilters__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__filtersSize__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__filtersColors__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__filtersLength__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__filtersVocals__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__filtersDropdown__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__filtersBoolean__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__filtersProMusic__ = __webpack_require__(544);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





















var SearchFilters = function SearchFilters(_ref) {
  var aggregations = _ref.aggregations,
      location = _ref.location,
      currentSite = _ref.currentSite;

  var basicFilters = [{
    Component: __WEBPACK_IMPORTED_MODULE_3__filtersCategory__["a" /* default */],
    isActive: !!__WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(aggregations, 'category.length'),
    props: {
      categoryRootCount: __WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(aggregations, 'category_root_count.count'),
      items: aggregations.category
    }
  }, {
    Component: __WEBPACK_IMPORTED_MODULE_4__filtersTags__["a" /* default */],
    isActive: !!__WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(aggregations, 'tags.length'),
    props: {
      items: aggregations.tags
    }
  }, {
    Component: __WEBPACK_IMPORTED_MODULE_5__filtersPrice__["a" /* default */],
    isActive: true,
    props: {
      cost: aggregations.cost
    }
  }, {
    Component: __WEBPACK_IMPORTED_MODULE_15__filtersDropdown__["a" /* default */],
    isActive: true,
    props: {
      name: 'sales',
      label: 'Sales',
      ignoreOptions: ['varies'],
      items: aggregations.sales_count
    }
  }, {
    Component: __WEBPACK_IMPORTED_MODULE_15__filtersDropdown__["a" /* default */],
    isActive: __WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(aggregations, 'rating.length') > 0,
    props: {
      name: 'rating_min',
      label: 'Rating',
      items: aggregations.rating
    }
  }];

  var extraFilters = [{
    Component: __WEBPACK_IMPORTED_MODULE_7__filtersSoftwareVersion__["a" /* default */],
    isActive: __WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(aggregations, 'platform.length') > 0,
    props: {
      items: aggregations.platform,
      platformRootCount: __WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(aggregations, 'platform_root_count.count')
    }
  }, {
    Component: __WEBPACK_IMPORTED_MODULE_6__filtersCompatibleWith__["a" /* default */],
    isActive: __WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(aggregations, 'compatible_with.length') > 0,
    props: {
      items: aggregations.compatible_with
    }
  }, {
    Component: __WEBPACK_IMPORTED_MODULE_8__filtersPolygons__["a" /* default */],
    isActive: aggregations.poly_count,
    props: {
      items: aggregations.poly_count
    }
  }, {
    Component: __WEBPACK_IMPORTED_MODULE_9__filtersFileType__["a" /* default */],
    isActive: __WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(aggregations, 'file_formats.length') > 0,
    props: {
      items: aggregations.file_formats
    }
  }, {
    Component: __WEBPACK_IMPORTED_MODULE_15__filtersDropdown__["a" /* default */],
    isActive: __WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(aggregations, 'orientation.length') > 0,
    props: {
      name: 'orientation',
      label: 'Orientation',
      items: aggregations.orientation
    }
  }, {
    Component: __WEBPACK_IMPORTED_MODULE_15__filtersDropdown__["a" /* default */],
    isActive: __WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(aggregations, 'resolution.length') > 0,
    props: {
      name: 'resolution_min',
      label: 'Minimum resolution',
      items: aggregations.resolution
    }
  }, {
    Component: __WEBPACK_IMPORTED_MODULE_15__filtersDropdown__["a" /* default */],
    isActive: __WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(aggregations, 'frame_rate.length') > 0,
    props: {
      name: 'frame_rate',
      label: 'Frame rate',
      items: aggregations.frame_rate
    }
  }, {
    Component: __WEBPACK_IMPORTED_MODULE_15__filtersDropdown__["a" /* default */],
    isActive: __WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(aggregations, 'requires_plugins.length') > 0,
    props: {
      name: 'requires_plugins',
      label: 'Requires Plugins',
      items: aggregations.requires_plugins
    }
  }, {
    Component: __WEBPACK_IMPORTED_MODULE_11__filtersSize__["a" /* default */],
    isActive: __WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(aggregations, 'size.length') > 0,
    props: {
      items: aggregations.size
    }
  }, {
    Component: __WEBPACK_IMPORTED_MODULE_12__filtersColors__["a" /* default */],
    isActive: __WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(aggregations, 'colors.length') > 0,
    props: {
      items: aggregations.colors
    }
  }, {
    Component: __WEBPACK_IMPORTED_MODULE_13__filtersLength__["a" /* default */],
    isActive: !!aggregations.length,
    props: {
      length: aggregations.length
    }
  }, {
    Component: __WEBPACK_IMPORTED_MODULE_14__filtersVocals__["a" /* default */],
    isActive: __WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(aggregations, 'vocals_in_audio.length') > 0,
    props: {
      items: aggregations.vocals_in_audio
    }
  }, {
    Component: __WEBPACK_IMPORTED_MODULE_15__filtersDropdown__["a" /* default */],
    isActive: __WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(aggregations, 'tempo.length') > 0,
    props: {
      name: 'tempo',
      label: 'Tempo',
      ignoreOptions: ['varies'],
      items: aggregations.tempo
    }
  }, {
    Component: __WEBPACK_IMPORTED_MODULE_16__filtersBoolean__["a" /* default */],
    isActive: !!aggregations.alpha,
    props: {
      name: 'alpha',
      label: 'Alpha channel',
      count: __WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(aggregations, 'alpha.count')
    }
  }, {
    Component: __WEBPACK_IMPORTED_MODULE_16__filtersBoolean__["a" /* default */],
    isActive: !!aggregations.looped,
    props: {
      name: 'looped',
      label: 'Looped',
      count: __WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(aggregations, 'looped.count')
    }
  }, {
    Component: __WEBPACK_IMPORTED_MODULE_17__filtersProMusic__["a" /* default */],
    isActive: currentSite === 'audiojungle'
  }];

  var activeBasicFilters = basicFilters.filter(function (filter) {
    return filter.isActive;
  });
  var activeExtraFilters = extraFilters.filter(function (filter) {
    return filter.isActive;
  });

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: 'search-facet-panel' },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__selectedFilters__["a" /* default */], { location: location }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'search-facet fds-u-is-hidden--no-js' },
      activeBasicFilters.map(function (filter, index, list) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(filter.Component, _extends({
          key: index,
          location: location,
          isAtTop: index === 0,
          isAtBottom: list.length === index + 1
        }, filter.props));
      })
    ),
    !!activeExtraFilters.length && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'search-facet fds-u-is-hidden--no-js' },
      activeExtraFilters.map(function (filter, index, list) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(filter.Component, _extends({
          key: index,
          location: location,
          isAtTop: index === 0,
          isAtBottom: list.length === index + 1
        }, filter.props));
      })
    )
  );
};

SearchFilters.propTypes = {
  aggregations: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  currentSite: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
};

SearchFilters.defaultProps = {
  aggregations: {}
};

/* harmony default export */ __webpack_exports__["a"] = (SearchFilters);

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_constants_filterParamsConfig__ = __webpack_require__(38);






/**
 * A function to render the selected filter link
 * @param  {String} the type of the param, can be category, tags
 * @param  {String} the displayName of the filter
 * @param  {String} the link to the filter
 * @param  {Number} the index of the current option
 * @return {HTML} HTML for the option
 */
var FilterItem = function FilterItem(_ref) {
  var paramType = _ref.paramType,
      displayName = _ref.displayName,
      link = _ref.link,
      index = _ref.index;

  // only show icon for the first item
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'li',
    { key: index },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'search-facet-actives__facet' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        { className: 'search-facet-actives__icon' },
        index === 0 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'e-icon -icon-' + __WEBPACK_IMPORTED_MODULE_3__common_constants_filterParamsConfig__["a" /* default */][paramType].icon }) : null
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        { className: 'search-facet-actives__text' },
        displayName
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],
        { to: link, className: 'search-facet-actives__glyph-cancel' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'e-icon -icon-cancel' })
      )
    )
  );
};

FilterItem.propTypes = {
  paramType: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  displayName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  link: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  index: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (FilterItem);

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_omit__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils_formatString__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filterItem__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils_urlHelper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_constants_filterParamsConfig__ = __webpack_require__(38);









var FilterList = function FilterList(_ref) {
  var parsedLocation = _ref.parsedLocation,
      param = _ref.param;

  // if the fitler is not in the config, simply return null
  if (!__WEBPACK_IMPORTED_MODULE_6__common_constants_filterParamsConfig__["a" /* default */][param] || !parsedLocation[param]) return null;

  if (__WEBPACK_IMPORTED_MODULE_6__common_constants_filterParamsConfig__["a" /* default */][param].isMultiple) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'ul',
      null,
      parsedLocation[param].split(__WEBPACK_IMPORTED_MODULE_6__common_constants_filterParamsConfig__["a" /* default */][param].delimiter).map(function (option, index) {
        var link = void 0,
            newQuery = void 0;
        var displayName = param === 'sizes' ? __WEBPACK_IMPORTED_MODULE_6__common_constants_filterParamsConfig__["a" /* default */].sizes.labels[option] : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_utils_formatString__["a" /* toTitle */])(option);

        // category is separate by '/' eg. 'category/wordpress/clean'
        if (__WEBPACK_IMPORTED_MODULE_6__common_constants_filterParamsConfig__["a" /* default */][param].delimiter === '/') {
          newQuery = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_urlHelper__["e" /* getQueryWithoutCategory */])(parsedLocation, param, option);
          // tags
        } else if (__WEBPACK_IMPORTED_MODULE_6__common_constants_filterParamsConfig__["a" /* default */][param].delimiter === ',') {
          newQuery = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_urlHelper__["f" /* getQueryWithoutOption */])(parsedLocation, param, option);
        }
        // reset page param
        delete newQuery.page;
        link = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_urlHelper__["b" /* makeLink */])(newQuery);
        if (displayName) {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__filterItem__["a" /* default */], {
            paramType: param,
            displayName: displayName,
            link: link,
            key: index,
            index: index
          });
        } else {
          return null;
        }
      })
    );
  } else {
    if (__WEBPACK_IMPORTED_MODULE_6__common_constants_filterParamsConfig__["a" /* default */][param].inRangeWith) {
      var minRangeParam = __WEBPACK_IMPORTED_MODULE_6__common_constants_filterParamsConfig__["a" /* default */][param].inRangeWith.min || param;
      var maxRangeParam = __WEBPACK_IMPORTED_MODULE_6__common_constants_filterParamsConfig__["a" /* default */][param].inRangeWith.max || param;
      var minParamValue = parsedLocation[minRangeParam];
      var maxParamValue = parsedLocation[maxRangeParam];

      // combine price_min and price_max if both exist
      if (minParamValue && maxParamValue) {
        var minParamFormatValue = __WEBPACK_IMPORTED_MODULE_6__common_constants_filterParamsConfig__["a" /* default */][param].format ? __WEBPACK_IMPORTED_MODULE_6__common_constants_filterParamsConfig__["a" /* default */][param].format(minParamValue) : minParamValue;
        var maxParamFormatValue = __WEBPACK_IMPORTED_MODULE_6__common_constants_filterParamsConfig__["a" /* default */][param].format ? __WEBPACK_IMPORTED_MODULE_6__common_constants_filterParamsConfig__["a" /* default */][param].format(maxParamValue) : maxParamValue;
        var priceDisplayName = minParamFormatValue + ' - ' + maxParamFormatValue;
        var link = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_urlHelper__["b" /* makeLink */])(__WEBPACK_IMPORTED_MODULE_2_lodash_omit___default()(parsedLocation, [minRangeParam, maxRangeParam, 'page']));
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'ul',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__filterItem__["a" /* default */], {
            paramType: param,
            displayName: priceDisplayName,
            link: link,
            index: 0
          })
        );
      } else {
        var paramFormatValue = __WEBPACK_IMPORTED_MODULE_6__common_constants_filterParamsConfig__["a" /* default */][param].format ? __WEBPACK_IMPORTED_MODULE_6__common_constants_filterParamsConfig__["a" /* default */][param].format(parsedLocation[param]) : parsedLocation[param];
        var _priceDisplayName = __WEBPACK_IMPORTED_MODULE_6__common_constants_filterParamsConfig__["a" /* default */][param].label + ' ' + paramFormatValue;
        var _link = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_urlHelper__["b" /* makeLink */])(__WEBPACK_IMPORTED_MODULE_2_lodash_omit___default()(parsedLocation, [param, 'page']));
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'ul',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__filterItem__["a" /* default */], {
            paramType: param,
            displayName: _priceDisplayName,
            link: _link,
            index: 0
          })
        );
      }
    } else {
      var label = parsedLocation[param];
      var _link2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_urlHelper__["b" /* makeLink */])(__WEBPACK_IMPORTED_MODULE_2_lodash_omit___default()(parsedLocation, [param, 'page']));
      if (param === 'sort_by' && parsedLocation['sort_direction']) {
        // parse label for sort_by filter
        label = parsedLocation['sort_by'] + '-' + parsedLocation['sort_direction'];
        // when it's a sort by filter, we remove the `sort_direction`
        // as well when clear
        _link2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_urlHelper__["b" /* makeLink */])(__WEBPACK_IMPORTED_MODULE_2_lodash_omit___default()(parsedLocation, [param, 'page', 'sort_direction']));
      }
      var displayName = !__WEBPACK_IMPORTED_MODULE_6__common_constants_filterParamsConfig__["a" /* default */][param].labels ? parsedLocation[param] : __WEBPACK_IMPORTED_MODULE_6__common_constants_filterParamsConfig__["a" /* default */][param].labels[label];

      if (__WEBPACK_IMPORTED_MODULE_6__common_constants_filterParamsConfig__["a" /* default */][param].format) {
        displayName = __WEBPACK_IMPORTED_MODULE_6__common_constants_filterParamsConfig__["a" /* default */][param].format(displayName);
      }

      if (label && __WEBPACK_IMPORTED_MODULE_6__common_constants_filterParamsConfig__["a" /* default */][param].isBoolean) {
        displayName = 'Yes';
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'ul',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__filterItem__["a" /* default */], {
          paramType: param,
          displayName: displayName,
          link: _link2,
          index: 0
        })
      );
    }
  }
};

FilterList.propTypes = {
  parsedLocation: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  param: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (FilterList);

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_undefsafe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_array_duplicate__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_array_duplicate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_array_duplicate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filterList__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils_urlHelper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_constants_filterParamsConfig__ = __webpack_require__(38);











var SelectedFilters = function SelectedFilters(props) {
  var location = props.location;
  var query = location.query;


  var parsedLocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils_urlHelper__["a" /* parseLocation */])(location);
  // check there are selected fitlers and the selected filters are in the filter param config
  // we can tell whether it's default sort by checking if it's in the url
  var isDefaultSortByFilter = __WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty___default()(query.sort);
  var hasSelectedFilter = isDefaultSortByFilter ?
  // has filters exclude default one
  Object.keys(parsedLocation).length > 1 &&
  // has valid filters
  __WEBPACK_IMPORTED_MODULE_4_array_duplicate___default()(Object.keys(parsedLocation), Object.keys(__WEBPACK_IMPORTED_MODULE_8__common_constants_filterParamsConfig__["a" /* default */])).length > 1 : // has filters exclude default one
  Object.keys(parsedLocation).length > 0 &&
  // has valid filters
  __WEBPACK_IMPORTED_MODULE_4_array_duplicate___default()(Object.keys(parsedLocation), Object.keys(__WEBPACK_IMPORTED_MODULE_8__common_constants_filterParamsConfig__["a" /* default */])).length > 0;

  var clearAllLink = parsedLocation.term ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils_urlHelper__["b" /* makeLink */])({ category: 'all', term: parsedLocation.term }) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils_urlHelper__["b" /* makeLink */])({ category: 'all' });

  var filteredFilters = Object.keys(parsedLocation).sort(function (param1, param2) {
    return __WEBPACK_IMPORTED_MODULE_3_undefsafe___default()(__WEBPACK_IMPORTED_MODULE_8__common_constants_filterParamsConfig__["a" /* default */], param1 + '.order') > __WEBPACK_IMPORTED_MODULE_3_undefsafe___default()(__WEBPACK_IMPORTED_MODULE_8__common_constants_filterParamsConfig__["a" /* default */], param2 + '.order');
  }).filter(function (param) {
    // do not display default sort_by option
    return !(isDefaultSortByFilter && param === 'sort_by');
  });

  // if price_min and price_max are selected at the same time, only show one of them.
  if (parsedLocation.price_min && parsedLocation.price_max) {
    filteredFilters = filteredFilters.filter(function (filter) {
      return filter !== 'price_min';
    });
  }

  // if length_min and length_max are selected at the same time, only show one of them.
  if (parsedLocation.length_min && parsedLocation.length_max) {
    filteredFilters = filteredFilters.filter(function (filter) {
      return filter !== 'length_min';
    });
  }

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { id: 'selected-filters' },
    !hasSelectedFilter && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'search-facet-refine' },
      'Refine your results:'
    ),
    hasSelectedFilter && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'search-facet' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'search-facet-actives__remove-all' },
        'Your filters:',
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],
          { to: clearAllLink },
          'Clear all'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'search-facet-actives__facet-wrapper' },
        filteredFilters.map(function (param, key) {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__filterList__["a" /* default */], {
            parsedLocation: parsedLocation,
            param: param,
            key: key
          });
        })
      )
    )
  );
};

SelectedFilters.propTypes = {
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (SelectedFilters);

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils_formatString__ = __webpack_require__(56);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var MarketplaceStats = function (_React$Component) {
  _inherits(MarketplaceStats, _React$Component);

  function MarketplaceStats() {
    _classCallCheck(this, MarketplaceStats);

    return _possibleConstructorReturn(this, (MarketplaceStats.__proto__ || Object.getPrototypeOf(MarketplaceStats)).apply(this, arguments));
  }

  _createClass(MarketplaceStats, [{
    key: 'render',
    value: function render() {
      var stats = this.props.stats;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'ul',
        { className: 'global-footer-stats__list' },
        stats && stats.total_users.toString() && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'li',
          { className: 'global-footer-stats__list-item h-p0' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'global-footer-stats__number' },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_utils_formatString__["b" /* commaStyleString */])(stats.total_users) + ' '
          ),
          'community members'
        ),
        stats && stats.total_items.toString() && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'li',
          { className: 'global-footer-stats__list-item h-p0' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'global-footer-stats__number' },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_utils_formatString__["b" /* commaStyleString */])(stats.total_items) + ' '
          ),
          'items for sale'
        )
      );
    }
  }]);

  return MarketplaceStats;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MarketplaceStats.propTypes = {
  stats: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (MarketplaceStats);

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_layout_footer__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__marketplaceStats__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils_assetsPath__ = __webpack_require__(81);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var SiteFooter = function (_React$Component) {
  _inherits(SiteFooter, _React$Component);

  function SiteFooter() {
    _classCallCheck(this, SiteFooter);

    return _possibleConstructorReturn(this, (SiteFooter.__proto__ || Object.getPrototypeOf(SiteFooter)).apply(this, arguments));
  }

  _createClass(SiteFooter, [{
    key: 'render',
    value: function render() {
      var stats = this.props.stats;
      var infoLinks = __WEBPACK_IMPORTED_MODULE_2__config_layout_footer__["a" /* default */].infoLinks,
          companyLinks = __WEBPACK_IMPORTED_MODULE_2__config_layout_footer__["a" /* default */].companyLinks,
          socialMediaLinks = __WEBPACK_IMPORTED_MODULE_2__config_layout_footer__["a" /* default */].socialMediaLinks;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'footer',
        { className: 'global-footer' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'grid-container -layout-wide' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'global-footer__container' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'nav',
              { className: 'global-footer-info-links' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr', { className: 'global-footer__separator fds-u-hide-large-and-above fds-u-mb4' }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'ul',
                { className: 'global-footer-info-links__list' },
                infoLinks.map(function (column) {
                  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'li',
                    { key: column.key,
                      className: 'global-footer-info-links__list-item' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'ul',
                      { className: 'global-footer-sublist' },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'li',
                        { className: 'global-footer-sublist__item-title' },
                        column.titleHtml
                      ),
                      column.entries.map(function (entry) {
                        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'li',
                          { key: entry.key,
                            className: 'global-footer-sublist__item h-p0' },
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'a',
                            { className: 'global-footer__text-link',
                              href: entry.url },
                            entry.label
                          )
                        );
                      })
                    )
                  );
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'global-footer-stats' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { className: 'global-footer-stats__logo',
                alt: 'Envato Market',
                src: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_utils_assetsPath__["a" /* default */])() + '/images/logo-envato-market.svg' }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__marketplaceStats__["a" /* default */], { stats: stats })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr', { className: 'global-footer__separator' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'global-footer__container' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'global-footer-company-links' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'ul',
                { className: 'global-footer-company-links__list' },
                companyLinks.map(function (entry) {
                  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'li',
                    { key: entry.key,
                      className: 'global-footer-company-links__list-item' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'a',
                      { className: 'global-footer__text-link -opacity-full',
                        href: entry.url },
                      entry.label
                    )
                  );
                })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr', { className: 'global-footer__separator fds-u-hide-small-and-above fds-u-mt3' }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'small',
                { className: 'global-footer-company-links__copyright' },
                '\xA9 2017 Envato Pty Ltd. Trademarks and brands are the property of their respective owners.'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'global-footer-social' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('link', { itemProp: 'sameAs', href: 'https://instagram.com/envato' }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'ul',
                { itemScope: true, itemType: 'http://schema.org/Organization' },
                socialMediaLinks.map(function (entry) {
                  var iconSrc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_utils_assetsPath__["a" /* default */])() + entry.icon;
                  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'li',
                    { key: entry.key,
                      className: 'global-footer-social__list-item' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'a',
                      { className: 'global-footer__icon-link',
                        itemProp: 'sameAs', rel: 'nofollow', href: entry.url },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { className: 'global-footer-social__icon',
                        alt: entry.label, title: entry.label, src: iconSrc })
                    )
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);

  return SiteFooter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

SiteFooter.propTypes = {
  stats: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (SiteFooter);

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 512 512' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Cart' },
      props.title || 'Cart'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M440.2 328.3c-3.5 13.9-15.7 23.8-30.2 23.8H159.8c-14.5 0-27.3-9.9-30.2-23.8L65.7 69.9H34.4C16.9 69.9 3 55.9 3 38.5S16.9 7.2 34.4 7.2h55.7c14.5 0 27.3 9.9 30.8 23.8l17.4 70.3h355.9c2.9 0 6.4 1.7 8.1 4.1 2.3 2.3 2.9 5.8 1.8 8.7l-63.9 214.2zm-238.6 76c29 0 52.2 23.2 52.2 52.3 0 29-23.2 52.2-52.2 52.2s-52.3-23.2-52.3-52.2 23.3-52.3 52.3-52.3zm167.2 0c29 0 52.2 23.2 52.2 52.3 0 29-23.2 52.2-52.2 52.2s-52.3-23.2-52.3-52.2 23.3-52.3 52.3-52.3z' })
    )
  );
});

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 16 16' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Cart_reverse' },
      props.title || 'Cart_reverse'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'title',
        null,
        'Cart'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M 0.009 1.349 C 0.009 1.753 0.347 2.086 0.765 2.086 C 0.765 2.086 0.766 2.086 0.767 2.086 L 0.767 2.09 L 2.289 2.09 L 5.029 7.698 L 4.001 9.507 C 3.88 9.714 3.812 9.958 3.812 10.217 C 3.812 11.028 4.496 11.694 5.335 11.694 L 14.469 11.694 L 14.469 11.694 C 14.886 11.693 15.227 11.36 15.227 10.957 C 15.227 10.552 14.886 10.221 14.469 10.219 L 14.469 10.217 L 5.653 10.217 C 5.547 10.217 5.463 10.135 5.463 10.031 L 5.487 9.943 L 6.171 8.738 L 11.842 8.738 C 12.415 8.738 12.917 8.436 13.175 7.978 L 15.901 3.183 C 15.96 3.08 15.991 2.954 15.991 2.828 C 15.991 2.422 15.65 2.09 15.23 2.09 L 3.972 2.09 L 3.481 1.077 L 3.466 1.043 C 3.343 0.79 3.084 0.612 2.778 0.612 C 2.777 0.612 0.765 0.612 0.765 0.612 C 0.347 0.612 0.009 0.943 0.009 1.349 Z M 3.819 13.911 C 3.819 14.724 4.496 15.389 5.335 15.389 C 6.171 15.389 6.857 14.724 6.857 13.911 C 6.857 13.097 6.171 12.434 5.335 12.434 C 4.496 12.434 3.819 13.097 3.819 13.911 Z M 11.431 13.911 C 11.431 14.724 12.11 15.389 12.946 15.389 C 13.784 15.389 14.469 14.724 14.469 13.911 C 14.469 13.097 13.784 12.434 12.946 12.434 C 12.11 12.434 11.431 13.097 11.431 13.911 Z' })
    )
  );
});

/***/ }),
/* 557 */,
/* 558 */,
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 512 512' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Favorite' },
      props.title || 'Favorite'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M256 475.8c-4.9 0-9.1-1.7-12.5-5.1L66.8 300.2c-1.9-1.5-4.5-4-7.8-7.4-3.3-3.4-8.5-9.6-15.7-18.6-7.2-9-13.6-18.2-19.3-27.6-5.7-9.4-10.7-20.9-15.2-34.3C4.5 199 2.3 186 2.3 173.4c0-41.5 12-74 36-97.4 24-23.4 57.1-35.1 99.4-35.1 11.7 0 23.6 2 35.8 6.1 12.2 4.1 23.5 9.5 34 16.4 10.5 6.9 19.5 13.4 27 19.4 7.5 6 14.7 12.5 21.5 19.3 6.8-6.8 14-13.2 21.5-19.3 7.5-6 16.6-12.5 27-19.4 10.5-6.9 21.8-12.4 34-16.4 12.2-4.1 24.1-6.1 35.8-6.1 42.3 0 75.4 11.7 99.4 35.1 24 23.4 36 55.9 36 97.4 0 41.7-21.6 84.2-64.9 127.4L268.5 470.7c-3.4 3.4-7.6 5.1-12.5 5.1z' })
    )
  );
});

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 512 512' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Folder-Open' },
      props.title || 'Folder-Open'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M415.8 188.5v43.1H191.9c-16.9 0-34.5 4.3-53 12.8s-33.2 19.2-44.1 32.2L4.1 383l-1.3 1.6c0-.7 0-1.8-.1-3.4-.1-1.5-.1-2.6-.1-3.4V119.6c0-16.5 5.9-30.7 17.8-42.5 11.8-11.8 26-17.8 42.5-17.8H149c16.5 0 30.7 5.9 42.5 17.8 11.8 11.8 17.8 26 17.8 42.5v8.6h146.4c16.5 0 30.7 5.9 42.5 17.8 11.7 11.8 17.6 26 17.6 42.5zm92.3 92.5c0 5.6-2.8 11.5-8.3 17.8l-90.4 106.6c-7.7 9.2-18.5 16.9-32.4 23.3-13.9 6.4-26.8 9.6-38.6 9.6H45.5c-6.1 0-11.5-1.2-16.3-3.5-4.8-2.3-7.1-6.2-7.1-11.6 0-5.6 2.8-11.5 8.3-17.8l90.4-106.6c7.7-9.1 18.5-16.9 32.4-23.3 13.9-6.4 26.8-9.6 38.6-9.6h292.8c6.1 0 11.5 1.2 16.3 3.5 4.8 2.4 7.2 6.3 7.2 11.6z' })
    )
  );
});

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 16 16' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Menu-Dropdown' },
      props.title || 'Menu-Dropdown'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'title',
        null,
        'Menu'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M3.5 2A1.5 1.5 0 0 1 5 3.5 1.5 1.5 0 0 1 3.5 5 1.5 1.5 0 0 1 2 3.5 1.5 1.5 0 0 1 3.5 2zM8 2a1.5 1.5 0 0 1 1.5 1.5A1.5 1.5 0 0 1 8 5a1.5 1.5 0 0 1-1.5-1.5A1.5 1.5 0 0 1 8 2zM12.5 2A1.5 1.5 0 0 1 14 3.5 1.5 1.5 0 0 1 12.5 5 1.5 1.5 0 0 1 11 3.5 1.5 1.5 0 0 1 12.5 2zM3.5 6.5A1.5 1.5 0 0 1 5 8a1.5 1.5 0 0 1-1.5 1.5A1.5 1.5 0 0 1 2 8a1.5 1.5 0 0 1 1.5-1.5zM8 6.5A1.5 1.5 0 0 1 9.5 8 1.5 1.5 0 0 1 8 9.5 1.5 1.5 0 0 1 6.5 8 1.5 1.5 0 0 1 8 6.5zM12.5 6.5A1.5 1.5 0 0 1 14 8a1.5 1.5 0 0 1-1.5 1.5A1.5 1.5 0 0 1 11 8a1.5 1.5 0 0 1 1.5-1.5zM3.5 11A1.5 1.5 0 0 1 5 12.5 1.5 1.5 0 0 1 3.5 14 1.5 1.5 0 0 1 2 12.5 1.5 1.5 0 0 1 3.5 11zM8 11a1.5 1.5 0 0 1 1.5 1.5A1.5 1.5 0 0 1 8 14a1.5 1.5 0 0 1-1.5-1.5A1.5 1.5 0 0 1 8 11zM12.5 11a1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5 1.5 1.5 0 0 1 1.5-1.5z' })
    )
  );
});

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 18 18' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Mute' },
      props.title || 'Mute'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M9 1L6.91 3.09 9 5.18V1zM1.27 0L0 1.27 4.73 6H0v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L16.73 18 18 16.73l-9-9L1.27 0zM16 9c0 .94-.2 1.82-.54 2.64l1.51 1.51C17.63 11.91 18 10.5 18 9c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zm-2.5 0c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63z', fillRule: 'evenodd' })
    )
  );
});

/***/ }),
/* 563 */,
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 18 18' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'Unmute' },
      props.title || 'Unmute'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M11 0v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77C18 4.49 15.01.91 11 0zm2.5 8.77c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM0 5.77v6h4l5 5v-16l-5 5H0z', fillRule: 'evenodd' })
    )
  );
});

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icon_base__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_icon_base___default.a,
    _extends({ viewBox: '0 0 16 16' }, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'title',
      { id: 'User' },
      props.title || 'User'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'title',
        null,
        'User'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M 8 0 C 3.591 0 0 3.589 0 8 C 0 12.41 3.59 16 8 16 C 12.41 16 16 12.411 16 8 C 16 3.591 12.41 0 8 0 M 12.786 12.624 C 12.768 12.624 12.732 12.607 12.714 12.607 C 11.25 12.25 10.054 11.697 10.054 11.697 C 9.91 11.5 9.821 11.161 9.803 10.929 C 10.125 10.482 10.304 9.964 10.375 9.5 C 10.41 9.518 10.446 9.536 10.481 9.536 C 10.624 9.536 10.803 9.357 10.999 8.643 C 11.213 7.911 11.089 7.66 10.91 7.589 C 11.499 4.767 10.16 4.678 10.16 4.678 C 10.16 4.678 9.965 4.286 9.429 3.999 C 9.126 3.821 8.715 3.659 8.197 3.659 C 8.107 3.659 8.036 3.659 7.946 3.678 C 7.732 3.695 7.535 3.73 7.356 3.785 C 7.124 3.874 6.892 3.981 6.696 4.124 C 6.446 4.285 6.232 4.463 6.017 4.695 C 5.695 5.034 5.41 5.444 5.286 5.98 C 5.161 6.426 5.178 6.927 5.339 7.427 L 5.286 7.427 C 5.053 7.427 4.821 7.605 5.071 8.498 C 5.267 9.194 5.446 9.391 5.59 9.391 C 5.661 9.89 5.84 10.479 6.214 10.961 C 6.179 11.158 6.125 11.443 6.001 11.641 C 6.001 11.641 4.751 12.248 3.287 12.606 C 3.269 12.606 3.233 12.624 3.215 12.624 C 2.054 11.427 1.34 9.801 1.34 7.998 C 1.34 4.32 4.322 1.337 8.001 1.337 C 11.679 1.337 14.662 4.319 14.662 7.998 C 14.661 9.803 13.947 11.428 12.786 12.624' })
    )
  );
});

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_undefsafe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_search_result_utils__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__audio_audioPlayerSmallContainer__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_itemActions__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_trendingItem__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__gridAudio_module_css__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__gridAudio_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__gridAudio_module_css__);












var ItemCardGridAudio = function ItemCardGridAudio(_ref) {
  var item = _ref.item,
      onAddToFavourites = _ref.onAddToFavourites,
      rank = _ref.rank,
      onAddToCollections = _ref.onAddToCollections,
      _ref$onItemLinkClick = _ref.onItemLinkClick,
      onItemLinkClick = _ref$onItemLinkClick === undefined ? function () {} : _ref$onItemLinkClick,
      _ref$onAddToCart = _ref.onAddToCart,
      onAddToCart = _ref$onAddToCart === undefined ? function () {} : _ref$onAddToCart;

  var salesLabel = item.number_of_sales === 1 ? 'Sale' : 'Sales';

  var mp3Url = __WEBPACK_IMPORTED_MODULE_3_undefsafe___default()(item, 'previews.icon_with_audio_preview.mp3_url');

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_8__gridAudio_module_css___default.a.itemView },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_8__gridAudio_module_css___default.a.actionContainer },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_8__gridAudio_module_css___default.a.miniAudioPlayerContainer },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__audio_audioPlayerSmallContainer__["a" /* default */], { src: mp3Url })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'a',
          { className: __WEBPACK_IMPORTED_MODULE_8__gridAudio_module_css___default.a.thumbnail, href: item.url + '?s_rank=' + rank, onClick: onItemLinkClick },
          item.trending && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_trendingItem__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { alt: item.name, src: item.ui.smallPreviewUrl, title: item.name, width: '80', height: '80', className: __WEBPACK_IMPORTED_MODULE_8__gridAudio_module_css___default.a.thumbnailImage })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_itemActions__["a" /* default */], { item: item, onAddToFavourites: onAddToFavourites, onAddToCollections: onAddToCollections, onAddToCart: onAddToCart })
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'h3',
      { className: __WEBPACK_IMPORTED_MODULE_8__gridAudio_module_css___default.a.itemName },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'a',
        { className: 'fds-c-text-link -color-inherit -decoration-reversed',
          href: item.url + '?s_rank=' + rank, onClick: onItemLinkClick },
        item.name
      )
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      null,
      !!item.rating.rating && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__pages_search_result_utils__["b" /* StarRating */], {
        rating: item.rating.rating,
        className: 'star-rating--search' })
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'footer',
      { className: __WEBPACK_IMPORTED_MODULE_8__gridAudio_module_css___default.a.footer },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'p',
        { className: 'fds-c-text-body -size-xs fds-u-m0' },
        item.number_of_sales,
        ' ',
        salesLabel,
        ' ',
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'product-grid__price' },
          '$',
          item.price
        )
      ),
      item.ui.footerLink && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],
        { to: item.ui.footerLink.href },
        item.ui.footerLink.label
      )
    )
  );
};

ItemCardGridAudio.propTypes = {
  item: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  onAddToFavourites: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  rank: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  onItemLinkClick: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onAddToCart: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (ItemCardGridAudio);

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_search_result_utils__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_trendingItem__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__magnifier_configurator__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__overlay__ = __webpack_require__(311);









var ItemCardGridDefault = function ItemCardGridDefault(_ref) {
  var item = _ref.item,
      onAddToFavourites = _ref.onAddToFavourites,
      rank = _ref.rank,
      onAddToCollections = _ref.onAddToCollections,
      _ref$onItemLinkClick = _ref.onItemLinkClick,
      onItemLinkClick = _ref$onItemLinkClick === undefined ? function () {} : _ref$onItemLinkClick,
      _ref$onAddToCart = _ref.onAddToCart,
      onAddToCart = _ref$onAddToCart === undefined ? function () {} : _ref$onAddToCart;

  var salesLabel = item.number_of_sales === 1 ? 'Sale' : 'Sales';
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'product-grid__inside' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'item-thumbnail' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__overlay__["a" /* default */],
            { position: 'side', content: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__magnifier_configurator__["a" /* default */])({ item: item }) },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'item-thumbnail__image' },
              item.trending && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_trendingItem__["a" /* default */], null),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                { href: item.url + '?s_rank=' + rank, onClick: onItemLinkClick },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { alt: item.name,
                  className: 'preload no_preview landscape-image-magnifier',
                  src: item.ui.smallPreviewUrl, title: item.name })
              ),
              item.previews.live_site ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'item-thumbnail__preview' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'a',
                  { href: item.previews.live_site.url, target: '_blank' },
                  'Live preview'
                )
              ) : null
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'product-grid__item-thumbnail-actions' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'item-thumbnail-actions -width-full' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'ul',
            { className: 'item-thumbnail-actions__list' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'li',
              { className: 'item-thumbnail-actions__control -icon-favorite -responsive-size-l' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { className: 'js-favorite-widget is-initialized' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'a',
                  { href: '/favorites?item_id=' + item.id,
                    onClick: onAddToFavourites,
                    className: item.ui.isInFavourites ? 'is-active' : '',
                    rel: 'nofollow', title: 'Add to Favorites' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    null,
                    'Add to Favorites'
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'li',
              { className: 'item-thumbnail-actions__control -icon-collection -responsive-size-l' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { className: 'is-initialized' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'a',
                  {
                    href: '/bookmarks/widget?item_id=' + item.id,
                    className: item.ui.isInBookmarks ? 'is-active' : '',
                    rel: 'nofollow',
                    onClick: function onClick(event) {
                      return onAddToCollections(event);
                    },
                    title: 'Add to Collection' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    null,
                    'Add to Collection'
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'li',
              { className: 'item-thumbnail-actions__control -icon-cart -responsive-size-l' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'a',
                  {
                    className: item.ui.isInCart ? 'is-active' : '',
                    onClick: onAddToCart,
                    href: '/cart/configure_before_adding/' + item.id, rel: 'nofollow', title: 'Add to Cart' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    null,
                    'Add to Cart'
                  )
                )
              )
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'h3',
        { className: 'product-grid__heading fds-u-text-truncate' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'a',
          { className: 'fds-c-text-link -color-inherit -decoration-reversed',
            href: item.url + '?s_rank=' + rank, onClick: onItemLinkClick },
          item.name
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'product-grid__rating' },
        item.rating.rating ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__pages_search_result_utils__["b" /* StarRating */], { rating: item.rating.rating, className: 'star-rating--search' }) : null
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'footer',
        { className: 'product-grid__footer' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          { className: 'fds-c-text-body -size-xs fds-u-m0' },
          item.number_of_sales,
          ' ',
          salesLabel,
          ' ',
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'product-grid__price' },
            '$',
            item.price
          )
        ),
        item.ui.footerLink && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],
          { to: item.ui.footerLink.href },
          item.ui.footerLink.label
        )
      )
    )
  );
};

ItemCardGridDefault.propTypes = {
  item: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  onAddToFavourites: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  rank: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  onItemLinkClick: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onAddToCart: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (ItemCardGridDefault);

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_undefsafe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_itemActions__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_trendingItem__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gridVideo_module_css__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gridVideo_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__gridVideo_module_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ItemCardGridVideo = function (_React$Component) {
  _inherits(ItemCardGridVideo, _React$Component);

  function ItemCardGridVideo(props) {
    _classCallCheck(this, ItemCardGridVideo);

    var _this = _possibleConstructorReturn(this, (ItemCardGridVideo.__proto__ || Object.getPrototypeOf(ItemCardGridVideo)).call(this, props));

    _this.state = {
      playing: false,
      hideCursor: false,
      videoPlayPromise: null,
      videoLooped: false,
      reportedEvents: []
    };

    _this.onMouseOver = _this.onMouseOver.bind(_this);
    _this.onMouseOut = _this.onMouseOut.bind(_this);

    _this.onMouseOverVideo = _this.onMouseOverVideo.bind(_this);
    _this.onMouseOutVideo = _this.onMouseOutVideo.bind(_this);
    _this.onMouseMoveVideo = _this.onMouseMoveVideo.bind(_this);

    _this.setVideoElementRef = _this.setVideoElementRef.bind(_this);
    _this.onVideoProgress = _this.onVideoProgress.bind(_this);
    return _this;
  }

  _createClass(ItemCardGridVideo, [{
    key: 'setVideoElementRef',
    value: function setVideoElementRef(element) {
      this.videoElement = element;
    }
  }, {
    key: 'onMouseMoveVideo',
    value: function onMouseMoveVideo() {
      if (this.state.hideCursor) {
        this.setState({ hideCursor: false });
        this.onMouseOverVideo();
      }
    }
  }, {
    key: 'onMouseOverVideo',
    value: function onMouseOverVideo() {
      var _this2 = this;

      this.timeout = setTimeout(function () {
        _this2.setState({ hideCursor: true });
      }, 3000);
    }
  }, {
    key: 'onMouseOutVideo',
    value: function onMouseOutVideo() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.setState({ hideCursor: false });
    }
  }, {
    key: 'onVideoProgress',
    value: function onVideoProgress() {
      if (this.state.playing) {
        var playProgress = Math.floor(this.videoElement.currentTime / this.videoElement.duration * 100);
        this.handleVideoReportEvent(playProgress);
        __WEBPACK_IMPORTED_MODULE_2_raf___default()(this.onVideoProgress);
      }
    }
  }, {
    key: 'handleVideoReportEvent',
    value: function handleVideoReportEvent(playProgress) {
      if (this.videoElement.currentTime === 0) {
        this.reportEvent('video_start');
      }

      if (playProgress >= 25 && playProgress < 50) {
        this.reportEvent('25_percent');
      }

      if (playProgress >= 50 && playProgress < 75) {
        this.reportEvent('50_percent');
      }

      if (playProgress >= 75) {
        this.reportEvent('75_percent');
      }

      if (playProgress + 1 >= 100) {
        this.reportEvent('video_complete');
        this.setState({
          videoLooped: true
        });
      }
    }
  }, {
    key: 'hasEventReported',
    value: function hasEventReported(eventName) {
      return this.state.reportedEvents.indexOf(eventName) >= 0;
    }
  }, {
    key: 'reportEvent',
    value: function reportEvent(eventName) {
      if (!this.state.videoLooped && !this.hasEventReported(eventName)) {
        var item = this.props.item;

        var videoSrc = __WEBPACK_IMPORTED_MODULE_1_undefsafe___default()(item, 'previews.icon_with_video_preview.video_url');

        if (this.props.reportVideoProgress) {
          this.props.reportVideoProgress(eventName, videoSrc);
          this.setState({
            reportedEvents: [eventName].concat(_toConsumableArray(this.state.reportedEvents))
          });
        }
      }
    }
  }, {
    key: 'onMouseOver',
    value: function onMouseOver() {
      var _this3 = this;

      if (this.videoElement && this.videoElement.paused) {
        this.setState({
          videoPlayPromise: this.videoElement.play().then(function () {
            _this3.setState({ playing: true }, function () {
              _this3.onVideoProgress();
            });
          })
        });
      }
    }
  }, {
    key: 'onMouseOut',
    value: function onMouseOut() {
      var _this4 = this;

      var videoPlayPromise = this.state.videoPlayPromise;

      if (this.videoElement && !this.videoElement.paused) {
        if (videoPlayPromise) {
          videoPlayPromise.then(function () {
            _this4.videoElement.pause();
            _this4.setState({ playing: false });
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          item = _props.item,
          onAddToFavourites = _props.onAddToFavourites,
          rank = _props.rank,
          onAddToCollections = _props.onAddToCollections,
          onItemLinkClick = _props.onItemLinkClick,
          onAddToCart = _props.onAddToCart,
          muted = _props.muted;


      var videoLinkStyle = void 0;
      var overlayStyle = void 0;

      if (this.state.hideCursor) {
        videoLinkStyle = { cursor: 'none' };
        overlayStyle = { opacity: 0 };
      }

      var videoLength = __WEBPACK_IMPORTED_MODULE_1_undefsafe___default()(item.attributes.find(function (attribute) {
        return attribute.name === 'length-video';
      }), 'value');
      var videoUrl = __WEBPACK_IMPORTED_MODULE_1_undefsafe___default()(item, 'previews.icon_with_video_preview.video_url');
      var posterUrl = __WEBPACK_IMPORTED_MODULE_1_undefsafe___default()(item, 'previews.icon_with_video_preview.landscape_url');

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_5__gridVideo_module_css___default.a.container },
        item.trending && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_trendingItem__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_5__gridVideo_module_css___default.a.videoContainer, onMouseOver: this.onMouseOver, onMouseOut: this.onMouseOut },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { href: item.url + '?s_rank=' + rank, onClick: onItemLinkClick, style: videoLinkStyle },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video', {
              muted: muted,
              onMouseOver: this.onMouseOverVideo,
              onMouseOut: this.onMouseOutVideo,
              onMouseMove: this.onMouseMoveVideo,
              ref: this.setVideoElementRef,
              className: __WEBPACK_IMPORTED_MODULE_5__gridVideo_module_css___default.a.video,
              loop: true,
              src: videoUrl,
              poster: posterUrl })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_5__gridVideo_module_css___default.a.overlay, style: overlayStyle },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __WEBPACK_IMPORTED_MODULE_5__gridVideo_module_css___default.a.itemActions },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_itemActions__["a" /* default */], {
                item: item,
                defaultTheme: false,
                onAddToFavourites: onAddToFavourites,
                onAddToCollections: onAddToCollections,
                onAddToCart: onAddToCart })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __WEBPACK_IMPORTED_MODULE_5__gridVideo_module_css___default.a.price },
              '$',
              item.price
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_5__gridVideo_module_css___default.a.meta },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_5__gridVideo_module_css___default.a.titleContainer },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: __WEBPACK_IMPORTED_MODULE_5__gridVideo_module_css___default.a.title, href: item.url + '?s_rank=' + rank, onClick: onItemLinkClick },
              item.name
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_5__gridVideo_module_css___default.a.duration },
            videoLength
          )
        )
      );
    }
  }]);

  return ItemCardGridVideo;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ItemCardGridVideo);

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_undefsafe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_search_result_utils__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__audio_audioPlayerLargeContainer__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_itemActions__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_trendingItem__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__listAudio_module_css__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__listAudio_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__listAudio_module_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var ItemCardListAudio = function (_React$Component) {
  _inherits(ItemCardListAudio, _React$Component);

  function ItemCardListAudio() {
    _classCallCheck(this, ItemCardListAudio);

    return _possibleConstructorReturn(this, (ItemCardListAudio.__proto__ || Object.getPrototypeOf(ItemCardListAudio)).apply(this, arguments));
  }

  _createClass(ItemCardListAudio, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          item = _props.item,
          onAddToFavourites = _props.onAddToFavourites,
          rank = _props.rank,
          onAddToCollections = _props.onAddToCollections,
          onItemLinkClick = _props.onItemLinkClick,
          onAddToCart = _props.onAddToCart;


      var trackLength = __WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(item.attributes.find(function (attribute) {
        return attribute.name === 'length-audio';
      }), 'value');
      var trackTempo = __WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(item.attributes.find(function (attribute) {
        return attribute.name === 'bpm';
      }), 'value');

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_7__listAudio_module_css___default.a.container },
        item.trending && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_trendingItem__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_7__listAudio_module_css___default.a.itemSummary },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            { className: __WEBPACK_IMPORTED_MODULE_7__listAudio_module_css___default.a.thumbnail, href: item.url + '?s_rank=' + rank, onClick: onItemLinkClick },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { alt: item.name, width: '80', height: '80', src: item.ui.smallPreviewUrl, title: item.name })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_itemActions__["a" /* default */], { item: item, onAddToFavourites: onAddToFavourites, onAddToCollections: onAddToCollections, onAddToCart: onAddToCart })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_7__listAudio_module_css___default.a.itemDescription },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_7__listAudio_module_css___default.a.flexColumn },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: __WEBPACK_IMPORTED_MODULE_7__listAudio_module_css___default.a.spaceBetween },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h3',
                { className: 'fds-u-m0 fds-c-text-heading -size-xs' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'a',
                  { className: 'fds-c-text-link -color-inherit -decoration-reversed',
                    href: item.url + '?s_rank=' + rank, onClick: onItemLinkClick },
                  item.name
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                null,
                'by ',
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'a',
                  { className: 'fds-c-text-link -color-dark -decoration-reversed',
                    href: item.author_url },
                  item.author_username
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__audio_audioPlayerLargeContainer__["a" /* default */], { item: item }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: __WEBPACK_IMPORTED_MODULE_7__listAudio_module_css___default.a.meta },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { className: 'fds-c-text-body -size-xs fds-u-m0' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__pages_search_result_utils__["c" /* MetaCategories */], { classification: item.classification, className: 'meta-categories -no-slash' })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                trackLength ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'span',
                  { className: 'fds-u-pr2' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'fds-u-pr1 e-icon -icon-clock -size-small' }),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'fds-c-text-body -size-xs -weight-bold fds-u-m0' },
                    trackLength
                  )
                ) : null,
                trackTempo ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'span',
                  { className: 'fds-u-pr2' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'fds-u-pr1 e-icon -icon-tempo -size-small' }),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'fds-c-text-body -size-xs -weight-bold fds-u-m0' },
                    trackTempo
                  )
                ) : null,
                item.number_of_sales ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'span',
                  { className: 'fds-u-pr4' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'fds-u-pr1 e-icon -icon-bar-chart -size-small' }),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'fds-c-text-body -size-xs -weight-bold fds-u-m0' },
                    item.number_of_sales
                  )
                ) : null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'span',
                  { className: 'fds-c-text-heading -size-xs' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'b',
                    { className: 'fds-c-text-currency' },
                    '$',
                    item.price
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ItemCardListAudio;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

ItemCardListAudio.propTypes = {
  item: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  onAddToFavourites: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  rank: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  onItemLinkClick: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onAddToCart: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (ItemCardListAudio);

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_search_result_utils__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_trendingItem__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__magnifier_configurator__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__overlay__ = __webpack_require__(311);








var ItemCardListDefault = function ItemCardListDefault(_ref) {
  var item = _ref.item,
      onAddToFavourites = _ref.onAddToFavourites,
      rank = _ref.rank,
      onAddToCollections = _ref.onAddToCollections,
      _ref$onItemLinkClick = _ref.onItemLinkClick,
      onItemLinkClick = _ref$onItemLinkClick === undefined ? function () {} : _ref$onItemLinkClick,
      _ref$onAddToCart = _ref.onAddToCart,
      onAddToCart = _ref$onAddToCart === undefined ? function () {} : _ref$onAddToCart;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    null,
    item.trending && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_trendingItem__["a" /* default */], null),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'product-list__columns-container' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'product-list__column-detail' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'product-list__item-thumbnail' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'item-thumbnail' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__overlay__["a" /* default */],
              { position: 'side', content: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__magnifier_configurator__["a" /* default */])({ item: item }) },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'item-thumbnail__image' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'a',
                  { href: item.url + '?s_rank=' + rank, onClick: onItemLinkClick },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { alt: item.name,
                    className: 'preload no_preview landscape-image-magnifier',
                    height: '80', src: item.ui.smallPreviewUrl, title: item.name, width: '80' })
                ),
                item.previews.live_site ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: 'item-thumbnail__preview' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'a',
                    { href: item.previews.live_site.url, target: '_blank' },
                    'Live preview'
                  )
                ) : null
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'product-list__adjacent-thumbnail' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h3',
            { className: 'product-list__heading' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { className: 'fds-c-text-link -color-inherit -decoration-reversed',
                href: item.url + '?s_rank=' + rank, onClick: onItemLinkClick },
              item.name
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'product-list__price' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              { className: 'fds-c-text-body -size-m -color-inherit -weight-bold fds-u-m0' },
              '$',
              item.price
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'product-list__info' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'product-list__info-author' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                { className: 'fds-c-text-link -color-default -decoration-reversed',
                  href: item.author_url },
                item.author_username
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'product-list__info-rating' },
              item.rating.rating ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__pages_search_result_utils__["b" /* StarRating */], { rating: item.rating.rating, className: 'star-rating--search' }) : null,
              item.rating.rating && item.rating.count ? item.rating.count + ' ratings' : null
            ),
            item.number_of_sales ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'product-list__info-sale' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { className: 'product-list__info-sale-glyph' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'e-icon -icon-bar-chart' })
              ),
              item.number_of_sales,
              ' Sales'
            ) : null
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'fds-u-clear' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'product-list__item-thumbnail-actions' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'item-thumbnail-actions -width-full' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'ul',
                { className: 'item-thumbnail-actions__list' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'li',
                  { className: 'item-thumbnail-actions__control -icon-favorite -responsive-size-l' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'js-favorite-widget is-initialized' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'a',
                      { href: '/favorites?item_id=' + item.id,
                        onClick: onAddToFavourites,
                        className: item.ui.isInFavourites ? 'is-active' : '',
                        rel: 'nofollow', title: 'Add to Favorites' },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'span',
                        null,
                        'Add to Favorites'
                      )
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'li',
                  { className: 'item-thumbnail-actions__control -icon-collection -responsive-size-l' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'is-initialized' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'a',
                      {
                        href: '/bookmarks/widget?item_id=' + item.id,
                        className: item.ui.isInBookmarks ? 'is-active' : '',
                        rel: 'nofollow',
                        onClick: function onClick(event) {
                          return onAddToCollections(event);
                        },
                        title: 'Add to Collection' },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'span',
                        null,
                        'Add to Collection'
                      )
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'li',
                  { className: 'item-thumbnail-actions__control -icon-cart -responsive-size-l' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    null,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'a',
                      {
                        className: item.ui.isInCart ? 'is-active' : '',
                        onClick: onAddToCart,
                        href: '/cart/configure_before_adding/' + item.id, rel: 'nofollow', title: 'Add to Cart' },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'span',
                        null,
                        'Add to Cart'
                      )
                    )
                  )
                )
              )
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'product-list__column-category' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          { className: 'fds-c-text-body -size-xs fds-u-m0' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__pages_search_result_utils__["c" /* MetaCategories */], { classification: item.classification, className: 'meta-categories -no-slash' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
          ' ',
          item.summary
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'product-list__column-price' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          { className: 'product-list__price-desktop' },
          '$',
          item.price
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'product-list__info-desktop' },
          item.rating.rating ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__pages_search_result_utils__["b" /* StarRating */], { rating: item.rating.rating, className: 'star-rating--search' }) : null,
          item.rating.rating ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null) : null,
          item.rating.rating && item.rating.count ? item.rating.count + ' ratings' : null,
          item.number_of_sales ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'product-list__sales-desktop' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'e-icon -icon-bar-chart -size-medium' }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
            item.number_of_sales ? item.number_of_sales + ' Sales' : null
          ) : null
        )
      )
    )
  );
};

ItemCardListDefault.propTypes = {
  item: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  onAddToFavourites: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  rank: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  onItemLinkClick: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onAddToCart: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (ItemCardListDefault);

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);



var Magnifier = function Magnifier(_ref) {
  var item = _ref.item,
      width = _ref.width,
      height = _ref.height,
      children = _ref.children;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: 'magnifier', style: { width: width } },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'size-limiter', style: { height: height } },
      children
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'strong',
      null,
      item.name
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'info' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'author-category' },
        'by ',
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'author' },
          item.author_username
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'category' },
          item.formattedClassification
        )
      ),
      item.price ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'price' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'cost' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'sup',
            null,
            '$'
          ),
          item.price
        )
      ) : null
    )
  );
};

Magnifier.propTypes = {
  item: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
};

/* harmony default export */ __webpack_exports__["a"] = (Magnifier);

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__itemMatrixSelector__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modalErrorMessage__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__itemSummary__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__loadItemMatrixError__ = __webpack_require__(309);








/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var item = _ref.item,
      itemMatrix = _ref.itemMatrix,
      selectedMatrixLicense = _ref.selectedMatrixLicense,
      selectedMatrixSupport = _ref.selectedMatrixSupport,
      onMatrixLicenseChange = _ref.onMatrixLicenseChange,
      onMatrixSupportChange = _ref.onMatrixSupportChange,
      loadItemMatrixError = _ref.loadItemMatrixError,
      modalMessages = _ref.modalMessages,
      closeModal = _ref.closeModal,
      onAddToCart = _ref.onAddToCart,
      onEditCartEntry = _ref.onEditCartEntry,
      modalStep = _ref.modalStep,
      isLoading = _ref.isLoading;

  var modalClassName = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('fds-c-modal -width-m modal', {
    'is-disabled-loading': isLoading
  });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: modalClassName },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'header',
      { className: 'fds-c-modal__header fds-u-text-align-center' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h2',
        { className: 'fds-c-text-heading -size-m fds-u-mb0' },
        'Customize Your Selection'
      )
    ),
    itemMatrix && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__itemMatrixSelector__["a" /* default */], {
      itemMatrix: itemMatrix,
      selectedMatrixLicense: selectedMatrixLicense,
      selectedMatrixSupport: selectedMatrixSupport,
      onMatrixLicenseChange: onMatrixLicenseChange,
      onMatrixSupportChange: onMatrixSupportChange
    }),
    loadItemMatrixError && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__loadItemMatrixError__["a" /* default */], { error: loadItemMatrixError }),
    modalMessages && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__modalErrorMessage__["a" /* default */], { modalMessages: modalMessages }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__itemSummary__["a" /* default */], {
      item: item,
      itemMatrix: itemMatrix,
      selectedMatrixLicense: selectedMatrixLicense,
      selectedMatrixSupport: selectedMatrixSupport
    }),
    !loadItemMatrixError && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'footer',
      { className: 'fds-c-modal__footer' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'fds-c-modal__footer-cta -align-left' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'fds-c-button -color-light', onClick: closeModal },
          'Cancel'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'fds-c-modal__footer-cta -align-right' },
        modalStep === 'add' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            className: 'fds-c-button--3d -color-primary',
            onClick: onAddToCart
          },
          'Add to Cart'
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            className: 'fds-c-button--3d -color-primary',
            onClick: onEditCartEntry
          },
          'Save Selection'
        )
      )
    )
  );
});

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_undefsafe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__addEntry__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__entrySummary__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils_itemMatrix__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils_async__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils_sites__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils_errors__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_analytics_cartAnalytics__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_utils_ga__ = __webpack_require__(33);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var AddItemToCart = function (_React$Component) {
  _inherits(AddItemToCart, _React$Component);

  function AddItemToCart(props) {
    _classCallCheck(this, AddItemToCart);

    // modal step could be add/edit/summary
    var _this = _possibleConstructorReturn(this, (AddItemToCart.__proto__ || Object.getPrototypeOf(AddItemToCart)).call(this, props));

    _this.state = {
      modalStep: 'add',
      cartEntry: null,
      isLoadingItemMatrix: false,
      loadItemMatrixError: null,
      itemMatrix: null,
      selectedMatrixLicense: null,
      selectedMatrixSupport: null,
      hasSupportBeenExtended: false,
      isAddingItem: false
    };
    _this.onAddToCart = _this.onAddToCart.bind(_this);
    _this.onEditCartEntry = _this.onEditCartEntry.bind(_this);
    _this.onMatrixLicenseChange = _this.onMatrixLicenseChange.bind(_this);
    _this.onMatrixSupportChange = _this.onMatrixSupportChange.bind(_this);
    _this.goToEditScreen = _this.goToEditScreen.bind(_this);
    _this.updateMatrixSupport = _this.updateMatrixSupport.bind(_this);
    return _this;
  }

  _createClass(AddItemToCart, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.setState({
        isLoadingItemMatrix: true
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_utils_itemMatrix__["a" /* getItemMatrix */])(this.props.openModalData.item.id).then(function (itemMatrix) {
        var defaultSelectedMatrixLicense = itemMatrix ? Object.keys(itemMatrix)[0] : null;
        var defaultSupportOption = itemMatrix[defaultSelectedMatrixLicense].support;
        var defaultSelectedMatrixSupport = itemMatrix ? Object.keys(defaultSupportOption)[0] : null;
        _this2.setState({
          isLoadingItemMatrix: false,
          itemMatrix: itemMatrix,
          selectedMatrixLicense: defaultSelectedMatrixLicense,
          selectedMatrixSupport: defaultSelectedMatrixSupport
        });
      }).catch(function (error) {
        _this2.setState({
          isLoadingItemMatrix: false,
          loadItemMatrixError: error
        });
      });
    }
  }, {
    key: 'onMatrixLicenseChange',
    value: function onMatrixLicenseChange(e) {
      this.setState({
        selectedMatrixLicense: e.target.value
      });
    }
  }, {
    key: 'onMatrixSupportChange',
    value: function onMatrixSupportChange(e) {
      this.setState({
        selectedMatrixSupport: e.target.value
      });
    }
  }, {
    key: 'updateMatrixSupport',
    value: function updateMatrixSupport(value) {
      var _props = this.props,
          item = _props.openModalData.item,
          currentSite = _props.currentSite;
      var _state = this.state,
          itemMatrix = _state.itemMatrix,
          selectedMatrixLicense = _state.selectedMatrixLicense;

      var selectedMatrixSupportOptions = __WEBPACK_IMPORTED_MODULE_1_undefsafe___default()(itemMatrix[selectedMatrixLicense], 'support');
      var price = __WEBPACK_IMPORTED_MODULE_1_undefsafe___default()(selectedMatrixSupportOptions[value], 'price').replace('$', '');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__common_analytics_cartAnalytics__["a" /* reportCartSupportUpgrade */])({
        item: item,
        currentSite: currentSite,
        license: selectedMatrixLicense,
        price: price,
        support: value
      });
      this.setState({
        hasSupportBeenExtended: true,
        selectedMatrixSupport: value
      });
    }
  }, {
    key: 'onAddToCart',
    value: function onAddToCart() {
      var _this3 = this;

      var _props2 = this.props,
          item = _props2.openModalData.item,
          addItemToCart = _props2.addItemToCart,
          dismissModalMessage = _props2.dismissModalMessage;
      var _state2 = this.state,
          selectedMatrixLicense = _state2.selectedMatrixLicense,
          selectedMatrixSupport = _state2.selectedMatrixSupport;

      var data = {
        item_id: item.id,
        license_key: selectedMatrixLicense,
        support_key: selectedMatrixSupport
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_async__["a" /* setTimeoutFallback */])(function (resolve) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__common_utils_ga__["a" /* default */])(function (tracker) {
          resolve(tracker.get('clientId'));
        });
      }, function (resolve) {
        resolve(null);
      }, 1000).then(function (gaClientId) {
        data.ga_client_id = gaClientId;
        _this3.setState({
          isAddingItem: true
        });
        addItemToCart(data).then(function (action) {
          if (action && action.type === 'addItemToCartSuccess') {
            dismissModalMessage();
            _this3.setState({
              modalStep: 'summary',
              cartEntry: action.payload,
              isAddingItem: false
            });
          } else {
            _this3.setState({
              isAddingItem: false
            });
          }
        }).catch(__WEBPACK_IMPORTED_MODULE_7__common_utils_errors__["a" /* logError */]);
      });
    }
  }, {
    key: 'onEditCartEntry',
    value: function onEditCartEntry() {
      var _props3 = this.props,
          item = _props3.openModalData.item,
          closeModal = _props3.closeModal,
          editCartEntry = _props3.editCartEntry,
          dismissModalMessage = _props3.dismissModalMessage,
          currentSite = _props3.currentSite;
      var _state3 = this.state,
          cartEntry = _state3.cartEntry,
          selectedMatrixLicense = _state3.selectedMatrixLicense,
          selectedMatrixSupport = _state3.selectedMatrixSupport;


      var data = {
        item_id: item.id,
        license_key: selectedMatrixLicense,
        support_key: selectedMatrixSupport
      };
      editCartEntry(cartEntry.id, data).then(function (action) {
        if (action && action.type === 'editCartEntrySuccess') {
          dismissModalMessage();
          closeModal();
          window.location = '//' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_utils_sites__["a" /* getCurrentSiteDomain */])(currentSite) + '/cart';
        }
      }).catch(__WEBPACK_IMPORTED_MODULE_7__common_utils_errors__["a" /* logError */]);
    }
  }, {
    key: 'goToEditScreen',
    value: function goToEditScreen() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__common_analytics_cartAnalytics__["b" /* reportEditCartEntryAttempt */])({
        page: '/search/edit-cart-entry' + window.location.search
      });
      this.setState({
        modalStep: 'edit'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          item = _props4.openModalData.item,
          closeModal = _props4.closeModal,
          modalMessages = _props4.modalMessages,
          editCartEntry = _props4.editCartEntry,
          currentSite = _props4.currentSite;
      var _state4 = this.state,
          cartEntry = _state4.cartEntry,
          modalStep = _state4.modalStep,
          itemMatrix = _state4.itemMatrix,
          selectedMatrixLicense = _state4.selectedMatrixLicense,
          selectedMatrixSupport = _state4.selectedMatrixSupport,
          loadItemMatrixError = _state4.loadItemMatrixError,
          hasSupportBeenExtended = _state4.hasSupportBeenExtended,
          isAddingItem = _state4.isAddingItem,
          isLoadingItemMatrix = _state4.isLoadingItemMatrix;


      var isLoading = isLoadingItemMatrix || isAddingItem;

      if (modalStep === 'add' || modalStep === 'edit') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__addEntry__["a" /* default */], {
          item: item,
          itemMatrix: itemMatrix,
          selectedMatrixLicense: selectedMatrixLicense,
          selectedMatrixSupport: selectedMatrixSupport,
          onMatrixLicenseChange: this.onMatrixLicenseChange,
          onMatrixSupportChange: this.onMatrixSupportChange,
          loadItemMatrixError: loadItemMatrixError,
          modalMessages: modalMessages,
          closeModal: closeModal,
          onAddToCart: this.onAddToCart,
          onEditCartEntry: this.onEditCartEntry,
          modalStep: modalStep,
          isLoading: isLoading
        });
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__entrySummary__["a" /* default */], {
          item: item,
          itemMatrix: itemMatrix,
          selectedMatrixLicense: selectedMatrixLicense,
          selectedMatrixSupport: selectedMatrixSupport,
          onMatrixLicenseChange: this.onMatrixLicenseChange,
          onMatrixSupportChange: this.onMatrixSupportChange,
          loadItemMatrixError: loadItemMatrixError,
          modalMessages: modalMessages,
          closeModal: closeModal,
          editCartEntry: editCartEntry,
          goToEditScreen: this.goToEditScreen,
          cartEntry: cartEntry,
          updateMatrixSupport: this.updateMatrixSupport,
          hasSupportBeenExtended: hasSupportBeenExtended,
          currentSite: currentSite
        });
      }
    }
  }]);

  return AddItemToCart;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (AddItemToCart);

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_actions_layout__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_actions_user_cart__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addItemToCart__ = __webpack_require__(573);






var mapStateToProps = function mapStateToProps(state) {
  var modalMessages = state.layout.modalMessages,
      currentSite = state.common.currentSite;

  return {
    modalMessages: modalMessages,
    currentSite: currentSite
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    closeModal: function closeModal() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_actions_layout__["d" /* closeModal */])());
    },
    addItemToCart: function addItemToCart(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_actions_user_cart__["b" /* addItemToCart */])(data));
    },
    editCartEntry: function editCartEntry(entryID, data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_actions_user_cart__["c" /* editCartEntry */])(entryID, data));
    },
    dismissModalMessage: function dismissModalMessage() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_actions_layout__["e" /* dismissModalMessage */])());
    }
  };
};

var AddItemToCartContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__addItemToCart__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AddItemToCartContainer);

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modalErrorMessage__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__itemSummary__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loadItemMatrixError__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__itemSupportUpgrade__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils_sites__ = __webpack_require__(71);








/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var item = _ref.item,
      itemMatrix = _ref.itemMatrix,
      selectedMatrixLicense = _ref.selectedMatrixLicense,
      selectedMatrixSupport = _ref.selectedMatrixSupport,
      onMatrixLicenseChange = _ref.onMatrixLicenseChange,
      onMatrixSupportChange = _ref.onMatrixSupportChange,
      loadItemMatrixError = _ref.loadItemMatrixError,
      modalMessages = _ref.modalMessages,
      closeModal = _ref.closeModal,
      editCartEntry = _ref.editCartEntry,
      goToEditScreen = _ref.goToEditScreen,
      cartEntry = _ref.cartEntry,
      updateMatrixSupport = _ref.updateMatrixSupport,
      hasSupportBeenExtended = _ref.hasSupportBeenExtended,
      currentSite = _ref.currentSite;

  // the selected support could be one of none/bundle_6month/bundle_12month
  // and it could be show in the follwing two cases:
  // 1. user has selected a support, and the support is `bundle_6month`
  // 2. user has extended support
  var shouldShowExtendedSupport = selectedMatrixSupport && selectedMatrixSupport === 'bundle_6month' || hasSupportBeenExtended;

  // Temporary link to cart page, will need to set to real checkout page later.
  var currentSiteDomain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_sites__["a" /* getCurrentSiteDomain */])(currentSite);
  var checkoutPageLink = '//' + currentSiteDomain + '/cart';

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'fds-c-modal -width-m modal' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'header',
      { className: 'fds-c-modal__header fds-u-text-align-center fds-u-p3' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h1',
        { className: 'fds-c-text-heading -size-s fds-u-mb0' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fds-c-icon -icon-ok -size-jumbo' })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h2',
        { className: 'fds-c-text-heading -size-m fds-u-mb0' },
        'Item added to your cart'
      )
    ),
    loadItemMatrixError && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__loadItemMatrixError__["a" /* default */], null),
    modalMessages && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__modalErrorMessage__["a" /* default */], { modalMessages: modalMessages }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__itemSummary__["a" /* default */], {
      item: item,
      itemMatrix: itemMatrix,
      selectedMatrixLicense: selectedMatrixLicense,
      selectedMatrixSupport: selectedMatrixSupport,
      showChangeDetailsLink: true,
      goToEditScreen: goToEditScreen,
      cartEntry: cartEntry
    }),
    shouldShowExtendedSupport && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__itemSupportUpgrade__["a" /* default */], {
      selectedMatrixLicense: selectedMatrixLicense,
      itemMatrix: itemMatrix,
      editCartEntry: editCartEntry,
      cartEntry: cartEntry,
      updateMatrixSupport: updateMatrixSupport
    }),
    !loadItemMatrixError && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'footer',
      { className: 'fds-c-modal__footer' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'fds-c-modal__footer-cta -align-left' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            className: 'fds-c-button -color-light',
            onClick: closeModal
          },
          'Keep Browsing'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'fds-c-modal__footer-cta -align-right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          {
            className: 'fds-c-button--3d -color-primary',
            href: checkoutPageLink
          },
          'Go to Checkout'
        )
      )
    )
  );
});

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_undefsafe__);



var renderMatrixLicenseSelector = function renderMatrixLicenseSelector(_ref) {
  var itemMatrix = _ref.itemMatrix,
      selectedMatrixLicense = _ref.selectedMatrixLicense,
      onMatrixLicenseChange = _ref.onMatrixLicenseChange;

  var hasExtendedLicense = itemMatrix && Object.keys(itemMatrix).length > 1;
  if (hasExtendedLicense) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'cart-modal__variant-selector__option' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h4',
        { className: 'fds-c-text-heading -size-s' },
        'Select a License'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'select',
        { className: 'fds-c-form-select', defaultValue: selectedMatrixLicense, onChange: onMatrixLicenseChange },
        Object.keys(itemMatrix).map(function (matrix, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'option',
            {
              key: index,
              value: matrix
            },
            __WEBPACK_IMPORTED_MODULE_1_undefsafe___default()(itemMatrix[matrix], 'license_label')
          );
        })
      )
    );
  } else {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h4',
        { className: 'fds-c-text-heading -size-s' },
        'License Available'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: 'fds-c-text-body -size-m' },
        __WEBPACK_IMPORTED_MODULE_1_undefsafe___default()(itemMatrix[selectedMatrixLicense], 'license_label')
      )
    );
  }
};

var renderMatrixSupportSelector = function renderMatrixSupportSelector(_ref2) {
  var itemMatrix = _ref2.itemMatrix,
      selectedMatrixLicense = _ref2.selectedMatrixLicense,
      selectedMatrixSupport = _ref2.selectedMatrixSupport,
      onMatrixSupportChange = _ref2.onMatrixSupportChange;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'cart-modal__variant-selector__option' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h4',
      { className: 'fds-c-text-heading -size-s' },
      'Select support duration'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'select',
      { className: 'fds-c-form-select', defaultValue: selectedMatrixSupport, onChange: onMatrixSupportChange },
      Object.keys(itemMatrix[selectedMatrixLicense].support).map(function (supportName, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'option',
          { key: index, value: supportName },
          itemMatrix[selectedMatrixLicense].support[supportName].label
        );
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (function (_ref3) {
  var itemMatrix = _ref3.itemMatrix,
      selectedMatrixLicense = _ref3.selectedMatrixLicense,
      selectedMatrixSupport = _ref3.selectedMatrixSupport,
      onMatrixLicenseChange = _ref3.onMatrixLicenseChange,
      onMatrixSupportChange = _ref3.onMatrixSupportChange;

  var hasItemSupport = itemMatrix && Object.keys(itemMatrix).some(function (license) {
    var support = itemMatrix[license].support;

    return Object.keys(support).some(function (supportName) {
      return support[supportName] && supportName !== 'none';
    });
  });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'fds-c-modal__section fds-u-text-align-center fds-u-p3 cart-modal__variant-selector' },
    renderMatrixLicenseSelector({
      itemMatrix: itemMatrix,
      selectedMatrixLicense: selectedMatrixLicense,
      onMatrixLicenseChange: onMatrixLicenseChange
    }),
    hasItemSupport && renderMatrixSupportSelector({
      itemMatrix: itemMatrix,
      selectedMatrixLicense: selectedMatrixLicense,
      selectedMatrixSupport: selectedMatrixSupport,
      onMatrixSupportChange: onMatrixSupportChange
    })
  );
});

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_utils_formatString__ = __webpack_require__(56);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var ItemSupportUpgrade = function (_React$Component) {
  _inherits(ItemSupportUpgrade, _React$Component);

  function ItemSupportUpgrade(props) {
    _classCallCheck(this, ItemSupportUpgrade);

    var _this = _possibleConstructorReturn(this, (ItemSupportUpgrade.__proto__ || Object.getPrototypeOf(ItemSupportUpgrade)).call(this, props));

    _this.state = {
      isExtendedSupportSelected: false,
      isUpdatingSupport: false
    };
    _this.onExtendedSupportSelectChange = _this.onExtendedSupportSelectChange.bind(_this);
    return _this;
  }

  _createClass(ItemSupportUpgrade, [{
    key: 'onExtendedSupportSelectChange',
    value: function onExtendedSupportSelectChange(event) {
      var _this2 = this;

      var _props = this.props,
          editCartEntry = _props.editCartEntry,
          cartEntry = _props.cartEntry,
          updateMatrixSupport = _props.updateMatrixSupport;

      this.setState({
        isExtendedSupportSelected: !this.state.isExtendedSupportSelected,
        isUpdatingSupport: true
      }, function () {
        var updatedSupportType = _this2.state.isExtendedSupportSelected ? 'bundle_12month' : 'bundle_6month';
        editCartEntry(cartEntry.id, _extends({}, cartEntry, {
          support_key: updatedSupportType
        })).then(function (action) {
          _this2.setState({
            isUpdatingSupport: false
          }, function () {
            updateMatrixSupport(updatedSupportType);
          });
        }).catch(function () {
          _this2.setState({
            isUpdatingSupport: false
          });
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          selectedMatrixLicense = _props2.selectedMatrixLicense,
          itemMatrix = _props2.itemMatrix;
      var _state = this.state,
          isExtendedSupportSelected = _state.isExtendedSupportSelected,
          isUpdatingSupport = _state.isUpdatingSupport;


      var selectedLicenseSupport = itemMatrix[selectedMatrixLicense].support;

      var bundle12MonthPrice = selectedLicenseSupport['bundle_12month'].price;
      var bundle6MonthPrice = selectedLicenseSupport['bundle_6month'].price;
      var priceVariation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_utils_formatString__["c" /* getPriceVariation */])(bundle6MonthPrice, bundle12MonthPrice);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'fds-c-modal__section' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'cart-modal__item-support' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            { 'for': 'support' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
              className: 'fds-c-form-checkbox fds-u-mr1',
              type: 'checkbox',
              name: 'support',
              disabled: isUpdatingSupport,
              checked: isExtendedSupportSelected,
              onChange: this.onExtendedSupportSelectChange
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              'Extend support to 12 months. ',
              priceVariation
            )
          )
        )
      );
    }
  }]);

  return ItemSupportUpgrade;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ItemSupportUpgrade);

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createNewCollectionForm__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__addItemToCollectionList__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils_errors__ = __webpack_require__(16);






/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var item = _ref.openModalData.item,
      collections = _ref.collections,
      modalMessages = _ref.modalMessages,
      deleteBookmark = _ref.deleteBookmark,
      addBookmark = _ref.addBookmark,
      showModalMessage = _ref.showModalMessage,
      dismissModalMessage = _ref.dismissModalMessage,
      createCollection = _ref.createCollection,
      closeModal = _ref.closeModal;

  var onCloseClick = function onCloseClick(event) {
    event.preventDefault();
    closeModal();
  };

  var onToggleItemInCollectionModal = function onToggleItemInCollectionModal(event, collection, item) {
    event.preventDefault();
    var isItemInCollection = !!collection.bookmarks[item.id];
    if (isItemInCollection) {
      var bookmark = collections[collection.id].bookmarks[item.id];
      if (bookmark.id && bookmark.optimisticStatus !== 'pending') {
        deleteBookmark(collection.id, item.id, bookmark.id);
      }
    } else {
      addBookmark(collection.id, item.id);
    }
  };

  var onCreateNewCollectionFormSubmit = function onCreateNewCollectionFormSubmit(collectionName, collectionIsPublic) {
    return createCollection({
      name: collectionName,
      isPublic: collectionIsPublic
    }).then(function (action) {
      if (action && action.type === 'createCollectionSuccess') {
        dismissModalMessage();
        var newColectionId = action.payload.id;
        return addBookmark(newColectionId, item.id);
      }
    }).catch(__WEBPACK_IMPORTED_MODULE_3__common_utils_errors__["a" /* logError */]);
  };

  var renderCollectionList = function renderCollectionList(collections) {
    var collectionsIDsWithoutFavouriteCollection = Object.keys(collections).filter(function (collectionId) {
      return collections[collectionId].special_role !== 'favorite';
    });

    return collectionsIDsWithoutFavouriteCollection.length > 0 ? collectionsIDsWithoutFavouriteCollection.map(function (collectionId) {
      return collections[collectionId];
    }).map(function (collection, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__addItemToCollectionList__["a" /* default */], {
        collection: collection,
        item: item,
        index: index,
        key: index,
        onToggleItemInCollectionModal: onToggleItemInCollectionModal
      });
    }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'li',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: 'fds-c-text-body -size-s -color-mid fds-u-mt4 fds-u-text-align-center' },
        'You have no Collections yet'
      )
    );
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'fds-c-modal -width-m modal' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'header',
      { className: 'fds-c-modal__header' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h2',
        { className: 'fds-c-text-heading -size-m fds-u-mb1' },
        'Add this Item to a Collection'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: 'fds-c-text-body -size-s -weight-bold' },
        item.name
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { title: 'Close', className: 'fds-c-modal__close', onClick: onCloseClick },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'i',
          { className: 'fds-c-icon -icon-cancel -color-grey-medium -size-small' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'fds-c-icon__alt' },
            'Close'
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'fds-c-modal__section -padding-none -height-scroll collection__list' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        { className: 'fds-c-text-list -style-none' },
        renderCollectionList(collections)
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__createNewCollectionForm__["a" /* default */], {
      onCreateNewCollectionFormSubmit: onCreateNewCollectionFormSubmit,
      modalMessages: modalMessages,
      dismissModalMessage: dismissModalMessage,
      showModalMessage: showModalMessage
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'footer',
      { className: 'fds-c-modal__footer' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: '' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'fds-c-text-body -size-s fds-u-mb0 fds-u-mt1' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { href: '/collections/manage', className: 'fds-c-text-link -weight-normal -decoration-none' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fds-c-icon -icon-cog' }),
            ' Manage my Collections'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { href: '#', className: 'fds-c-button--3d -color-primary', onClick: onCloseClick },
        'Great, I\'m done'
      )
    )
  );
});

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_actions_layout__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_actions_user_collection__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_actions_user_bookmark__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_selectors_user__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__addItemToCollection__ = __webpack_require__(578);








var mapStateToProps = function mapStateToProps(state) {
  var modalMessages = state.layout.modalMessages;


  return {
    collections: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_selectors_user__["a" /* getUserCollections */])(state),
    modalMessages: modalMessages
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    closeModal: function closeModal() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_actions_layout__["d" /* closeModal */])());
    },
    dismissModalMessage: function dismissModalMessage() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_actions_layout__["e" /* dismissModalMessage */])());
    },
    deleteBookmark: function deleteBookmark(collectionID, itemID, id) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_actions_user_bookmark__["a" /* deleteBookmark */])(collectionID, itemID, id));
    },
    addBookmark: function addBookmark(collectionId, itemId) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_actions_user_bookmark__["b" /* addBookmark */])(collectionId, itemId));
    },
    createCollection: function createCollection(payload) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_actions_user_collection__["b" /* createCollection */])(payload));
    },
    showModalMessage: function showModalMessage(message) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_actions_layout__["b" /* showModalMessage */])(message));
    }
  };
};

var AddItemToCollectionContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__addItemToCollection__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AddItemToCollectionContainer);

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var AddItemToCollectionList = function (_React$Component) {
  _inherits(AddItemToCollectionList, _React$Component);

  function AddItemToCollectionList(props) {
    _classCallCheck(this, AddItemToCollectionList);

    var _this = _possibleConstructorReturn(this, (AddItemToCollectionList.__proto__ || Object.getPrototypeOf(AddItemToCollectionList)).call(this, props));

    _this.state = {
      showSaved: false
    };
    return _this;
  }

  _createClass(AddItemToCollectionList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var _props = this.props,
          item = _props.item,
          collection = _props.collection;

      var currentBookmarkState = collection.bookmarks[item.id];
      var newBookmarkState = nextProps.collection.bookmarks[item.id];
      var bookmarkRemoved = currentBookmarkState && !newBookmarkState;
      var bookmarkAdded = !currentBookmarkState && newBookmarkState;
      if (bookmarkAdded || bookmarkRemoved) {
        this.setState({
          showSaved: true
        });
        setTimeout(function () {
          _this2.setState({
            showSaved: false
          });
        }, 500);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          collection = _props2.collection,
          item = _props2.item,
          onToggleItemInCollectionModal = _props2.onToggleItemInCollectionModal,
          index = _props2.index;
      var showSaved = this.state.showSaved;


      var collectionIconClassName = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('fds-c-icon fds-u-mr1', collection.bookmarks[item.id] ? '-color-blue' : '-color-grey-dark', collection.bookmarks[item.id] ? '-icon-ok' : '-icon-plus');
      var collectionItemStyle = {
        background: collection.bookmarks[item.id] ? '#e5f2f7' : '#fff',
        padding: '8px 16px',
        marginTop: index === 0 ? '8px' : '0px',
        marginBottom: '8px',
        fontSize: '14px'
      };
      var collectionItemLinkStyle = {
        display: 'block'
      };
      var flashMessageStyle = {
        position: 'absolute',
        right: '20px',
        color: '#0084b4'
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        {
          className: 'fds-c-text-body',
          style: collectionItemStyle
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          {
            href: '/collections/' + collection.id + '/bookmarks?item_id=' + item.id,
            onClick: function onClick(event) {
              return onToggleItemInCollectionModal(event, collection, item);
            },
            className: 'fds-c-text-link -color-dark -weight-bold -decoration-none',
            style: collectionItemLinkStyle,
            rel: 'nofollow',
            title: 'Add to Collection ' + collection.name
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: collectionIconClassName }),
          ' ',
          collection.name,
          showSaved && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { style: flashMessageStyle },
            'saved'
          )
        )
      );
    }
  }]);

  return AddItemToCollectionList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (AddItemToCollectionList);

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_radio_group__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_radio_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_radio_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils_errors__ = __webpack_require__(16);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var CreateNewCollectionForm = function (_React$Component) {
  _inherits(CreateNewCollectionForm, _React$Component);

  function CreateNewCollectionForm(props) {
    _classCallCheck(this, CreateNewCollectionForm);

    var _this = _possibleConstructorReturn(this, (CreateNewCollectionForm.__proto__ || Object.getPrototypeOf(CreateNewCollectionForm)).call(this, props));

    _this.state = {
      shouldShowMore: false,
      collectionIsPublic: 'false',
      collectionName: ''
    };
    _this.onVisibleInputChange = _this.onVisibleInputChange.bind(_this);
    _this.onAddNewCollection = _this.onAddNewCollection.bind(_this);
    _this.onCollectionNameInputChange = _this.onCollectionNameInputChange.bind(_this);
    _this.showMore = _this.showMore.bind(_this);
    _this.showLess = _this.showLess.bind(_this);
    return _this;
  }

  _createClass(CreateNewCollectionForm, [{
    key: 'onVisibleInputChange',
    value: function onVisibleInputChange(value) {
      this.setState({
        collectionIsPublic: value
      });
    }
  }, {
    key: 'onCollectionNameInputChange',
    value: function onCollectionNameInputChange(event) {
      this.setState({
        collectionName: event.target.value
      });
    }
  }, {
    key: 'showMore',
    value: function showMore() {
      this.setState({
        shouldShowMore: true
      });
    }
  }, {
    key: 'showLess',
    value: function showLess(event) {
      if (event) event.preventDefault();
      // clean up modal messages when toggle the form section
      var dismissModalMessage = this.props.dismissModalMessage;

      dismissModalMessage();
      this.setState({
        shouldShowMore: false,
        collectionName: ''
      });
    }
  }, {
    key: 'onAddNewCollection',
    value: function onAddNewCollection(event) {
      var _this2 = this;

      var _state = this.state,
          collectionIsPublic = _state.collectionIsPublic,
          collectionName = _state.collectionName;
      var _props = this.props,
          onCreateNewCollectionFormSubmit = _props.onCreateNewCollectionFormSubmit,
          showModalMessage = _props.showModalMessage;

      event.preventDefault();

      if (!collectionName || collectionName === '') {
        showModalMessage({
          type: 'error',
          message: 'You need to name your collection.'
        });
      } else {
        onCreateNewCollectionFormSubmit(collectionName, collectionIsPublic).then(function (action) {
          if (action && action.type === 'addBookmarkSuccess') {
            _this2.setState({
              collectionName: '',
              shouldShowMore: false
            });
          }
        }).catch(__WEBPACK_IMPORTED_MODULE_2__common_utils_errors__["a" /* logError */]);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state2 = this.state,
          collectionIsPublic = _state2.collectionIsPublic,
          shouldShowMore = _state2.shouldShowMore,
          collectionName = _state2.collectionName;
      var modalMessages = this.props.modalMessages;

      var fromGroupStyle = {
        margin: '16px 0'
      };
      var radioLabelStyle = {
        margin: '0 16px 8px 0'
      };
      var radioInputStyle = {
        marginRight: '8px'
      };
      var whatsThisLinkStyle = {
        fontSize: '11px'
      };
      var cancelButtonStyle = {
        marginLeft: '16px',
        color: '#bababa'
      };
      var messageStyle = {
        margin: '16px 0',
        background: '#c24242',
        color: '#fff',
        padding: '10px',
        display: 'block',
        lineHeight: '10px',
        borderRadius: '2px'
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'fds-c-modal__section' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: '' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'fds-c-text-heading -size-s' },
            'Create a new Collection'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'form',
            { className: 'fds-c-form -layout-vertical-inline', onSubmit: this.onAddNewCollection },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: fromGroupStyle, className: 'fds-c-form__group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                className: 'fds-c-form-input -type-string -width-full',
                id: 'bookmark_form_name',
                name: 'bookmark_form[name]',
                placeholder: 'Choose a name that is meaningful and descriptive',
                onClick: this.showMore,
                value: collectionName,
                onChange: this.onCollectionNameInputChange,
                type: 'text' })
            ),
            shouldShowMore && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              modalMessages && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: messageStyle, className: 'fds-c-form__group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: '-size-m -color-mid' },
                  modalMessages.message || 'There was an error creating your collection. Please try again.'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: fromGroupStyle, className: 'fds-c-form__group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_1_react_radio_group__["RadioGroup"],
                  { name: 'bookmark_form[publically_visible]', selectedValue: collectionIsPublic, onChange: this.onVisibleInputChange },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    { style: radioLabelStyle },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_radio_group__["Radio"], { style: radioInputStyle, value: 'false' }),
                    'Keep it private'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    { style: radioLabelStyle },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_radio_group__["Radio"], { style: radioInputStyle, value: 'true' }),
                    'Make it public'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: fromGroupStyle, className: 'fds-c-form__group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { style: whatsThisLinkStyle, className: 'fds-c-text-link -weight-normal -color-dark -decoration-none', href: 'https://help.market.envato.com/hc/en-us/articles/202821260', target: '_blank' },
                  'What\'s this?'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: fromGroupStyle, className: 'fds-c-form__group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'fds-c-button--3d -color-primary', type: 'submit', value: 'Add new collection' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { href: '#', style: cancelButtonStyle, className: 'fds-c-text-link -color-dark -decoration-none fds-u-mt1', onClick: this.showLess },
                  'Cancel'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return CreateNewCollectionForm;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (CreateNewCollectionForm);

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__collection_addItemToCollectionContainer__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cart_addItemToCartContainer__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_signInContainer__ = __webpack_require__(584);







/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var isModalOpen = _ref.isModalOpen,
      closeModal = _ref.closeModal,
      openModalType = _ref.openModalType,
      openModalData = _ref.openModalData;

  var renderModalContent = function renderModalContent() {
    switch (openModalType) {
      case 'addItemToCollection':
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__collection_addItemToCollectionContainer__["a" /* default */], {
          openModalData: openModalData,
          closeModal: closeModal
        });

      case 'addItemToCart':
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__cart_addItemToCartContainer__["a" /* default */], {
          openModalData: openModalData
        });

      case 'signIn':
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__user_signInContainer__["a" /* default */], {
          closeModal: closeModal,
          openModalData: openModalData
        });

      default:
        return null;
    }
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_modal___default.a,
    {
      isOpen: isModalOpen,
      onRequestClose: closeModal,
      contentLabel: 'Modal',
      className: 'ReactModal__Content',
      overlayClassName: 'ReactModal__Overlay'
    },
    renderModalContent()
  );
});

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_google_recaptcha__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_google_recaptcha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_google_recaptcha__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils_assetsPath__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__signIn_module_css__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__signIn_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__signIn_module_css__);








var SignInModal = function SignInModal(_ref) {
  var showReCAPTCHA = _ref.showReCAPTCHA,
      show2FA = _ref.show2FA,
      showUsernameMissing = _ref.showUsernameMissing,
      showPasswordMissing = _ref.showPasswordMissing,
      showServerError = _ref.showServerError,
      showLoading = _ref.showLoading,
      data = _ref.data,
      passwordErrorMsg = _ref.passwordErrorMsg,
      twoFAErrorMsg = _ref.twoFAErrorMsg,
      openModalData = _ref.openModalData,
      onSubmit = _ref.onSubmit,
      onInputChange = _ref.onInputChange,
      onReCAPTCHAChange = _ref.onReCAPTCHAChange,
      recaptchaKey = _ref.recaptchaKey;
  var welcomeMsg = openModalData.welcomeMsg,
      welcomeMsgDescription = openModalData.welcomeMsgDescription;

  var logoAssetsPath = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_utils_assetsPath__["a" /* default */])() + '/images/envato_white.svg';
  var modalClassNames = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('fds-c-modal', '-width-s', {
    'is-disabled-loading': showLoading
  });

  // apply invalid status to form when either is missing or wrong details
  var usernameInputStatus = showUsernameMissing || passwordErrorMsg ? 'invalid' : null;
  var passwordInputStatus = showPasswordMissing || passwordErrorMsg ? 'invalid' : null;
  var twoFAInputStats = twoFAErrorMsg ? 'invalid' : null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: modalClassNames },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'header',
      { className: 'fds-c-modal__header fds-u-text-align-center fds-c-modal__section -background-dark' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'fds-u-py1' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
          alt: 'Envato',
          width: '130',
          src: logoAssetsPath
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'fds-c-modal__section -radius-bottom' },
      welcomeMsg && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h2',
        { className: 'fds-c-text-heading fds-u-text-align-center -size-s fds-u-mb0 fds-u-pt2 fds-u-pb2' },
        welcomeMsg
      ),
      welcomeMsgDescription && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: 'fds-c-text-body fds-u-text-align-center -size-s fds-u-mb0 fds-u-pb2' },
        welcomeMsgDescription
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'form',
        {
          acceptCharset: 'UTF-8',
          onSubmit: onSubmit,
          className: 'fds-c-form -layout-vertical-inline',
          noValidate: true
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'fds-c-form__group fds-u-text-align-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_4__signIn_module_css___default.a.formLabelInlineGroup },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __WEBPACK_IMPORTED_MODULE_4__signIn_module_css___default.a.formLabel },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Username'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  className: 'fds-c-text-link -decoration-none',
                  href: 'https://account.envato.com/recover_usernames'
                },
                'Remind me'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'fds-c-form__input' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
              autoFocus: true,
              tabIndex: 1,
              'data-status': usernameInputStatus,
              defaultValue: data.username,
              onChange: onInputChange('username'),
              name: 'username',
              className: 'fds-c-form-input -type-string',
              size: '50',
              type: 'text',
              required: true
            })
          ),
          showUsernameMissing && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { id: 'missing-username', className: __WEBPACK_IMPORTED_MODULE_4__signIn_module_css___default.a.formResponse },
            'Username is required'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'fds-c-form__group fds-u-text-align-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_4__signIn_module_css___default.a.formLabelInlineGroup },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __WEBPACK_IMPORTED_MODULE_4__signIn_module_css___default.a.formLabel },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Password'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                {
                  className: 'fds-c-text-link -decoration-none',
                  href: 'https://account.envato.com/reset_password'
                },
                'Reset'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'fds-c-form__input' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
              tabIndex: 2,
              'data-status': passwordInputStatus,
              defaultValue: data.password,
              onChange: onInputChange('password'),
              name: 'password',
              className: 'fds-c-form-input -type-string',
              size: '50',
              type: 'password',
              required: true
            })
          ),
          showPasswordMissing && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { id: 'missing-password', className: __WEBPACK_IMPORTED_MODULE_4__signIn_module_css___default.a.formResponse },
            'Password is required'
          ),
          passwordErrorMsg && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { id: 'password-error', className: 'fds-c-form__response' },
            passwordErrorMsg
          )
        ),
        showReCAPTCHA && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { id: 'recaptcha', className: 'fds-c-form__group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_4__signIn_module_css___default.a.captcha },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_google_recaptcha___default.a, {
              sitekey: recaptchaKey,
              onChange: onReCAPTCHAChange
            })
          )
        ),
        show2FA && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { id: 'two-fa', className: 'fds-c-form__group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_4__signIn_module_css___default.a.formLabelInlineGroup },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __WEBPACK_IMPORTED_MODULE_4__signIn_module_css___default.a.formLabel },
              'Authentication Code'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'fds-c-form__input fds-u-text-align-center' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
              'data-status': twoFAInputStats,
              defaultValue: data.authentication_code,
              onChange: onInputChange('authentication_code'),
              name: 'twoFactor',
              className: 'fds-c-form-input -type-string',
              size: '50',
              type: 'text'
            })
          ),
          twoFAErrorMsg && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'fds-c-form__response fds-u-text-align-center' },
            twoFAErrorMsg
          )
        ),
        showServerError && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { id: 'server-error', className: 'fds-c-form__group  fds-u-text-align-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'fds-c-form__response' },
            'Whoops! Something went wrong.',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            'Please try again or sign in via this ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: 'https://account.envato.com/' },
              'link'
            ),
            '.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'fds-u-text-align-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              tabIndex: 3,
              disabled: showLoading,
              type: 'submit',
              className: 'fds-c-button--3d -color-primary -size-m'
            },
            'Sign in to your account'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'fds-u-text-align-center fds-u-mt2 fds-u-mb3' },
          'New here? ',
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            {
              className: 'fds-c-text-link -decoration-none',
              href: 'https://account.envato.com/'
            },
            'Create an Envato account'
          )
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SignInModal);

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__signIn__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_config__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__signInHelper__ = __webpack_require__(585);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var recaptchaKey = __WEBPACK_IMPORTED_MODULE_2__common_config__["a" /* default */].sso.RECAPTCHA_KEY;

var SignInModalContainer = function (_React$Component) {
  _inherits(SignInModalContainer, _React$Component);

  function SignInModalContainer(props) {
    _classCallCheck(this, SignInModalContainer);

    var _this = _possibleConstructorReturn(this, (SignInModalContainer.__proto__ || Object.getPrototypeOf(SignInModalContainer)).call(this, props));

    _this.state = {
      showReCAPTCHA: false,
      show2FA: false,
      showLoading: false,
      showUsernameMissing: false,
      showPasswordMissing: false,
      showServerError: false,
      data: {
        username: null,
        password: null,
        to: props.openModalData.currentSite,
        authentication_code: null
      },
      passwordErrorMsg: null,
      twoFAErrorMsg: null
    };

    _this.onInputChange = _this.onInputChange.bind(_this);
    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.onReCAPTCHAChange = _this.onReCAPTCHAChange.bind(_this);
    return _this;
  }

  _createClass(SignInModalContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var closeModal = this.props.closeModal;
      var _props$openModalData = this.props.openModalData,
          onSignInSuccess = _props$openModalData.onSignInSuccess,
          currentSite = _props$openModalData.currentSite;

      this.setState({
        showLoading: true
      });
      var payload = {
        to: currentSite
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__signInHelper__["a" /* autoSignIn */])(payload, {
        handleAutoSignInSuccess: function handleAutoSignInSuccess(token) {
          onSignInSuccess(token).then(function () {
            _this2.setState({
              showLoading: false
            });
            closeModal();
          });
        },
        handleAutoSignInError: function handleAutoSignInError() {
          _this2.setState({
            showLoading: false
          });
        }
      });
    }
  }, {
    key: 'onReCAPTCHAChange',
    value: function onReCAPTCHAChange(recaptchaResponse) {
      this.setState({
        data: _extends({}, this.state.data, {
          recaptcha_version: '2',
          recaptcha_site_key: recaptchaKey,
          recaptcha_response: recaptchaResponse
        })
      });
    }
  }, {
    key: 'onInputChange',
    value: function onInputChange(name) {
      var _this3 = this;

      return function (event) {
        _this3.setState({
          data: _extends({}, _this3.state.data, _defineProperty({}, name, event.target.value))
        });
      };
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit(event) {
      var _this4 = this;

      var closeModal = this.props.closeModal;
      var data = this.state.data;
      var onSignInSuccess = this.props.openModalData.onSignInSuccess;

      event.preventDefault();

      // reset form state on submit
      this.setState({
        showLoading: true,
        showReCAPTCHA: false,
        show2FA: false,
        showUsernameMissing: false,
        showPasswordMissing: false,
        showServerError: false,
        data: _extends({}, this.state.data, {
          recaptcha_version: null,
          recaptcha_site_key: null,
          recaptcha_response: null,
          authentication_code: null
        }),
        passwordErrorMsg: null,
        twoFAErrorMsg: null
      });

      if (!data.username) {
        this.setState({
          showLoading: false,
          showUsernameMissing: true
        });
        return;
      }

      if (!data.password) {
        this.setState({
          showLoading: false,
          showPasswordMissing: true
        });
        return;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__signInHelper__["b" /* handleSubmit */])(data, {
        handleSignInSuccess: function handleSignInSuccess(token) {
          onSignInSuccess(token).then(function () {
            _this4.setState({
              showLoading: false
            });
            closeModal();
          });
        },
        handleSignInError: function handleSignInError() {
          _this4.setState({
            showLoading: false,
            showServerError: true
          });
        },
        handlePassword: function handlePassword(data) {
          _this4.setState({
            showLoading: false,
            passwordErrorMsg: data.error_message || 'Whoops! Something went wrong.'
          });
        },
        handleCaptcha: function handleCaptcha(data) {
          if (data.error_message) {
            _this4.setState({
              showLoading: false,
              showReCAPTCHA: true,
              passwordErrorMsg: data.error_message || 'Whoops! Something went wrong.'
            });
          } else {
            _this4.setState({
              showLoading: false,
              showReCAPTCHA: true
            });
          }
        },
        handle2FA: function handle2FA(data) {
          if (data.error_message) {
            _this4.setState({
              showLoading: false,
              show2FA: true,
              twoFAErrorMsg: data.error_message
            });
          } else {
            _this4.setState({
              showLoading: false,
              show2FA: true
            });
          }
        },
        handleSignInVerification: function handleSignInVerification(data) {
          if (data.redirect) {
            window.location = data.redirect;
          }
          _this4.setState({
            showLoading: false
          });
        },
        handlePasswordReset: function handlePasswordReset(data) {
          if (data.redirect) {
            window.location = data.redirect;
          }
          _this4.setState({
            showLoading: false
          });
        },
        handleEmailConfirmation: function handleEmailConfirmation(data) {
          if (data.redirect) {
            window.location = data.redirect;
          }
          _this4.setState({
            showLoading: false
          });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          showReCAPTCHA = _state.showReCAPTCHA,
          show2FA = _state.show2FA,
          showUsernameMissing = _state.showUsernameMissing,
          showPasswordMissing = _state.showPasswordMissing,
          showServerError = _state.showServerError,
          showLoading = _state.showLoading,
          data = _state.data,
          passwordErrorMsg = _state.passwordErrorMsg,
          twoFAErrorMsg = _state.twoFAErrorMsg;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__signIn__["a" /* default */], {
        showReCAPTCHA: showReCAPTCHA,
        show2FA: show2FA,
        showUsernameMissing: showUsernameMissing,
        showPasswordMissing: showPasswordMissing,
        showServerError: showServerError,
        showLoading: showLoading,
        data: data,
        passwordErrorMsg: passwordErrorMsg,
        twoFAErrorMsg: twoFAErrorMsg,
        openModalData: this.props.openModalData,
        onSubmit: this.onSubmit,
        onInputChange: this.onInputChange,
        onReCAPTCHAChange: this.onReCAPTCHAChange,
        recaptchaKey: recaptchaKey
      });
    }
  }]);

  return SignInModalContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (SignInModalContainer);

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleSubmit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return autoSignIn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_omitBy__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_omitBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_omitBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils_ssoRequest__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_config__ = __webpack_require__(46);







var ssoHost = __WEBPACK_IMPORTED_MODULE_4__common_config__["a" /* default */].sso.SERVER_HOST;

var handleSubmit = function handleSubmit(data, _ref) {
  var handleSignInSuccess = _ref.handleSignInSuccess,
      handleSignInError = _ref.handleSignInError,
      handlePassword = _ref.handlePassword,
      handleCaptcha = _ref.handleCaptcha,
      handle2FA = _ref.handle2FA,
      handleSignInVerification = _ref.handleSignInVerification,
      handlePasswordReset = _ref.handlePasswordReset,
      handleEmailConfirmation = _ref.handleEmailConfirmation;

  // remove empty form field
  var formData = __WEBPACK_IMPORTED_MODULE_2_lodash_omitBy___default()(data, function (value) {
    return !value;
  });
  var payload = __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.stringify(formData);

  __WEBPACK_IMPORTED_MODULE_3__common_utils_ssoRequest__["a" /* default */].post(ssoHost + '/sign_in', payload, { withCredentials: true }).then(function (response) {
    var data = response.data;

    if (data && data.state) {
      switch (data.state) {
        case 'ok':
          var token = data.token;
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/jwt_session', {
            token: token
          }).then(function (response) {
            var token = response.data.token;

            handleSignInSuccess(token);
          }).catch(function (err) {
            handleSignInError(err);
          });
          break;
        case 'password':
          handlePassword(data);
          break;
        case 'captcha':
          handleCaptcha(data);
          break;
        case 'two_factor':
          handle2FA(data);
          break;
        case 'sign_in_verification':
          handleSignInVerification(data);
          break;
        case 'password_reset_required':
          handlePasswordReset(data);
          break;
        case 'email_confirmation_required':
          handleEmailConfirmation(data);
          break;
      }
    }
  }).catch(function (error) {
    handleSignInError(error);
  });
};

var autoSignIn = function autoSignIn(payload, _ref2) {
  var handleAutoSignInSuccess = _ref2.handleAutoSignInSuccess,
      handleAutoSignInError = _ref2.handleAutoSignInError;

  var data = __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.stringify(payload);
  __WEBPACK_IMPORTED_MODULE_3__common_utils_ssoRequest__["a" /* default */].post(ssoHost + '/api/auto_sign_in', data, {
    withCredentials: true
  }).then(function (response) {
    var token = response.data.token;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/jwt_session', {
      token: token
    }).then(function (response) {
      var token = response.data.token;

      handleAutoSignInSuccess(token);
    }).catch(function (err) {
      handleAutoSignInError(err);
    });
  });
};

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pageOffSitesMenu__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pageOffLeftSearchBar__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pageOffLeftMenu__ = __webpack_require__(587);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var PageOffCanvasLeft = function (_React$Component) {
  _inherits(PageOffCanvasLeft, _React$Component);

  function PageOffCanvasLeft(props) {
    _classCallCheck(this, PageOffCanvasLeft);

    var _this = _possibleConstructorReturn(this, (PageOffCanvasLeft.__proto__ || Object.getPrototypeOf(PageOffCanvasLeft)).call(this, props));

    _this.state = {
      isSitesMenuOpen: false
    };
    return _this;
  }

  _createClass(PageOffCanvasLeft, [{
    key: 'onMainMenuToggle',
    value: function onMainMenuToggle(event) {
      event.preventDefault();
      this.setState({ isSitesMenuOpen: !this.state.isSitesMenuOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          showLeftOffCanvas = _props.showLeftOffCanvas,
          currentSite = _props.currentSite,
          menuConfig = _props.menuConfig,
          location = _props.location;

      var offCanvasLeftClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('page__off-canvas--left', {
        'page__off-canvas--is-active': showLeftOffCanvas
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: offCanvasLeftClass },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'off-canvas-left' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'off-canvas-left__top' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { href: 'https://market.envato.com/' },
              'Envato Market'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'off-canvas-left__current-site -color-' + currentSite },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { className: 'off-canvas-left__site-logo--' + currentSite },
              currentSite
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { href: '#', onClick: this.onMainMenuToggle.bind(this), className: 'off-canvas-left__current-site-toggle' })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__pageOffSitesMenu__["a" /* default */], { isOpen: this.state.isSitesMenuOpen, currentSite: currentSite }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__pageOffLeftSearchBar__["a" /* default */], { location: location }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__pageOffLeftMenu__["a" /* default */], { items: menuConfig })
        )
      );
    }
  }]);

  return PageOffCanvasLeft;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

PageOffCanvasLeft.propTypes = {
  showLeftOffCanvas: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
  currentSite: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  menuConfig: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (PageOffCanvasLeft);

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_undefsafe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var PageOffLeftMenuItem = function (_React$Component) {
  _inherits(PageOffLeftMenuItem, _React$Component);

  function PageOffLeftMenuItem(props) {
    _classCallCheck(this, PageOffLeftMenuItem);

    var _this = _possibleConstructorReturn(this, (PageOffLeftMenuItem.__proto__ || Object.getPrototypeOf(PageOffLeftMenuItem)).call(this, props));

    _this.state = { isOpen: false };
    return _this;
  }

  _createClass(PageOffLeftMenuItem, [{
    key: 'hasChildren',
    value: function hasChildren() {
      return __WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(this.props.config, 'children.length');
    }
  }, {
    key: 'onLinkClick',
    value: function onLinkClick(event) {
      if (!this.hasChildren()) {
        return;
      }
      event.preventDefault();
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          config = _props.config,
          level = _props.level;
      var isOpen = this.state.isOpen;

      var nextLevel = level + 1;
      var linkClass = __WEBPACK_IMPORTED_MODULE_3_classnames___default()({
        'off-canvas-category-link--empty': level === 1 && !this.hasChildren(),
        'off-canvas-category-link--sub': level > 1 && !this.hasChildren(),
        'off-canvas-category-link': this.hasChildren(),
        'is-open': isOpen
      });
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'li',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'a',
          { href: config.url, onClick: this.onLinkClick.bind(this), className: linkClass },
          config.name + ' ',
          config.isNew ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'e-text-label -size-s -color-grey-light' },
            ' New'
          ) : null
        ),
        this.hasChildren() ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PageOffLeftMenu, { items: config.children, level: nextLevel, isHidden: !isOpen }) : null
      );
    }
  }]);

  return PageOffLeftMenuItem;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

PageOffLeftMenuItem.propTypes = {
  config: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  level: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
};


var PageOffLeftMenu = function PageOffLeftMenu(_ref) {
  var items = _ref.items,
      _ref$level = _ref.level,
      level = _ref$level === undefined ? 1 : _ref$level,
      _ref$isHidden = _ref.isHidden,
      isHidden = _ref$isHidden === undefined ? false : _ref$isHidden;

  var className = isHidden ? 'fds-u-is-hidden' : '';
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'ul',
    { className: className },
    items.map(function (subConfig, index) {
      if (subConfig.divider) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li', { key: index, className: 'off-canvas-category-spacer' });
      } else {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PageOffLeftMenuItem, { key: index, config: subConfig, level: level });
      }
    })
  );
};

PageOffLeftMenu.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired,
  level: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
};

/* harmony default export */ __webpack_exports__["a"] = (PageOffLeftMenu);

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_searchBar_searchBarForm__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_searchBar_searchBarInput__ = __webpack_require__(313);





var PageOffLeftSearchBar = function PageOffLeftSearchBar(_ref) {
  var location = _ref.location;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'off-canvas-left__search' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__components_searchBar_searchBarForm__["a" /* default */],
      { location: location },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { margin: 0, padding: 0, display: 'inline' } }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'search-field -border-none' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'search-field__input' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_searchBar_searchBarInput__["a" /* default */], { value: location.query.term, className: 'search-field__input-field', name: 'term', placeholder: 'Search' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'fds-c-button search-field__button', type: 'submit' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'i',
            { className: 'e-icon -icon-search' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'e-icon__alt' },
              'Search'
            )
          )
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (PageOffLeftSearchBar);

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_constants_siteList__ = __webpack_require__(193);




var PageOffSitesMenu = function PageOffSitesMenu(_ref) {
  var isOpen = _ref.isOpen,
      currentSite = _ref.currentSite;

  var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('off-canvas-left__sites', {
    'fds-u-is-hidden': !isOpen
  });

  var sitesFilter = function sitesFilter(siteName) {
    return [currentSite, 'activeden'].indexOf(siteName) === -1;
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: className },
    __WEBPACK_IMPORTED_MODULE_2__common_constants_siteList__["b" /* siteNames */].filter(sitesFilter).map(function (siteName, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { key: index, href: 'https://' + siteName + '.net/', className: 'off-canvas-left__site' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'off-canvas-left__site-logo--' + siteName },
          siteName
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'e-icon -icon-right-open' })
      );
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (PageOffSitesMenu);

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_sites___ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_constants_userMenuConfig__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils_sites__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils_assetsPath__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_config__ = __webpack_require__(46);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var ssoServerHost = __WEBPACK_IMPORTED_MODULE_7__common_config__["a" /* default */].sso.SERVER_HOST;
var defaultUserImageUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_utils_assetsPath__["a" /* default */])() + __WEBPACK_IMPORTED_MODULE_3__config_sites___["a" /* default */]['defaults'].ui.default_user_image_path;

var PageOffCanvasRight = function (_React$Component) {
  _inherits(PageOffCanvasRight, _React$Component);

  function PageOffCanvasRight() {
    _classCallCheck(this, PageOffCanvasRight);

    return _possibleConstructorReturn(this, (PageOffCanvasRight.__proto__ || Object.getPrototypeOf(PageOffCanvasRight)).apply(this, arguments));
  }

  _createClass(PageOffCanvasRight, [{
    key: 'render',
    value: function render() {
      var offCanvasRightClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('page__off-canvas--right', {
        'page__off-canvas--is-active': this.props.showRightOffCanvas
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: offCanvasRightClass },
        this.renderNav()
      );
    }
  }, {
    key: 'renderNav',
    value: function renderNav() {
      var user = this.props.user;

      var hasUserProfile = user && user.profile;
      return hasUserProfile ? this.renderSignedInNav(user) : this.renderSignedOutNav(user);
    }
  }, {
    key: 'renderMenu',
    value: function renderMenu(config) {
      var user = this.props.user;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'ul',
        null,
        config.map(function (item, index) {
          var iconClassName = item.icon + ' -size-medium -color-grey-dark';
          var userProfileUrl = item.link.replace('{username}', user.profile.username);
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'li',
            { key: index },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { href: userProfileUrl, className: 'off-canvas-right__link' },
              item.name,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: iconClassName })
            )
          );
        })
      );
    }
  }, {
    key: 'renderCartSummary',
    value: function renderCartSummary(cart) {
      var cartEntryCount = cart && cart.entries ? cart.entries.length : '';
      var currentSite = this.props.currentSite;

      var currentSiteDomain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_sites__["a" /* getCurrentSiteDomain */])(currentSite);
      var cartSummaryClassNames = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('shopping-cart-summary', {
        'is-empty': cartEntryCount === 0 || cartEntryCount === ''
      });
      var cartUrl = '//' + currentSiteDomain + '/cart';
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'off-canvas-right__cart' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'a',
          { href: cartUrl, ref: 'nofollow' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: cartSummaryClassNames },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'e-icon -icon-cart -margin-right' }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { className: 'shopping-cart-summary__count' },
              cartEntryCount
            )
          )
        )
      );
    }
  }, {
    key: 'renderSignedInNav',
    value: function renderSignedInNav(user) {
      var currentSite = this.props.currentSite;

      var avatarUrl = user.profile.image ? user.profile.image : defaultUserImageUrl;
      var userProfileUrl = 'https://' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_sites__["a" /* getCurrentSiteDomain */])(currentSite) + '/user/' + user.profile.username;
      var signOutUrl = ssoServerHost + '/sign_out?to=' + currentSite;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'off-canvas-right' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'off-canvas-right__top' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'media' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { href: userProfileUrl, className: 'media__item' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { alt: user.profile.username, className: 'off-canvas-right__avatar', src: avatarUrl })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'media__body' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                {
                  href: userProfileUrl,
                  className: 'off-canvas-right__username'
                },
                user.profile.username
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
              user.profile.balance && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { className: 'off-canvas-right__balance' },
                '$',
                user.profile.balance
              )
            )
          ),
          this.renderCartSummary(user.cart)
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'strong',
          { className: 'off-canvas-right__section-heading' },
          'account'
        ),
        this.renderMenu(__WEBPACK_IMPORTED_MODULE_4__common_constants_userMenuConfig__["a" /* default */].buyer),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'strong',
          { className: 'off-canvas-right__section-heading' },
          'author'
        ),
        user.profile.is_author ? this.renderMenu(__WEBPACK_IMPORTED_MODULE_4__common_constants_userMenuConfig__["a" /* default */].author) : this.renderMenu(__WEBPACK_IMPORTED_MODULE_4__common_constants_userMenuConfig__["a" /* default */].nonAuthor),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'ul',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'li',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { href: signOutUrl, className: 'off-canvas-right__link--logout' },
              'Sign out',
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'e-icon -icon-logout -size-medium -color-white' })
            )
          )
        )
      );
    }
  }, {
    key: 'renderSignedOutNav',
    value: function renderSignedOutNav(user) {
      var currentSite = this.props.currentSite;

      var signUpUrl = ssoServerHost + '/sign_up?to=' + currentSite;
      var signInUrl = ssoServerHost + '/sign_in?to=' + currentSite;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'off-canvas-right' },
        this.renderGuestCartSummary(user.cart),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'a',
          { href: signUpUrl, className: 'off-canvas-right__link' },
          'Create an Envato Account',
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'e-icon -icon-envato' })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'a',
          { href: signInUrl, className: 'off-canvas-right__link', rel: 'nofollow' },
          'Sign In',
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'e-icon -icon-login' })
        )
      );
    }
  }, {
    key: 'renderGuestCartSummary',
    value: function renderGuestCartSummary(cart) {
      var cartEntryCount = cart && cart.entries ? cart.entries.length : '';
      var cartSummaryClassNames = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('shopping-cart-summary', {
        'is-empty': cartEntryCount === 0 || cartEntryCount === ''
      });
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'a',
        { className: 'off-canvas-right__link--cart', href: '/cart', ref: 'nofollow' },
        'Guest Cart',
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: cartSummaryClassNames },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'shopping-cart-summary__count' },
            cartEntryCount
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'e-icon -icon-cart -margin-right' })
        )
      );
    }
  }]);

  return PageOffCanvasRight;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

PageOffCanvasRight.propTypes = {
  currentSite: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  showRightOffCanvas: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
  user: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (PageOffCanvasRight);

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var PageOverlay = function (_React$Component) {
  _inherits(PageOverlay, _React$Component);

  function PageOverlay() {
    _classCallCheck(this, PageOverlay);

    return _possibleConstructorReturn(this, (PageOverlay.__proto__ || Object.getPrototypeOf(PageOverlay)).apply(this, arguments));
  }

  _createClass(PageOverlay, [{
    key: 'toggleOffCanvasNav',
    value: function toggleOffCanvasNav(direction, event) {
      event.preventDefault();
      this.props.toggleOffCanvas(direction);
    }
  }, {
    key: 'render',
    value: function render() {
      var PageOverlayClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('page__overlay', {
        'page__overlay--is-active': this.props.isOffCanvasActive
      });
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: PageOverlayClass, onClick: this.toggleOffCanvasNav.bind(this, 'close') });
    }
  }]);

  return PageOverlay;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

PageOverlay.propTypes = {
  isOffCanvasActive: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
  toggleOffCanvas: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (PageOverlay);

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_url__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_url__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEqual__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_constants_searchQueryWhitelist__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils_fetchAllRequest__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils_ga__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_utils_analytics__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_actions_common__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_actions_user_preference__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_utils_urlHelper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_utils_objectDiff__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_actions_search_trackSiteSearches__ = __webpack_require__(317);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var PendingNavDataLoader = function (_React$Component) {
  _inherits(PendingNavDataLoader, _React$Component);

  function PendingNavDataLoader() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PendingNavDataLoader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PendingNavDataLoader.__proto__ || Object.getPrototypeOf(PendingNavDataLoader)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      previousLocation: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PendingNavDataLoader, [{
    key: 'shouldFetchData',
    value: function shouldFetchData(previousLocation, newLoaction) {
      var previousParsedLocationQuery = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__common_utils_urlHelper__["a" /* parseLocation */])({
        pathname: previousLocation.pathname,
        query: __WEBPACK_IMPORTED_MODULE_3_query_string___default.a.parse(previousLocation.search)
      });
      var newParsedLocationQuery = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__common_utils_urlHelper__["a" /* parseLocation */])({
        pathname: newLoaction.pathname,
        query: __WEBPACK_IMPORTED_MODULE_3_query_string___default.a.parse(newLoaction.search)
      });

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__common_utils_objectDiff__["a" /* default */])(previousParsedLocationQuery, newParsedLocationQuery).some(function (key) {
        return __WEBPACK_IMPORTED_MODULE_5__common_constants_searchQueryWhitelist__["b" /* default */].includes(key);
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      // check whether url has changed
      var navigated = !__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default()(nextProps.location, this.props.location);
      var store = this.props.store;


      var newLocationQuery = __WEBPACK_IMPORTED_MODULE_3_query_string___default.a.parse(nextProps.location.search);

      if (navigated) {
        // https://developers.google.com/analytics/devguides/collection/analyticsjs/pages#overriding
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils_ga__["a" /* default */])('set', 'location', window.location.href);

        // update previous location so we can compare later
        this.setState({
          previousLocation: this.props.location
        });

        // Reset / hide alerts when changing the route after first rendering
        if (store.getState().common.alerts.length) {
          store.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__common_actions_common__["e" /* resetAlerts */])());
        }

        // Reset (remove) error page if present
        if (store.getState().common.errorPage) {
          store.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__common_actions_common__["f" /* resetErrorPage */])());
        }

        if (typeof window !== 'undefined' && newLocationQuery.view) {
          store.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__common_actions_user_preference__["d" /* setUserSearchResultsViewType */])(newLocationQuery.view));
        }

        if (this.shouldFetchData(this.props.location, nextProps.location)) {
          // we have to ge the full location because `matchRoutes` does not return the search query part
          var opts = {
            baseUrl: '',
            isServer: false
          };
          var parsedUrl = __WEBPACK_IMPORTED_MODULE_2_url___default.a.parse(window.location.href);
          var promiseRequests = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_utils_fetchAllRequest__["a" /* default */])(store, parsedUrl, opts);
          var currentSite = this.props.store.getState().common.currentSite;

          Promise.all(promiseRequests).then(function (results) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__common_utils_analytics__["a" /* reportPageView */])();
            if (currentSite === 'photodune') __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__common_actions_search_trackSiteSearches__["a" /* countSearchFor */])(currentSite);
            _this2.setState({
              previousLocation: null
            });
          }).catch(function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__common_utils_analytics__["a" /* reportPageView */])();
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          location = _props.location;
      var previousLocation = this.state.previousLocation;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */], {
        location: previousLocation || location,
        render: function render() {
          return children;
        }
      });
    }
  }]);

  return PendingNavDataLoader;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* withRouter */])(PendingNavDataLoader));

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__itemCard__ = __webpack_require__(187);




var GridDefault = function GridDefault(_ref) {
  var items = _ref.items,
      viewType = _ref.viewType,
      currentSite = _ref.currentSite,
      itemDecorator = _ref.itemDecorator;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'ul',
    { className: 'product-grid' },
    items.map(function (item, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        { key: item.id },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__itemCard__["a" /* default */], {
          currentSite: currentSite,
          viewType: viewType,
          itemProps: itemDecorator(item, index)
        })
      );
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (GridDefault);

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__itemCard__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gridVideo_module_css__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gridVideo_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__gridVideo_module_css__);






var GridVideo = function GridVideo(_ref) {
  var items = _ref.items,
      viewType = _ref.viewType,
      videoMuted = _ref.videoMuted,
      currentSite = _ref.currentSite,
      itemDecorator = _ref.itemDecorator;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'ul',
    { className: __WEBPACK_IMPORTED_MODULE_2__gridVideo_module_css___default.a.grid },
    items.map(function (item, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        { className: __WEBPACK_IMPORTED_MODULE_2__gridVideo_module_css___default.a.result, key: item.id },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__itemCard__["a" /* default */], {
          videoMuted: videoMuted,
          currentSite: currentSite,
          viewType: viewType,
          itemProps: itemDecorator(item, index)
        })
      );
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (GridVideo);

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getFinalViewType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gridDefault__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listDefault__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gridVideo__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils_siteConfig__ = __webpack_require__(70);







/**
 * if a site only has one view type, we force to use it
 * other wise we use the user preference
 * @param  {String} expectedViewType
 * @param  {String} currentSite
 * @return {String} the final view type we use
 */
var getFinalViewType = function getFinalViewType(expectedViewType, currentSite) {
  var siteDefaultViewType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_utils_siteConfig__["a" /* default */])(currentSite, 'default_category_view');
  if (!expectedViewType) return siteDefaultViewType;

  var itemViewsConfig = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_utils_siteConfig__["a" /* default */])(currentSite, 'ui.item_list_views') || [];
  // a few sites only have one view type, we force to use it
  if (itemViewsConfig.length === 1) {
    return itemViewsConfig[0].value;
  } else {
    return expectedViewType;
  }
};

var ProductList = function ProductList(_ref) {
  var items = _ref.items,
      currentSite = _ref.currentSite,
      preferences = _ref.preferences,
      itemDecorator = _ref.itemDecorator;

  var viewType = getFinalViewType(preferences.searchResultsViewType, currentSite);
  var videoMuted = preferences.searchVideoMuted;

  if (viewType === 'grid') {
    if (currentSite === 'videohive') {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__gridVideo__["a" /* default */], {
        items: items,
        viewType: viewType,
        videoMuted: videoMuted,
        currentSite: currentSite,
        itemDecorator: itemDecorator
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__gridDefault__["a" /* default */], {
        items: items,
        viewType: viewType,
        currentSite: currentSite,
        itemDecorator: itemDecorator
      });
    }
  } else {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__listDefault__["a" /* default */], {
      items: items,
      viewType: viewType,
      currentSite: currentSite,
      itemDecorator: itemDecorator
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ProductList);

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__itemCard__ = __webpack_require__(187);




var ListDefault = function ListDefault(_ref) {
  var items = _ref.items,
      viewType = _ref.viewType,
      currentSite = _ref.currentSite,
      itemDecorator = _ref.itemDecorator;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'ul',
    { className: 'product-list' },
    items.map(function (item, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        { key: item.id },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__itemCard__["a" /* default */], {
          currentSite: currentSite,
          viewType: viewType,
          itemProps: itemDecorator(item, index)
        })
      );
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ListDefault);

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_phoenix_socket__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_phoenix_socket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_phoenix_socket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_analytics_searchBarAnalytics__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_constants_autoSuggestEndpoints__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__autosuggest___ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils_urlHelper__ = __webpack_require__(5);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var SearchBarInputComponent = function (_React$Component) {
  _inherits(SearchBarInputComponent, _React$Component);

  function SearchBarInputComponent(props) {
    _classCallCheck(this, SearchBarInputComponent);

    var _this = _possibleConstructorReturn(this, (SearchBarInputComponent.__proto__ || Object.getPrototypeOf(SearchBarInputComponent)).call(this, props));

    _this.state = {
      suggestions: [],
      term: props.value || '',
      socketChannel: null,
      socketConnection: null
    };

    _this.setSuggestions = _this.setSuggestions.bind(_this);
    _this.onInputChange = _this.onInputChange.bind(_this);
    _this.onSelectOption = _this.onSelectOption.bind(_this);
    return _this;
  }

  _createClass(SearchBarInputComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.initSocket();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.closeSocket();
    }
  }, {
    key: 'initSocket',
    value: function initSocket() {
      var _this2 = this;

      var endpoint = __WEBPACK_IMPORTED_MODULE_4__common_constants_autoSuggestEndpoints__["a" /* default */].endpoint,
          channel = __WEBPACK_IMPORTED_MODULE_4__common_constants_autoSuggestEndpoints__["a" /* default */].channel;


      var socketConnection = new __WEBPACK_IMPORTED_MODULE_2_phoenix_socket__["Socket"](endpoint);
      var socketChannel = socketConnection.channel(channel, {});

      this.setState({
        socketChannel: socketChannel,
        socketConnection: socketConnection
      });

      socketConnection.connect();

      socketChannel.on('phx_reply', function (payload) {
        if (payload.status === 'error') {
          console.log('connection to auto suggest service error', payload);
        }
      });

      socketChannel.on('new_msg', function (message) {
        _this2.setSuggestions(message.body);
      });

      socketChannel.join().receive('ok', function () {
        if (_this2.state.term) {
          _this2.sendMessage(_this2.state.term);
        }
      });
    }
  }, {
    key: 'closeSocket',
    value: function closeSocket() {
      if (this.state.socketConnection) {
        this.state.socketConnection.disconnect();
      }
    }
  }, {
    key: 'sendMessage',
    value: function sendMessage() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var currentSite = this.props.currentSite;
      var socketChannel = this.state.socketChannel;


      var message = {
        body: value.trim().toLowerCase(),
        category: null,
        site: currentSite || 'themeforest'
      };

      if (socketChannel && socketChannel.state === 'joined') {
        socketChannel.push('new_msg', message);
      }
    }
  }, {
    key: 'setSuggestions',
    value: function setSuggestions(suggestions) {
      this.setState({
        suggestions: suggestions
      });
    }
  }, {
    key: 'onInputChange',
    value: function onInputChange() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.setState({
        term: value
      });
      this.sendMessage(value);
    }
  }, {
    key: 'onSelectOption',
    value: function onSelectOption(option, event) {
      var _props = this.props,
          location = _props.location,
          history = _props.history;
      var suggestions = this.state.suggestions;

      // if the selection option is a string, we need to build the link

      if (typeof option === 'string') {
        var nextQueries = Object.assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_utils_urlHelper__["a" /* parseLocation */])(location), { term: option });

        // reset page number when change search term
        delete nextQueries.page;

        var link = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_utils_urlHelper__["b" /* makeLink */])(nextQueries);
        option = {
          text: option,
          link: link
        };
        // if the selection option is an object, it means it's triggered by auto-suggest
        // we need to report this to ga
      } else if ((typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_analytics_searchBarAnalytics__["a" /* reportAutoSuggest */])({
          action: event && event.type === 'mousedown' ? 'click' : 'keyboard',
          label: option.text,
          suggestedTerm: suggestions.map(function (suggestion) {
            return suggestion.text;
          })
        });
      }

      this.setState({
        term: option.text
      }, function () {
        history.push(option.link);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          suggestions = _state.suggestions,
          term = _state.term;
      var name = this.props.name;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__autosuggest___["a" /* default */], {
        suggestions: suggestions,
        onInputChange: this.onInputChange,
        placeholder: 'Search within these results',
        onSelectOption: this.onSelectOption,
        inputName: name,
        inputValue: term,
        type: 'search'
      });
    }
  }]);

  return SearchBarInputComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* withRouter */])(SearchBarInputComponent));

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__categoryLink__ = __webpack_require__(528);





var TopLevelMenu = function TopLevelMenu(_ref) {
  var item = _ref.item;

  var hasChildren = item.children.length > 0;
  var isNew = item.isNew;
  var linkClassName = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('-rounded-corners', {
    'header-categories__main-link': hasChildren,
    'header-categories__main-link--empty': !hasChildren,
    'header-categories__main-link--new-label': hasChildren && isNew,
    'header-categories__main-link--empty--new-label': !hasChildren && isNew
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'li',
    { className: 'header-categories__links-item' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__categoryLink__["a" /* default */],
      { to: item.url, className: linkClassName },
      item.name + ' ',
      isNew && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'e-text-label -size-s -color-grey-light' },
        'New'
      )
    ),
    hasChildren && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubLevelMenu, { items: item.children })
  );
};

var SubLevelMenu = function SubLevelMenu(_ref2) {
  var items = _ref2.items;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'header-categories__links-dropdown' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'ul',
      { className: 'hub-header-dropdown' },
      items.map(function (item, key) {
        var isTop = item.isTop;
        var isBottom = item.isBottom;
        var linkClassName = __WEBPACK_IMPORTED_MODULE_1_classnames___default()({
          'hub-header-dropdown__top': isTop,
          'hub-header-dropdown__bottom': isBottom
        });
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { className: linkClassName, key: key },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__categoryLink__["a" /* default */],
            { to: item.url },
            item.name + ' '
          )
        );
      })
    )
  );
};

var CategoriesMenu = function CategoriesMenu(_ref3) {
  var items = _ref3.items;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'ul',
    { className: 'header-categories__links' },
    items.map(function (item, key) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TopLevelMenu, { key: key, item: item });
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (CategoriesMenu);

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils_assetsPath__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_layout_header__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__header_envatoProducts__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__header_adminLink__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__header_cart__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__header_userMenu__ = __webpack_require__(607);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var GlobalHeader = function (_React$Component) {
  _inherits(GlobalHeader, _React$Component);

  function GlobalHeader() {
    _classCallCheck(this, GlobalHeader);

    return _possibleConstructorReturn(this, (GlobalHeader.__proto__ || Object.getPrototypeOf(GlobalHeader)).apply(this, arguments));
  }

  _createClass(GlobalHeader, [{
    key: 'render',
    value: function render() {
      var staticLinks = __WEBPACK_IMPORTED_MODULE_3__config_layout_header__["a" /* default */].staticLinks,
          envatoProducts = __WEBPACK_IMPORTED_MODULE_3__config_layout_header__["a" /* default */].envatoProducts,
          envatoProductsStaticLinks = __WEBPACK_IMPORTED_MODULE_3__config_layout_header__["a" /* default */].envatoProductsStaticLinks;
      var _props = this.props,
          user = _props.user,
          currentSite = _props.currentSite;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'global-header fds-u-hide-extra-large-and-below' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'grid-container -layout-wide' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'global-header__wrapper' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { href: 'https://market.envato.com' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { className: 'global-header__logo',
                alt: 'Envato Market',
                src: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_utils_assetsPath__["a" /* default */])() + '/images/logo-envato-market.svg' })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'nav',
              { className: 'global-header-menu', role: 'navigation' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'ul',
                { className: 'global-header-menu__list' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__header_adminLink__["a" /* default */], { user: user }),
                staticLinks.map(function (staticLink) {
                  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'li',
                    { key: staticLink.label,
                      className: 'global-header-menu__list-item' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'a',
                      { href: staticLink.url,
                        className: 'global-header-menu__link' },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'span',
                        { className: 'global-header-menu__link-text' },
                        staticLink.label
                      )
                    )
                  );
                }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__header_envatoProducts__["a" /* default */], { envatoProducts: envatoProducts, envatoProductsStaticLinks: envatoProductsStaticLinks }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__header_cart__["a" /* default */], { user: user }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__header_userMenu__["a" /* default */], {
                  user: user,
                  currentSite: currentSite
                })
              )
            )
          )
        )
      );
    }
  }]);

  return GlobalHeader;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

GlobalHeader.propTypes = {
  currentSite: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  user: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (GlobalHeader);

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils_userAuthorization__ = __webpack_require__(329);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var AdminLink = function (_React$Component) {
  _inherits(AdminLink, _React$Component);

  function AdminLink() {
    _classCallCheck(this, AdminLink);

    return _possibleConstructorReturn(this, (AdminLink.__proto__ || Object.getPrototypeOf(AdminLink)).apply(this, arguments));
  }

  _createClass(AdminLink, [{
    key: 'render',
    value: function render() {
      var user = this.props.user;


      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_utils_userAuthorization__["a" /* canUser */])(user, 'canViewAdmin')) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'li',
          { className: 'global-header-menu__list-item' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            { href: '/admin', className: 'global-header-menu__link' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { className: 'global-header-menu__link-text' },
              'Admin'
            )
          )
        );
      } else {
        return null;
      }
    }
  }]);

  return AdminLink;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

AdminLink.propTypes = {
  user: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (AdminLink);

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icons_cartReverse__ = __webpack_require__(556);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Cart = function (_React$Component) {
  _inherits(Cart, _React$Component);

  function Cart() {
    _classCallCheck(this, Cart);

    return _possibleConstructorReturn(this, (Cart.__proto__ || Object.getPrototypeOf(Cart)).apply(this, arguments));
  }

  _createClass(Cart, [{
    key: 'render',
    value: function render() {
      var user = this.props.user;

      var cart = user.cart;
      var cartEntryCount = cart && cart.entries ? cart.entries.length : null;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'li',
        { className: 'global-header-menu__list-item -background-light -border-radius' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'a',
          { href: '/cart', className: 'global-header-menu__link fds-u-pr1' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__icons_cartReverse__["a" /* default */], { className: 'global-header-menu__icon',
            width: '16px', height: '16px' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('global-header-menu__link-cart-amount', { 'fds-u-hidden': cartEntryCount === null }) },
            cartEntryCount
          )
        )
      );
    }
  }]);

  return Cart;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

Cart.propTypes = {
  user: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Cart);

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icons_menuDropdown__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils_assetsPath__ = __webpack_require__(81);





/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var envatoProducts = _ref.envatoProducts,
      envatoProductsStaticLinks = _ref.envatoProductsStaticLinks;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'li',
    { className: 'global-header-menu__list-item--with-dropdown' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      { href: '#', className: 'global-header-menu__link' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__icons_menuDropdown__["a" /* default */], { className: 'global-header-menu__icon',
        width: '16px', height: '16px' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'global-header-menu__link-text' },
        'Our Products'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'global-header-menu__dropdown-container' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'global-header-dropdown' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          { className: 'global-header-dropdown__list' },
          envatoProducts.map(function (product) {
            var productLogoPath = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_utils_assetsPath__["a" /* default */])() + product.logo;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              { key: product.key },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { href: product.url,
                  className: 'global-header-dropdown__link',
                  target: '_blank' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'global-header-dropdown__product-logo',
                  src: productLogoPath,
                  alt: product.name }),
                product.description ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'global-header-dropdown__link-text -decoration-none' },
                  product.description
                ) : null
              )
            );
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'global-header-dropdown-footer' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            null,
            envatoProductsStaticLinks.map(function (link) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { key: link.key,
                  className: 'global-header-dropdown-footer__list-item' },
                link.label,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { href: link.url,
                    className: 'global-header-dropdown-footer__link',
                    target: '_blank' },
                  link.linkLabel
                )
              );
            })
          )
        )
      )
    )
  );
});

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var currentSite = _ref.currentSite,
      openModal = _ref.openModal,
      handleSignInSuccess = _ref.handleSignInSuccess;

  var signInUrl = '/sign_in';

  var openSignInModal = function openSignInModal(event) {
    event.preventDefault();
    openModal({
      type: 'signIn',
      payload: {
        currentSite: currentSite,
        onSignInSuccess: handleSignInSuccess,
        welcomeMsg: 'Great to have you back!'
      }
    });
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'li',
    { className: 'global-header-menu__list-item -background-light -border-radius' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      {
        href: signInUrl,
        onClick: openSignInModal,
        className: 'global-header-menu__link fds-u-pl1'
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'global-header-menu__link-text' },
        'Sign In'
      )
    )
  );
});

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__guestMenu__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_actions_layout__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_actions_user__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_actions_user_session__ = __webpack_require__(192);







var mapStateToProps = function mapStateToProps(state) {
  var currentSite = state.common.currentSite;


  return {
    currentSite: currentSite
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    closeModal: function closeModal() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_actions_layout__["d" /* closeModal */])());
    },
    openModal: function openModal(data) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_actions_layout__["a" /* openModal */])(data));
    },
    handleSignInSuccess: function handleSignInSuccess(token) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_actions_user_session__["b" /* getSessionSuccessAction */])(token));
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_actions_user__["b" /* getUserProfile */])(token));
    }
  };
};

var guestMenuContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__guestMenu__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (guestMenuContainer);

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_layout_userMenu__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_utils_userAuthorization__ = __webpack_require__(329);



var parsePath = function parsePath(path, username, site) {
  return path.replace('{{username}}', username).replace('{{currentSite}}', site);
};

var canViewBlock = function canViewBlock(user, block) {
  if (block.requires) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_utils_userAuthorization__["a" /* canUser */])(user, block.requires);
  } else {
    return true;
  }
};

var blockEntriesForUser = function blockEntriesForUser(user, site, entries) {
  return entries.filter(function (entry) {
    if (entry.requires) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_utils_userAuthorization__["a" /* canUser */])(user, entry.requires, site);
    } else {
      return true;
    }
  });
};

var createNewEntry = function createNewEntry(entry, username, site, isLastEntry) {
  var newEntry = {
    path: parsePath(entry.path, username, site),
    label: entry.label,
    isLastEntry: isLastEntry
  };

  if (entry.showCredit) {
    newEntry.showCredit = entry.showCredit;
  }

  if (entry.creditLabel) {
    newEntry.creditLabel = entry.creditLabel;
  }

  return newEntry;
};

/* harmony default export */ __webpack_exports__["a"] = (function (user, site) {
  var username = user.profile.username;

  return __WEBPACK_IMPORTED_MODULE_0__config_layout_userMenu__["a" /* default */].blocks.reduce(function (collection, block) {
    if (canViewBlock(user, block)) {
      if (block.title) {
        collection.push({ title: block.title.replace('{{username}}', username) });
      }

      var entries = blockEntriesForUser(user, site, block.entries);
      var last = entries.pop();

      entries.forEach(function (entry) {
        collection.push(createNewEntry(entry, username, site, false));
      });

      collection.push(createNewEntry(last, username, site, true));
    }

    return collection;
  }, []);
});

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_undefsafe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__menuBuilder__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__icons_user__ = __webpack_require__(565);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var SignedInMenu = function (_React$Component) {
  _inherits(SignedInMenu, _React$Component);

  function SignedInMenu() {
    _classCallCheck(this, SignedInMenu);

    return _possibleConstructorReturn(this, (SignedInMenu.__proto__ || Object.getPrototypeOf(SignedInMenu)).apply(this, arguments));
  }

  _createClass(SignedInMenu, [{
    key: 'blockTitle',
    value: function blockTitle(entry) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'li',
        { key: entry.title, className: 'global-header-dropdown__list-title' },
        entry.title
      );
    }
  }, {
    key: 'blockEntry',
    value: function blockEntry(entry) {
      var user = this.props.user;

      var credit = '$' + __WEBPACK_IMPORTED_MODULE_3_undefsafe___default()(user, 'profile.total_deposits');
      var entryClassNames = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('global-header-dropdown__list-item', { '-border-top fds-u-pt1 fds-u-mt1': entry.isLastEntry });
      var linkClassNames = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('global-header-dropdown__link', { 'fds-u-pb0': entry.isLastEntry });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'li',
        { className: entryClassNames, key: entry.label },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'a',
          { href: entry.path, className: linkClassNames },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'global-header-dropdown__link-text' },
            entry.label
          )
        ),
        entry.showCredit && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          { className: 'global-header-dropdown__text' },
          entry.creditLabel,
          ' ',
          credit
        )
      );
    }

    /*
     build the user entries if the user has been loaded and there is a valid
     profile. Returns an empty array instead if the user does not have the profile
    */

  }, {
    key: 'userMenuEntries',
    value: function userMenuEntries() {
      var _props = this.props,
          user = _props.user,
          currentSite = _props.currentSite;


      if (user && user.profile) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__menuBuilder__["a" /* default */])(user, currentSite);
      } else {
        return [];
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var user = this.props.user;

      var earnings = __WEBPACK_IMPORTED_MODULE_3_undefsafe___default()(user, 'profile.available_earnings');
      var earningsLabel = '$' + earnings;
      var hasPositiveEarnings = parseInt(earnings) > 0;
      var username = __WEBPACK_IMPORTED_MODULE_3_undefsafe___default()(user, 'profile.username');

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'li',
        { className: 'global-header-menu__list-item--with-dropdown -background-light -border-radius' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],
          { to: '#', className: 'global-header-menu__link' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__icons_user__["a" /* default */], { className: 'global-header-menu__icon',
            width: '16px', height: '16px' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'global-header-menu__link-text has-truncated-length -weight-bold' },
            username
          ),
          hasPositiveEarnings && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'global-header-menu__link-text' },
            'Earnings: ',
            earningsLabel
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'global-header-menu__dropdown-container' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'global-header-dropdown' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'ul',
              { className: 'global-header-dropdown__list' },
              this.userMenuEntries().map(function (entry) {
                return entry.title ? _this2.blockTitle(entry) : _this2.blockEntry(entry);
              })
            )
          )
        )
      );
    }
  }]);

  return SignedInMenu;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

SignedInMenu.propTypes = {
  user: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  currentSite: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (SignedInMenu);

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user_guestMenuContainer__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_signedInMenu__ = __webpack_require__(606);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var UserMenu = function (_React$Component) {
  _inherits(UserMenu, _React$Component);

  function UserMenu() {
    _classCallCheck(this, UserMenu);

    return _possibleConstructorReturn(this, (UserMenu.__proto__ || Object.getPrototypeOf(UserMenu)).apply(this, arguments));
  }

  _createClass(UserMenu, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          currentSite = _props.currentSite;


      if (user && user.profile) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__user_signedInMenu__["a" /* default */], { user: user, currentSite: currentSite });
      } else {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__user_guestMenuContainer__["a" /* default */], null);
      }
    }
  }]);

  return UserMenu;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

UserMenu.propTypes = {
  user: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  currentSite: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (UserMenu);

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__banners_headBanner__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__categoriesMenu__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__marketSiteMenu__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__globalHeader__ = __webpack_require__(599);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var SiteHeader = function (_React$Component) {
  _inherits(SiteHeader, _React$Component);

  function SiteHeader() {
    _classCallCheck(this, SiteHeader);

    return _possibleConstructorReturn(this, (SiteHeader.__proto__ || Object.getPrototypeOf(SiteHeader)).apply(this, arguments));
  }

  _createClass(SiteHeader, [{
    key: 'toggleOffCanvasNav',
    value: function toggleOffCanvasNav(direction, event) {
      event.preventDefault();
      this.props.toggleOffCanvas(direction);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentSite = _props.currentSite,
          user = _props.user,
          menuConfig = _props.menuConfig,
          banners = _props.banners;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'canvas__header' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__banners_headBanner__["a" /* default */], { banners: banners }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'header',
          { className: 'site-header' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'site-header__mini fds-u-hide-extra-large-and-above' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'header-mini' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'header-mini__button--account' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'a',
                  { href: '#account', className: 'btn-square', onClick: this.toggleOffCanvasNav.bind(this, 'right') },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'e-icon -icon-person' }),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'fds-u-is-hidden' },
                    'Account'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'header-mini__button--categories' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'a',
                  { href: '#categories', className: 'btn-square', onClick: this.toggleOffCanvasNav.bind(this, 'left') },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'e-icon -icon-hamburger' }),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'fds-u-is-hidden' },
                    'Sites, Search & Categories'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'header-mini__logo' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'a',
                  { href: '/', className: 'header-mini__logo--' + currentSite },
                  currentSite
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__globalHeader__["a" /* default */], { currentSite: currentSite, user: user }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__marketSiteMenu__["a" /* default */], { currentSite: currentSite }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'site-header__categories fds-u-hide-extra-large-and-below' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'header-categories' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'grid-container -layout-wide' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__categoriesMenu__["a" /* default */], { items: menuConfig })
              )
            )
          )
        )
      );
    }
  }]);

  return SiteHeader;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

SiteHeader.propTypes = {
  currentSite: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  toggleOffCanvas: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  menuConfig: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired,
  user: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (SiteHeader);

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_constants_siteList__ = __webpack_require__(193);





var siteTitles = {
  audiojungle: 'Stock Music and Audio',
  themeforest: 'Website Templates',
  videohive: 'Motion Graphics',
  graphicriver: 'Graphics, Vectors and Print',
  '3docean': '3D Models and Materials',
  codecanyon: 'Code, Plugins and Mobile',
  photodune: 'Stock Photography'
};

/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var currentSite = _ref.currentSite;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'site-header__sites fds-u-hide-extra-large-and-below' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'header-sites' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'grid-container -layout-wide' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'nav',
          { className: 'header-sites__container' },
          __WEBPACK_IMPORTED_MODULE_2__common_constants_siteList__["b" /* siteNames */].map(function (site, index) {
            var isCurrentSite = site === currentSite;
            var shouldHaveOsr = !isCurrentSite ? '?osr=tn' : '';
            var siteLink = 'https://' + site + '.net/' + shouldHaveOsr;
            var linkClassName = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('header-sites__site--' + site, {
              'is-active': isCurrentSite
            });
            var siteTitle = siteTitles[site];
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              {
                key: index,
                href: siteLink,
                className: linkClassName,
                title: siteTitle },
              site
            );
          })
        )
      )
    )
  );
});

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils_siteConfig__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils_buildCanonicalPath__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_sites__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_sites_menus__ = __webpack_require__(331);








/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var seoMeta = _ref.seoMeta,
      location = _ref.location,
      currentSite = _ref.currentSite,
      noIndex = _ref.noIndex,
      baseUrl = _ref.baseUrl;

  var title = seoMeta.title || '';
  var description = seoMeta.meta_description || seoMeta.description || '';
  var siteConfig = __WEBPACK_IMPORTED_MODULE_4__config_sites__["a" /* default */][currentSite];

  // Defining meta tags
  var meta = [{ name: 'description', content: description }, { property: 'og:title', content: title }, { property: 'og:description', content: description }];

  // set no index header
  if (noIndex) {
    meta.push({ name: 'robots', content: 'noindex' });
  }

  var canonicalPath = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_utils_buildCanonicalPath__["a" /* default */])(currentSite, location);

  meta.push({ property: 'og:url', content: baseUrl + canonicalPath });
  // Defining link tags
  var link = [{ rel: 'canonical', href: baseUrl + canonicalPath }];

  // Define extra scripts
  var script = [{
    type: 'application/ld+json',
    innerHTML: '{\n        "@context": "http://schema.org",\n        "@type": "WebSite",\n        "name": "' + siteConfig.name + '",\n        "url": "' + baseUrl + '"\n      }'
  }];

  // rss feeds links
  var menuConfig = __WEBPACK_IMPORTED_MODULE_5__config_sites_menus__["a" /* default */][currentSite];
  var RSSFeeds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_utils_siteConfig__["b" /* getRSSFeeds */])(currentSite, menuConfig, siteConfig.feeds_categories || []);
  if (RSSFeeds.length) {
    RSSFeeds.forEach(function (feed) {
      link.push({
        rel: 'alternate',
        type: 'application/atom+xml',
        href: feed.url,
        title: feed.title
      });
    });
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_helmet___default.a, {
    title: title,
    defaultTitle: 'Envato Market',
    meta: meta,
    link: link,
    script: script
  });
});

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var VideoLoader = function (_React$Component) {
  _inherits(VideoLoader, _React$Component);

  function VideoLoader(props) {
    _classCallCheck(this, VideoLoader);

    var _this = _possibleConstructorReturn(this, (VideoLoader.__proto__ || Object.getPrototypeOf(VideoLoader)).call(this, props));

    _this.state = {
      isLoading: true
    };
    return _this;
  }

  _createClass(VideoLoader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.$video.addEventListener('canplay', function () {
        _this2.setState({ isLoading: false });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'video-loader' },
        this.state.isLoading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'video-loader__spinner' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'video',
          _extends({}, this.props, { ref: function ref($video) {
              _this3.$video = $video;
            } }),
          this.props.children
        )
      );
    }
  }]);

  return VideoLoader;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (VideoLoader);

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_undefsafe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_config__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_siteHeader__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_footer_siteFooter__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_crossSellLinksFooter__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pageOverlay__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pageOffCanvasLeft__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pageOffCanvasRight__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_siteMeta_siteMeta__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modals___ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__searchOfflinePage__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__notFoundContainer__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__server_template_oldIE__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_utils_sites__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__config_sites__ = __webpack_require__(57);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var App = function (_React$Component) {
  _inherits(App, _React$Component);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
  }

  _createClass(App, [{
    key: 'toggleOffCanvas',
    value: function toggleOffCanvas(direction) {
      this.props.toggleOffCanvas(direction);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var fastclick = __webpack_require__(959);
      var initUser = this.props.initUser;


      fastclick.attach(document.body);

      // init user and load user preference
      initUser();
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var _props = this.props,
          errorPage = _props.errorPage,
          location = _props.location,
          currentSite = _props.currentSite,
          route = _props.route;

      // add query back to location object

      location.query = __WEBPACK_IMPORTED_MODULE_4_query_string___default.a.parse(location.search);

      var popularFilesUrl = '//' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__common_utils_sites__["a" /* getCurrentSiteDomain */])(currentSite) + '/page/top_sellers';
      var siteDisplayName = __WEBPACK_IMPORTED_MODULE_3_undefsafe___default()(__WEBPACK_IMPORTED_MODULE_18__config_sites__["a" /* default */], currentSite + '.name') || currentSite;

      switch (errorPage) {
        case 'NotFoundContainer':
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__notFoundContainer__["a" /* default */], {
            location: location
          });

        case 'SearchOffline':
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__searchOfflinePage__["a" /* default */], {
            popularFilesUrl: popularFilesUrl,
            siteDisplayName: siteDisplayName
          });

        default:
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_router_config__["renderRoutes"])(route.routes);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          user = _props2.user,
          pageIsOffCanvas = _props2.pageIsOffCanvas,
          pageCanvasDirection = _props2.pageCanvasDirection,
          stats = _props2.stats,
          currentSite = _props2.currentSite,
          seoMeta = _props2.seoMeta,
          location = _props2.location,
          baseUrl = _props2.baseUrl,
          menuConfig = _props2.menuConfig,
          noIndex = _props2.noIndex,
          isModalOpen = _props2.isModalOpen,
          closeModal = _props2.closeModal,
          openModalType = _props2.openModalType,
          openModalData = _props2.openModalData,
          banners = _props2.banners;

      // add query back to location object
      // TODO: fetch from redux store instead of `withRouter`

      location.query = __WEBPACK_IMPORTED_MODULE_4_query_string___default.a.parse(location.search);

      var isOffCanvasActive = pageIsOffCanvas;
      var showLeftOffCanvas = isOffCanvasActive && pageCanvasDirection === 'left';
      var showRightOffCanvas = isOffCanvasActive && pageCanvasDirection === 'right';

      var pageClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('page', {
        'page--is-off-canvas': isOffCanvasActive
      });
      var pageCanvasClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('page__canvas', {
        'page__canvas--is-off-canvas-left': showLeftOffCanvas,
        'page__canvas--is-off-canvas-right': showRightOffCanvas
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: pageClass },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__server_template_oldIE__["a" /* default */], { siteName: currentSite }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_siteMeta_siteMeta__["a" /* default */], {
          seoMeta: seoMeta,
          location: location,
          currentSite: currentSite,
          noIndex: noIndex,
          baseUrl: baseUrl
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_modals___["a" /* default */], {
          closeModal: closeModal,
          isModalOpen: isModalOpen,
          openModalType: openModalType,
          openModalData: openModalData
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_pageOffCanvasLeft__["a" /* default */], {
          showLeftOffCanvas: showLeftOffCanvas,
          currentSite: currentSite,
          menuConfig: menuConfig,
          location: location
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_pageOffCanvasRight__["a" /* default */], {
          user: user,
          currentSite: currentSite,
          showRightOffCanvas: showRightOffCanvas
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: pageCanvasClass },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'canvas' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_siteHeader__["a" /* default */], { user: user,
              currentSite: currentSite,
              toggleOffCanvas: this.toggleOffCanvas.bind(this),
              menuConfig: menuConfig,
              banners: banners }),
            this.renderContent(),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_crossSellLinksFooter__["a" /* default */], { currentSite: currentSite }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_footer_siteFooter__["a" /* default */], {
              currentSite: currentSite,
              stats: stats,
              location: location
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_pageOverlay__["a" /* default */], {
              isOffCanvasActive: isOffCanvasActive,
              toggleOffCanvas: this.toggleOffCanvas.bind(this)
            })
          )
        )
      );
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

App.propTypes = {
  pageIsOffCanvas: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  pageCanvasDirection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  stats: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggleOffCanvas: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  seoMeta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  menuConfig: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  errorPage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  noIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  banners: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_actions_user___ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_actions_user_preference__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_actions_layout__ = __webpack_require__(79);







var mapStateToProps = function mapStateToProps(state) {
  var layout = state.layout,
      common = state.common,
      searchPage = state.searchPage,
      user = state.user,
      marketing = state.marketing;
  var pageIsOffCanvas = layout.pageIsOffCanvas,
      pageCanvasDirection = layout.pageCanvasDirection,
      isModalOpen = layout.isModalOpen,
      openModalType = layout.openModalType,
      openModalData = layout.openModalData;
  var seoMeta = searchPage.seoMeta,
      ingestedContent = searchPage.ingestedContent;
  var banners = marketing.banners;


  return {
    user: user,
    pageIsOffCanvas: pageIsOffCanvas,
    pageCanvasDirection: pageCanvasDirection,
    isModalOpen: isModalOpen,
    openModalType: openModalType,
    openModalData: openModalData,
    stats: common.stats,
    currentSite: common.currentSite,
    baseUrl: common.baseUrl,
    menuConfig: common.menuConfig,
    errorPage: common.errorPage,
    noIndex: common.noIndex,
    seoMeta: seoMeta,
    ingestedContent: ingestedContent,
    banners: banners
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    initUser: function initUser() {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_actions_user_preference__["b" /* initUserSearchResultsViewType */])(ownProps.location));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_actions_user_preference__["c" /* getUserVideoPlayerStatus */])());
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_actions_user___["a" /* getUser */])());
    },
    toggleOffCanvas: function toggleOffCanvas(direction) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_actions_layout__["c" /* toggleOffCanvas */])(direction));
    },
    closeModal: function closeModal() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_actions_layout__["d" /* closeModal */])());
    }
  };
};

var AppContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_0__app__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AppContainer);

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var ErrorPage = function ErrorPage(_ref) {
  var title = _ref.title,
      children = _ref.children;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'section',
    { className: 'page-section' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'grid-container' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'header',
        { className: 'fds-u-text-align-center' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h1',
          { className: 'fds-c-text-heading -size-xxl' },
          title
        ),
        children
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ErrorPage);

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_innerHtml__ = __webpack_require__(122);



var LandingPage = function LandingPage(_ref) {
  var html = _ref.html,
      css = _ref.css;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'landing-page-content' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'style',
      null,
      css
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__components_innerHtml__["a" /* default */],
      { className: 'landing-page-body' },
      html
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (LandingPage);

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__landingPage__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_actions_fetchLandingPageContent__ = __webpack_require__(644);





var mapStateToProps = function mapStateToProps(state) {
  var _state$landingPage = state.landingPage,
      html = _state$landingPage.html,
      css = _state$landingPage.css;
  var _state$common = state.common,
      currentSite = _state$common.currentSite,
      baseUrl = _state$common.baseUrl;
  var user = state.user;


  return {
    html: html,
    css: css,
    currentSite: currentSite,
    user: user,
    baseUrl: baseUrl
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {};
};

var LandingPageContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__landingPage__["a" /* default */]);

LandingPageContainer.loadData = function (store, parsedUrl, opts) {
  return store.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_actions_fetchLandingPageContent__["a" /* default */])(parsedUrl, opts));
};

/* harmony default export */ __webpack_exports__["a"] = (LandingPageContainer);

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_amGrid__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_searchBar_searchBarForm__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_searchBar_searchBarInput__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils_sites__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils_ga__ = __webpack_require__(33);










var NotFoundPage = function NotFoundPage(_ref) {
  var location = _ref.location,
      currentSite = _ref.currentSite;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils_ga__["a" /* default */])('send', 'event', '404', 'https://' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_utils_sites__["a" /* getCurrentSiteDomain */])(currentSite) + '/404');
  var pageTitle = 'Page Not Found | ' + currentSite;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'section',
    { className: 'page-section' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'grid-container' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_helmet___default.a, { title: pageTitle }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'header',
        { className: 'fds-u-text-align-center' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h1',
          { className: 'fds-c-text-heading -size-xxl' },
          '404 - Nothing to see here'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          { className: 'fds-c-text-body -size-xl' },
          'Just kidding. There\'s plenty to see on ',
          currentSite,
          '. Why not',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', { className: 'fds-u-hide-medium-and-below' }),
          ' try a search, or take a look at our ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],
            { to: '/page/top_sellers' },
            'Popular files'
          ),
          '?'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__components_amGrid__["a" /* default */],
        { 'am-grid': true, className: 'fds-u-my2' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__components_amGrid__["a" /* default */],
          { 'am-grid-col': 'l:8 l:pre2 m:6 m:pre1', 'am-grid-row': 'm:start m:end l:start l:end' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__components_searchBar_searchBarForm__["a" /* default */],
            { location: location, className: 'search-field -size-xl' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { margin: 0, padding: 0, display: 'inline' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { name: 'utf8', type: 'hidden', value: '\u2713' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'search-field__input' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_searchBar_searchBarInput__["a" /* default */], { value: location.query.term, className: 'search-field__input-field', name: 'term', placeholder: 'e.g. responsive wordpress' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'fds-c-button search-field__button', type: 'submit' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'i',
                { className: 'e-icon -icon-search' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'e-icon__alt' })
              )
            )
          )
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (NotFoundPage);

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_innerHtml__ = __webpack_require__(122);




var SearchPageArticle = function SearchPageArticle(_ref) {
  var html = _ref.html;

  if (!html) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'section',
    { className: 'page-section -color-grey-light -border-top -border-bottom' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'search-page-content-article__text-section' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'grid-container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'sidebar-s -size-fixed-tablet is-hidden-phone' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'search-page-content__sidebar-spacer' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content-l -size-scale-tablet content-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'fds-c-text-preformatted' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1__components_innerHtml__["a" /* default */],
              null,
              html
            )
          )
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SearchPageArticle);

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_format__);



var SearchPageRelatedPost = function SearchPageRelatedPost(_ref) {
  var post = _ref.post;

  var publishDate = __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default()(post.date, 'DD MMM YYYY');

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'li',
    { className: 'search-related-posts__post' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'article',
      { className: 'search-related-posts__post-container' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'header',
        { className: 'search-related-posts__post-header' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { className: 'search-related-posts__post-preview-link is-hidden-phone', href: post.url },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: post.title, className: 'search-related-posts__post-image', src: post.image })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { className: 'search-related-posts__post-preview-title-link', href: post.url },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'fds-c-text-heading -size-xs -color-mid' },
            post.title
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'search-related-posts__post-teaser' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'fds-c-text-body -size-s -color-mid' },
          post.summary
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'footer',
        { className: 'search-related-posts__post-footer' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'fds-c-text-body -size-s -color-mid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'search-related-posts__post-publication-meta' },
            post.author && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'search-related-posts__post-author_photo', alt: post.author, src: post.author_avatar }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'search-related-posts__post-details' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'address',
                { className: 'search-related-posts__post-author' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { className: 'search-related-posts__post-author-link' },
                  post.author && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    { className: 'fds-c-text-link -decoration-reversed -color-inherit', href: post.author_url },
                    post.author
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'time',
                { dateTime: post.date, title: publishDate },
                publishDate
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'search-related-posts__post-primary-category' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { className: 'fds-c-text-link -decoration-reversed -color-inherit -weight-bold', href: post.category_url },
              post.category
            )
          )
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SearchPageRelatedPost);

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__searchPageRelatedPost__ = __webpack_require__(619);



var SearchPageRelatedPosts = function SearchPageRelatedPosts(_ref) {
  var posts = _ref.posts;

  var generateUID = function generateUID() {
    return Math.random().toString(32).substring(2);
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'section',
    { className: 'page-section' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'grid-container' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'search-related-posts__posts-section' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'sidebar-s -size-fixed-tablet is-hidden-phone' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'search-page-content__sidebar-spacer' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content-l -size-scale-tablet content-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ol',
            { className: 'search-related-posts__post_list' },
            posts.map(function (post) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__searchPageRelatedPost__["a" /* default */], {
                key: generateUID(),
                post: post
              });
            })
          )
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SearchPageRelatedPosts);

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_mute__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_unmute__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__muteSwitcher_module_css__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__muteSwitcher_module_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__muteSwitcher_module_css__);






var MuteSwitcher = function MuteSwitcher(_ref) {
  var muted = _ref.muted,
      _ref$onMute = _ref.onMute,
      onMute = _ref$onMute === undefined ? function () {} : _ref$onMute,
      _ref$onUnmute = _ref.onUnmute,
      onUnmute = _ref$onUnmute === undefined ? function () {} : _ref$onUnmute;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    muted ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: __WEBPACK_IMPORTED_MODULE_3__muteSwitcher_module_css___default.a.iconContainer, onClick: onUnmute },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_icons_mute__["a" /* default */], { width: '14', height: '14' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: __WEBPACK_IMPORTED_MODULE_3__muteSwitcher_module_css___default.a.iconLabel },
        'Unmute'
      )
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: __WEBPACK_IMPORTED_MODULE_3__muteSwitcher_module_css___default.a.iconContainer, onClick: onMute },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_unmute__["a" /* default */], { width: '14', height: '14' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: __WEBPACK_IMPORTED_MODULE_3__muteSwitcher_module_css___default.a.iconLabel },
        'Mute'
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (MuteSwitcher);

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils_urlHelper__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var RelatedSearchesItem = function (_React$Component) {
  _inherits(RelatedSearchesItem, _React$Component);

  function RelatedSearchesItem() {
    _classCallCheck(this, RelatedSearchesItem);

    return _possibleConstructorReturn(this, (RelatedSearchesItem.__proto__ || Object.getPrototypeOf(RelatedSearchesItem)).apply(this, arguments));
  }

  _createClass(RelatedSearchesItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var dom = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(this);
      /*
       This procedure is unfortunately necessary. React removes custom attributes from DOM and
       current design depend on am-grid-col and amd-grid-row attributes. The only way to add those is to
       do it directly on DOM after component mounted.
       */
      RelatedSearchesItem.customAttributes.forEach(function (attributeName) {
        dom.setAttribute(attributeName, _this2.props[attributeName]);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          term = _props.term,
          type = _props.type;

      var nextQuery = {};
      nextQuery[type] = term;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        { className: 'fds-c-text-body -size-s fds-u-m0' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],
          { className: 'fds-c-text-link -color-default -decoration-reversed',
            to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_utils_urlHelper__["b" /* makeLink */])(nextQuery) },
          term
        )
      );
    }
  }]);

  return RelatedSearchesItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

RelatedSearchesItem.propTypes = {
  term: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  amGridCol: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  amGridRow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
RelatedSearchesItem.customAttributes = ['am-grid-col', 'am-grid-row'];

var RelatedSearches = function (_React$Component2) {
  _inherits(RelatedSearches, _React$Component2);

  function RelatedSearches(props) {
    _classCallCheck(this, RelatedSearches);

    var _this3 = _possibleConstructorReturn(this, (RelatedSearches.__proto__ || Object.getPrototypeOf(RelatedSearches)).call(this, props));

    _this3.setListRef = _this3.setListRef.bind(_this3);
    return _this3;
  }

  _createClass(RelatedSearches, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      /*
        Needed to add a custom attribute for design purpose.
       */
      if (this.listElement) {
        var listDOM = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(this.listElement);
        listDOM.setAttribute('am-grid', 'abc');
      }
    }
  }, {
    key: 'setListRef',
    value: function setListRef(listElement) {
      this.listElement = listElement;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          recommendations = _props2.recommendations,
          type = _props2.type,
          hint = _props2.hint;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'fds-u-clearfix fds-u-mb2' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'fds-c-text-body -size-l fds-u-mb1' },
          'Searches related to',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'fds-c-text-body -size-l -weight-bold' },
            ' ',
            hint
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          { ref: this.setListRef },
          recommendations.map(function (term, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RelatedSearchesItem, { key: index, term: term, type: type,
              'am-grid-col': 's:4 m:8 l:6', 'am-grid-row': index % 2 ? 'l:end' : 'l:start' });
          })
        )
      );
    }
  }]);

  return RelatedSearches;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

RelatedSearches.propTypes = {
  recommendations: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hint: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (RelatedSearches);

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEqualWith__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEqualWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEqualWith__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils_siteConfig__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_analytics_resultAnalytics__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_productList__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(103);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var SearchResultBody = function (_React$Component) {
  _inherits(SearchResultBody, _React$Component);

  function SearchResultBody() {
    _classCallCheck(this, SearchResultBody);

    return _possibleConstructorReturn(this, (SearchResultBody.__proto__ || Object.getPrototypeOf(SearchResultBody)).apply(this, arguments));
  }

  _createClass(SearchResultBody, [{
    key: 'reportProductsImpressions',
    value: function reportProductsImpressions(prevMatches) {
      var _props = this.props,
          matches = _props.matches,
          currentSite = _props.currentSite;

      var compareFunction = function compareFunction(prevMatches, matches) {
        prevMatches = prevMatches.map(function (item) {
          return item.id;
        });
        matches = matches.map(function (item) {
          return item.id;
        });
        return __WEBPACK_IMPORTED_MODULE_2_lodash_isEqualWith___default()(prevMatches, matches);
      };

      if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isEqualWith___default()(prevMatches, matches, compareFunction)) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_analytics_resultAnalytics__["a" /* reportProductsImpressions */])(matches, currentSite);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props2 = this.props,
          matches = _props2.matches,
          currentSite = _props2.currentSite;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_analytics_resultAnalytics__["a" /* reportProductsImpressions */])(matches, currentSite);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      this.reportProductsImpressions(prevProps.matches);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          matches = _props3.matches,
          createFavoriteCollection = _props3.createFavoriteCollection,
          currentSite = _props3.currentSite,
          collections = _props3.collections,
          cartItems = _props3.cartItems,
          token = _props3.token,
          deleteBookmark = _props3.deleteBookmark,
          addBookmark = _props3.addBookmark,
          favoriteCollectionID = _props3.favoriteCollectionID,
          openModal = _props3.openModal,
          location = _props3.location,
          preferences = _props3.preferences;


      var pageSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_utils_siteConfig__["a" /* default */])(currentSite, 'common.search_page_size');

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_productList__["a" /* default */], {
        items: matches,
        currentSite: currentSite,
        preferences: preferences,
        itemDecorator: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* itemDecorator */])(currentSite, openModal, !token, favoriteCollectionID, collections, deleteBookmark, addBookmark, createFavoriteCollection, pageSize, cartItems, location)
      });
    }
  }]);

  return SearchResultBody;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SearchResultBody.propTypes = {
  matches: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  view: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (SearchResultBody);

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SearchResultHeaderComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dropdown__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_utils_urlHelper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils_formatString__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils_siteConfig__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sortByDropdown__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__muteSwitcher__ = __webpack_require__(621);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }













var dateFilterLabels = ['Any date', 'In the last year', 'In the last month', 'In the last week', 'In the last day'];

var SearchResultHeader = function SearchResultHeader(_ref) {
  var currentSite = _ref.currentSite,
      location = _ref.location,
      date = _ref.date,
      preferences = _ref.preferences,
      history = _ref.history,
      setUserVideoPlayerStatus = _ref.setUserVideoPlayerStatus;

  var view = preferences.searchResultsViewType;
  var muted = preferences.searchVideoMuted;

  var query = location.query;

  var parsedLocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_urlHelper__["a" /* parseLocation */])(location);
  var itemViews = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils_siteConfig__["a" /* default */])(currentSite, 'ui.item_list_views') || [];
  var shouldShowVideoMuteSwitcher = currentSite === 'videohive';

  var onMute = function onMute() {
    return setUserVideoPlayerStatus(true);
  };
  var onUnmute = function onUnmute() {
    return setUserVideoPlayerStatus(false);
  };

  var onDateSelectionChange = function onDateSelectionChange(event) {
    var date = event.target.value;

    var newQuery = Object.assign({}, parsedLocation, {
      date: date
    });

    delete newQuery.page;

    if (newQuery.date === '') {
      delete newQuery.date;
    }

    history.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_urlHelper__["b" /* makeLink */])(newQuery));
  };

  var getSelectDateDefaultValue = function getSelectDateDefaultValue() {
    return parsedLocation.date || '';
  };

  var renderDateFilter = function renderDateFilter() {
    // append the top level options
    var dates = [{
      count: null,
      description: null,
      key: ''
    }].concat(_toConsumableArray(date));

    var selectedDateFilterIndex = dates.map(function (d) {
      return d.key;
    }).indexOf(query.date || '');
    // build the date options
    var dateFilterOptions = dates.map(function (d, index) {
      /**
       * The label will choose whether to show count based on the current selected date
       * if it's filtered by year, it will show all the count
       * if it's filtered by month, it will not show year count but all the others
       * same rule applies to week/day
       */
      var label = d.count && index >= selectedDateFilterIndex ? dateFilterLabels[index] + ' - ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_utils_formatString__["b" /* commaStyleString */])(d.count) : dateFilterLabels[index];
      label = index === selectedDateFilterIndex ? 'Added: ' + label : label;
      return {
        value: d.key,
        label: label
      };
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'inline-select-wrapper -hide-phone' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'search-facet-header--horizontal' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'e-icon -icon-calendar -margin-right' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'e-icon__alt' },
            'Added'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: '-border-top-none -border-radius-none inline-select' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'label',
          { htmlFor: 'date', className: 'fds-u-is-visually-hidden' },
          'Added'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_dropdown__["a" /* default */], {
          name: 'date',
          options: dateFilterOptions,
          onChange: onDateSelectionChange,
          value: getSelectDateDefaultValue() })
      )
    );
  };

  var renderLayoutSwitcher = function renderLayoutSwitcher() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'search-facet-layout-switcher' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        itemViews.map(function (availableView, index) {
          var nextQuery = Object.assign({}, parsedLocation, {
            view: availableView.value
          });
          var className = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('btn-search-switch', {
            'is-active': view === availableView.value
          });
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],
            { to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_utils_urlHelper__["b" /* makeLink */])(nextQuery), className: className, key: index },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'i',
              { className: 'e-icon -icon-' + availableView.value },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'e-icon__alt' },
                availableView.label
              )
            )
          );
        })
      )
    );
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'fds-u-is-hidden--no-js search-facet-horizontal-form', id: 'search-result-header' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__sortByDropdown__["a" /* default */], {
      location: location,
      currentSite: currentSite
    }),
    renderDateFilter(),
    itemViews.length > 1 && renderLayoutSwitcher(),
    shouldShowVideoMuteSwitcher && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'fds-u-diplay-inlineblock fds-u-pull-right fds-c-text-body -size-xs -weight-bold fds-u-mt1' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__muteSwitcher__["a" /* default */], {
        muted: muted,
        onMute: onMute,
        onUnmute: onUnmute
      })
    )
  );
};

SearchResultHeader.propTypes = {
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  view: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  preferences: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

SearchResultHeader.defaultProps = {
  date: []
};

var SearchResultHeaderComponent = SearchResultHeader;
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* withRouter */])(SearchResultHeader));

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_actions_user_preference__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__searchResultHeader__ = __webpack_require__(624);





var mapStateToProps = function mapStateToProps(state) {
  var currentSite = state.common.currentSite,
      preferences = state.user.preferences;


  return {
    currentSite: currentSite,
    preferences: preferences
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setUserVideoPlayerStatus: function setUserVideoPlayerStatus(type) {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_actions_user_preference__["a" /* setUserVideoPlayerStatus */])(type));
    }
  };
};

var SearchResultHeaderContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__searchResultHeader__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SearchResultHeaderContainer);

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dropdown__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_sites_defaults__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils_urlHelper__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var searchQueryConfigs = __WEBPACK_IMPORTED_MODULE_5__config_sites_defaults__["a" /* default */]['search_query'];
var defaultSortByOptions = searchQueryConfigs['defalut_sort_by_options'];

/**
 * A sort by menu which has lots of business logic
 */

var SortByDropdown = function (_React$Component) {
  _inherits(SortByDropdown, _React$Component);

  function SortByDropdown(props) {
    _classCallCheck(this, SortByDropdown);

    var _this = _possibleConstructorReturn(this, (SortByDropdown.__proto__ || Object.getPrototypeOf(SortByDropdown)).call(this, props));

    _this.onSortBySelectionChange = _this.onSortBySelectionChange.bind(_this);
    return _this;
  }

  _createClass(SortByDropdown, [{
    key: 'getSelectSortByValue',
    value: function getSelectSortByValue(parsedLocation) {
      if (parsedLocation.sort_by) {
        if (parsedLocation.sort_by === 'price' && parsedLocation.sort_direction) {
          return 'price-' + parsedLocation.sort_direction;
        } else {
          return parsedLocation.sort_by;
        }
      }
    }
  }, {
    key: 'onSortBySelectionChange',
    value: function onSortBySelectionChange(event) {
      var location = this.props.location;


      var parsedLocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_utils_urlHelper__["a" /* parseLocation */])(location);

      var sort = event.target.value;
      var newQuery = Object.assign({}, parsedLocation, {
        sort: sort
      });
      delete newQuery.sort_by;
      delete newQuery.sort_direction;

      this.props.history.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_utils_urlHelper__["b" /* makeLink */])(newQuery));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          location = _props.location,
          currentSite = _props.currentSite;


      var parsedLocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_utils_urlHelper__["a" /* parseLocation */])(location);

      var sortByOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* filterSortByOptions */])(currentSite, parsedLocation, defaultSortByOptions);

      // Append "Sort by:" to selected label
      var sortByOptionsWithLabel = sortByOptions.map(function (option) {
        if (option.value === _this2.getSelectSortByValue(parsedLocation)) {
          return Object.assign({}, option, {
            label: 'Sort by: ' + option.label
          });
        } else {
          return option;
        }
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'inline-select-wrapper' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'search-facet-header--horizontal' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'e-icon -icon-sort -margin-right' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'e-icon__alt' },
              'Sort by'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: '-border-top-none -border-radius-none inline-select' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            { htmlFor: 'sortby', className: 'fds-u-is-visually-hidden' },
            'Sort by: '
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_dropdown__["a" /* default */], {
            name: 'sortby',
            options: sortByOptionsWithLabel,
            onChange: this.onSortBySelectionChange,
            defaultValue: this.getSelectSortByValue(parsedLocation) })
        )
      );
    }
  }]);

  return SortByDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SortByDropdown.propTypes = {
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  currentSite: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* withRouter */])(SortByDropdown));

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_undefsafe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_filters_searchFilters__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__result_searchResultHeaderContainer__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__result_searchResultBodyContainer__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__result_searchNoResults__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__result_relatedSearches__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_banners_elementsBanner__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_banners_studioRecommendationsBanner__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_utils_urlHelper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_utils_siteConfig__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pagination_pagination__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_banners_crossPromoBanner__ = __webpack_require__(523);
















var SearchContentSection = function SearchContentSection(_ref) {
  var user = _ref.user,
      baseUrl = _ref.baseUrl,
      results = _ref.results,
      location = _ref.location,
      loading = _ref.loading,
      currentSite = _ref.currentSite,
      relatedSearches = _ref.relatedSearches,
      studioRecommendations = _ref.studioRecommendations;

  var shouldShowRecommendedSearches = !loading && relatedSearches && relatedSearches.recommendations.length > 0;
  var totalHits = results.total_hits;
  var matches = results.matches;
  var aggregations = __WEBPACK_IMPORTED_MODULE_1_undefsafe___default()(results, 'aggregations');
  var haveResults = !!(matches && matches.length);
  var shouldShowPagination = totalHits > 0;
  var flattenLocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__common_utils_urlHelper__["c" /* getFlattenLocation */])(location);
  var pageSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__common_utils_siteConfig__["a" /* default */])(currentSite, 'common.search_page_size');
  var maxPagesCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__common_utils_siteConfig__["a" /* default */])(currentSite, 'common.max_pages_count');
  var parsedLocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__common_utils_urlHelper__["a" /* parseLocation */])(location);
  var currentCategory = parsedLocation.category;
  var viewType = __WEBPACK_IMPORTED_MODULE_1_undefsafe___default()(user, 'preferences.searchResultsViewType');

  var containerClassNames = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('grid-container', {
    '-layout-videohive': currentSite === 'videohive' && viewType === 'grid'
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: containerClassNames },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'aside',
      { className: 'sidebar-s -size-fixed-tablet fds-u-hide-small-and-below' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_filters_searchFilters__["a" /* default */], {
        aggregations: aggregations,
        location: flattenLocation,
        currentSite: currentSite
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_banners_crossPromoBanner__["a" /* default */], {
        currentSite: currentSite,
        currentCategory: currentCategory
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'content-l -size-scale-tablet content-right' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__result_searchResultHeaderContainer__["a" /* default */], {
        date: __WEBPACK_IMPORTED_MODULE_1_undefsafe___default()(aggregations, 'date'),
        location: location
      }),
      haveResults ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__result_searchResultBodyContainer__["a" /* default */], {
        location: location,
        matches: matches
      }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__result_searchNoResults__["a" /* default */], { location: location }),
      shouldShowRecommendedSearches && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__result_relatedSearches__["a" /* default */], relatedSearches),
      shouldShowPagination && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_pagination_pagination__["a" /* default */], {
        currentPage: Number(location.query.page) || 1,
        totalItemsCount: totalHits,
        pageSize: pageSize,
        location: location,
        baseUrl: baseUrl,
        maxPagesCount: maxPagesCount
      }),
      haveResults && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_banners_elementsBanner__["a" /* default */], { currentSite: currentSite }),
      haveResults && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_banners_studioRecommendationsBanner__["a" /* default */], {
        config: studioRecommendations,
        currentSite: currentSite,
        category: parsedLocation.category,
        term: parsedLocation.term
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SearchContentSection);

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils_urlHelper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_innerHtml__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_searchBar_searchBarForm__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_searchBar_searchBarAutoSuggest__ = __webpack_require__(597);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var SearchHeader = function (_React$Component) {
  _inherits(SearchHeader, _React$Component);

  function SearchHeader() {
    _classCallCheck(this, SearchHeader);

    return _possibleConstructorReturn(this, (SearchHeader.__proto__ || Object.getPrototypeOf(SearchHeader)).apply(this, arguments));
  }

  _createClass(SearchHeader, [{
    key: 'renderResultsInfo',
    value: function renderResultsInfo() {
      var _props = this.props,
          location = _props.location,
          seoMeta = _props.seoMeta;

      var parsedLocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_utils_urlHelper__["a" /* parseLocation */])(location);
      var shouldShowSubheading = (!parsedLocation.page || parsedLocation.page && parsedLocation.page === '1') && seoMeta.sub_heading;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h1',
          { className: 'fds-c-text-heading -color-light -size-xs h-remove-margin -weight-normal' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__components_innerHtml__["a" /* default */],
            null,
            seoMeta.heading
          )
        ),
        shouldShowSubheading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          { className: 'fds-c-text-heading -color-light -size-xs -weight-normal fds-u-hide-small-and-below' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__components_innerHtml__["a" /* default */],
            null,
            seoMeta.sub_heading
          )
        )
      );
    }
  }, {
    key: 'renderNoResultsFound',
    value: function renderNoResultsFound() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h1',
        { className: 'fds-c-text-heading -color-light -size-xs h-remove-margin -weight-normal fds-u-hide-small-and-below' },
        'No results found'
      );
    }
  }, {
    key: 'renderDidYouMeanBy',
    value: function renderDidYouMeanBy() {
      var _props2 = this.props,
          didYouMeanByTerms = _props2.didYouMeanByTerms,
          location = _props2.location;

      var parsedLocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_utils_urlHelper__["a" /* parseLocation */])(location);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        'Did you mean: ',
        didYouMeanByTerms.map(function (term, index) {
          var nextQuery = Object.assign({}, parsedLocation, {
            term: term
          });
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { key: index },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],
              { to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_utils_urlHelper__["b" /* makeLink */])(nextQuery) },
              term
            ),
            index < didYouMeanByTerms.length - 1 ? ', ' : null
          );
        }),
        '?'
      );
    }
  }, {
    key: 'renderAuthorSuggestions',
    value: function renderAuthorSuggestions() {
      var authorSuggestion = this.props.authorSuggestion;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: 'author-search-result' },
        'We found an author by that name: ',
        authorSuggestion ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { href: authorSuggestion.url },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { width: '25', height: '25', src: authorSuggestion.image, alt: authorSuggestion.username }),
          authorSuggestion.username
        ) : null
      );
    }
  }, {
    key: 'renderSuggestions',
    value: function renderSuggestions() {
      var _props3 = this.props,
          didYouMeanByTerms = _props3.didYouMeanByTerms,
          authorSuggestion = _props3.authorSuggestion;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'search-header__extras' },
        authorSuggestion ? this.renderAuthorSuggestions() : null,
        didYouMeanByTerms.length ? this.renderDidYouMeanBy() : null
      );
    }
  }, {
    key: 'renderSearchBar',
    value: function renderSearchBar() {
      var _props4 = this.props,
          location = _props4.location,
          currentSite = _props4.currentSite;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'fds-u-p2' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__components_searchBar_searchBarForm__["a" /* default */],
          { className: 'huge-search--search-home', location: location },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_searchBar_searchBarAutoSuggest__["a" /* default */], {
            name: 'term',
            value: location.query.term,
            placeholder: 'Search within these results',
            currentSite: currentSite,
            location: location
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          resultsTerm = _props5.resultsTerm,
          totalHits = _props5.totalHits,
          didYouMeanByTerms = _props5.didYouMeanByTerms,
          authorSuggestion = _props5.authorSuggestion,
          seoMeta = _props5.seoMeta,
          currentSite = _props5.currentSite,
          hideSearchBar = _props5.hideSearchBar;


      var shouldShowSeo = seoMeta && seoMeta.heading && totalHits > 0;
      var shouldShowNoResults = resultsTerm && !totalHits;

      var pageSectionClassNames = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('page-section', '-size-xcompact', '-theme-' + (currentSite || 'themeforest'));
      var resultsCountClassNames = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('search-header__results-count', {
        'fds-u-pt2': hideSearchBar
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: 'search-header' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: pageSectionClassNames },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'page-section__content' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'page-section__background' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'search-header__form-wrapper' },
              !hideSearchBar && this.renderSearchBar(),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: resultsCountClassNames },
                shouldShowSeo && this.renderResultsInfo(),
                shouldShowNoResults && this.renderNoResultsFound(),
                didYouMeanByTerms.length || authorSuggestion ? this.renderSuggestions() : null
              )
            )
          )
        )
      );
    }
  }]);

  return SearchHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

SearchHeader.propTypes = {
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  totalHits: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  resultsTerm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  didYouMeanByTerms: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  authorSuggestion: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  seoMeta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  currentSite: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hideSearchBar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
SearchHeader.defaultProps = {
  totalHits: 0,
  didYouMeanByTerms: [],
  authorSuggestion: null
};


/* harmony default export */ __webpack_exports__["a"] = (SearchHeader);

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_undefsafe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__searchHeader__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_alerts_alertsStreamContainer__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__content_searchPageArticle__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__content_searchPageRelatedPosts__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils_eventsApi__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_utils_urlHelper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__similarImagesPage__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__searchContentSection__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_banners_photoduneSearchSurveyBanner__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_actions_search_trackSiteSearches__ = __webpack_require__(317);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var SearchPage = function (_React$Component) {
  _inherits(SearchPage, _React$Component);

  function SearchPage() {
    _classCallCheck(this, SearchPage);

    return _possibleConstructorReturn(this, (SearchPage.__proto__ || Object.getPrototypeOf(SearchPage)).apply(this, arguments));
  }

  _createClass(SearchPage, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var prevUser = prevProps.user;
      var prevResultsUrl = prevProps.resultsUrl;
      var _props = this.props,
          user = _props.user,
          results = _props.results,
          resultsUrl = _props.resultsUrl,
          location = _props.location,
          currentSite = _props.currentSite,
          timeout = _props.timeout;

      // Log to events api only when:
      // - user data will be loaded on search results page for the first time (inital search page render)
      // - successful search will be done after initial render
      // - timeout will happen (we need to log timeouts also)

      var newUserLoadAttempt = !prevUser.hasLoadAttempt && user.hasLoadAttempt;
      var isNewSearch = prevResultsUrl !== resultsUrl;
      var isTimeout = user.hasLoadAttempt && timeout;
      if (newUserLoadAttempt || isNewSearch || isTimeout) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_utils_eventsApi__["a" /* logSearchResult */])(results, location, currentSite, user, timeout);
        if (currentSite === 'photodune') __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__common_actions_search_trackSiteSearches__["a" /* countSearchFor */])(currentSite);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          user = _props2.user,
          location = _props2.location,
          results = _props2.results,
          loading = _props2.loading,
          seoMeta = _props2.seoMeta,
          ingestedContent = _props2.ingestedContent,
          currentSite = _props2.currentSite,
          baseUrl = _props2.baseUrl,
          relatedSearches = _props2.relatedSearches,
          studioRecommendations = _props2.studioRecommendations;


      var didYouMeanByTerms = __WEBPACK_IMPORTED_MODULE_1_undefsafe___default()(results, 'suggestions');
      var authorSuggestion = __WEBPACK_IMPORTED_MODULE_1_undefsafe___default()(results, 'matching_author');
      var flattenLocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_utils_urlHelper__["c" /* getFlattenLocation */])(location);
      var resultsTerm = flattenLocation.query.term;
      var shouldShowSimilarImagesPage = !!flattenLocation.query.item_id;
      var showPhotoduneSurvey = currentSite === 'photodune' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__common_actions_search_trackSiteSearches__["b" /* searchesCount */])(currentSite) > 2;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'canvas_body' },
        loading ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'loading-cover' }) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__searchHeader__["a" /* default */], {
          location: flattenLocation,
          totalHits: results.total_hits,
          resultsTerm: resultsTerm,
          didYouMeanByTerms: didYouMeanByTerms,
          authorSuggestion: authorSuggestion,
          currentSite: currentSite,
          seoMeta: seoMeta,
          hideSearchBar: shouldShowSimilarImagesPage
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'grid-container' },
          showPhotoduneSurvey && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_banners_photoduneSearchSurveyBanner__["a" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_alerts_alertsStreamContainer__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content-main--basic' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'faceted-search' },
            shouldShowSimilarImagesPage ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__similarImagesPage__["a" /* default */], {
              results: results,
              location: location,
              baseUrl: baseUrl,
              currentSite: currentSite
            }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__searchContentSection__["a" /* default */], {
              user: user,
              baseUrl: baseUrl,
              results: results,
              location: location,
              loading: loading,
              currentSite: currentSite,
              relatedSearches: relatedSearches,
              studioRecommendations: studioRecommendations
            })
          ),
          ingestedContent && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'search-page-content' },
            !!ingestedContent.article && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__content_searchPageArticle__["a" /* default */], { html: ingestedContent.article }),
            ingestedContent.related_posts && ingestedContent.related_posts.length === 3 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__content_searchPageRelatedPosts__["a" /* default */], { posts: ingestedContent.related_posts })
          )
        )
      );
    }
  }]);

  return SearchPage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (SearchPage);

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__searchPage__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_actions_searchPage__ = __webpack_require__(189);





var mapStateToProps = function mapStateToProps(state) {
  var _state$searchPage = state.searchPage,
      results = _state$searchPage.results,
      resultsUrl = _state$searchPage.resultsUrl,
      loading = _state$searchPage.loading,
      seoMeta = _state$searchPage.seoMeta,
      ingestedContent = _state$searchPage.ingestedContent,
      relatedSearches = _state$searchPage.relatedSearches,
      timeout = _state$searchPage.timeout,
      studioRecommendations = _state$searchPage.studioRecommendations;
  var _state$common = state.common,
      currentSite = _state$common.currentSite,
      baseUrl = _state$common.baseUrl;
  var user = state.user;

  return {
    results: results,
    resultsUrl: resultsUrl,
    loading: loading,
    seoMeta: seoMeta,
    studioRecommendations: studioRecommendations,
    ingestedContent: ingestedContent,
    currentSite: currentSite,
    relatedSearches: relatedSearches,
    user: user,
    baseUrl: baseUrl,
    timeout: timeout
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {};
};

var SearchPageContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__searchPage__["a" /* default */]);

SearchPageContainer.loadData = function (store, parsedUrl, opts) {
  return store.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_actions_searchPage__["a" /* default */])(parsedUrl, opts));
};

/* harmony default export */ __webpack_exports__["a"] = (SearchPageContainer);

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_utils_siteConfig__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__result_searchResultBodyContainer__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__result_searchNoResults__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pagination_pagination__ = __webpack_require__(312);






var SimilarImagesPage = function SimilarImagesPage(_ref) {
  var results = _ref.results,
      location = _ref.location,
      baseUrl = _ref.baseUrl,
      currentSite = _ref.currentSite;

  var totalHits = results.total_hits;
  var matches = results.matches;
  var haveResults = matches && matches.length;
  var shouldShowPagination = totalHits > 0;
  var pageSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_utils_siteConfig__["a" /* default */])(currentSite, 'common.search_page_size');
  var maxPagesCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_utils_siteConfig__["a" /* default */])(currentSite, 'common.max_pages_count');

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'grid-container' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'content-l -size-scale-tablet content-centre' },
      haveResults ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__result_searchResultBodyContainer__["a" /* default */], { location: location, matches: matches, view: 'grid' }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__result_searchNoResults__["a" /* default */], { location: location }),
      shouldShowPagination && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_pagination_pagination__["a" /* default */], {
        currentPage: Number(location.query.page) || 1,
        totalItemsCount: totalHits,
        pageSize: pageSize,
        location: location,
        baseUrl: baseUrl,
        maxPagesCount: maxPagesCount
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SimilarImagesPage);

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__errorPage__ = __webpack_require__(614);




/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var popularFilesUrl = _ref.popularFilesUrl,
      siteDisplayName = _ref.siteDisplayName;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__errorPage__["a" /* default */],
    { title: 'Search is unavailable' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      { className: 'fds-c-text-body -size-xl' },
      '...but don\'t worry, you can still discover.',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      'We are working hard to fix this. Meanwhile you can',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      '- Browse ',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { className: 'fds-c-text-link -decoration-none', href: popularFilesUrl },
        'popular files'
      ),
      ' in ',
      siteDisplayName,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      '- ',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { className: 'fds-c-text-link -decoration-none', href: 'javascript:history.back()' },
        ' Go Back'
      ),
      ' to where you were before',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      '- Try search again in few mintures'
    )
  );
});

/***/ }),
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_undefsafe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_errors__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_getProxyApiUrl__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_axios_axiosVerbose__ = __webpack_require__(32);







var fetchLandingPageContent = function fetchLandingPageContent(parsedUrl, opts) {
  return function (dispatch, getState) {
    var apiUrlPrefix = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_getProxyApiUrl__["a" /* default */])(opts);
    var site = __WEBPACK_IMPORTED_MODULE_0_undefsafe___default()(getState(), 'common.currentSite') || 'themeforest';
    var queryString = __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.stringify({ site: site, path: parsedUrl.path });

    return __WEBPACK_IMPORTED_MODULE_4__utils_axios_axiosVerbose__["a" /* default */].get(apiUrlPrefix + '/shopfront_api/landing_page?' + queryString).then(function (res) {
      return dispatch(fetchLandingPageContentSuccess(res.data));
    }).catch(__WEBPACK_IMPORTED_MODULE_2__utils_errors__["a" /* logError */]);
  };
};

var fetchLandingPageContentSuccess = function fetchLandingPageContentSuccess(content) {
  return {
    type: 'fetchLandingPageContentSuccess',
    payload: content
  };
};

/* harmony default export */ __webpack_exports__["a"] = (fetchLandingPageContent);

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_undefsafe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_sites___ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_sites_categories___ = __webpack_require__(330);






var recommendationsLimit = __WEBPACK_IMPORTED_MODULE_3__config_sites___["a" /* default */]['defaults'].recommendations_limit;

var rootCategoryRecommendations = function rootCategoryRecommendations(results, rootCategoryPaths) {
  var tagAggregations = __WEBPACK_IMPORTED_MODULE_2_undefsafe___default()(results, 'aggregations.tags');
  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty___default()(tagAggregations)) {
    return [];
  } else {
    var lowercasedRootCategories = rootCategoryPaths.map(function (category) {
      return category.toLowerCase();
    });

    var recommendations = [];
    var index = 0;
    while (recommendations.length < recommendationsLimit) {
      var tag = tagAggregations[index];
      if (!tag) {
        break;
      }
      if (!lowercasedRootCategories.includes(tag.key)) {
        recommendations.push(tag.key);
      }
      index++;
    }
    return recommendations;
  }
};

var fetchRecommendedSearchesByCategoryResults = function fetchRecommendedSearchesByCategoryResults(query, results, currentSite) {
  var siteRootCategories = __WEBPACK_IMPORTED_MODULE_4__config_sites_categories___["a" /* default */][currentSite];
  var siteRootCategoryPaths = siteRootCategories.reduce(function (paths, category) {
    paths.push(category.path);
    return paths;
  }, []);

  if (siteRootCategoryPaths.includes(query.category)) {
    var rootCategory = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(siteRootCategories, { path: query.category });
    return {
      type: 'fetchRecommendedSearchesByCategoryResultsSuccess',
      payload: {
        type: 'tags',
        recommendations: rootCategoryRecommendations(results, siteRootCategoryPaths),
        hint: rootCategory.name
      }
    };
  } else {
    return { type: 'fetchRecommendedSearchesByCategoryResultsFailure' };
  }
};

/* harmony default export */ __webpack_exports__["a"] = (fetchRecommendedSearchesByCategoryResults);

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_axios_axiosVerbose__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_errors__ = __webpack_require__(16);




var fetchRecommendedSearchesByTermResults = function fetchRecommendedSearchesByTermResults(term, _ref) {
  var apiUrlPrefix = _ref.apiUrlPrefix;

  return function (dispatch) {
    var url = apiUrlPrefix + '/shopfront_api/recommendation/' + encodeURIComponent(term);
    dispatch({
      type: 'fetchRecommendedSearchesByTermResultsRequest'
    });

    return __WEBPACK_IMPORTED_MODULE_0__utils_axios_axiosVerbose__["a" /* default */].get(url, { timeout: 5000 }).then(function (res) {
      if (res.data && res.data.relatedSearches && !res.data.error) {
        return dispatch({
          type: 'fetchRecommendedSearchesByTermResultsSuccess',
          payload: {
            recommendations: res.data.relatedSearches,
            hint: term
          }
        });
      } else {
        throw __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_errors__["e" /* ResponseDataError */])({ response: res });
      }
    }).catch(function (err) {
      return Promise.reject(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_errors__["a" /* logError */])(err));
    }).catch(function (err) {
      return dispatch(fetchRecommendedSearchesByTermResultsFailure(err));
    });
  };
};

var fetchRecommendedSearchesByTermResultsFailure = function fetchRecommendedSearchesByTermResultsFailure() {
  return function (dispatch) {
    dispatch({
      type: 'fetchRecommendedSearchesByTermResultsFailure',
      error: true
    });
  };
};

/* harmony default export */ __webpack_exports__["a"] = (fetchRecommendedSearchesByTermResults);

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_random__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_random___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_random__);


var setStudioRecommendations = function setStudioRecommendations() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var maxItems = config.links_in_ad || 4;
  var generation = config.generation;
  var items = config.items || [];
  var randomKeys = new Set();
  var randomItems = void 0;

  // if there is less items in config than max number of items which should be randomly selected,
  // pick all of them
  if (items.length <= maxItems) {
    randomItems = items;
  } else {
    // select random items from given config, by maxItems number
    while (randomKeys.size < maxItems) {
      randomKeys.add(__WEBPACK_IMPORTED_MODULE_0_lodash_random___default()(0, items.length - 1));
    }
    randomItems = Array.from(randomKeys).map(function (key) {
      return items[key];
    });
  }

  return {
    type: 'setStudioRecommendations',
    payload: {
      generation: generation,
      items: randomItems
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (setStudioRecommendations);

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getUserRequestAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getUserSuccessAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getUserFailureAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getGuestUserAction; });
/**
 * Get user profile actions
 */
var getUserRequestAction = function getUserRequestAction() {
  return { type: 'getUserRequest' };
};
var getUserSuccessAction = function getUserSuccessAction(user) {
  return {
    type: 'getUserSuccess',
    payload: user
  };
};
var getUserFailureAction = function getUserFailureAction() {
  return { type: 'getUserFailure' };
};

var getGuestUserAction = function getGuestUserAction() {
  return {
    type: 'getGuestUser'
  };
};

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reportHeaderBannerClick; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_ga__ = __webpack_require__(33);


// https://github.com/envato/marketplace/blob/master/app/assets/javascripts/market/shared/google_analytics/_promo.js.coffee
var reportHeaderBannerClick = function reportHeaderBannerClick(payload) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["a" /* default */])('ec:addPromo', payload);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["a" /* default */])('ec:setAction', 'promo_click');
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["a" /* default */])('send', 'event', 'Internal Promotions', 'click', {
    label: payload.name
  });
};

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reportEditCartEntryAttempt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reportCartSupportUpgrade; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_sites__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_ga__ = __webpack_require__(33);



var reportEditCartEntryAttempt = function reportEditCartEntryAttempt(_ref) {
  var page = _ref.page;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_ga__["a" /* default */])('send', {
    hitType: 'pageview',
    page: page,
    title: 'Modal: Edit cart entry'
  });
};

var reportCartSupportUpgrade = function reportCartSupportUpgrade(_ref2) {
  var item = _ref2.item,
      currentSite = _ref2.currentSite,
      license = _ref2.license,
      price = _ref2.price,
      support = _ref2.support;

  var currentSiteDomain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_sites__["a" /* getCurrentSiteDomain */])(currentSite);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_ga__["a" /* default */])('ec:addProduct', {
    id: item.id,
    name: item.name,
    variant: license,
    category: currentSiteDomain + '/' + item.classification,
    brand: item.author_username,
    price: price,
    quantity: '1',
    dimension14: support
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_ga__["a" /* default */])('ec:setAction', 'add');
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_ga__["a" /* default */])('send', 'event', 'Ecommerce', 'click', 'Search support upgrade');
};

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reportAutoSuggest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_ga__ = __webpack_require__(33);


var reportAutoSuggest = function reportAutoSuggest(payload) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["a" /* default */])('set', {
    metric2: payload.suggestedTerm.length,
    metric3: payload.label.length,
    dimension16: payload.suggestedTerm.join(',')
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["a" /* default */])('send', 'event', 'autosuggestion', payload.action || 'click', payload.label);
};

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reportViewSurveyBanner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reportStartSurveyClick; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_ga__ = __webpack_require__(33);


var reportViewSurveyBanner = function reportViewSurveyBanner(surveyName) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["a" /* default */])('send', 'event', 'Survey', 'View', surveyName, { nonInteraction: true });
};

var reportStartSurveyClick = function reportStartSurveyClick(surveyName) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["a" /* default */])('send', 'event', 'Survey', 'click', surveyName);
};

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reportVideoProgress; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_ga__ = __webpack_require__(33);


var reportVideoProgress = function reportVideoProgress(eventName, videoSrc) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_ga__["a" /* default */])('send', 'event', 'video player - search', eventName, videoSrc);
};

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  production: '//assets.shopfront.envato-static.com',
  development: '/assets'
});

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  endpoint: 'wss://suggest.market.envato.com/socket',
  channel: 'autocomplete:standard'
});

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// https://github.com/envato/marketplace/blob/master/engines/search/app/models/search/faceting_search_service.rb#L216-L230
/* harmony default export */ __webpack_exports__["a"] = (['attribute_key', 'attribute_value', 'category', 'compatible_with', 'price_max', 'resolution_min', 'tags', 'term', 'size', 'sort', 'vocals_in_audio', 'item_id', 'page']);

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  buyer: [{
    name: 'Profile',
    link: '/user/{username}',
    icon: 'e-icon -icon-person'
  }, {
    name: 'Envato Account',
    link: '//account.envato.com',
    icon: 'e-icon -icon-envato'
  }, {
    name: 'Settings',
    link: '/user/{username}/personal_information/edit',
    icon: 'e-icon -icon-cog'
  }, {
    name: 'Downloads',
    link: '/downloads',
    icon: 'e-icon -icon-download'
  }, {
    name: 'Favorites',
    link: '/favorites',
    icon: 'e-icon -icon-favorite'
  }, {
    name: 'Collections',
    link: '/collections/manage',
    icon: 'e-icon -icon-folder-open'
  }, {
    name: 'Follow Feed',
    link: '/follow_feed',
    icon: 'e-icon -icon-people'
  }, {
    name: 'Statement',
    link: '/user/{username}/statement',
    icon: 'e-icon -icon-document-filled'
  }, {
    name: 'Add Credit',
    link: '/payment/deposit/new',
    icon: 'e-icon -icon-dollar'
  }],
  nonAuthor: [{
    name: 'Become an Author',
    link: 'https://author.envato.com',
    icon: 'e-icon -icon-moneybag'
  }],
  author: [{
    name: 'Author Dashboard',
    link: '/author_dashboard',
    icon: 'e-icon -icon-gauge'
  }, {
    name: 'Upload',
    link: '/upload',
    icon: 'e-icon -icon-upload'
  }, {
    name: 'Portfolio',
    link: '/user/{username}/portfolio',
    icon: 'e-icon -icon-briefcase'
  }, {
    name: 'Earnings',
    link: '/user/{username}/earnings',
    icon: 'e-icon -icon-moneybag'
  }, {
    name: 'Withdrawals',
    link: '/accounts/withdrawal/new',
    icon: 'e-icon -icon-withdrawal'
  }]
});

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = common;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var initialState = {
  currentSite: null,
  stats: null,
  baseUrl: null,
  menuConfig: [],
  alerts: [],
  errorPage: null,
  noIndex: false
};

/**
 * UI state store action handler
 * @param  {Object} action Object
 * @param  {Object} state  Object
 * @return {Object} new State
 */
function common() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  var alerts = void 0;

  switch (action.type) {
    case 'receiveStats':
      return _extends({}, state, {
        stats: action.payload
      });

    case 'setCurrentSite':
      return _extends({}, state, {
        currentSite: action.payload
      });

    case 'setBaseUrl':
      return _extends({}, state, {
        baseUrl: action.payload
      });

    case 'setMenuConfig':
      return _extends({}, state, {
        menuConfig: action.payload
      });

    case 'showAlert':
      alerts = state.alerts.slice();
      alerts.push(action.payload);
      return _extends({}, state, {
        alerts: alerts
      });

    case 'hideAlert':
      alerts = state.alerts.slice().filter(function (alert) {
        return alert.message !== action.payload.message;
      });

      return _extends({}, state, {
        alerts: alerts
      });

    case 'resetAlerts':
      return _extends({}, state, {
        alerts: []
      });

    case 'setErrorPage':
      return _extends({}, state, {
        errorPage: action.payload.id
      });

    case 'resetErrorPage':
      return _extends({}, state, {
        errorPage: null
      });

    case 'noIndex':
      return _extends({}, state, {
        noIndex: true
      });

    default:
      return state;
  }
}

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__searchPage__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__landingPage__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__marketing__ = __webpack_require__(662);









var rootReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* combineReducers */])({
  searchPage: __WEBPACK_IMPORTED_MODULE_4__searchPage__["a" /* default */],
  landingPage: __WEBPACK_IMPORTED_MODULE_5__landingPage__["a" /* default */],
  layout: __WEBPACK_IMPORTED_MODULE_3__layout__["a" /* default */],
  user: __WEBPACK_IMPORTED_MODULE_1__user__["a" /* default */],
  common: __WEBPACK_IMPORTED_MODULE_2__common__["a" /* default */],
  marketing: __WEBPACK_IMPORTED_MODULE_6__marketing__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (rootReducer);

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = landingPage;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var initialState = {
  html: '',
  css: null
};

function landingPage() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case 'fetchLandingPageContentSuccess':
      return _extends({}, state, {
        html: action.payload.html,
        css: action.payload.css
      });

    default:
      return state;
  }
}

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var initialState = {
  pageIsOffCanvas: false,
  pageCanvasDirection: null,
  isModalOpen: false,
  openModalType: null,
  openModalData: null,
  modalMessages: null
};

/**
 * UI state store action handler
 * @param  {Object} action Object
 * @param  {Object} state  Object
 * @return {Object} new State
 */
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case 'toggleOffCanvas':
      var direction = action.payload;
      return _extends({}, state, {
        'pageIsOffCanvas': !state['pageIsOffCanvas'],
        'pageCanvasDirection': direction
      });

    case 'closeModal':
      return _extends({}, state, {
        isModalOpen: false,
        openModalType: null,
        openModalData: null,
        modalMessages: null
      });

    case 'openModal':
      var _action$payload = action.payload,
          type = _action$payload.type,
          payload = _action$payload.payload;

      return _extends({}, state, {
        isModalOpen: true,
        openModalType: type,
        openModalData: payload
      });

    case 'showModalMessage':
      return _extends({}, state, {
        modalMessages: action.payload
      });

    case 'dismissModalMessage':
      return _extends({}, state, {
        modalMessages: null
      });

    default:
      return state;
  }
});

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var initialState = {
  banners: []
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case 'receiveBannerData':
      var banners = action.payload;
      return _extends({}, state, {
        banners: banners
      });

    default:
      return state;
  }
});

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = searchPage;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var initialState = {
  activeAudio: null,
  showSidebar: false,
  showModal: false,
  loading: false,
  timeout: false,
  relatedSearches: {
    recommendations: []
  },
  resultsUrl: '',
  results: {
    aggregations: {},
    matches: [],
    total_hits: 0,
    term: ''
  },
  seoMeta: {
    heading: null,
    sub_heading: null,
    title: 'Envato Market',
    meta_description: 'Over 3 million digital products created by a global community of designers, developers, photographers, illustrators &amp; producers.'
  },
  studioRecommendations: {
    generation: null,
    items: []
  },
  ingestedContent: null
};

function searchPage() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case 'setActiveAudio':
      return _extends({}, state, {
        activeAudio: action.payload.activeAudio
      });

    case 'fetchSearchResultsRequest':
      return _extends({}, state, {
        loading: true,
        timeout: false,
        relatedSearches: {
          recommendations: []
        }
      });

    case 'fetchSearchResultsSuccess':
      return _extends({}, state, {
        results: action.payload.results,
        resultsUrl: action.payload.resultsUrl,
        loading: false
      });

    case 'fetchSearchResultsFailure':
      return _extends({}, state, {
        loading: false,
        timeout: action.timeout
      });

    case 'fetchRecommendedSearchesByTermResultsSuccess':
      return _extends({}, state, {
        relatedSearches: {
          type: 'term',
          recommendations: action.payload.recommendations,
          hint: action.payload.hint
        }
      });

    case 'fetchRecommendedSearchesByCategoryResultsSuccess':
      return _extends({}, state, {
        relatedSearches: {
          type: action.payload.type,
          recommendations: action.payload.recommendations,
          hint: action.payload.hint
        }
      });

    case 'setSeoData':
      return _extends({}, state, {
        seoMeta: action.payload.seoMeta || initialState.seoMeta
      });

    case 'setStudioRecommendations':
      return _extends({}, state, {
        studioRecommendations: action.payload
      });

    case 'fetchIngestedContentSuccess':
      return _extends({}, state, {
        ingestedContent: action.payload.content || initialState.ingestedContent
      });

    default:
      return state;
  }
}

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = user;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  hasLoadAttempt: false,
  isPending: false,
  token: null,
  profile: null,
  collections: {},
  cart: null,
  preferences: {
    searchResultsViewType: 'list',
    searchVideoMuted: false
  }
};

function user() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case 'addBookmarkRequest':
      {
        var _action$payload = action.payload,
            collectionID = _action$payload.collectionID,
            itemID = _action$payload.itemID;


        return _extends({}, state, {
          collections: _extends({}, state.collections, _defineProperty({}, collectionID, _extends({}, state.collections[collectionID], {
            bookmarks: _extends({}, state.collections[collectionID].bookmarks, _defineProperty({}, itemID, { optimisticStatus: 'pending' }))
          })))
        });
      }
    case 'addBookmarkSuccess':
      {
        var _action$payload2 = action.payload,
            _collectionID = _action$payload2.collectionID,
            _itemID = _action$payload2.itemID,
            bookmarkID = _action$payload2.bookmarkID;


        return _extends({}, state, {
          collections: _extends({}, state.collections, _defineProperty({}, _collectionID, _extends({}, state.collections[_collectionID], {
            bookmarks: _extends({}, state.collections[_collectionID].bookmarks, _defineProperty({}, _itemID, { id: bookmarkID, optimisticStatus: 'successful' }))
          })))
        });
      }
    case 'deleteBookmarkRequest':
      {
        var _action$payload3 = action.payload,
            _collectionID2 = _action$payload3.collectionID,
            _itemID2 = _action$payload3.itemID;


        return _extends({}, state, {
          collections: _extends({}, state.collections, _defineProperty({}, _collectionID2, _extends({}, state.collections[_collectionID2], {
            bookmarks: _extends({}, state.collections[_collectionID2].bookmarks, _defineProperty({}, _itemID2, _extends({}, state.collections[_collectionID2].bookmarks[_itemID2], {
              optimisticStatus: 'deleted'
            })))
          })))
        });
      }
    case 'deleteBookmarkFailure':
      {
        var _action$payload4 = action.payload,
            _collectionID3 = _action$payload4.collectionID,
            _itemID3 = _action$payload4.itemID;


        var newState = _extends({}, state, {
          collections: _extends({}, state.collections, _defineProperty({}, _collectionID3, _extends({}, state.collections[_collectionID3], {
            bookmarks: _extends({}, state.collections[_collectionID3].bookmarks, _defineProperty({}, _itemID3, _extends({}, state.collections[_collectionID3].bookmarks[_itemID3])))
          })))
        });

        delete newState.collections[_collectionID3].bookmarks[_itemID3].optimisticStatus;

        return newState;
      }
    case 'deleteBookmarkSuccess':
    case 'addBookmarkFailure':
      {
        var _action$payload5 = action.payload,
            _collectionID4 = _action$payload5.collectionID,
            _itemID4 = _action$payload5.itemID;


        var _newState = _extends({}, state, {
          collections: _extends({}, state.collections, _defineProperty({}, _collectionID4, _extends({}, state.collections[_collectionID4], {
            bookmarks: _extends({}, state.collections[_collectionID4].bookmarks)
          })))
        });

        delete _newState.collections[_collectionID4].bookmarks[_itemID4];

        return _newState;
      }
    case 'createCollectionRequest':
      return state;
    case 'createCollectionSuccess':
      var collection = action.payload;
      return _extends({}, state, {
        collections: _extends(_defineProperty({}, collection.id, _extends({}, collection, { bookmarks: {} })), state.collections)
      });
    case 'createCollectionFailure':
      return state;

    /**
     * User profile
     */
    case 'getUserRequest':
      return _extends({}, state, {
        isPending: true
      });
    case 'getUserSuccess':
      var _action$payload6 = action.payload,
          profile = _action$payload6.profile,
          collections = _action$payload6.collections,
          cart = _action$payload6.cart;


      return _extends({}, state, {
        profile: profile,
        collections: collections || state.collections,
        cart: cart,
        hasLoadAttempt: true,
        isPending: false
      });
    case 'getUserFailure':
      return _extends({}, state, {
        profile: null,
        collections: {},
        cart: null,
        hasLoadAttempt: true,
        isPending: false
      });

    /**
     * Token
     */
    case 'getSessionRequest':
      return state;
    case 'getSessionSuccess':
      var token = action.payload.token;

      return _extends({}, state, { token: token });
    case 'getSessionFailure':
      return _extends({}, state, {
        token: null,
        hasLoadAttempt: true,
        isPending: false
      });

    /**
     * Guest user
     */
    case 'getGuestUser':
      return _extends({}, state, {
        hasLoadAttempt: true,
        isPending: false
      });
    case 'getGuestUserCartRequest':
      return state;
    case 'getGuestUserCartSuccess':
      return _extends({}, state, { cart: action.payload });
    case 'getGuestUserCartFailure':
      return state;

    /**
     * User cart action
     */
    case 'createUserCartRequest':
      return state;
    case 'createUserCartSuccess':
      return _extends({}, state, { cart: action.payload });
    case 'createUserCartFailure':
      return state;

    case 'addItemToCartRequest':
      return state;
    case 'addItemToCartSuccess':
      return _extends({}, state, {
        cart: _extends({}, state.cart, {
          entries_count: state.cart.entries_count + 1,
          entries: [].concat(_toConsumableArray(state.cart.entries), [action.payload])
        })
      });
    case 'addItemToCartFailure':
      return state;

    case 'setUserSearchResultsViewType':
    case 'getUserSearchResultsViewType':
      return _extends({}, state, {
        preferences: _extends({}, state.preferences, {
          searchResultsViewType: action.payload.view
        })
      });

    case 'setUserVideoPlayerStatus':
    case 'getUserVideoPlayerStatus':
      return _extends({}, state, {
        preferences: _extends({}, state.preferences, {
          searchVideoMuted: action.payload.type
        })
      });

    default:
      return state;
  }
}

/***/ }),
/* 665 */,
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = configureStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_envHelper__ = __webpack_require__(194);






function configureStore(preloadedState) {
  var store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* createStore */])(__WEBPACK_IMPORTED_MODULE_2__reducers__["a" /* default */], preloadedState, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* compose */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_1_redux_thunk___default.a), !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_envHelper__["c" /* isServer */])() && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_envHelper__["b" /* isProduction */])() && window.devToolsExtension ? window.devToolsExtension() : function (f) {
    return f;
  }));

  if (false) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', function () {
      var nextRootReducer = require('../reducers').default;
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reportPageView; });
/* unused harmony export reportExperiment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ga__ = __webpack_require__(33);


var reportPageView = function reportPageView() {
  var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (typeof document === 'undefined') {
    return;
  }

  title = title || document.title;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ga__["a" /* default */])('send', {
    hitType: 'pageview',
    title: title
  });
};

var reportExperiment = function reportExperiment(experimentId, variantName) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ga__["a" /* default */])('set', 'expId', experimentId);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ga__["a" /* default */])('set', 'expVar', variantName);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ga__["a" /* default */])('send', {
    hitType: 'event',
    eventCategory: 'experiment',
    eventAction: 'view',
    eventLabel: experimentId,
    eventValue: variantName,
    nonInteraction: true
  });
};



/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setTimeoutFallback; });
/**
 * Executes the first callback, if it not resolve within timeout the fallback
 * function will be called.
 * @param {Function} mainExecutor
 * @param {Function} fallbackExecutor
 * @param {Number} timeout
 * @returns {Promise}
 */
var setTimeoutFallback = function setTimeoutFallback(mainExecutor, fallbackExecutor, timeout) {
  var mainPromise = new Promise(mainExecutor);
  var fallbackPromise = new Promise(function (resolve, reject) {
    setTimeout(function () {
      fallbackExecutor(resolve, reject);
    }, timeout);
  });

  return Promise.race([mainPromise, fallbackPromise]);
};

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(46);


var intercomAppId = __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].analytics.intercom.APP_ID;

/* harmony default export */ __webpack_exports__["a"] = ({
  boot: function boot(user) {
    if (window.Intercom) {
      if (!user) {
        window.Intercom('boot', {
          app_id: intercomAppId
        });
      } else {
        window.Intercom('boot', {
          app_id: intercomAppId,
          email: user.profile.email,
          user_id: user.profile.envato_id,
          user_hash: user.misc.intercom_user_hash,
          created_at: user.profile.created_at
        });
      }
    }
  }
});

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_pick__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_urlHelper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_canonicalUrlAttributes__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_sites_categories__ = __webpack_require__(330);








var getTagFromPath = function getTagFromPath(path) {
  return path.split('/')[2];
};

var isTagAlsoACategory = function isTagAlsoACategory(currentSite, tag) {
  var siteRootCategories = __WEBPACK_IMPORTED_MODULE_5__config_sites_categories__["a" /* default */][currentSite];

  return !__WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_find___default()(siteRootCategories, { path: tag }));
};

var isTagOnlySearch = function isTagOnlySearch(path) {
  return path.indexOf('/tags/') === 0;
};

var buildCanonicalPath = function buildCanonicalPath(currentSite, location) {
  var parsedLocation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_urlHelper__["a" /* parseLocation */])(location);
  var filteredCanonicalQueries = __WEBPACK_IMPORTED_MODULE_0_lodash_pick___default()(parsedLocation, __WEBPACK_IMPORTED_MODULE_4__constants_canonicalUrlAttributes__["a" /* default */]);
  if (filteredCanonicalQueries.page && filteredCanonicalQueries.page.toString() === '1') {
    delete filteredCanonicalQueries.page;
  }
  var canonicalPath = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_urlHelper__["b" /* makeLink */])(filteredCanonicalQueries);

  var actualPath = location.pathname;
  if (isTagOnlySearch(actualPath)) {
    var tag = getTagFromPath(actualPath);
    if (isTagAlsoACategory(currentSite, tag)) {
      canonicalPath = canonicalPath.replace('tags', 'category');
    }
  }
  return canonicalPath;
};

/* harmony default export */ __webpack_exports__["a"] = (buildCanonicalPath);

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return logSearchResult; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_undefsafe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__urlHelper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_filterParamsConfig__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__errors__ = __webpack_require__(16);








/**
 * Log success search result or timed out result to events api
 * @param {Object/null} results
 * @param {Object} query
 * @param {Object} user
 * @param {Boolean} timeout
 */
var logSearchResult = function logSearchResult(results, location, currentSite) {
  var user = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var timeout = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  var query = Object.assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__urlHelper__["a" /* parseLocation */])(location), {
    site: currentSite + '.net'
  });
  var data = {
    event: 'item.keyword',
    search_phrase: query.term,
    timed_out: timeout,
    site: query.site,
    param_view: 'list',
    param_page: 1
  };

  if (results) {
    data['took'] = results.took;
    data['total_hits'] = results.total_hits;
    data['param_item_ids'] = __WEBPACK_IMPORTED_MODULE_1_undefsafe___default()(results, 'matches.length') && results.matches.map(function (item) {
      return item.id;
    });
  }

  if (user) {
    data['param_view'] = __WEBPACK_IMPORTED_MODULE_1_undefsafe___default()(user, 'preferences.searchResultsViewType') || 'list';
    if (user.profile) {
      data['username'] = user.profile.username;
      data['user_id'] = user.profile.id;
      data['envato_id'] = user.profile.envato_id;
    }
  }

  var params = Object.keys(query).filter(function (param) {
    return ['term', 'site'].indexOf(param) === -1;
  });

  params.forEach(function (param) {
    var paramConfig = __WEBPACK_IMPORTED_MODULE_4__constants_filterParamsConfig__["a" /* default */][param];
    var isMultiple = param !== 'category' && paramConfig && paramConfig.isMultiple;
    var value = isMultiple ? query[param].split(',') : query[param];

    if (value !== 0 && value) {
      data['param_' + param] = value;
    }
  });

  if ('sendBeacon' in navigator) {
    navigator.sendBeacon(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].eventsApi.URL + '/search', JSON.stringify(data));
  } else {
    __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__["a" /* default */].post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].eventsApi.URL + '/search', data, { withCredentials: true }).catch(__WEBPACK_IMPORTED_MODULE_5__errors__["a" /* logError */]);
  }
};

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_config__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_router_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routes__ = __webpack_require__(323);




/* harmony default export */ __webpack_exports__["a"] = (function (store, parsedUrl, opts) {
  var branch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_router_config__["matchRoutes"])(__WEBPACK_IMPORTED_MODULE_1__routes__["a" /* default */], parsedUrl.pathname);
  return branch.map(function (_ref) {
    var route = _ref.route,
        match = _ref.match;

    return route.component.loadData ? route.component.loadData(store, parsedUrl, opts) : Promise.resolve({
      // resolve empty action
      type: 'noopAction'
    });
  });
});

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getItemMatrix; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__errors__ = __webpack_require__(16);



var getItemMatrix = function getItemMatrix(itemId) {
  return __WEBPACK_IMPORTED_MODULE_0__axios_axiosVerbose__["a" /* default */].get('/shopfront_api/item/' + itemId + '/price_matrix').then(function (res) {
    return res.data;
  }).catch(__WEBPACK_IMPORTED_MODULE_1__errors__["a" /* logError */]);
};

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);


/* harmony default export */ __webpack_exports__["a"] = (function (obj1, obj2) {
  return Object.keys(obj1).reduce(function (result, key) {
    if (!obj2[key]) {
      result.push(key);
    } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(obj1[key], obj2[key])) {
      var resultKeyIndex = result.indexOf(key);
      result.splice(resultKeyIndex, 1);
    }
    return result;
  }, Object.keys(obj2));
});

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isCategoryOnlySearch; });
/* unused harmony export isFirstPage */
/* unused harmony export includesExactlyTheseFacetingParams */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildSearchQueryString; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_pick__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_omitBy__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_omitBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_omitBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_undefsafe__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_undefsafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_undefsafe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_searchQueryWhitelist__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_filterParamsConfig__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__siteConfig__ = __webpack_require__(70);











var isCategoryOnlySearch = function isCategoryOnlySearch(query) {
  return includesExactlyTheseFacetingParams(query, ['category']);
};

var isFirstPage = function isFirstPage(query) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty___default()(query.page) || [0, 1].includes(parseInt(query.page));
};

var includesExactlyTheseFacetingParams = function includesExactlyTheseFacetingParams(query, expectedParamKeys) {
  var queryFacetingParams = __WEBPACK_IMPORTED_MODULE_2_lodash_pick___default()(query, facetingParams);
  var queryFacetingParamsWithValues = __WEBPACK_IMPORTED_MODULE_3_lodash_omitBy___default()(queryFacetingParams, __WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty___default.a);
  var facetingParamKeys = Object.keys(queryFacetingParamsWithValues);

  return __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual___default()(facetingParamKeys.sort(), expectedParamKeys.sort());
};

var facetingParams = ['term', 'sizes', 'username', 'price_min', 'price_max', 'length_min', 'length_max', 'sales_min', 'sales_max', 'sales', 'poly_count', 'rating_min', 'item_id', 'item_ids', 'tags', 'file_type', 'category', 'platform', 'colours', 'attribute_key', 'attribute_value', 'length_min', 'length_max', 'tempo', 'orientation', 'stock_footage_number_of_people', 'alpha', 'looped', 'requires_plugins', 'resolution_min', 'vocals_in_audio', 'frame_rate', 'compatible_with', 'date', 'include_pro_affiliated'];

/**
 * Build the search query string
 * @param  {Object} query
 * @return {String} the search query string pass to public-search
 */
var buildSearchQueryString = function buildSearchQueryString(parsedLocation, currentSite) {
  var filteredQueryObject = Object.keys(parsedLocation).filter(function (param) {
    // only keep the queries in the public-search query whitelist
    return __WEBPACK_IMPORTED_MODULE_6__constants_searchQueryWhitelist__["b" /* default */].indexOf(param) >= 0;
  }).filter(function (param) {
    // filter empty params
    return !!parsedLocation[param];
  }).reduce(function (prev, curr) {
    if (Array.isArray(parsedLocation[curr])) {
      var arrayLenght = parsedLocation[curr].length;
      prev[curr] = parsedLocation[curr][arrayLenght - 1];
    } else if (__WEBPACK_IMPORTED_MODULE_5_undefsafe___default()(__WEBPACK_IMPORTED_MODULE_7__constants_filterParamsConfig__["a" /* default */], curr + '.isArrayFormat')) {
      prev[curr] = parsedLocation[curr].split(',');
    } else {
      prev[curr] = parsedLocation[curr];
    }
    return prev;
  }, {});

  var pageSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__siteConfig__["a" /* default */])(currentSite, 'common.search_page_size');
  var site = currentSite + '.net';

  // we have a few default value here
  var newQueryObject = Object.assign({}, filteredQueryObject, {
    site: site,
    page: filteredQueryObject.page || 1,
    page_size: filteredQueryObject.page_size || pageSize
  });

  return __WEBPACK_IMPORTED_MODULE_4_query_string___default.a.stringify(newQueryObject, { arrayFormat: 'bracket' });
};

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axios_interceptors__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(46);





var ssoServerHost = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].sso.SERVER_HOST;
var TIMEOUT = 15000;

/**
 * A simple function to wrap sso api with default endpoint and request headers
 * @type {Object}
 */
var instance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: ssoServerHost,
  timeout: TIMEOUT,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded'
  }
});

instance.interceptors.response.use(undefined, __WEBPACK_IMPORTED_MODULE_1__axios_interceptors__["a" /* timeoutRetryRejectionInterceptor */]);
/* harmony default export */ __webpack_exports__["a"] = (instance);

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  key: 'elements',
  label: 'Envato Elements',
  imageSrc: '/images/cross-sell__elements.jpg',
  imageSrcSet: ['/images/cross-sell__elements.jpg', '/images/cross-sell__elements--2x.jpg'],
  heading: 'Deliver better projects faster. Photos, templates & courses',
  subHeading: 'Unlimited downloads. Only $29/month',
  url: {
    base: { 'default': 'https://elements.envato.com/' },
    path: { 'default': 'all-items' },
    params: {
      themeforest: {
        utm_source: 'themeforest.net',
        utm_campaign: 'elements_mkt-footer_26JUNE2017',
        utm_content: 'tf_global-footer',
        utm_medium: 'promos'
      },
      codecanyon: {
        utm_source: 'codecanyon.net',
        utm_campaign: 'elements_mkt-footer_26JUNE2017',
        utm_content: 'cc_global-footer',
        utm_medium: 'promos'
      },
      graphicriver: {
        utm_source: 'graphicriver.net',
        utm_campaign: 'elements_mkt-footer_26JUNE2017',
        utm_content: 'gr_global-footer',
        utm_medium: 'promos'
      },
      photodune: {
        utm_source: 'photodune.net',
        utm_campaign: 'elements_mkt-footer_26JUNE2017',
        utm_content: 'pd_global-footer',
        utm_medium: 'promos'
      },
      videohive: {
        utm_source: 'videohive.net',
        utm_campaign: 'elements_mkt-footer_26JUNE2017',
        utm_content: 'vh_global-footer',
        utm_medium: 'promos'
      },
      audiojungle: {
        utm_source: 'audiojungle.net',
        utm_campaign: 'elements_mkt-footer_26JUNE2017',
        utm_content: 'aj_global-footer',
        utm_medium: 'promos'
      },
      '3docean': {
        utm_source: '3docean.net',
        utm_campaign: 'elements_mkt-footer_26JUNE2017',
        utm_content: '3do_global-footer',
        utm_medium: 'promos'
      }
    }
  }
}, {
  key: 'tutplus',
  label: 'Tuts+',
  imageSrc: '/images/cross-sell__tutsplus.jpg',
  imageSrcSet: ['/images/cross-sell__tutsplus.jpg', '/images/cross-sell__tutsplus--2x.jpg'],
  heading: 'Learn almost anything with<br>Envato Tuts+ for free',
  subHeading: '9000 free tutorials, 3000 paid courses',
  url: {
    base: {
      codecanyon: 'https://webdesign.tutsplus.com',
      themeforest: 'https://webdesign.tutsplus.com',
      'default': 'http://tutsplus.com'
    },
    path: {
      codecanyon: '/courses/a-beginners-guide-to-using-wordpress',
      themeforest: '/courses/a-beginners-guide-to-using-wordpress',
      'default': ''
    },
    params: {
      codecanyon: {
        utm_source: 'EnvatoMarket',
        utm_medium: 'TF_Footer',
        utm_campaign: 'Envato_CC_Footer_FreeWPCourse'
      },
      themeforest: {
        utm_source: 'EnvatoMarket',
        utm_medium: 'CC_Footer',
        utm_campaign: 'Envato_TF_Footer_FreeWPCourse'
      },
      'default': {
        utm_source: 'market.envato.com',
        utm_medium: 'referral',
        utm_campaign: 'global_footer'
      }
    }
  }
}, {
  key: 'studio',
  label: 'Envato Studio',
  imageSrc: '/images/cross-sell__studio.jpg',
  imageSrcSet: ['/images/cross-sell__studio.jpg', '/images/cross-sell__studio--2x.jpg'],
  heading: 'Designers matched perfectly to<br>you on Envato Studio',
  subHeading: '2000 artists ready to undertake your work',
  url: {
    base: {
      'default': 'https://studio.envato.com'
    },
    path: {
      codecanyon: '/explore/websites-programming',
      videohive: '/explore/video-animation',
      audiojungle: '/explore/audio',
      graphicriver: '/explore/design-graphics',
      photodune: '/explore/photo-editing',
      '3docean': '/explore/3d-design-modeling',
      'default': '/explore/wordpress'
    },
    params: {
      '3docean': {
        utm_source: 'marketplaces',
        utm_content: 'footernav',
        utm_campaign: 'internal navigation',
        utm_medium: '3docean'
      },
      audiojungle: {
        utm_source: 'marketplaces',
        utm_content: 'footernav',
        utm_campaign: 'internal navigation',
        utm_medium: 'audiojungle'
      },
      codecanyon: {
        utm_source: 'marketplaces',
        utm_content: 'footernav',
        utm_campaign: 'internal navigation',
        utm_medium: 'codecanyon'
      },
      graphicriver: {
        utm_source: 'marketplaces',
        utm_content: 'footernav',
        utm_campaign: 'internal navigation',
        utm_medium: 'graphicriver'
      },
      photodune: {
        utm_source: 'marketplaces',
        utm_content: 'footernav',
        utm_campaign: 'internal navigation',
        utm_medium: 'photodune'
      },
      themeforest: {
        utm_source: 'marketplaces',
        utm_content: 'footernav',
        utm_campaign: 'internal navigation',
        utm_medium: 'themeforest'
      },
      videohive: {
        utm_source: 'marketplaces',
        utm_content: 'footernav',
        utm_campaign: 'internal navigation',
        utm_medium: 'videohive'
      },
      'default': {}
    }
  }
}]);

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  companyLinks: [{ key: 'about', label: 'About Envato', url: 'https://envato.com' }, { key: 'careers', label: 'Careers', url: 'http://careers.envato.com' }, { key: 'privacy', label: 'Privacy Policy', url: 'https://envato.com/privacy/' }],
  infoLinks: [{
    key: 'envato',
    titleHtml: 'Envato Market',
    entries: [{ key: 'terms', label: 'Terms', url: 'https://themeforest.net/legal/market' }, { key: 'licenses', label: 'Licenses', url: 'https://themeforest.net/licenses' }, { key: 'api', label: 'Market API', url: 'https://build.envato.com' }, { key: 'affiliate', label: 'Become an affiliate', url: 'https://themeforest.net/affiliate_program' }]
  }, {
    key: 'help',
    titleHtml: 'Help',
    entries: [{ key: 'helpCenter', label: 'Help Center', url: 'https://help.market.envato.com' }, { key: 'itemSupport', label: 'Item support', url: '/page/item_support_policy' }, { key: 'custRefunds', label: 'Customer refunds', url: '/page/customer_refund_policy' }, { key: 'authorRefunds', label: 'Author refunds', url: '/page/author_refund_policy' }]
  }, {
    key: 'community',
    titleHtml: 'Our Community',
    entries: [{ key: 'forums', label: 'Forums', url: 'https://forums.envato.com' }, { key: 'communityHub', label: 'Community hub', url: 'http://community.envato.com' }, { key: 'blog', label: 'Blog', url: 'https://envato.com/blog' }, { key: 'meetups', label: 'Meetups', url: 'http://community.envato.com/#/events' }]
  }],
  socialMediaLinks: [{
    key: 'twitter',
    label: 'Twitter',
    url: 'https://twitter.com/envatomarket',
    icon: '/images/icon-twitter.svg'
  }, {
    key: 'facebook',
    label: 'Facebook',
    url: 'https://www.facebook.com/envatomarket/',
    icon: '/images/icon-facebook.svg'
  }, {
    key: 'youtube',
    label: 'YouTube',
    url: 'https://www.youtube.com/user/Envato',
    icon: '/images/icon-youtube.svg'
  }, {
    key: 'instagram',
    label: 'Instagram',
    url: 'https://www.instagram.com/envato/',
    icon: '/images/icon-instagram.svg'
  }, {
    key: 'pinterest',
    label: 'Pinterest',
    url: 'https://www.pinterest.com/envato/',
    icon: '/images/icon-pinterest.svg'
  }]
});

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  staticLinks: [{ label: 'Forums', url: 'https://forums.envato.com' }, { label: 'Start Selling', url: '/become-an-author' }],
  envatoProducts: [{
    key: 'elements',
    name: 'Envato Elements',
    logo: '/images/logo-envato-elements.svg',
    description: 'Digital assets subscription',
    url: 'https://elements.envato.com'
  }, {
    key: 'sites',
    name: 'Envato Sites',
    logo: '/images/logo-envato-sites.svg',
    description: 'Websites builder',
    url: 'https://sites.envato.com'
  }, {
    key: 'studio',
    name: 'Envato Studio',
    logo: '/images/logo-envato-studio.svg',
    description: 'Hire a freelancer',
    url: 'https://studio.envato.com'
  }, {
    key: 'tutsplus',
    name: 'Tuts+',
    logo: '/images/logo-envato-tutsplus.svg',
    description: 'Tutorials & courses',
    url: 'https://tutsplus.com'
  }],
  envatoProductsStaticLinks: [{
    key: 'community',
    label: 'Join the ',
    linkLabel: 'Envato community',
    url: 'http://community.envato.com'
  }, {
    key: 'forums',
    label: 'Learn from others in ',
    linkLabel: 'the forums',
    url: 'https://forums.envato.com'
  }]
});

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_config__ = __webpack_require__(46);


var ssoServerHost = __WEBPACK_IMPORTED_MODULE_0__common_config__["a" /* default */].sso.SERVER_HOST;

/* harmony default export */ __webpack_exports__["a"] = ({
  blocks: [{
    key: 'account',
    title: 'Hi, {{username}}',
    entries: [{
      key: 'profile',
      label: 'Profile',
      path: '/user/{{username}}'
    }, {
      key: 'settings',
      label: 'Settings',
      path: '/user/{{username}}/personal_information/edit'
    }, {
      key: 'downloads',
      label: 'Downloads',
      path: '/downloads'
    }, {
      key: 'favorites',
      label: 'Favorites',
      path: '/favorites'
    }, {
      key: 'collections',
      label: 'Collections',
      path: '/collections/manage'
    }, {
      key: 'addCredit',
      label: 'Add Credit',
      path: '/payment/deposit/new',
      showCredit: true,
      creditLabel: 'Current credit:'
    }]
  }, {
    key: 'author',
    title: 'Author Settings', // TODO
    requires: 'userIsAuthor',
    entries: [{
      key: 'dashboard',
      label: 'Dashboard',
      path: '/author_dashboard',
      requires: 'hasAuthorPermissionsInCurrentSite'
    }, {
      key: 'upload',
      label: 'Upload',
      path: '/content/upload',
      requires: 'canUploadInCurrentSite'
    }, {
      key: 'portfolio',
      label: 'Portfolio',
      path: '/user/{{username}}/portfolio',
      requires: 'canViewPortfolio'
    }, {
      key: 'earnings',
      label: 'Earnings',
      path: '/user/{{username}}/earnings'
    }, {
      key: 'statement',
      label: 'Statement',
      path: '/user/{{username}}/statement'
    }, {
      key: 'withdrawals',
      label: 'Withdrawals',
      path: '/accounts/withdrawal/new'
    }]
  }, {
    key: 'buyer',
    requires: 'userIsNotAuthor',
    entries: [{
      key: 'become-author',
      label: 'Become an Author',
      path: '/become-an-author'
    }]
  }, {
    key: 'logout',
    entries: [{
      key: 'sign_out',
      label: 'Sign Out',
      path: ssoServerHost + '/sign_out?to={{currentSite}}'
    }]
  }]
});

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3docean_json__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3docean_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3docean_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__audiojungle_json__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__audiojungle_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__audiojungle_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__codecanyon_json__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__codecanyon_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__codecanyon_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphicriver_json__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphicriver_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__graphicriver_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__photodune_json__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__photodune_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__photodune_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__themeforest_json__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__themeforest_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__themeforest_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__videohive_json__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__videohive_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__videohive_json__);








/* harmony default export */ __webpack_exports__["a"] = ({
  '3docean': __WEBPACK_IMPORTED_MODULE_0__3docean_json___default.a,
  audiojungle: __WEBPACK_IMPORTED_MODULE_1__audiojungle_json___default.a,
  codecanyon: __WEBPACK_IMPORTED_MODULE_2__codecanyon_json___default.a,
  graphicriver: __WEBPACK_IMPORTED_MODULE_3__graphicriver_json___default.a,
  photodune: __WEBPACK_IMPORTED_MODULE_4__photodune_json___default.a,
  themeforest: __WEBPACK_IMPORTED_MODULE_5__themeforest_json___default.a,
  videohive: __WEBPACK_IMPORTED_MODULE_6__videohive_json___default.a
});

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3docean_json__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3docean_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3docean_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__audiojungle_json__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__audiojungle_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__audiojungle_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__codecanyon_json__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__codecanyon_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__codecanyon_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphicriver_json__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphicriver_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__graphicriver_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__photodune_json__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__photodune_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__photodune_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__themeforest_json__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__themeforest_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__themeforest_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__videohive_json__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__videohive_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__videohive_json__);








/* harmony default export */ __webpack_exports__["a"] = ({
  '3docean': __WEBPACK_IMPORTED_MODULE_0__3docean_json___default.a,
  audiojungle: __WEBPACK_IMPORTED_MODULE_1__audiojungle_json___default.a,
  codecanyon: __WEBPACK_IMPORTED_MODULE_2__codecanyon_json___default.a,
  graphicriver: __WEBPACK_IMPORTED_MODULE_3__graphicriver_json___default.a,
  photodune: __WEBPACK_IMPORTED_MODULE_4__photodune_json___default.a,
  themeforest: __WEBPACK_IMPORTED_MODULE_5__themeforest_json___default.a,
  videohive: __WEBPACK_IMPORTED_MODULE_6__videohive_json___default.a
});

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var OldIE = function (_React$Component) {
  _inherits(OldIE, _React$Component);

  function OldIE(props) {
    _classCallCheck(this, OldIE);

    var _this = _possibleConstructorReturn(this, (OldIE.__proto__ || Object.getPrototypeOf(OldIE)).call(this, props));

    _this.state = {
      isIE10: false
    };
    return _this;
  }

  _createClass(OldIE, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var isIE10 = /MSIE 10/.test(navigator.userAgent);
      this.setState({
        isIE10: isIE10
      });
    }
  }, {
    key: 'renderIE9String',
    value: function renderIE9String(siteName) {
      return '\n      <!--[if lte IE 9]>\n        <div class="alert-ie">\n          ' + siteName + '.net no longer actively supports this version of Internet Explorer. We suggest that you <a href="http://windows.microsoft.com/en-us/internet-explorer/download-ie">upgrade to a newer version</a> or <a href="http://browsehappy.com/">try a different browser</a>.\n        </div>\n      <![endif]-->\n    ';
    }
  }, {
    key: 'renderIE10String',
    value: function renderIE10String(siteName) {
      return '\n      <div class="alert-ie">\n        ' + siteName + '.net no longer actively supports this version of Internet Explorer. We suggest that you <a href="http://windows.microsoft.com/en-us/internet-explorer/download-ie">upgrade to a newer version</a> or <a href="http://browsehappy.com/">try a different browser</a>.\n      </div>\n    ';
    }
  }, {
    key: 'render',
    value: function render() {
      var siteName = this.props.siteName;
      var isIE10 = this.state.isIE10;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        isIE10 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: this.renderIE10String(siteName) } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: this.renderIE9String(siteName) } })
      );
    }
  }]);

  return OldIE;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (OldIE);

/***/ }),
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 943 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 944 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 945 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 946 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"spaceBetween":"audioPlayerLarge-module_spaceBetween_3oGwP","waveformContainer":"audioPlayerLarge-module_waveformContainer_HJ29_","timeContainer":"audioPlayerLarge-module_timeContainer_1jKIW","icon":"audioPlayerLarge-module_icon_M7BxM","spinningIcon":"audioPlayerLarge-module_spinningIcon_F84JX audioPlayerLarge-module_icon_M7BxM","spin":"audioPlayerLarge-module_spin_21SFC"};

/***/ }),
/* 947 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"audioPlayerSmall-module_container_16wYs","playButton":"audioPlayerSmall-module_playButton_37F_g","progressBarContainer":"audioPlayerSmall-module_progressBarContainer_3wq89","progressBar":"audioPlayerSmall-module_progressBar_279tw","icon":"audioPlayerSmall-module_icon_2OfgP","whiteIcon":"audioPlayerSmall-module_whiteIcon_3_GER audioPlayerSmall-module_icon_2OfgP","spinningIcon":"audioPlayerSmall-module_spinningIcon_32ro5 audioPlayerSmall-module_icon_2OfgP","spin":"audioPlayerSmall-module_spin_2kbrQ"};

/***/ }),
/* 948 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"defaultTheme":"itemActions-module_defaultTheme_z7_4l","actionsContainer":"itemActions-module_actionsContainer_3Aqtb","action":"itemActions-module_action_ynHWV","active":"itemActions-module_active_2lLlY","icon":"itemActions-module_icon_-ugTk"};

/***/ }),
/* 949 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"itemView":"gridAudio-module_itemView_11GKV","itemName":"gridAudio-module_itemName_16nQO","actionContainer":"gridAudio-module_actionContainer_1g0Fx","footer":"gridAudio-module_footer_mrlFK","thumbnail":"gridAudio-module_thumbnail_zGLL3","miniAudioPlayerContainer":"gridAudio-module_miniAudioPlayerContainer_5Od3E"};

/***/ }),
/* 950 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"gridVideo-module_container_1_IOL","videoContainer":"gridVideo-module_videoContainer_24Vwl","video":"gridVideo-module_video_350t8","overlay":"gridVideo-module_overlay_1gzeX","itemActions":"gridVideo-module_itemActions_27pvf","titleContainer":"gridVideo-module_titleContainer_4p3d9","title":"gridVideo-module_title_27qO4","meta":"gridVideo-module_meta_1WKWO","price":"gridVideo-module_price_wYGD3","duration":"gridVideo-module_duration_2lmj6"};

/***/ }),
/* 951 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"listAudio-module_container_GGAn2","itemDescription":"listAudio-module_itemDescription_2Menn","flexColumn":"listAudio-module_flexColumn_3pmRv","spaceBetween":"listAudio-module_spaceBetween_10AmB","meta":"listAudio-module_meta_2fW6R listAudio-module_spaceBetween_10AmB","itemSummary":"listAudio-module_itemSummary_14l41","thumbnail":"listAudio-module_thumbnail_1KJCs"};

/***/ }),
/* 952 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"formLabelInlineGroup":"signIn-module_formLabelInlineGroup_11klt","formResponse":"signIn-module_formResponse_3beQl","formLabel":"signIn-module_formLabel_pL_Nu","captcha":"signIn-module_captcha_2UXzj"};

/***/ }),
/* 953 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"grid":"gridVideo-module_grid_1GL6j","result":"gridVideo-module_result__y9fZ"};

/***/ }),
/* 954 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"iconContainer":"muteSwitcher-module_iconContainer_2lKEi","iconLabel":"muteSwitcher-module_iconLabel_CJtFY"};

/***/ }),
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(183);
module.exports = __webpack_require__(462);


/***/ })
],[1264]);


// WEBPACK FOOTER //
// v0-c580a5a64b248bb4f7cb.js